import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField = {
  /** Default aggregation of the field, i.e. 'Sum', 'Average'. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_aggregation.html#AggFuncs */
  aggregation: Maybe<Scalars['String']>;
  /** For the percentile aggregation, the percentile number */
  aggregationParam: Maybe<Scalars['String']>;
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** Default format for number or date */
  defaultFormat: Maybe<Scalars['String']>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** For geographic data, the geographic role of the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/maps_geographicroles.html */
  semanticRole: Maybe<Scalars['String']>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing analytics metadata */
export type AnalyticsField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum AnalyticsFieldOrderField {
  /** Sort by id */
  ID = 'ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type AnalyticsFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: AnalyticsFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type AnalyticsField_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for AnalyticsField */
export type AnalyticsFieldsConnection = {
  __typename: 'AnalyticsFieldsConnection';
  /** List of nodes */
  nodes: Array<AnalyticsField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** AskDataExtensions to base Tableau functionality. */
export type AskDataExtension = {
  __typename: 'AskDataExtension';
  /** The dashboard that contains this askData extension */
  dashboard: Maybe<Dashboard>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Lens configured for the askData extension */
  lens: Maybe<Lens>;
};

/** Enum for fields that can be used for sorting */
export enum AskDataExtensionOrderField {
  /** Sort by id */
  ID = 'ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type AskDataExtensionSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: AskDataExtensionOrderField;
};

/** Filter by GraphQL field and given value */
export type AskDataExtension_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Filter by GraphQL field and given value */
export type AskDataExtension_Required_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for AskDataExtension */
export type AskDataExtensionsConnection = {
  __typename: 'AskDataExtensionsConnection';
  /** List of nodes */
  nodes: Array<AskDataExtension>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField = DataField & Field & FieldReferencingField & Node & {
  __typename: 'BinField';
  /** Size of the bin */
  binSize: Maybe<Scalars['String']>;
  /** Data category of the field */
  dataCategory: Maybe<FieldRoleCategory>;
  /** Type of the data in the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_typesandroles_datatypes.html */
  dataType: Maybe<FieldDataType>;
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** List of fields, if any, that this field references */
  fields: Array<Field>;
  /** List of fields, if any, that this field references */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Formula of the calculated field */
  formula: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** List of parameters, if any, used in this field */
  parameters: Array<Parameter>;
  /** List of parameters, if any, used in this field */
  parametersConnection: Maybe<ParametersConnection>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Role of the field: 'dimension', 'measure' or 'unknown' */
  role: Maybe<FieldRole>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ParametersArgs = {
  filter: InputMaybe<Parameter_Filter>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ParametersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Parameter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a binned continuous measure field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_bins.html */
export type BinField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum BinFieldOrderField {
  /** Sort by dataCategory */
  DATA_CATEGORY = 'DATA_CATEGORY',
  /** Sort by dataType */
  DATA_TYPE = 'DATA_TYPE',
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by role */
  ROLE = 'ROLE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type BinFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: BinFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type BinField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type BinField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for BinField */
export type BinFieldsConnection = {
  __typename: 'BinFieldsConnection';
  /** List of nodes */
  nodes: Array<BinField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField = AnalyticsField & DataField & Field & FieldReferencingField & Node & {
  __typename: 'CalculatedField';
  /** Default aggregation of the field, i.e. 'Sum', 'Average'. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_aggregation.html#AggFuncs */
  aggregation: Maybe<Scalars['String']>;
  /** For the percentile aggregation, the percentile number */
  aggregationParam: Maybe<Scalars['String']>;
  /** Data category of the field */
  dataCategory: Maybe<FieldRoleCategory>;
  /** Type of the data in the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_typesandroles_datatypes.html */
  dataType: Maybe<FieldDataType>;
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** Default format for number or date */
  defaultFormat: Maybe<Scalars['String']>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** List of fields, if any, that this field references */
  fields: Array<Field>;
  /** List of fields, if any, that this field references */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Formula of the calculated field */
  formula: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** True if field formula that involves a user function (for example, USERNAME or ISMEMBEROF) */
  hasUserReference: Maybe<Scalars['Boolean']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if Tableau automatically created this field. A list of autogenerated fields are here: https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_understanddatawindow.html#AutoFields */
  isAutoGenerated: Maybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** List of parameters, if any, used in this field */
  parameters: Array<Parameter>;
  /** List of parameters, if any, used in this field */
  parametersConnection: Maybe<ParametersConnection>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Role of the field: 'dimension', 'measure' or 'unknown' */
  role: Maybe<FieldRole>;
  /** For geographic data, the geographic role of the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/maps_geographicroles.html */
  semanticRole: Maybe<Scalars['String']>;
  /** Sheet that contains this calculated field */
  sheet: Maybe<Sheet>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ParametersArgs = {
  filter: InputMaybe<Parameter_Filter>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ParametersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Parameter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a calculated field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_calculatedfields.html */
export type CalculatedField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum CalculatedFieldOrderField {
  /** Sort by dataCategory */
  DATA_CATEGORY = 'DATA_CATEGORY',
  /** Sort by dataType */
  DATA_TYPE = 'DATA_TYPE',
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by role */
  ROLE = 'ROLE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type CalculatedFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: CalculatedFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type CalculatedField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type CalculatedField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for CalculatedField */
export type CalculatedFieldsConnection = {
  __typename: 'CalculatedFieldsConnection';
  /** List of nodes */
  nodes: Array<CalculatedField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**
 * A content item that can have labels.
 * *Available in Tableau Cloud March 2023 / Server 2023.1 and later.*
 */
export type CanHaveLabels = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** The labels on a content item. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a content item. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** The name of the asset */
  name: Maybe<Scalars['String']>;
};


/**
 * A content item that can have labels.
 * *Available in Tableau Cloud March 2023 / Server 2023.1 and later.*
 */
export type CanHaveLabels_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A content item that can have labels.
 * *Available in Tableau Cloud March 2023 / Server 2023.1 and later.*
 */
export type CanHaveLabels_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum CanHaveLabelsOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type CanHaveLabelsSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: CanHaveLabelsOrderField;
};

/** Filter by GraphQL field and given value */
export type CanHaveLabels_Filter = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for CanHaveLabels */
export type CanHaveLabelsesConnection = {
  __typename: 'CanHaveLabelsesConnection';
  /** List of nodes */
  nodes: Array<CanHaveLabels>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  content item that can be certified */
export type Certifiable = {
  /** The data quality certifications on a content item */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a content item */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this content item contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** The name of the asset */
  name: Maybe<Scalars['String']>;
};


/**  content item that can be certified */
export type Certifiable_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  content item that can be certified */
export type Certifiable_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum CertifiableOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by luid */
  LUID = 'LUID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type CertifiableSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: CertifiableOrderField;
};

/** Filter by GraphQL field and given value */
export type Certifiable_Filter = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this content item contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this content item contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Certifiable */
export type CertifiablesConnection = {
  __typename: 'CertifiablesConnection';
  /** List of nodes */
  nodes: Array<Certifiable>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  cloud file connection */
export type CloudFile = CanHaveLabels & Certifiable & Database & Taggable & Warnable & {
  __typename: 'CloudFile';
  /**
   * Notes related to this database being marked as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certificationNote: Maybe<Scalars['String']>;
  /**
   * User who marked this database as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifier: Maybe<TableauUser>;
  /** Connection type shortname */
  connectionType: Maybe<Scalars['String']>;
  /** Contact for this database */
  contact: Maybe<TableauUser>;
  /** The data quality certifications on a database */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a database */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * The optional data quality warning on a database
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this database */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the database */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the database */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this database */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this database */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the database */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the database */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this database */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this database */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected to the database */
  downstreamLenses: Array<Lens>;
  /** Lenses connected to the database */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected to the database */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected to the database */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners connected to the database */
  downstreamOwners: Array<TableauUser>;
  /** Owners connected to the database */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the database */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the database */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this database */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this database */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the database */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the database */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** The file extension */
  fileExtension: Maybe<Scalars['String']>;
  /** The ID used by the provider for the cloud file. Each provider uses IDs in a different format. */
  fileId: Maybe<Scalars['String']>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this database contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** True if this database has its permission locked */
  isControlledPermissionsEnabled: Maybe<Scalars['Boolean']>;
  /** True if this file is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** True if this database has been grouped with other databases */
  isGrouped: Maybe<Scalars['Boolean']>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** The MIME type */
  mimeType: Maybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The provider of the cloud file, e.g., onedrive, google-sheets, dropbox, and box */
  provider: Maybe<Scalars['String']>;
  /** The custom SQL queries that reference this database */
  referencedByQueries: Maybe<Array<Maybe<CustomSqlTable>>>;
  /** The custom SQL queries that reference this database */
  referencedByQueriesConnection: Maybe<CustomSqlTablesConnection>;
  /** URL for requesting the cloud file */
  requestUrl: Maybe<Scalars['String']>;
  /** Tables belonging to this database */
  tables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** Tables belonging to this database */
  tablesConnection: Maybe<DatabaseTablesConnection>;
  /** Tags associated with the database */
  tags: Array<Tag>;
  /** Tags associated with the database */
  tagsConnection: Maybe<TagsConnection>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this database */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this database */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this database */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this database */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this database */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this database */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this database */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this database */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Vizportal ID of this database, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};


/**  cloud file connection */
export type CloudFile_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  cloud file connection */
export type CloudFile_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  cloud file connection */
export type CloudFile_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_ReferencedByQueriesArgs = {
  filter: InputMaybe<CustomSqlTable_Filter>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_ReferencedByQueriesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CustomSqlTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_TablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  cloud file connection */
export type CloudFile_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  cloud file connection */
export type CloudFile_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  cloud file connection */
export type CloudFile_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum CloudFileOrderField {
  /** Sort by connectionType */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamVirtualConnections count */
  DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT = 'DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by isEmbedded */
  IS_EMBEDDED = 'IS_EMBEDDED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type CloudFileSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: CloudFileOrderField;
};

/** Filter by GraphQL field and given value */
export type CloudFile_Filter = {
  /** Connection type shortname */
  connectionType: InputMaybe<Scalars['String']>;
  /** Connection type shortname */
  connectionTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the database has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this database contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this database contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if this file is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: InputMaybe<Scalars['Boolean']>;
  /** True if this file is embedded in Tableau content, e.g., a packaged workbook */
  isEmbeddedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Connection Type for CloudFile */
export type CloudFilesConnection = {
  __typename: 'CloudFilesConnection';
  /** List of nodes */
  nodes: Array<CloudFile>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** GraphQL type for a table column */
export type Column = CanHaveLabels & Node & Taggable & Warnable & {
  __typename: 'Column';
  /**
   * The optional data quality warning on this column.
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on this column. Available in Tableau Cloud October 2022 / Server 2022.3 and later. */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on this column. Available in Tableau Cloud October 2022 / Server 2022.3 and later. */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this column */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Columns downstream from the column */
  downstreamColumns: Array<Column>;
  /** Columns downstream from the column */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards downstream from the column */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards downstream from the column */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream from the column */
  downstreamDatabases: Array<Database>;
  /** Databases downstream from the column */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources downstream from the column */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources downstream from the column */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Fields downstream from the column */
  downstreamFields: Array<Field>;
  /** Fields downstream from the column */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream from the column */
  downstreamFlows: Array<Flow>;
  /** Flows downstream from the column */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses downstream from the column */
  downstreamLenses: Array<Lens>;
  /** Lenses downstream from the column */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics downstream from the column */
  downstreamMetrics: Array<Metric>;
  /** Metrics downstream from the column */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners of workbooks and published datasources downstream from the column */
  downstreamOwners: Array<TableauUser>;
  /** Owners of workbooks and published datasources downstream from the column */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets downstream from the column */
  downstreamSheets: Array<Sheet>;
  /** Sheets downstream from the column */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream from the column */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream from the column */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream from the column */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream from the column */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream from the column */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream from the column */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks downstream from the column */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks downstream from the column */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** True if this column has an active data quality warning. Available in Tableau Cloud October 2022 / Server 2022.3 and later. */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this column may contain null values */
  isNullable: Maybe<Scalars['Boolean']>;
  /** The labels on this column.  Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on this column.  Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name of column */
  name: Maybe<Scalars['String']>;
  /** The column field that references this column */
  referencedByFields: Maybe<Array<Maybe<ColumnField>>>;
  /** The column field that references this column */
  referencedByFieldsConnection: Maybe<ColumnFieldsConnection>;
  /** A flow input field that wraps this column */
  referencedByFlowColumnInputField: Maybe<Array<Maybe<FlowColumnInputField>>>;
  /** A flow input field that wraps this column */
  referencedByFlowColumnInputFieldConnection: Maybe<FlowColumnInputFieldsConnection>;
  /** A flow output field that wraps this column */
  referencedByFlowColumnOutputField: Maybe<Array<Maybe<FlowColumnOutputField>>>;
  /** A flow output field that wraps this column */
  referencedByFlowColumnOutputFieldConnection: Maybe<FlowColumnOutputFieldsConnection>;
  /** A column that logically represents this column. */
  referencedByRemoteColumn: Maybe<Array<Maybe<Column>>>;
  /** A column that logically represents this column. */
  referencedByRemoteColumnConnection: Maybe<ColumnsConnection>;
  /** A column that this column logically represents. */
  remoteColumn: Maybe<Column>;
  /** Remote type on the database. Types correspond to OLEDB types here: https://referencesource.microsoft.com/#system.data/System/Data/OleDb/OLEDB_Enum.cs,364 */
  remoteType: RemoteType;
  /** The table that this column belongs to */
  table: Maybe<Table>;
  /** Tags associated with the column */
  tags: Array<Tag>;
  /** Tags associated with the column */
  tagsConnection: Maybe<TagsConnection>;
  /** All upstream columns this column references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this column references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases upstream from the Table */
  upstreamDatabases: Array<Database>;
  /** Databases upstream from the Table */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream from this column */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream from this column */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this column */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this column */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the column */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the column */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables upstream from the column */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream from the column */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream from the column */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream from the column */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream from the column */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream from the column */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Vizportal ID of this column, for use in client-to-server communications */
  vizportalId: Maybe<Scalars['String']>;
};


/** GraphQL type for a table column */
export type Column_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a table column */
export type Column_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a table column */
export type Column_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByFieldsArgs = {
  filter: InputMaybe<ColumnField_Filter>;
  orderBy: InputMaybe<ColumnFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<ColumnField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByFlowColumnInputFieldArgs = {
  filter: InputMaybe<FlowColumnInputField_Filter>;
  orderBy: InputMaybe<FlowColumnInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByFlowColumnInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowColumnInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowColumnInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByFlowColumnOutputFieldArgs = {
  filter: InputMaybe<FlowColumnOutputField_Filter>;
  orderBy: InputMaybe<FlowColumnOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByFlowColumnOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowColumnOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowColumnOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByRemoteColumnArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_ReferencedByRemoteColumnConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** GraphQL type for a table column */
export type Column_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** GraphQL type for a table column */
export type Column_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a table column */
export type Column_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField = AnalyticsField & DataField & Field & Node & {
  __typename: 'ColumnField';
  /** Default aggregation of the field, i.e. 'Sum', 'Average'. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/calculations_aggregation.html#AggFuncs */
  aggregation: Maybe<Scalars['String']>;
  /** For the percentile aggregation, the percentile number */
  aggregationParam: Maybe<Scalars['String']>;
  /** List of columns, if any, that this field references */
  columns: Array<Column>;
  /** List of columns, if any, that this field references */
  columnsConnection: Maybe<ColumnsConnection>;
  /** Data category of the field */
  dataCategory: Maybe<FieldRoleCategory>;
  /** Type of the data in the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_typesandroles_datatypes.html */
  dataType: Maybe<FieldDataType>;
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** Default format for number or date */
  defaultFormat: Maybe<Scalars['String']>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Role of the field: 'dimension', 'measure' or 'unknown' */
  role: Maybe<FieldRole>;
  /** For geographic data, the geographic role of the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/maps_geographicroles.html */
  semanticRole: Maybe<Scalars['String']>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** ColumnFields are a type of field which directly connects to a column in some type of table. */
export type ColumnField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum ColumnFieldOrderField {
  /** Sort by dataCategory */
  DATA_CATEGORY = 'DATA_CATEGORY',
  /** Sort by dataType */
  DATA_TYPE = 'DATA_TYPE',
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by role */
  ROLE = 'ROLE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type ColumnFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: ColumnFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type ColumnField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type ColumnField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for ColumnField */
export type ColumnFieldsConnection = {
  __typename: 'ColumnFieldsConnection';
  /** List of nodes */
  nodes: Array<ColumnField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Enum for fields that can be used for sorting */
export enum ColumnOrderField {
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type ColumnSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: ColumnOrderField;
};

/** Filter by GraphQL field and given value */
export type Column_Filter = {
  /** True if this column has an active data quality warning. Available in Tableau Cloud October 2022 / Server 2022.3 and later. */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if this column has an active data quality warning. Available in Tableau Cloud October 2022 / Server 2022.3 and later. */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name of column */
  name: InputMaybe<Scalars['String']>;
  /** Name of column */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Filter by GraphQL field and given value */
export type Column_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name of column */
  name: InputMaybe<Scalars['String']>;
  /** Name of column */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Column */
export type ColumnsConnection = {
  __typename: 'ColumnsConnection';
  /** List of nodes */
  nodes: Array<Column>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField = Field & FieldReferencingField & Node & {
  __typename: 'CombinedField';
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** List of fields, if any, that this field references */
  fields: Array<Field>;
  /** List of fields, if any, that this field references */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined field. Combined fields concatanate fields together into one string. */
export type CombinedField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum CombinedFieldOrderField {
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type CombinedFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: CombinedFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type CombinedField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type CombinedField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for CombinedField */
export type CombinedFieldsConnection = {
  __typename: 'CombinedFieldsConnection';
  /** List of nodes */
  nodes: Array<CombinedField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField = Field & FieldReferencingField & Node & {
  __typename: 'CombinedSetField';
  /** How the sets are combined. 'All Members in Both Sets', 'Shared Members in Both Sets', or 'Except Shared Members' */
  combinationType: Maybe<Scalars['String']>;
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** Delimiter used to separate members of the two sets. Usually ',' or ';' */
  delimiter: Maybe<Scalars['String']>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** List of fields, if any, that this field references */
  fields: Array<Field>;
  /** List of fields, if any, that this field references */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a combined set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html#Combine */
export type CombinedSetField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum CombinedSetFieldOrderField {
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type CombinedSetFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: CombinedSetFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type CombinedSetField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type CombinedSetField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for CombinedSetField */
export type CombinedSetFieldsConnection = {
  __typename: 'CombinedSetFieldsConnection';
  /** List of nodes */
  nodes: Array<CombinedSetField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable = Table & {
  __typename: 'CustomSQLTable';
  /** Columns contained in this table */
  columns: Array<Column>;
  /** Columns contained in this table */
  columnsConnection: Maybe<ColumnsConnection>;
  /** Connection type shortname */
  connectionType: Maybe<Scalars['String']>;
  /** Database this query is executed on */
  database: Maybe<Database>;
  /** User modifiable description of this table */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the table */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the table */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this table */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this table */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the table */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the table */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this table */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this table */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from the table */
  downstreamLenses: Array<Lens>;
  /** Lenses connected downstream from the table */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the table */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected downstream from the table */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwners: Array<TableauUser>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the table */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the table */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this table */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this table */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this table */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this table */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection downstream of this table */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection downstream of this table */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the table */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the table */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** A custom SQL tables is always embedded in Tableau content */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** True if the query is unsupported by Tableau Catalog, in which case lineage may be incomplete */
  isUnsupportedCustomSql: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Text of the query */
  query: Maybe<Scalars['String']>;
  /** Actual tables that this query references. */
  tables: Array<DatabaseTable>;
  /** Actual tables that this query references. */
  tablesConnection: Maybe<DatabaseTablesConnection>;
  /** Databases upstream of this table */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this table */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this table */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this table */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this table */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this table */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables upstream of this table */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this table */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_ColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_ColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_TablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that represents the result of evaluating a custom SQL query. These "tables" are owned by the Tableau data source (embedded or published) which contains the SQL query, so they only exist within that data source. */
export type CustomSqlTable_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum CustomSqlTableOrderField {
  /** Sort by columns count */
  COLUMNS_COUNT = 'COLUMNS_COUNT',
  /** Sort by downstreamDashboards count */
  DOWNSTREAM_DASHBOARDS_COUNT = 'DOWNSTREAM_DASHBOARDS_COUNT',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isUnsupportedCustomSql */
  IS_UNSUPPORTED_CUSTOM_SQL = 'IS_UNSUPPORTED_CUSTOM_SQL',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type CustomSqlTableSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: CustomSqlTableOrderField;
};

/** Filter by GraphQL field and given value */
export type CustomSqlTable_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the query is unsupported by Tableau Catalog, in which case lineage may be incomplete */
  isUnsupportedCustomSql: InputMaybe<Scalars['Boolean']>;
  /** True if the query is unsupported by Tableau Catalog, in which case lineage may be incomplete */
  isUnsupportedCustomSqlWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Connection Type for CustomSQLTable */
export type CustomSqlTablesConnection = {
  __typename: 'CustomSQLTablesConnection';
  /** List of nodes */
  nodes: Array<CustomSqlTable>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  dashboard contained in a published workbook. */
export type Dashboard = Taggable & View & {
  __typename: 'Dashboard';
  /** AskDataExtensions that are added into this dashboard */
  askDataExtensions: Array<AskDataExtension>;
  /** AskDataExtensions that are added into this dashboard */
  askDataExtensionsConnection: Maybe<AskDataExtensionsConnection>;
  /** Time the dashboard was created */
  createdAt: Scalars['DateTime'];
  /** Unique ID for the dashboard generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewId: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Index of view; the order it appears in the workbook */
  index: Maybe<Scalars['Int']>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if worksheet is hidden in Workbook) */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Server path to dashboard */
  path: Maybe<Scalars['String']>;
  /** The Metrics that reference this View */
  referencedByMetrics: Maybe<Array<Maybe<Metric>>>;
  /** The Metrics that reference this View */
  referencedByMetricsConnection: Maybe<MetricsConnection>;
  /** Sheets referenced by this dashboard */
  sheets: Array<Sheet>;
  /** Sheets referenced by this dashboard */
  sheetsConnection: Maybe<SheetsConnection>;
  /** Tags associated with the view */
  tags: Array<Tag>;
  /** Tags associated with the view */
  tagsConnection: Maybe<TagsConnection>;
  /** Time the dashboard was updated */
  updatedAt: Scalars['DateTime'];
  /** The columns that are upstream of this dashboard */
  upstreamColumns: Maybe<Array<Maybe<Column>>>;
  /** The columns that are upstream of this dashboard */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Data quality warnings upstream from this dashboard */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this dashboard */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** The databases that are upstream of this dashboard */
  upstreamDatabases: Maybe<Array<Maybe<Database>>>;
  /** The databases that are upstream of this dashboard */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** The data sources that are upstream of this dashboard */
  upstreamDatasources: Maybe<Array<Maybe<Datasource>>>;
  /** The data sources that are upstream of this dashboard */
  upstreamDatasourcesConnection: Maybe<DatasourcesConnection>;
  /** The fields that are upstream of this dashboard */
  upstreamFields: Maybe<Array<Maybe<Field>>>;
  /** The fields that are upstream of this dashboard */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** The flows that are upstream of this dashboard */
  upstreamFlows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that are upstream of this dashboard */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this dashboard Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this dashboard Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** The Lenses that are upstream of this dashboard */
  upstreamLenses: Maybe<Array<Maybe<Lens>>>;
  /** The Lenses that are upstream of this dashboard */
  upstreamLensesConnection: Maybe<LensesConnection>;
  /** Sheet field instances used by the sheets referenced by this dashboard */
  upstreamSheetFieldInstances: Maybe<Array<Maybe<Field>>>;
  /** Sheet field instances used by the sheets referenced by this dashboard */
  upstreamSheetFieldInstancesConnection: Maybe<FieldsConnection>;
  /** The tables that are upstream of this dashboard */
  upstreamTables: Maybe<Array<Maybe<Table>>>;
  /** The tables that are upstream of this dashboard */
  upstreamTablesConnection: Maybe<TablesConnection>;
  /** The workbook that contains this view */
  workbook: Maybe<Workbook>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_AskDataExtensionsArgs = {
  filter: InputMaybe<AskDataExtension_Filter>;
  orderBy: InputMaybe<AskDataExtensionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_AskDataExtensionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<AskDataExtension_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<AskDataExtensionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_ReferencedByMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_ReferencedByMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamDatasourcesArgs = {
  filter: InputMaybe<Datasource_Filter>;
  orderBy: InputMaybe<DatasourceSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Datasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamSheetFieldInstancesArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamSheetFieldInstancesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamTablesArgs = {
  filter: InputMaybe<Table_Filter>;
  orderBy: InputMaybe<TableSortOrder>;
};


/**  dashboard contained in a published workbook. */
export type Dashboard_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Table_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableSortOrder>;
};

/** Enum for fields that can be used for sorting */
export enum DashboardOrderField {
  /** Sort by documentViewId */
  DOCUMENT_VIEW_ID = 'DOCUMENT_VIEW_ID',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by path */
  PATH = 'PATH'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DashboardSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DashboardOrderField;
};

/** Filter by GraphQL field and given value */
export type Dashboard_Filter = {
  /** Unique ID for the dashboard generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewId: InputMaybe<Scalars['String']>;
  /** Unique ID for the dashboard generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if worksheet is hidden in Workbook) */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if worksheet is hidden in Workbook) */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Server path to dashboard */
  path: InputMaybe<Scalars['String']>;
  /** Server path to dashboard */
  pathWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Dashboard */
export type DashboardsConnection = {
  __typename: 'DashboardsConnection';
  /** List of nodes */
  nodes: Array<Dashboard>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField = {
  /** Data category of the field */
  dataCategory: Maybe<FieldRoleCategory>;
  /** Type of the data in the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_typesandroles_datatypes.html */
  dataType: Maybe<FieldDataType>;
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Role of the field: 'dimension', 'measure' or 'unknown' */
  role: Maybe<FieldRole>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field containing data. Most types of Fields will implement this interface with exceptions like HierarchyField. */
export type DataField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum DataFieldOrderField {
  /** Sort by dataCategory */
  DATA_CATEGORY = 'DATA_CATEGORY',
  /** Sort by dataType */
  DATA_TYPE = 'DATA_TYPE',
  /** Sort by id */
  ID = 'ID',
  /** Sort by role */
  ROLE = 'ROLE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DataFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DataFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type DataField_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for DataField */
export type DataFieldsConnection = {
  __typename: 'DataFieldsConnection';
  /** List of nodes */
  nodes: Array<DataField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  data quality certification associated with a content item */
export type DataQualityCertification = Label & {
  __typename: 'DataQualityCertification';
  /** The asset that contains the data quality certification */
  asset: Maybe<CanHaveLabels>;
  /** User who last updated this data quality certification */
  author: Maybe<TableauUser>;
  /** Name of the user who last updated this data quality certification */
  authorDisplayName: Maybe<Scalars['String']>;
  /** Category of the label */
  category: Scalars['String'];
  /** Time the data quality certification was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the data quality certification is active */
  isActive: Scalars['Boolean'];
  /** True if the data quality certification is elevated */
  isElevated: Scalars['Boolean'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Message of the data quality certification */
  message: Maybe<Scalars['String']>;
  /** Time the data quality certification was last updated */
  updatedAt: Scalars['DateTime'];
  /** Value of the label */
  value: Scalars['String'];
  /** Vizportal ID of this data quality certifcation, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};

/** Enum for fields that can be used for sorting */
export enum DataQualityCertificationOrderField {
  /** Sort by category */
  CATEGORY = 'CATEGORY',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isActive */
  IS_ACTIVE = 'IS_ACTIVE',
  /** Sort by isElevated */
  IS_ELEVATED = 'IS_ELEVATED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by value */
  VALUE = 'VALUE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DataQualityCertificationSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DataQualityCertificationOrderField;
};

/** Filter by GraphQL field and given value */
export type DataQualityCertification_Filter = {
  /** Category of the label */
  category: InputMaybe<Scalars['String']>;
  /** Category of the label */
  categoryWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the data quality certification is active */
  isActive: InputMaybe<Scalars['Boolean']>;
  /** True if the data quality certification is active */
  isActiveWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if the data quality certification is elevated */
  isElevated: InputMaybe<Scalars['Boolean']>;
  /** True if the data quality certification is elevated */
  isElevatedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Value of the label */
  value: InputMaybe<Scalars['String']>;
  /** Value of the label */
  valueWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for DataQualityCertification */
export type DataQualityCertificationsConnection = {
  __typename: 'DataQualityCertificationsConnection';
  /** List of nodes */
  nodes: Array<DataQualityCertification>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  data quality warning associated with a content item */
export type DataQualityWarning = Label & {
  __typename: 'DataQualityWarning';
  /** The asset that contains the data quality warning */
  asset: Maybe<CanHaveLabels>;
  /** User who last updated this data quality warning */
  author: Maybe<TableauUser>;
  /** Name of the user who last updated this data quality warning */
  authorDisplayName: Maybe<Scalars['String']>;
  /** Category of the label */
  category: Scalars['String'];
  /** Time the data quality warning was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the data quality warning is active */
  isActive: Scalars['Boolean'];
  /** True if the data quality warning is elevated */
  isElevated: Scalars['Boolean'];
  /**
   * Synonymous with isElevated
   * @deprecated Use 'isElevated'
   */
  isSevere: Scalars['Boolean'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Message of the data quality warning */
  message: Maybe<Scalars['String']>;
  /** Time the data quality warning was last updated */
  updatedAt: Scalars['DateTime'];
  /** Value of the label */
  value: Scalars['String'];
  /** Vizportal ID of this data quality warning, for use in client-to-server communications */
  vizportalId: Scalars['String'];
  /**
   * Synonymous with value
   * @deprecated Use 'value'
   */
  warningType: Scalars['String'];
};

/** Enum for fields that can be used for sorting */
export enum DataQualityWarningOrderField {
  /** Sort by category */
  CATEGORY = 'CATEGORY',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isActive */
  IS_ACTIVE = 'IS_ACTIVE',
  /** Sort by isElevated */
  IS_ELEVATED = 'IS_ELEVATED',
  /** Sort by isSevere */
  IS_SEVERE = 'IS_SEVERE',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by value */
  VALUE = 'VALUE',
  /** Sort by warningType */
  WARNING_TYPE = 'WARNING_TYPE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DataQualityWarningSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DataQualityWarningOrderField;
};

/** Filter by GraphQL field and given value */
export type DataQualityWarning_Filter = {
  /** Category of the label */
  category: InputMaybe<Scalars['String']>;
  /** Category of the label */
  categoryWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the data quality warning is active */
  isActive: InputMaybe<Scalars['Boolean']>;
  /** True if the data quality warning is active */
  isActiveWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if the data quality warning is elevated */
  isElevated: InputMaybe<Scalars['Boolean']>;
  /** True if the data quality warning is elevated */
  isElevatedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Synonymous with isElevated */
  isSevere: InputMaybe<Scalars['Boolean']>;
  /** Synonymous with isElevated */
  isSevereWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Value of the label */
  value: InputMaybe<Scalars['String']>;
  /** Value of the label */
  valueWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Synonymous with value */
  warningType: InputMaybe<Scalars['String']>;
  /** Synonymous with value */
  warningTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for DataQualityWarning */
export type DataQualityWarningsConnection = {
  __typename: 'DataQualityWarningsConnection';
  /** List of nodes */
  nodes: Array<DataQualityWarning>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  database containing tables */
export type Database = {
  /**
   * Notes related to this database being marked as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certificationNote: Maybe<Scalars['String']>;
  /**
   * User who marked this database as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifier: Maybe<TableauUser>;
  /** Connection type shortname */
  connectionType: Maybe<Scalars['String']>;
  /** Contact for this database */
  contact: Maybe<TableauUser>;
  /** The data quality certifications on a database */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a database */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * The optional data quality warning on a database
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this database */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the database */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the database */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this database */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this database */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the database */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the database */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this database */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this database */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected to the database */
  downstreamLenses: Array<Lens>;
  /** Lenses connected to the database */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected to the database */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected to the database */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners connected to the database */
  downstreamOwners: Array<TableauUser>;
  /** Owners connected to the database */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the database */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the database */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this database */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this database */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the database */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the database */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this database contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** True if this database has its permission locked */
  isControlledPermissionsEnabled: Maybe<Scalars['Boolean']>;
  /** True if this database is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** True if this database has been grouped with other databases */
  isGrouped: Maybe<Scalars['Boolean']>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The custom SQL queries that reference this database */
  referencedByQueries: Maybe<Array<Maybe<CustomSqlTable>>>;
  /** The custom SQL queries that reference this database */
  referencedByQueriesConnection: Maybe<CustomSqlTablesConnection>;
  /** Tables belonging to this database */
  tables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** Tables belonging to this database */
  tablesConnection: Maybe<DatabaseTablesConnection>;
  /** Tags associated with the database */
  tags: Array<Tag>;
  /** Tags associated with the database */
  tagsConnection: Maybe<TagsConnection>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this database */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this database */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this database */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this database */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this database */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this database */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this database */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this database */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Vizportal ID of this database, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};


/**  database containing tables */
export type Database_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  database containing tables */
export type Database_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  database containing tables */
export type Database_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_ReferencedByQueriesArgs = {
  filter: InputMaybe<CustomSqlTable_Filter>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_ReferencedByQueriesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CustomSqlTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_TablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  database containing tables */
export type Database_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  database containing tables */
export type Database_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database containing tables */
export type Database_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum DatabaseOrderField {
  /** Sort by connectionType */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamVirtualConnections count */
  DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT = 'DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by isEmbedded */
  IS_EMBEDDED = 'IS_EMBEDDED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME'
}

/**  database server connection */
export type DatabaseServer = CanHaveLabels & Certifiable & Database & Taggable & Warnable & {
  __typename: 'DatabaseServer';
  /**
   * Notes related to this database being marked as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certificationNote: Maybe<Scalars['String']>;
  /**
   * User who marked this database as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifier: Maybe<TableauUser>;
  /** Connection type shortname */
  connectionType: Maybe<Scalars['String']>;
  /** Contact for this database */
  contact: Maybe<TableauUser>;
  /** The data quality certifications on a database */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a database */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * The optional data quality warning on a database
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this database */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the database */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the database */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this database */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this database */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the database */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the database */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this database */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this database */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected to the database */
  downstreamLenses: Array<Lens>;
  /** Lenses connected to the database */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected to the database */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected to the database */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners connected to the database */
  downstreamOwners: Array<TableauUser>;
  /** Owners connected to the database */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the database */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the database */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this database */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this database */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the database */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the database */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** optional Extended Connection info for specific connection types, eg hive for Cloudera Hadoop */
  extendedConnectionType: Maybe<Scalars['String']>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Hostname of the database */
  hostName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this database contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** True if this database has its permission locked */
  isControlledPermissionsEnabled: Maybe<Scalars['Boolean']>;
  /** A database server is never embedded in Tableau content */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** True if this database has been grouped with other databases */
  isGrouped: Maybe<Scalars['Boolean']>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Port number of the database connection */
  port: Maybe<Scalars['Int']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The custom SQL queries that reference this database */
  referencedByQueries: Maybe<Array<Maybe<CustomSqlTable>>>;
  /** The custom SQL queries that reference this database */
  referencedByQueriesConnection: Maybe<CustomSqlTablesConnection>;
  /** service string for certain datasources eg Oracle */
  service: Maybe<Scalars['String']>;
  /** Tables belonging to this database */
  tables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** Tables belonging to this database */
  tablesConnection: Maybe<DatabaseTablesConnection>;
  /** Tags associated with the database */
  tags: Array<Tag>;
  /** Tags associated with the database */
  tagsConnection: Maybe<TagsConnection>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this database */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this database */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this database */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this database */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this database */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this database */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this database */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this database */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Vizportal ID of this database, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};


/**  database server connection */
export type DatabaseServer_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  database server connection */
export type DatabaseServer_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  database server connection */
export type DatabaseServer_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_ReferencedByQueriesArgs = {
  filter: InputMaybe<CustomSqlTable_Filter>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_ReferencedByQueriesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CustomSqlTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_TablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  database server connection */
export type DatabaseServer_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  database server connection */
export type DatabaseServer_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  database server connection */
export type DatabaseServer_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum DatabaseServerOrderField {
  /** Sort by connectionType */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamVirtualConnections count */
  DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT = 'DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by hostName */
  HOST_NAME = 'HOST_NAME',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by isEmbedded */
  IS_EMBEDDED = 'IS_EMBEDDED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DatabaseServerSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DatabaseServerOrderField;
};

/** Filter by GraphQL field and given value */
export type DatabaseServer_Filter = {
  /** Connection type shortname */
  connectionType: InputMaybe<Scalars['String']>;
  /** Connection type shortname */
  connectionTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the database has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Hostname of the database */
  hostName: InputMaybe<Scalars['String']>;
  /** Hostname of the database */
  hostNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this database contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this database contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** A database server is never embedded in Tableau content */
  isEmbedded: InputMaybe<Scalars['Boolean']>;
  /** A database server is never embedded in Tableau content */
  isEmbeddedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Connection Type for DatabaseServer */
export type DatabaseServersConnection = {
  __typename: 'DatabaseServersConnection';
  /** List of nodes */
  nodes: Array<DatabaseServer>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DatabaseSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DatabaseOrderField;
};

/**  table that is contained in a database */
export type DatabaseTable = CanHaveLabels & Certifiable & Table & Taggable & Warnable & {
  __typename: 'DatabaseTable';
  /**
   * Notes related to the database table being marked as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certificationNote: Maybe<Scalars['String']>;
  /**
   * User who marked this table as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifier: Maybe<TableauUser>;
  /** Columns contained in this table */
  columns: Array<Column>;
  /** Columns contained in this table */
  columnsConnection: Maybe<ColumnsConnection>;
  /** Connection type of parent database */
  connectionType: Maybe<Scalars['String']>;
  /** Contact for this table */
  contact: Maybe<TableauUser>;
  /** The data quality certifications on a table */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a table */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * The optional data quality warning on a table
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a table */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a table */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** The database to which this table belongs */
  database: Maybe<Database>;
  /** User modifiable description of this table */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected downstream from the table */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the table */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this table */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this table */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the table */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the table */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this table */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this table */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from the table */
  downstreamLenses: Array<Lens>;
  /** Lenses connected downstream from the table */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the table */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected downstream from the table */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwners: Array<TableauUser>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the table */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the table */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this table */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this table */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream from this table */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream from this table */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream from this table */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream from this table */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the table */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the table */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Fully qualified table name */
  fullName: Maybe<Scalars['String']>;
  /** True if the table has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this table contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** True if this table is embedded in Tableau content */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** The labels on a table. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a table. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The custom SQL queries that reference this table */
  referencedByQueries: Maybe<Array<Maybe<CustomSqlTable>>>;
  /** The custom SQL queries that reference this table */
  referencedByQueriesConnection: Maybe<CustomSqlTablesConnection>;
  /**
   *  Name of table schema.
   *
   *  Note: For some databases, such as Amazon Athena and Exasol, the schema attribute may not return the correct schema name for the table. For more information, see https://help.tableau.com/current/api/metadata_api/en-us/docs/meta_api_model.html#schema_attribute.
   *
   */
  schema: Maybe<Scalars['String']>;
  /** Tags associated with the table */
  tags: Array<Tag>;
  /** Tags associated with the table */
  tagsConnection: Maybe<TagsConnection>;
  /** Data quality warnings upstream from this table */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this table */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this table */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this table */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this table */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this table */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this table */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this table */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this table. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this table. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this table */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this table */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream from this table */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream from this table */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream from this table */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream from this table */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Vizportal ID of this table, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};


/**  table that is contained in a database */
export type DatabaseTable_ColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_ColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_ReferencedByQueriesArgs = {
  filter: InputMaybe<CustomSqlTable_Filter>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_ReferencedByQueriesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CustomSqlTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  table that is contained in a database */
export type DatabaseTable_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table that is contained in a database */
export type DatabaseTable_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum DatabaseTableOrderField {
  /** Sort by columns count */
  COLUMNS_COUNT = 'COLUMNS_COUNT',
  /** Sort by connectionType */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Sort by downstreamDashboards count */
  DOWNSTREAM_DASHBOARDS_COUNT = 'DOWNSTREAM_DASHBOARDS_COUNT',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamVirtualConnections count */
  DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT = 'DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by fullName */
  FULL_NAME = 'FULL_NAME',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by isEmbedded */
  IS_EMBEDDED = 'IS_EMBEDDED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME',
  /** Sort by schema */
  SCHEMA = 'SCHEMA'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DatabaseTableSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DatabaseTableOrderField;
};

/** Filter by GraphQL field and given value */
export type DatabaseTable_Filter = {
  /** Connection type of parent database */
  connectionType: InputMaybe<Scalars['String']>;
  /** Connection type of parent database */
  connectionTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Fully qualified table name */
  fullName: InputMaybe<Scalars['String']>;
  /** Fully qualified table name */
  fullNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the table has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the table has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this table contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this table contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if this table is embedded in Tableau content */
  isEmbedded: InputMaybe<Scalars['Boolean']>;
  /** True if this table is embedded in Tableau content */
  isEmbeddedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   *  Name of table schema.
   *
   *  Note: For some databases, such as Amazon Athena and Exasol, the schema attribute may not return the correct schema name for the table. For more information, see https://help.tableau.com/current/api/metadata_api/en-us/docs/meta_api_model.html#schema_attribute.
   *
   */
  schema: InputMaybe<Scalars['String']>;
  /**
   *  Name of table schema.
   *
   *  Note: For some databases, such as Amazon Athena and Exasol, the schema attribute may not return the correct schema name for the table. For more information, see https://help.tableau.com/current/api/metadata_api/en-us/docs/meta_api_model.html#schema_attribute.
   *
   */
  schemaWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Connection Type for DatabaseTable */
export type DatabaseTablesConnection = {
  __typename: 'DatabaseTablesConnection';
  /** List of nodes */
  nodes: Array<DatabaseTable>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Filter by GraphQL field and given value */
export type Database_Filter = {
  /** Connection type shortname */
  connectionType: InputMaybe<Scalars['String']>;
  /** Connection type shortname */
  connectionTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the database has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this database contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this database contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if this database is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: InputMaybe<Scalars['Boolean']>;
  /** True if this database is embedded in Tableau content, e.g., a packaged workbook */
  isEmbeddedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Connection Type for Database */
export type DatabasesConnection = {
  __typename: 'DatabasesConnection';
  /** List of nodes */
  nodes: Array<Database>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource = {
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: Maybe<Scalars['Boolean']>;
  /** Time the datasource was created. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Data source filters contained in this data source */
  datasourceFilters: Array<DatasourceFilter>;
  /** Data source filters contained in this data source */
  datasourceFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** Dashboards downstream from this data source */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards downstream from this data source */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Workbook owners downstream from this data source */
  downstreamOwners: Array<TableauUser>;
  /** Workbook owners downstream from this data source */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets downstream from this data source */
  downstreamSheets: Array<Sheet>;
  /** Sheets downstream from this data source */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Workbooks downstream from this data source */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks downstream from this data source */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Time an extract was last incrementally updated */
  extractLastIncrementalUpdateTime: Maybe<Scalars['DateTime']>;
  /** Time an extract was last fully refreshed */
  extractLastRefreshTime: Maybe<Scalars['DateTime']>;
  /** Time an extract was last updated by either a full refresh, incremental update, or creation */
  extractLastUpdateTime: Maybe<Scalars['DateTime']>;
  /** Fields usable in workbooks connected to this data source */
  fields: Array<Field>;
  /** Fields usable in workbooks connected to this data source */
  fieldsConnection: Maybe<FieldsConnection>;
  /** True if datasource contains extracted data */
  hasExtracts: Maybe<Scalars['Boolean']>;
  /** True if data source contains a formula that involves a user function (for example, USERNAME or ISMEMBEROF) */
  hasUserReference: Maybe<Scalars['Boolean']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** The lenses derived from this datasource */
  lenses: Maybe<Array<Maybe<Lens>>>;
  /** The lenses derived from this datasource */
  lensesConnection: Maybe<LensesConnection>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Time the datasource was last updated. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Databases upstream from this data source */
  upstreamDatabases: Array<Database>;
  /** Databases upstream from this data source */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Tables upstream from this data source */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream from this data source */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DatasourceFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DatasourceFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_LensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_LensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Root GraphQL type for embedded and published data sources
 *
 * Data sources are a way to represent how Tableau Desktop and Tableau Server model and connect to data. Data sources can be published separately, as a published data source, or may be contained in a workbook as an embedded data source.
 *
 * See https://onlinehelp.tableau.com/current/server/en-us/datasource.htm
 */
export type Datasource_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField = Field & Node & {
  __typename: 'DatasourceField';
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Reference to a field from a published data source. This property only exists on Fields that are in an embedded data source with a connection to a published data source. */
  remoteField: Maybe<Field>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a data source field. Data source fields can only exist in embedded data sources which connect to a published data source. A data source field is an embedded data source's 'layered' representation of a field that already exists in the published data source and is mostly a copy of the field in the published data source. Data source fields can get their own descriptions and renames local to the embedded data source, but cannot otherwise be modified in the embedded data source. */
export type DatasourceField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum DatasourceFieldOrderField {
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DatasourceFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DatasourceFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type DatasourceField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type DatasourceField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for DatasourceField */
export type DatasourceFieldsConnection = {
  __typename: 'DatasourceFieldsConnection';
  /** List of nodes */
  nodes: Array<DatasourceField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**
 * Data source filters include/exclude certain values from a single field to filter out rows of data from this data source. For data security reasons, we don't track the values used in the filter in this schema, but you can see the field used in the filter.
 *
 * See https://onlinehelp.tableau.com/current/pro/desktop/en-us/filtering_datasource.html
 */
export type DatasourceFilter = {
  __typename: 'DatasourceFilter';
  /** Data source that contains this datasource filter */
  datasource: Maybe<Datasource>;
  /** Field used by this filter. */
  field: Field;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
};

/** Enum for fields that can be used for sorting */
export enum DatasourceFilterOrderField {
  /** Sort by id */
  ID = 'ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DatasourceFilterSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DatasourceFilterOrderField;
};

/** Filter by GraphQL field and given value */
export type DatasourceFilter_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for DatasourceFilter */
export type DatasourceFiltersConnection = {
  __typename: 'DatasourceFiltersConnection';
  /** List of nodes */
  nodes: Array<DatasourceFilter>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Enum for fields that can be used for sorting */
export enum DatasourceOrderField {
  /** Sort by containsUnsupportedCustomSql */
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = 'CONTAINS_UNSUPPORTED_CUSTOM_SQL',
  /** Sort by downstreamOwners count */
  DOWNSTREAM_OWNERS_COUNT = 'DOWNSTREAM_OWNERS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type DatasourceSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: DatasourceOrderField;
};

/** Filter by GraphQL field and given value */
export type Datasource_Filter = {
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: InputMaybe<Scalars['Boolean']>;
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSqlWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Datasource */
export type DatasourcesConnection = {
  __typename: 'DatasourcesConnection';
  /** List of nodes */
  nodes: Array<Datasource>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  data source embedded in a workbook */
export type EmbeddedDatasource = Datasource & {
  __typename: 'EmbeddedDatasource';
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: Maybe<Scalars['Boolean']>;
  /** Time the datasource was created. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Data source filters contained in this data source */
  datasourceFilters: Array<DatasourceFilter>;
  /** Data source filters contained in this data source */
  datasourceFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** Dashboards downstream from this data source */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards downstream from this data source */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Flows downstream from this data source */
  downstreamFlows: Array<Flow>;
  /** Flows downstream from this data source */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Workbook owners downstream from this data source */
  downstreamOwners: Array<TableauUser>;
  /** Workbook owners downstream from this data source */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets downstream from this data source */
  downstreamSheets: Array<Sheet>;
  /** Sheets downstream from this data source */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Workbooks downstream from this data source */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks downstream from this data source */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Time an extract was last incrementally updated */
  extractLastIncrementalUpdateTime: Maybe<Scalars['DateTime']>;
  /** Time an extract was last fully refreshed */
  extractLastRefreshTime: Maybe<Scalars['DateTime']>;
  /** Time an extract was last updated by either a full refresh, incremental update, or creation */
  extractLastUpdateTime: Maybe<Scalars['DateTime']>;
  /** Fields, usually measures or dimensions, contained in the data source */
  fields: Array<Field>;
  /** Fields, usually measures or dimensions, contained in the data source */
  fieldsConnection: Maybe<FieldsConnection>;
  /** True if datasource contains extracted data */
  hasExtracts: Maybe<Scalars['Boolean']>;
  /** True if data source contains a formula that involves a user function (for example, USERNAME or ISMEMBEROF) */
  hasUserReference: Maybe<Scalars['Boolean']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** The lenses derived from this datasource */
  lenses: Maybe<Array<Maybe<Lens>>>;
  /** The lenses derived from this datasource */
  lensesConnection: Maybe<LensesConnection>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Parent published data sources of this embedded data source */
  parentPublishedDatasources: Array<PublishedDatasource>;
  /** Parent published data sources of this embedded data source */
  parentPublishedDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Time the datasource was last updated. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Data quality warnings upstream from this data source */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this data source */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream from this data source */
  upstreamDatabases: Array<Database>;
  /** Databases upstream from this data source */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream from this data source */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream from this data source */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream from this data source */
  upstreamFlows: Array<Flow>;
  /** Flows upstream from this data source */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this data source. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this data source. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream from this data source */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream from this data source */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Workbook that contains these embedded datasources */
  workbook: Maybe<Workbook>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DatasourceFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DatasourceFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_LensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_LensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_ParentPublishedDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_ParentPublishedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  data source embedded in a workbook */
export type EmbeddedDatasource_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum EmbeddedDatasourceOrderField {
  /** Sort by containsUnsupportedCustomSql */
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = 'CONTAINS_UNSUPPORTED_CUSTOM_SQL',
  /** Sort by downstreamOwners count */
  DOWNSTREAM_OWNERS_COUNT = 'DOWNSTREAM_OWNERS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type EmbeddedDatasourceSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: EmbeddedDatasourceOrderField;
};

/** Filter by GraphQL field and given value */
export type EmbeddedDatasource_Filter = {
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: InputMaybe<Scalars['Boolean']>;
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSqlWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for EmbeddedDatasource */
export type EmbeddedDatasourcesConnection = {
  __typename: 'EmbeddedDatasourcesConnection';
  /** List of nodes */
  nodes: Array<EmbeddedDatasource>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Possible types of extract */
export enum ExtractType {
  FULL = 'FULL',
  INCREMENTAL = 'INCREMENTAL'
}

/** Filter by GraphQL field and given value */
export type ExtractType_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Base GraphQL type for a field */
export type Field = {
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** Downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server */
  name: Maybe<Scalars['String']>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** Base GraphQL type for a field */
export type Field_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field */
export type Field_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Possible data types for a field. */
export enum FieldDataType {
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  INTEGER = 'INTEGER',
  REAL = 'REAL',
  SPATIAL = 'SPATIAL',
  STRING = 'STRING',
  TABLE = 'TABLE',
  TUPLE = 'TUPLE',
  UNKNOWN = 'UNKNOWN'
}

/** Filter by GraphQL field and given value */
export type FieldDataType_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Enum for fields that can be used for sorting */
export enum FieldOrderField {
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME'
}

/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField = {
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Fields referenced by this field */
  fields: Array<Field>;
  /** Fields referenced by this field */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Base GraphQL type for a field that references another field. For example, a CalculatedField can reference a ColumnField in its formula. */
export type FieldReferencingField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FieldReferencingFieldOrderField {
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FieldReferencingFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FieldReferencingFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type FieldReferencingField_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for FieldReferencingField */
export type FieldReferencingFieldsConnection = {
  __typename: 'FieldReferencingFieldsConnection';
  /** List of nodes */
  nodes: Array<FieldReferencingField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Possible roles of a field. */
export enum FieldRole {
  DIMENSION = 'DIMENSION',
  MEASURE = 'MEASURE',
  UNKNOWN = 'UNKNOWN'
}

/** Possible categories of a field role. */
export enum FieldRoleCategory {
  NOMINAL = 'NOMINAL',
  ORDINAL = 'ORDINAL',
  QUANTITATIVE = 'QUANTITATIVE',
  UNKNOWN = 'UNKNOWN'
}

/** Filter by GraphQL field and given value */
export type FieldRoleCategory_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Filter by GraphQL field and given value */
export type FieldRole_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FieldOrderField;
};

/** Filter by GraphQL field and given value */
export type Field_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type Field_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Field */
export type FieldsConnection = {
  __typename: 'FieldsConnection';
  /** List of nodes */
  nodes: Array<Field>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  file connection */
export type File = CanHaveLabels & Certifiable & Database & Taggable & Warnable & {
  __typename: 'File';
  /**
   * Notes related to this database being marked as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certificationNote: Maybe<Scalars['String']>;
  /**
   * User who marked this database as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifier: Maybe<TableauUser>;
  /** Connection type shortname */
  connectionType: Maybe<Scalars['String']>;
  /** Contact for this database */
  contact: Maybe<TableauUser>;
  /** The data quality certifications on a database */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a database */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * The optional data quality warning on a database
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this database */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the database */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the database */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this database */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this database */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the database */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the database */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this database */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this database */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected to the database */
  downstreamLenses: Array<Lens>;
  /** Lenses connected to the database */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected to the database */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected to the database */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners connected to the database */
  downstreamOwners: Array<TableauUser>;
  /** Owners connected to the database */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the database */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the database */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this database */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this database */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the database */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the database */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Path to file */
  filePath: Maybe<Scalars['String']>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this database contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** True if this database has its permission locked */
  isControlledPermissionsEnabled: Maybe<Scalars['Boolean']>;
  /** True if this file is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** True if this database has been grouped with other databases */
  isGrouped: Maybe<Scalars['Boolean']>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The custom SQL queries that reference this database */
  referencedByQueries: Maybe<Array<Maybe<CustomSqlTable>>>;
  /** The custom SQL queries that reference this database */
  referencedByQueriesConnection: Maybe<CustomSqlTablesConnection>;
  /** Tables belonging to this database */
  tables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** Tables belonging to this database */
  tablesConnection: Maybe<DatabaseTablesConnection>;
  /** Tags associated with the database */
  tags: Array<Tag>;
  /** Tags associated with the database */
  tagsConnection: Maybe<TagsConnection>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this database */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this database */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this database */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this database */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this database */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this database */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this database */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this database */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Vizportal ID of this database, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};


/**  file connection */
export type File_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  file connection */
export type File_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  file connection */
export type File_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_ReferencedByQueriesArgs = {
  filter: InputMaybe<CustomSqlTable_Filter>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_ReferencedByQueriesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CustomSqlTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_TablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  file connection */
export type File_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  file connection */
export type File_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  file connection */
export type File_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FileOrderField {
  /** Sort by connectionType */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamVirtualConnections count */
  DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT = 'DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by isEmbedded */
  IS_EMBEDDED = 'IS_EMBEDDED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FileSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FileOrderField;
};

/** Filter by GraphQL field and given value */
export type File_Filter = {
  /** Connection type shortname */
  connectionType: InputMaybe<Scalars['String']>;
  /** Connection type shortname */
  connectionTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the database has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this database contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this database contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if this file is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: InputMaybe<Scalars['Boolean']>;
  /** True if this file is embedded in Tableau content, e.g., a packaged workbook */
  isEmbeddedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Connection Type for File */
export type FilesConnection = {
  __typename: 'FilesConnection';
  /** List of nodes */
  nodes: Array<File>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow = CanHaveLabels & Taggable & Warnable & {
  __typename: 'Flow';
  /** The name of the container in which the flow is visible and usable. Either a personal space or project. */
  containerName: Maybe<Scalars['String']>;
  /** The type of the container in which the flow is visible and usable. Either personal space or project. */
  containerType: Scalars['String'];
  /** True if the flow contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: Maybe<Scalars['Boolean']>;
  /** Time the flow was created. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  createdAt: Maybe<Scalars['DateTime']>;
  /**
   * The optional data quality warning on a flow
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a flow */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a flow */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Description of the flow */
  description: Maybe<Scalars['String']>;
  /** Dashboards that are downstream from this flow */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards that are downstream from this flow */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases that are downstream from this flow. */
  downstreamDatabases: Array<Database>;
  /** Databases that are downstream from this flow. */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published Data Sources that are downstream from this flow. */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published Data Sources that are downstream from this flow. */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are downstream from this flow. */
  downstreamFlows: Array<Flow>;
  /** Flows that are downstream from this flow. */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses that are downstream from this flow */
  downstreamLenses: Array<Lens>;
  /** Lenses that are downstream from this flow */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Linked flows that are downstream from this flow. */
  downstreamLinkedFlows: Array<LinkedFlow>;
  /** Linked flows that are downstream from this flow. */
  downstreamLinkedFlowsConnection: Maybe<LinkedFlowsConnection>;
  /** Metrics that are downstream from this flow */
  downstreamMetrics: Array<Metric>;
  /** Metrics that are downstream from this flow */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners that are downstream from this flow */
  downstreamOwners: Array<TableauUser>;
  /** Owners that are downstream from this flow */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets that are downstream from this flow */
  downstreamSheets: Array<Sheet>;
  /** Sheets that are downstream from this flow */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables that are downstream from this flow. */
  downstreamTables: Array<DatabaseTable>;
  /** Tables that are downstream from this flow. */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** VirtualConnectionTables that are downstream of this flow */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables that are downstream of this flow */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** VirtualConnections that are downstream of this flow */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** VirtualConnections that are downstream of this flow */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks that are downstream from this flow */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks that are downstream from this flow */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** True if the flow has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Fields that are inputs to this flow */
  inputFields: Array<FlowInputField>;
  /** Fields that are inputs to this flow */
  inputFieldsConnection: Maybe<FlowInputFieldsConnection>;
  /** The labels on a flow. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a flow. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Flows that are next immediate downstream from this flow. */
  nextDownstreamFlows: Array<Flow>;
  /** Flows that are next immediate downstream from this flow. */
  nextDownstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Flows that are next immediate upstream from this flow. */
  nextUpstreamFlows: Array<Maybe<Flow>>;
  /** Flows that are next immediate upstream from this flow. */
  nextUpstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Fields that are outputs of this flow */
  outputFields: Array<FlowOutputField>;
  /** Fields that are outputs of this flow */
  outputFieldsConnection: Maybe<FlowOutputFieldsConnection>;
  /** Output steps for this flow */
  outputSteps: Array<FlowOutputStep>;
  /** Output steps for this flow */
  outputStepsConnection: Maybe<FlowOutputStepsConnection>;
  /** User who owns this flow */
  owner: Maybe<TableauUser>;
  /** The link to the personal space in which the flow is visible and usable. Will be null if the flow is not in a personal space. */
  personalSpaceUrlLink: Maybe<Scalars['String']>;
  /** The name of the project in which the flow is visible and usable */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the flow is visible and usable. Will be null if the flow is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The site in which the flow is visible and usable */
  site: Maybe<TableauSite>;
  /** Tags associated with a flow */
  tags: Array<Tag>;
  /** Tags associated with a flow */
  tagsConnection: Maybe<TagsConnection>;
  /** Time the flow was updated. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Data quality warnings upstream from this flow */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this flow */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases that are upstream from this flow. */
  upstreamDatabases: Array<Database>;
  /** Databases that are upstream from this flow. */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are upstream from this flow. */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are upstream from this flow. */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are upstream from this flow. */
  upstreamFlows: Array<Flow>;
  /** Flows that are upstream from this flow. */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this flow. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this flow. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Linked flows that are upstream from this flow. */
  upstreamLinkedFlows: Array<LinkedFlow>;
  /** Linked flows that are upstream from this flow. */
  upstreamLinkedFlowsConnection: Maybe<LinkedFlowsConnection>;
  /** Tables that are upstream from this flow. */
  upstreamTables: Array<DatabaseTable>;
  /** Tables that are upstream from this flow. */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** The virtual connection table upstream to this Flow */
  upstreamVirtualConnectionTables: Array<Maybe<VirtualConnectionTable>>;
  /** The virtual connection table upstream to this Flow */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** The virtual connection upstream to this Flow */
  upstreamVirtualConnections: Maybe<Array<Maybe<VirtualConnection>>>;
  /** The virtual connection upstream to this Flow */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  uri: Maybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: Scalars['String'];
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamLinkedFlowsArgs = {
  filter: InputMaybe<LinkedFlow_Filter>;
  orderBy: InputMaybe<LinkedFlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamLinkedFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LinkedFlow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LinkedFlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_InputFieldsArgs = {
  filter: InputMaybe<FlowInputField_Filter>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_InputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_NextDownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_NextDownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_NextUpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_NextUpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_OutputFieldsArgs = {
  filter: InputMaybe<FlowOutputField_Filter>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_OutputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_OutputStepsArgs = {
  filter: InputMaybe<FlowOutputStep_Filter>;
  orderBy: InputMaybe<FlowOutputStepSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_OutputStepsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputStep_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputStepSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamLinkedFlowsArgs = {
  filter: InputMaybe<LinkedFlow_Filter>;
  orderBy: InputMaybe<LinkedFlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamLinkedFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LinkedFlow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LinkedFlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
};


/** Flows are used to prepare data, which can include aggregation, cleaning, preprocessing, etc. */
export type Flow_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
};

/** Column input field implementation */
export type FlowColumnInputField = FlowInputField & {
  __typename: 'FlowColumnInputField';
  /** Fields that are children of this field */
  childFields: Array<FlowOutputField>;
  /** Fields that are children of this field */
  childFieldsConnection: Maybe<FlowOutputFieldsConnection>;
  /** The underlying wrapped column */
  column: Maybe<Column>;
  /** Identifier internal to flow */
  fieldId: Maybe<Scalars['String']>;
  /** A flow to which these fields input */
  flow: Maybe<Flow>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Databases that are upstream from this outputField. */
  upstreamDatabases: Array<Database>;
  /** Databases that are upstream from this outputField. */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** PublishedDatasources that are upstream from this outputField. */
  upstreamDatasources: Array<PublishedDatasource>;
  /** PublishedDatasources that are upstream from this outputField. */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are upstream from this outputField. */
  upstreamFlows: Array<Flow>;
  /** Flows that are upstream from this outputField. */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables that are upstream of this field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables that are upstream of this field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
};


/** Column input field implementation */
export type FlowColumnInputField_ChildFieldsArgs = {
  filter: InputMaybe<FlowOutputField_Filter>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_ChildFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column input field implementation */
export type FlowColumnInputField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FlowColumnInputFieldOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowColumnInputFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowColumnInputFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type FlowColumnInputField_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for FlowColumnInputField */
export type FlowColumnInputFieldsConnection = {
  __typename: 'FlowColumnInputFieldsConnection';
  /** List of nodes */
  nodes: Array<FlowColumnInputField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Column output field implementation */
export type FlowColumnOutputField = FlowOutputField & {
  __typename: 'FlowColumnOutputField';
  /** The underlying wrapped column */
  column: Maybe<Column>;
  /** Dashboards that are downstream from this outputField */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards that are downstream from this outputField */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases that are downstream from this outputField */
  downstreamDatabases: Array<Database>;
  /** Databases that are downstream from this outputField */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are downstream from this outputField */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are downstream from this outputField */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are downstream from this outputField */
  downstreamFlows: Array<Flow>;
  /** Flows that are downstream from this outputField */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses that are downstream from this outputField */
  downstreamLenses: Array<Lens>;
  /** Lenses that are downstream from this outputField */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics that are downstream from this outputField */
  downstreamMetrics: Array<Metric>;
  /** Metrics that are downstream from this outputField */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners that are downstream from this outputField */
  downstreamOwners: Array<TableauUser>;
  /** Owners that are downstream from this outputField */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets that are downstream from this outputField */
  downstreamSheets: Array<Sheet>;
  /** Sheets that are downstream from this outputField */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables that are downstream from this outputField */
  downstreamTables: Array<DatabaseTable>;
  /** Tables that are downstream from this outputField */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** VirtualConnectionTables that are downstream of this outputField */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables that are downstream of this outputField */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** VirtualConnections that are downstream of this outputField */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** VirtualConnections that are downstream of this outputField */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks that are downstream from this outputField */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks that are downstream from this outputField */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Identifier internal to flow */
  fieldId: Maybe<Scalars['String']>;
  /** The flow that outputs these fields */
  flow: Maybe<Array<Maybe<Flow>>>;
  /** The flow that outputs these fields */
  flowConnection: Maybe<FlowsConnection>;
  /** The flow output step that contains this field */
  flowOutputStep: Maybe<FlowOutputStep>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Fields that are parents of this field */
  parentFields: Array<FlowInputField>;
  /** Fields that are parents of this field */
  parentFieldsConnection: Maybe<FlowInputFieldsConnection>;
  /** Databases that are upstream from this outputField */
  upstreamDatabases: Array<Database>;
  /** Databases that are upstream from this outputField */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are upstream from this flow. */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are upstream from this flow. */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are upstream from this flow */
  upstreamFlows: Array<Flow>;
  /** Flows that are upstream from this flow */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables that are upstream from this outputField */
  upstreamTables: Array<DatabaseTable>;
  /** Tables that are upstream from this outputField */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** VirtualConnectionTables that are uptream of this outputField */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables that are uptream of this outputField */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** VirtualConnections that are upstream of this outputField */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** VirtualConnections that are upstream of this outputField */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_FlowArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_FlowConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_ParentFieldsArgs = {
  filter: InputMaybe<FlowInputField_Filter>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_ParentFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Column output field implementation */
export type FlowColumnOutputField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FlowColumnOutputFieldOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowColumnOutputFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowColumnOutputFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type FlowColumnOutputField_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for FlowColumnOutputField */
export type FlowColumnOutputFieldsConnection = {
  __typename: 'FlowColumnOutputFieldsConnection';
  /** List of nodes */
  nodes: Array<FlowColumnOutputField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Field input field implementation */
export type FlowFieldInputField = FlowInputField & {
  __typename: 'FlowFieldInputField';
  /** Fields that are children of this field */
  childFields: Array<FlowOutputField>;
  /** Fields that are children of this field */
  childFieldsConnection: Maybe<FlowOutputFieldsConnection>;
  /** The underlying wrapped field */
  field: Maybe<Field>;
  /** Identifier internal to flow */
  fieldId: Maybe<Scalars['String']>;
  /** A flow to which these fields input */
  flow: Maybe<Flow>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Databases that are upstream from this outputField. */
  upstreamDatabases: Array<Database>;
  /** Databases that are upstream from this outputField. */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are upstream from this outputField. */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are upstream from this outputField. */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are upstream from this outputField. */
  upstreamFlows: Array<Flow>;
  /** Flows that are upstream from this outputField. */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables that are upstream of this field. */
  upstreamTables: Array<DatabaseTable>;
  /** Tables that are upstream of this field. */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
};


/** Field input field implementation */
export type FlowFieldInputField_ChildFieldsArgs = {
  filter: InputMaybe<FlowOutputField_Filter>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_ChildFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field input field implementation */
export type FlowFieldInputField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FlowFieldInputFieldOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowFieldInputFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowFieldInputFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type FlowFieldInputField_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for FlowFieldInputField */
export type FlowFieldInputFieldsConnection = {
  __typename: 'FlowFieldInputFieldsConnection';
  /** List of nodes */
  nodes: Array<FlowFieldInputField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Field output field implementation */
export type FlowFieldOutputField = FlowOutputField & {
  __typename: 'FlowFieldOutputField';
  /** Dashboards that are downstream from this outputField */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards that are downstream from this outputField */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases that are downstream from this outputField */
  downstreamDatabases: Array<Database>;
  /** Databases that are downstream from this outputField */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are downstream from this outputField */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are downstream from this outputField */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are downstream from this outputField */
  downstreamFlows: Array<Flow>;
  /** Flows that are downstream from this outputField */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses that are downstream from this outputField */
  downstreamLenses: Array<Lens>;
  /** Lenses that are downstream from this outputField */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics that are downstream from this outputField */
  downstreamMetrics: Array<Metric>;
  /** Metrics that are downstream from this outputField */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners that are downstream from this outputField */
  downstreamOwners: Array<TableauUser>;
  /** Owners that are downstream from this outputField */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets that are downstream from this outputField */
  downstreamSheets: Array<Sheet>;
  /** Sheets that are downstream from this outputField */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables that are downstream from this outputField */
  downstreamTables: Array<DatabaseTable>;
  /** Tables that are downstream from this outputField */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** VirtualConnectionTables that are downstream of this outputField */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables that are downstream of this outputField */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** VirtualConnections that are downstream of this outputField */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** VirtualConnections that are downstream of this outputField */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks that are downstream from this outputField */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks that are downstream from this outputField */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** The underlying wrapped field */
  field: Maybe<Field>;
  /** Identifier internal to flow */
  fieldId: Maybe<Scalars['String']>;
  /** The flow that outputs these fields */
  flow: Maybe<Array<Maybe<Flow>>>;
  /** The flow that outputs these fields */
  flowConnection: Maybe<FlowsConnection>;
  /** The flow output step that contains this field */
  flowOutputStep: Maybe<FlowOutputStep>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Fields that are parents of this field */
  parentFields: Array<FlowInputField>;
  /** Fields that are parents of this field */
  parentFieldsConnection: Maybe<FlowInputFieldsConnection>;
  /** Databases that are upstream from this outputField */
  upstreamDatabases: Array<Database>;
  /** Databases that are upstream from this outputField */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are upstream from this output field. */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are upstream from this output field. */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are upstream from this flow. */
  upstreamFlows: Array<Flow>;
  /** Flows that are upstream from this flow. */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables that are upstream from this outputField */
  upstreamTables: Array<DatabaseTable>;
  /** Tables that are upstream from this outputField */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** VirtualConnectionTables that are uptream of this outputField */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables that are uptream of this outputField */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** VirtualConnections that are upstream of this outputField */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** VirtualConnections that are upstream of this outputField */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_FlowArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_FlowConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_ParentFieldsArgs = {
  filter: InputMaybe<FlowInputField_Filter>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_ParentFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Field output field implementation */
export type FlowFieldOutputField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FlowFieldOutputFieldOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowFieldOutputFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowFieldOutputFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type FlowFieldOutputField_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for FlowFieldOutputField */
export type FlowFieldOutputFieldsConnection = {
  __typename: 'FlowFieldOutputFieldsConnection';
  /** List of nodes */
  nodes: Array<FlowFieldOutputField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  wrapper for an input field contained in a published flow. */
export type FlowInputField = {
  /** Fields that are children of this field */
  childFields: Array<FlowOutputField>;
  /** Fields that are children of this field */
  childFieldsConnection: Maybe<FlowOutputFieldsConnection>;
  /** A flow to which these fields input */
  flow: Maybe<Flow>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Databases that are upstream from this inputField. */
  upstreamDatabases: Array<Database>;
  /** Databases that are upstream from this inputField. */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Flows that are upstream from this inputField. */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Flows that are upstream from this inputField. */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are upstream from this inputField. */
  upstreamFlows: Array<Flow>;
  /** Flows that are upstream from this inputField. */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables that are upstream of this field. */
  upstreamTables: Array<DatabaseTable>;
  /** Tables that are upstream of this field. */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_ChildFieldsArgs = {
  filter: InputMaybe<FlowOutputField_Filter>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_ChildFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an input field contained in a published flow. */
export type FlowInputField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FlowInputFieldOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowInputFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowInputFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type FlowInputField_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for FlowInputField */
export type FlowInputFieldsConnection = {
  __typename: 'FlowInputFieldsConnection';
  /** List of nodes */
  nodes: Array<FlowInputField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Enum for fields that can be used for sorting */
export enum FlowOrderField {
  /** Sort by containerName */
  CONTAINER_NAME = 'CONTAINER_NAME',
  /** Sort by containsUnsupportedCustomSql */
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = 'CONTAINS_UNSUPPORTED_CUSTOM_SQL',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME',
  /** Sort by vizportalUrlId */
  VIZPORTAL_URL_ID = 'VIZPORTAL_URL_ID'
}

/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField = {
  /** Dashboards that are downstream from this outputField */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards that are downstream from this outputField */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases that are downstream from this outputField */
  downstreamDatabases: Array<Database>;
  /** Databases that are downstream from this outputField */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are downstream from this outputField */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are downstream from this outputField */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are downstream from this outputField */
  downstreamFlows: Array<Flow>;
  /** Flows that are downstream from this outputField */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses that are downstream from this outputField */
  downstreamLenses: Array<Lens>;
  /** Lenses that are downstream from this outputField */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics that are downstream from this outputField */
  downstreamMetrics: Array<Metric>;
  /** Metrics that are downstream from this outputField */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners that are downstream from this outputField */
  downstreamOwners: Array<TableauUser>;
  /** Owners that are downstream from this outputField */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets that are downstream from this outputField */
  downstreamSheets: Array<Sheet>;
  /** Sheets that are downstream from this outputField */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables that are downstream from this outputField */
  downstreamTables: Array<DatabaseTable>;
  /** Tables that are downstream from this outputField */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** VirtualConnectionTables that are downstream of this outputField */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables that are downstream of this outputField */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** VirtualConnections that are downstream of this outputField */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** VirtualConnections that are downstream of this outputField */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks that are downstream from this outputField */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks that are downstream from this outputField */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** The flow that outputs these fields */
  flow: Maybe<Array<Maybe<Flow>>>;
  /** The flow that outputs these fields */
  flowConnection: Maybe<FlowsConnection>;
  /** The flow output step that contains this field */
  flowOutputStep: Maybe<FlowOutputStep>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Fields that are parents of this field */
  parentFields: Array<FlowInputField>;
  /** Fields that are parents of this field */
  parentFieldsConnection: Maybe<FlowInputFieldsConnection>;
  /** Databases that are upstream from this outputField */
  upstreamDatabases: Array<Database>;
  /** Databases that are upstream from this outputField */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources that are upstream from this outputField */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources that are upstream from this outputField */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows that are upstream from this outputField. */
  upstreamFlows: Array<Flow>;
  /** Flows that are upstream from this outputField. */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables that are upstream from this outputField */
  upstreamTables: Array<DatabaseTable>;
  /** Tables that are upstream from this outputField */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** VirtualConnectionTables that are uptream of this outputField */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables that are uptream of this outputField */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** VirtualConnections that are upstream of this outputField */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** VirtualConnections that are upstream of this outputField */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_FlowArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_FlowConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_ParentFieldsArgs = {
  filter: InputMaybe<FlowInputField_Filter>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_ParentFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  wrapper for an output field contained in a published flow. */
export type FlowOutputField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FlowOutputFieldOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowOutputFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowOutputFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type FlowOutputField_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for FlowOutputField */
export type FlowOutputFieldsConnection = {
  __typename: 'FlowOutputFieldsConnection';
  /** List of nodes */
  nodes: Array<FlowOutputField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  flow output step */
export type FlowOutputStep = {
  __typename: 'FlowOutputStep';
  /** The flow that contains this output step */
  flow: Maybe<Flow>;
  /** Unique identifier used by the metadata API */
  id: Scalars['ID'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Fields output by this step */
  outputFields: Array<FlowOutputField>;
  /** Fields output by this step */
  outputFieldsConnection: Maybe<FlowOutputFieldsConnection>;
  /** Identifier internal to flow */
  stepId: Maybe<Scalars['String']>;
};


/**  flow output step */
export type FlowOutputStep_OutputFieldsArgs = {
  filter: InputMaybe<FlowOutputField_Filter>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  flow output step */
export type FlowOutputStep_OutputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum FlowOutputStepOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowOutputStepSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowOutputStepOrderField;
};

/** Filter by GraphQL field and given value */
export type FlowOutputStep_Filter = {
  /** Unique identifier used by the metadata API */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for FlowOutputStep */
export type FlowOutputStepsConnection = {
  __typename: 'FlowOutputStepsConnection';
  /** List of nodes */
  nodes: Array<FlowOutputStep>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type FlowSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: FlowOrderField;
};

/** Filter by GraphQL field and given value */
export type Flow_Filter = {
  /** The name of the container in which the flow is visible and usable. Either a personal space or project. */
  containerName: InputMaybe<Scalars['String']>;
  /** The name of the container in which the flow is visible and usable. Either a personal space or project. */
  containerNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the flow contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: InputMaybe<Scalars['Boolean']>;
  /** True if the flow contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSqlWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if the flow has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the flow has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the flow is visible and usable */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the flow is visible and usable */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: InputMaybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Flow */
export type FlowsConnection = {
  __typename: 'FlowsConnection';
  /** List of nodes */
  nodes: Array<Flow>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**
 * A label that can be attached to assets.
 * *Available in Tableau Cloud March 2023 / Server 2023.1 and later.*
 */
export type GenericLabel = Label & {
  __typename: 'GenericLabel';
  /** The asset that contains the label */
  asset: Maybe<CanHaveLabels>;
  /** User who last updated this label */
  author: Maybe<TableauUser>;
  /** Name of the user who last updated this label */
  authorDisplayName: Maybe<Scalars['String']>;
  /** Category of the label */
  category: Scalars['String'];
  /** Time the label was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the label is active */
  isActive: Scalars['Boolean'];
  /** True if the label is elevated */
  isElevated: Scalars['Boolean'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Message of the label */
  message: Maybe<Scalars['String']>;
  /** Time the label was last updated */
  updatedAt: Scalars['DateTime'];
  /** Value of the label */
  value: Scalars['String'];
  /** Vizportal ID of this label, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};

/** Enum for fields that can be used for sorting */
export enum GenericLabelOrderField {
  /** Sort by category */
  CATEGORY = 'CATEGORY',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isActive */
  IS_ACTIVE = 'IS_ACTIVE',
  /** Sort by isElevated */
  IS_ELEVATED = 'IS_ELEVATED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by value */
  VALUE = 'VALUE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type GenericLabelSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: GenericLabelOrderField;
};

/** Filter by GraphQL field and given value */
export type GenericLabel_Filter = {
  /** Category of the label */
  category: InputMaybe<Scalars['String']>;
  /** Category of the label */
  categoryWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the label is active */
  isActive: InputMaybe<Scalars['Boolean']>;
  /** True if the label is active */
  isActiveWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if the label is elevated */
  isElevated: InputMaybe<Scalars['Boolean']>;
  /** True if the label is elevated */
  isElevatedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Value of the label */
  value: InputMaybe<Scalars['String']>;
  /** Value of the label */
  valueWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for GenericLabel */
export type GenericLabelsConnection = {
  __typename: 'GenericLabelsConnection';
  /** List of nodes */
  nodes: Array<GenericLabel>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField = DataField & Field & FieldReferencingField & Node & {
  __typename: 'GroupField';
  /** Data category of the field */
  dataCategory: Maybe<FieldRoleCategory>;
  /** Type of the data in the field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_typesandroles_datatypes.html */
  dataType: Maybe<FieldDataType>;
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** List of fields, if any, that this field references */
  fields: Array<Field>;
  /** List of fields, if any, that this field references */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Field has an 'Other' group. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html#Include */
  hasOther: Maybe<Scalars['Boolean']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Role of the field: 'dimension', 'measure' or 'unknown' */
  role: Maybe<FieldRole>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a group field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_groups_creating.html */
export type GroupField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum GroupFieldOrderField {
  /** Sort by dataCategory */
  DATA_CATEGORY = 'DATA_CATEGORY',
  /** Sort by dataType */
  DATA_TYPE = 'DATA_TYPE',
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by role */
  ROLE = 'ROLE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type GroupFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: GroupFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type GroupField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type GroupField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for GroupField */
export type GroupFieldsConnection = {
  __typename: 'GroupFieldsConnection';
  /** List of nodes */
  nodes: Array<GroupField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField = Field & FieldReferencingField & Node & {
  __typename: 'HierarchyField';
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** List of fields, if any, that this field references */
  fields: Array<Field>;
  /** List of fields, if any, that this field references */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a hierarchy. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/qs_hierarchies.html */
export type HierarchyField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum HierarchyFieldOrderField {
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type HierarchyFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: HierarchyFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type HierarchyField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type HierarchyField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for HierarchyField */
export type HierarchyFieldsConnection = {
  __typename: 'HierarchyFieldsConnection';
  /** List of nodes */
  nodes: Array<HierarchyField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Method of selecting the objects (i.e., inheritance sources) to inherit from */
export enum InheritanceType {
  /** Inherit from the closest unambiguous upstream object */
  FIRST = 'FIRST'
}

/** Wrapper type containing the inherited result */
export type InheritedStringResult = {
  __typename: 'InheritedStringResult';
  /** The object (i.e., inheritance source) where the attribute was inherited from */
  asset: Maybe<Node>;
  /** Unique identifier of the object (i.e., inheritance source) that is providing the inherited attribute */
  assetId: Scalars['String'];
  /** Name of the property that is being inherited */
  attribute: Scalars['String'];
  /** Number of edges in between the inheritance source and inheritance target */
  distance: Maybe<Scalars['Int']>;
  /** The edges between inheritance source and inheritance target */
  edges: Maybe<Array<Scalars['String']>>;
  /** Inherited value */
  value: Maybe<Scalars['String']>;
};

/**
 * A label that can be attached to assets.
 * *Available in Tableau Cloud March 2023 / Server 2023.1 and later.*
 */
export type Label = {
  /** The asset that contains the label */
  asset: Maybe<CanHaveLabels>;
  /** User who last updated this label */
  author: Maybe<TableauUser>;
  /** Name of the user who last updated this label */
  authorDisplayName: Maybe<Scalars['String']>;
  /** Category of the label */
  category: Scalars['String'];
  /** Time the label was created */
  createdAt: Scalars['DateTime'];
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the label is active */
  isActive: Scalars['Boolean'];
  /** True if the label is elevated */
  isElevated: Scalars['Boolean'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Message of the label */
  message: Maybe<Scalars['String']>;
  /** Time the label was last updated */
  updatedAt: Scalars['DateTime'];
  /** Value of the label */
  value: Scalars['String'];
  /** Vizportal ID of this label, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};

/** Enum for fields that can be used for sorting */
export enum LabelOrderField {
  /** Sort by category */
  CATEGORY = 'CATEGORY',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isActive */
  IS_ACTIVE = 'IS_ACTIVE',
  /** Sort by isElevated */
  IS_ELEVATED = 'IS_ELEVATED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by value */
  VALUE = 'VALUE'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type LabelSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: LabelOrderField;
};

/** Filter by GraphQL field and given value */
export type Label_Filter = {
  /** Category of the label */
  category: InputMaybe<Scalars['String']>;
  /** Category of the label */
  categoryWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the label is active */
  isActive: InputMaybe<Scalars['Boolean']>;
  /** True if the label is active */
  isActiveWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if the label is elevated */
  isElevated: InputMaybe<Scalars['Boolean']>;
  /** True if the label is elevated */
  isElevatedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Value of the label */
  value: InputMaybe<Scalars['String']>;
  /** Value of the label */
  valueWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Label */
export type LabelsConnection = {
  __typename: 'LabelsConnection';
  /** List of nodes */
  nodes: Array<Label>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens = {
  __typename: 'Lens';
  /** The lens configured in askData extension */
  askDataExtensions: Maybe<Array<Maybe<AskDataExtension>>>;
  /** The lens configured in askData extension */
  askDataExtensionsConnection: Maybe<AskDataExtensionsConnection>;
  /** Time the Lens was created */
  createdAt: Scalars['DateTime'];
  /** Datasource this lens is derived from */
  datasource: Datasource;
  /** Description of the Lens */
  description: Maybe<Scalars['String']>;
  /** "Dashboards connected to the Lens" */
  downstreamDashboards: Array<Dashboard>;
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** "Metrics connected to the Lens" */
  downstreamMetrics: Array<Metric>;
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners of contents connected to the Lens */
  downstreamOwners: Array<TableauUser>;
  /** Owners of contents connected to the Lens */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** "Workbooks connected to the Lens" */
  downstreamWorkbooks: Array<Workbook>;
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** The list of fields */
  fields: Array<LensField>;
  /** The list of fields */
  fieldsConnection: Maybe<LensFieldsConnection>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server */
  name: Maybe<Scalars['String']>;
  /** User who owns this Lens */
  owner: TableauUser;
  /** The ID of the project in which the Lens is visible and usable. */
  projectVizportalUrlId: Scalars['String'];
  /** The site in which the Lens is visible and usable */
  site: TableauSite;
  /** Time the Lens was last updated */
  updatedAt: Scalars['DateTime'];
  /** The Databases that are upstream to this Lens */
  upstreamDatabases: Maybe<Array<Maybe<Database>>>;
  /** The Databases that are upstream to this Lens */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** The datasource that are upstream of this lens */
  upstreamDatasources: Maybe<Array<Maybe<PublishedDatasource>>>;
  /** The datasource that are upstream of this lens */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** The fields that are upstream of this lens */
  upstreamFields: Maybe<Array<Maybe<Field>>>;
  /** The fields that are upstream of this lens */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** The flows that are upstream of this Lens */
  upstreamFlows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that are upstream of this Lens */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables that are upstream of this Lens */
  upstreamTables: Array<Table>;
  /** Tables that are upstream of this Lens */
  upstreamTablesConnection: Maybe<TablesConnection>;
  /** The virtual connection table upstream to this Lens */
  upstreamVirtualConnectionTables: Maybe<Array<Maybe<VirtualConnectionTable>>>;
  /** The virtual connection table upstream to this Lens */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** The virtual connection upstream to this Lens */
  upstreamVirtualConnections: Maybe<Array<Maybe<VirtualConnection>>>;
  /** The virtual connection upstream to this Lens */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: Scalars['String'];
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_AskDataExtensionsArgs = {
  filter: InputMaybe<AskDataExtension_Filter>;
  orderBy: InputMaybe<AskDataExtensionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_AskDataExtensionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<AskDataExtension_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<AskDataExtensionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_FieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamTablesArgs = {
  filter: InputMaybe<Table_Filter>;
  orderBy: InputMaybe<TableSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Table_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
};


/**
 * Lenses are curated, embeddable Ask Data experiences.
 * *Available in Tableau Cloud June 2022 / Server 2022.3 and later.*
 */
export type Lens_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
};

/** Lens Fields contain extra information based on an underlying datasource field */
export type LensField = {
  __typename: 'LensField';
  /** The Lens which contains this lens field */
  containingLens: Maybe<Lens>;
  /** Underlying datasource field this lens field is based on */
  datasourceField: Field;
  /** Description of field shown in Ask Data. If null or empty, use description inherited from datasource field. */
  description: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Name of field shown locally in Ask Data. If null or empty, use name inherited from datasource field. */
  name: Maybe<Scalars['String']>;
};

/** Enum for fields that can be used for sorting */
export enum LensFieldOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type LensFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: LensFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type LensField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name of field shown locally in Ask Data. If null or empty, use name inherited from datasource field. */
  name: InputMaybe<Scalars['String']>;
  /** Name of field shown locally in Ask Data. If null or empty, use name inherited from datasource field. */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Filter by GraphQL field and given value */
export type LensField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for LensField */
export type LensFieldsConnection = {
  __typename: 'LensFieldsConnection';
  /** List of nodes */
  nodes: Array<LensField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Enum for fields that can be used for sorting */
export enum LensOrderField {
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by owner count */
  OWNER_COUNT = 'OWNER_COUNT',
  /** Sort by vizportalUrlId */
  VIZPORTAL_URL_ID = 'VIZPORTAL_URL_ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type LensSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: LensOrderField;
};

/** Filter by GraphQL field and given value */
export type Lens_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: InputMaybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Lens */
export type LensesConnection = {
  __typename: 'LensesConnection';
  /** List of nodes */
  nodes: Array<Lens>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Wrapper type including edge information */
export type LinkedFlow = {
  __typename: 'LinkedFlow';
  /** Object in this linked flow */
  asset: Flow;
  /** Unique identifier of the object in this linked flow */
  assetId: Scalars['String'];
  /** The nodes preceding this node */
  fromEdges: Maybe<Array<Scalars['String']>>;
  /** The nodes following this node */
  toEdges: Maybe<Array<Scalars['String']>>;
};

/** Enum for fields that can be used for sorting */
export enum LinkedFlowOrderField {
  /** Sort by id */
  ID = 'ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type LinkedFlowSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: LinkedFlowOrderField;
};

/** Filter by GraphQL field and given value */
export type LinkedFlow_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for LinkedFlow */
export type LinkedFlowsConnection = {
  __typename: 'LinkedFlowsConnection';
  /** List of nodes */
  nodes: Array<LinkedFlow>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Metrics are time series data constructed from fields contained in views. */
export type Metric = Taggable & {
  __typename: 'Metric';
  /** The name of the container in which the metric is visible and usable. This is always a project. */
  containerName: Maybe<Scalars['String']>;
  /** The type of the container in which the metric is visible and usable. This is always a project. */
  containerType: Scalars['String'];
  /** Time the Metric was created */
  createdAt: Scalars['DateTime'];
  /** Description of the Metric */
  description: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** User who owns this Metric */
  owner: TableauUser;
  /** The name of the project in which the Metric is visible and usable. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the Metric is visible and usable. */
  projectVizportalUrlId: Scalars['String'];
  /** The site in which the Metric is visible and usable */
  site: TableauSite;
  /** Tags associated with the Metric */
  tags: Array<Tag>;
  /** Tags associated with the Metric */
  tagsConnection: Maybe<TagsConnection>;
  /** The original View off of which the Metric is based */
  underlyingView: Maybe<View>;
  /** Time the Metric was last updated */
  updatedAt: Scalars['DateTime'];
  /** Columns that are upstream of this metric */
  upstreamColumns: Maybe<Array<Maybe<Column>>>;
  /** Columns that are upstream of this metric */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Data quality warnings upstream from this Metric */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this Metric */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases that are upstream of this metric */
  upstreamDatabases: Maybe<Array<Maybe<Database>>>;
  /** Databases that are upstream of this metric */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** The Published Datasources that are upstream to this Metric */
  upstreamDatasources: Maybe<Array<Maybe<PublishedDatasource>>>;
  /** The Published Datasources that are upstream to this Metric */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this metric */
  upstreamFields: Maybe<Array<Maybe<Field>>>;
  /** fields that are upstream of this metric */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** OutputFields that are upstream of this Metric */
  upstreamFlowColumnOutputFields: Maybe<Array<Maybe<FlowColumnOutputField>>>;
  /** OutputFields that are upstream of this Metric */
  upstreamFlowColumnOutputFieldsConnection: Maybe<FlowColumnOutputFieldsConnection>;
  /** OutputFields that are upstream of this Metric */
  upstreamFlowFieldOutputFields: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** OutputFields that are upstream of this Metric */
  upstreamFlowFieldOutputFieldsConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** OutputFields that are upstream of this Metric */
  upstreamFlowOutputFields: Maybe<Array<Maybe<FlowOutputField>>>;
  /** OutputFields that are upstream of this Metric */
  upstreamFlowOutputFieldsConnection: Maybe<FlowOutputFieldsConnection>;
  /** The flows that are upstream of this metric */
  upstreamFlows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that are upstream of this metric */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this Metric. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this Metric. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** The Lenses that are upstream of this workbook */
  upstreamLenses: Maybe<Array<Maybe<Lens>>>;
  /** The Lenses that are upstream of this workbook */
  upstreamLensesConnection: Maybe<LensesConnection>;
  /** tables that are upstream of this metric */
  upstreamTables: Array<Maybe<DatabaseTable>>;
  /** tables that are upstream of this metric */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Workbooks that are upstream of this metric */
  upstreamWorkbooks: Maybe<Array<Maybe<Workbook>>>;
  /** Workbooks that are upstream of this metric */
  upstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: Scalars['String'];
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowColumnOutputFieldsArgs = {
  filter: InputMaybe<FlowColumnOutputField_Filter>;
  orderBy: InputMaybe<FlowColumnOutputFieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowColumnOutputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowColumnOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowColumnOutputFieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowFieldOutputFieldsArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowFieldOutputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowOutputFieldsArgs = {
  filter: InputMaybe<FlowOutputField_Filter>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowOutputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputFieldSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
};


/** Metrics are time series data constructed from fields contained in views. */
export type Metric_UpstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
};

/** Enum for fields that can be used for sorting */
export enum MetricOrderField {
  /** Sort by containerName */
  CONTAINER_NAME = 'CONTAINER_NAME',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by owner count */
  OWNER_COUNT = 'OWNER_COUNT',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME',
  /** Sort by vizportalUrlId */
  VIZPORTAL_URL_ID = 'VIZPORTAL_URL_ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type MetricSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: MetricOrderField;
};

/** Filter by GraphQL field and given value */
export type Metric_Filter = {
  /** The name of the container in which the metric is visible and usable. This is always a project. */
  containerName: InputMaybe<Scalars['String']>;
  /** The name of the container in which the metric is visible and usable. This is always a project. */
  containerNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the Metric is visible and usable. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the Metric is visible and usable. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: InputMaybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Metric */
export type MetricsConnection = {
  __typename: 'MetricsConnection';
  /** List of nodes */
  nodes: Array<Metric>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Inheritance target */
export type Node = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
};

/** Enum for fields that can be used for sorting */
export enum NodeOrderField {
  /** Sort by id */
  ID = 'ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type NodeSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: NodeOrderField;
};

/** Filter by GraphQL field and given value */
export type Node_Filter = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Connection Type for Node */
export type NodesConnection = {
  __typename: 'NodesConnection';
  /** List of nodes */
  nodes: Array<Node>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** General object for sorting */
export enum OrderDirection {
  /** Sort in an ascending order. */
  ASC = 'ASC',
  /** Sort in a descending order. */
  DESC = 'DESC'
}

/** Information about pagination in a connection */
export type PageInfo = {
  __typename: 'PageInfo';
  /** Cursor to use in subsequent query to fetch next page of objects */
  endCursor: Maybe<Scalars['String']>;
  /** Indicates if there are more objects to fetch */
  hasNextPage: Scalars['Boolean'];
};

/** Tableau Parameter. For more info see https://onlinehelp.tableau.com/current/pro/desktop/en-us/parameters_create.html */
export type Parameter = {
  __typename: 'Parameter';
  /** Published data source that contains this parameter */
  datasource: Maybe<PublishedDatasource>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Name of parameter */
  name: Maybe<Scalars['String']>;
  /** Name of the parameter's parent */
  parentName: Maybe<Scalars['String']>;
  /** The bin field that references this parameter */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this parameter */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this parameter */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this parameter */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The set field that this parameter references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this parameter references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Workbook that contains this parameter */
  workbook: Maybe<Workbook>;
};


/** Tableau Parameter. For more info see https://onlinehelp.tableau.com/current/pro/desktop/en-us/parameters_create.html */
export type Parameter_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Tableau Parameter. For more info see https://onlinehelp.tableau.com/current/pro/desktop/en-us/parameters_create.html */
export type Parameter_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Tableau Parameter. For more info see https://onlinehelp.tableau.com/current/pro/desktop/en-us/parameters_create.html */
export type Parameter_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Tableau Parameter. For more info see https://onlinehelp.tableau.com/current/pro/desktop/en-us/parameters_create.html */
export type Parameter_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Tableau Parameter. For more info see https://onlinehelp.tableau.com/current/pro/desktop/en-us/parameters_create.html */
export type Parameter_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Tableau Parameter. For more info see https://onlinehelp.tableau.com/current/pro/desktop/en-us/parameters_create.html */
export type Parameter_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum ParameterOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by parentName */
  PARENT_NAME = 'PARENT_NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type ParameterSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: ParameterOrderField;
};

/** Filter by GraphQL field and given value */
export type Parameter_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name of parameter */
  name: InputMaybe<Scalars['String']>;
  /** Name of parameter */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name of the parameter's parent */
  parentName: InputMaybe<Scalars['String']>;
  /** Name of the parameter's parent */
  parentNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Parameter */
export type ParametersConnection = {
  __typename: 'ParametersConnection';
  /** List of nodes */
  nodes: Array<Parameter>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Enum of the different ways to apply permissions. */
export enum PermissionMode {
  /** Filter out results user is not authorized on. */
  FILTER_RESULTS = 'FILTER_RESULTS',
  /** Include results that user is not authorized to view with sensitive information obfuscated. */
  OBFUSCATE_RESULTS = 'OBFUSCATE_RESULTS'
}

/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource = CanHaveLabels & Certifiable & Datasource & Taggable & Warnable & {
  __typename: 'PublishedDatasource';
  /**
   * Notes related to the data source being marked as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certificationNote: Maybe<Scalars['String']>;
  /**
   * User who marked this data source as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifier: Maybe<TableauUser>;
  /**
   * Name of the user who marked this data source as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifierDisplayName: Maybe<Scalars['String']>;
  /** The name of the container in which the published data source is visible and usable. Either a personal space or project. */
  containerName: Maybe<Scalars['String']>;
  /** The type of the container in which the published data source is visible and usable. Either personal space or project. */
  containerType: Scalars['String'];
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: Maybe<Scalars['Boolean']>;
  /** Time the datasource was created. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The data quality certifications on a published datasource */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a published datasource */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * The optional data quality warning on a published datasource
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a published datasource */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a published datasource */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Data source filters contained in this data source */
  datasourceFilters: Array<DatasourceFilter>;
  /** Data source filters contained in this data source */
  datasourceFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** Description of the datasource */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream from this data source */
  downstreamDatabases: Array<Database>;
  /** Databases downstream from this data source */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources downstream from this data source */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Datasources downstream from this data source */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream from this data source */
  downstreamFlows: Array<Flow>;
  /** Flows downstream from this data source */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics downstream from this data source */
  downstreamMetrics: Array<Metric>;
  /** Metrics downstream from this data source */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners downstream from this data source */
  downstreamOwners: Array<TableauUser>;
  /** Workbook owners downstream from this data source */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets downstream from this data source */
  downstreamSheets: Array<Sheet>;
  /** Sheets downstream from this data source */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream from this data source */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream from this data source */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this data source */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this data source */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream from this data source */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream from this data source */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks downstream from this data source */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks downstream from this data source */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Time an extract was last incrementally updated */
  extractLastIncrementalUpdateTime: Maybe<Scalars['DateTime']>;
  /** Time an extract was last fully refreshed */
  extractLastRefreshTime: Maybe<Scalars['DateTime']>;
  /** Time an extract was last updated by either a full refresh, incremental update, or creation */
  extractLastUpdateTime: Maybe<Scalars['DateTime']>;
  /** Fields usable in workbooks connected to this data source */
  fields: Array<Field>;
  /** Fields usable in workbooks connected to this data source */
  fieldsConnection: Maybe<FieldsConnection>;
  /** True if the data source has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** True if datasource contains extracted data */
  hasExtracts: Maybe<Scalars['Boolean']>;
  /** True if data source contains a formula that involves a user function (for example, USERNAME or ISMEMBEROF) */
  hasUserReference: Maybe<Scalars['Boolean']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this data source contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** The labels on a published datasource. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a published datasource. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** The lenses derived from this datasource */
  lenses: Maybe<Array<Maybe<Lens>>>;
  /** The lenses derived from this datasource */
  lensesConnection: Maybe<LensesConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** User who owns this data source */
  owner: TableauUser;
  /** List of parameters, if any, used in this data source */
  parameters: Array<Parameter>;
  /** List of parameters, if any, used in this data source */
  parametersConnection: Maybe<ParametersConnection>;
  /** The name of the project that contains this published data source. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the published data source is visible and usable. Will return null if the published data source is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The site which contains this published data source */
  site: TableauSite;
  /** Tags associated with the published datasource */
  tags: Array<Tag>;
  /** Tags associated with the published datasource */
  tagsConnection: Maybe<TagsConnection>;
  /** Time the datasource was last updated. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Data quality warnings upstream from this data source */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this data source */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream from this data source */
  upstreamDatabases: Array<Database>;
  /** Databases upstream from this data source */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream from this data source */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream from this data source */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream from this data source */
  upstreamFlows: Array<Flow>;
  /** Flows upstream from this data source */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this data source. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this data source. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream from this data source */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream from this data source */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** The virtual connection table upstream to this Datasource */
  upstreamVirtualConnectionTables: Array<Maybe<VirtualConnectionTable>>;
  /** The virtual connection table upstream to this Datasource */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** The virtual connection upstream to this Datasource */
  upstreamVirtualConnections: Array<Maybe<VirtualConnection>>;
  /** The virtual connection upstream to this Datasource */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Uri of the datasource */
  uri: Maybe<Scalars['String']>;
  /** Vizportal ID of this published datasource, for use in client-to-server communications */
  vizportalId: Scalars['String'];
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: Scalars['String'];
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DatasourceFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DatasourceFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_LensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_LensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_ParametersArgs = {
  filter: InputMaybe<Parameter_Filter>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_ParametersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Parameter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  Tableau data source that has been published separately to Tableau Server. It can be used by multiple workbooks. */
export type PublishedDatasource_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum PublishedDatasourceOrderField {
  /** Sort by containerName */
  CONTAINER_NAME = 'CONTAINER_NAME',
  /** Sort by containsUnsupportedCustomSql */
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = 'CONTAINS_UNSUPPORTED_CUSTOM_SQL',
  /** Sort by downstreamOwners count */
  DOWNSTREAM_OWNERS_COUNT = 'DOWNSTREAM_OWNERS_COUNT',
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by owner count */
  OWNER_COUNT = 'OWNER_COUNT',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME',
  /** Sort by vizportalUrlId */
  VIZPORTAL_URL_ID = 'VIZPORTAL_URL_ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type PublishedDatasourceSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: PublishedDatasourceOrderField;
};

/** Filter by GraphQL field and given value */
export type PublishedDatasource_Filter = {
  /** The name of the container in which the published data source is visible and usable. Either a personal space or project. */
  containerName: InputMaybe<Scalars['String']>;
  /** The name of the container in which the published data source is visible and usable. Either a personal space or project. */
  containerNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: InputMaybe<Scalars['Boolean']>;
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSqlWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** True if the data source has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the data source has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this data source contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this data source contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project that contains this published data source. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project that contains this published data source. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: InputMaybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for PublishedDatasource */
export type PublishedDatasourcesConnection = {
  __typename: 'PublishedDatasourcesConnection';
  /** List of nodes */
  nodes: Array<PublishedDatasource>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Query root for Metadata GraphQL interface */
export type Query = {
  __typename: 'Query';
  /** Fetches AskDataExtensions by filtering on id or name */
  askDataExtensions: Array<AskDataExtension>;
  /** Fetch AskDataExtensions with support for pagination */
  askDataExtensionsConnection: AskDataExtensionsConnection;
  /** Fetches BinFields by filtering on id or name */
  binFields: Array<BinField>;
  /** Fetch BinFields with support for pagination */
  binFieldsConnection: BinFieldsConnection;
  /** Fetches CalculatedFields by filtering on id or name */
  calculatedFields: Array<CalculatedField>;
  /** Fetch CalculatedFields with support for pagination */
  calculatedFieldsConnection: CalculatedFieldsConnection;
  /** Fetches CloudFiles by filtering on id or name */
  cloudFiles: Array<CloudFile>;
  /** Fetch CloudFiles with support for pagination */
  cloudFilesConnection: CloudFilesConnection;
  /** Fetches ColumnFields by filtering on id or name */
  columnFields: Array<ColumnField>;
  /** Fetch ColumnFields with support for pagination */
  columnFieldsConnection: ColumnFieldsConnection;
  /** Fetches Columns by filtering on id or name */
  columns: Array<Column>;
  /** Fetch Columns with support for pagination */
  columnsConnection: ColumnsConnection;
  /** Fetches CombinedFields by filtering on id or name */
  combinedFields: Array<CombinedField>;
  /** Fetch CombinedFields with support for pagination */
  combinedFieldsConnection: CombinedFieldsConnection;
  /** Fetches CombinedSetFields by filtering on id or name */
  combinedSetFields: Array<CombinedSetField>;
  /** Fetch CombinedSetFields with support for pagination */
  combinedSetFieldsConnection: CombinedSetFieldsConnection;
  /** Fetches CustomSQLTables by filtering on id or name */
  customSQLTables: Array<CustomSqlTable>;
  /** Fetch CustomSQLTables with support for pagination */
  customSQLTablesConnection: CustomSqlTablesConnection;
  /** Fetches Dashboards by filtering on id or name */
  dashboards: Array<Dashboard>;
  /** Fetch Dashboards with support for pagination */
  dashboardsConnection: DashboardsConnection;
  /** Fetches DataQualityCertifications by filtering on id or name */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** Fetch DataQualityCertifications with support for pagination */
  dataQualityCertificationsConnection: DataQualityCertificationsConnection;
  /** Fetches DataQualityWarnings by filtering on id or name */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** Fetch DataQualityWarnings with support for pagination */
  dataQualityWarningsConnection: DataQualityWarningsConnection;
  /** Fetches DatabaseServers by filtering on id or name */
  databaseServers: Array<DatabaseServer>;
  /** Fetch DatabaseServers with support for pagination */
  databaseServersConnection: DatabaseServersConnection;
  /** Fetches DatabaseTables by filtering on id or name */
  databaseTables: Array<DatabaseTable>;
  /** Fetch DatabaseTables with support for pagination */
  databaseTablesConnection: DatabaseTablesConnection;
  /** Fetches Databases by filtering on id or name */
  databases: Array<Database>;
  /** Fetch Databases with support for pagination */
  databasesConnection: DatabasesConnection;
  /** Fetches DatasourceFields by filtering on id or name */
  datasourceFields: Array<DatasourceField>;
  /** Fetch DatasourceFields with support for pagination */
  datasourceFieldsConnection: DatasourceFieldsConnection;
  /** Fetches DatasourceFilters by filtering on id or name */
  datasourceFilters: Array<DatasourceFilter>;
  /** Fetch DatasourceFilters with support for pagination */
  datasourceFiltersConnection: DatasourceFiltersConnection;
  /** Fetches Datasources by filtering on id or name */
  datasources: Array<Datasource>;
  /** Fetch Datasources with support for pagination */
  datasourcesConnection: DatasourcesConnection;
  /** Fetches EmbeddedDatasources by filtering on id or name */
  embeddedDatasources: Array<EmbeddedDatasource>;
  /** Fetch EmbeddedDatasources with support for pagination */
  embeddedDatasourcesConnection: EmbeddedDatasourcesConnection;
  /** Fetches Fields by filtering on id or name */
  fields: Array<Field>;
  /** Fetch Fields with support for pagination */
  fieldsConnection: FieldsConnection;
  /** Fetches Files by filtering on id or name */
  files: Array<File>;
  /** Fetch Files with support for pagination */
  filesConnection: FilesConnection;
  /** Fetches FlowColumnInputFields by filtering on id or name */
  flowColumnInputFields: Array<FlowColumnInputField>;
  /** Fetch FlowColumnInputFields with support for pagination */
  flowColumnInputFieldsConnection: FlowColumnInputFieldsConnection;
  /** Fetches FlowColumnOutputFields by filtering on id or name */
  flowColumnOutputFields: Array<FlowColumnOutputField>;
  /** Fetch FlowColumnOutputFields with support for pagination */
  flowColumnOutputFieldsConnection: FlowColumnOutputFieldsConnection;
  /** Fetches FlowFieldInputFields by filtering on id or name */
  flowFieldInputFields: Array<FlowFieldInputField>;
  /** Fetch FlowFieldInputFields with support for pagination */
  flowFieldInputFieldsConnection: FlowFieldInputFieldsConnection;
  /** Fetches FlowFieldOutputFields by filtering on id or name */
  flowFieldOutputFields: Array<FlowFieldOutputField>;
  /** Fetch FlowFieldOutputFields with support for pagination */
  flowFieldOutputFieldsConnection: FlowFieldOutputFieldsConnection;
  /** Fetches FlowOutputSteps by filtering on id or name */
  flowOutputSteps: Array<FlowOutputStep>;
  /** Fetch FlowOutputSteps with support for pagination */
  flowOutputStepsConnection: FlowOutputStepsConnection;
  /** Fetches Flows by filtering on id or name */
  flows: Array<Flow>;
  /** Fetch Flows with support for pagination */
  flowsConnection: FlowsConnection;
  /** Fetches GenericLabels by filtering on id or name */
  genericLabels: Array<GenericLabel>;
  /** Fetch GenericLabels with support for pagination */
  genericLabelsConnection: GenericLabelsConnection;
  /** Fetches GroupFields by filtering on id or name */
  groupFields: Array<GroupField>;
  /** Fetch GroupFields with support for pagination */
  groupFieldsConnection: GroupFieldsConnection;
  /** Fetches HierarchyFields by filtering on id or name */
  hierarchyFields: Array<HierarchyField>;
  /** Fetch HierarchyFields with support for pagination */
  hierarchyFieldsConnection: HierarchyFieldsConnection;
  /** Fetches LensFields by filtering on id or name */
  lensFields: Array<LensField>;
  /** Fetch LensFields with support for pagination */
  lensFieldsConnection: LensFieldsConnection;
  /** Fetches Lenses by filtering on id or name */
  lenses: Array<Lens>;
  /** Fetch Lenss with support for pagination */
  lensesConnection: LensesConnection;
  /** Fetches Metrics by filtering on id or name */
  metrics: Array<Metric>;
  /** Fetch Metrics with support for pagination */
  metricsConnection: MetricsConnection;
  /** Fetches Parameters by filtering on id or name */
  parameters: Array<Parameter>;
  /** Fetch Parameters with support for pagination */
  parametersConnection: ParametersConnection;
  /** Fetches PublishedDatasources by filtering on id or name */
  publishedDatasources: Array<PublishedDatasource>;
  /** Fetch PublishedDatasources with support for pagination */
  publishedDatasourcesConnection: PublishedDatasourcesConnection;
  /** Fetches SetFields by filtering on id or name */
  setFields: Array<SetField>;
  /** Fetch SetFields with support for pagination */
  setFieldsConnection: SetFieldsConnection;
  /** Fetches Sheets by filtering on id or name */
  sheets: Array<Sheet>;
  /** Fetch Sheets with support for pagination */
  sheetsConnection: SheetsConnection;
  /** Fetches TableauSites by filtering on id or name */
  tableauSites: Array<TableauSite>;
  /** Fetch TableauSites with support for pagination */
  tableauSitesConnection: TableauSitesConnection;
  /** Fetches TableauUsers by filtering on id or name */
  tableauUsers: Array<TableauUser>;
  /** Fetch TableauUsers with support for pagination */
  tableauUsersConnection: TableauUsersConnection;
  /** Fetches Tables by filtering on id or name */
  tables: Array<Table>;
  /** Fetch Tables with support for pagination */
  tablesConnection: TablesConnection;
  /** Fetches Tags by filtering on id or name */
  tags: Array<Tag>;
  /** Fetch Tags with support for pagination */
  tagsConnection: TagsConnection;
  /** Fetches Views by filtering on id or name */
  views: Array<View>;
  /** Fetch Views with support for pagination */
  viewsConnection: ViewsConnection;
  /** Fetches VirtualConnectionTables by filtering on id or name */
  virtualConnectionTables: Array<VirtualConnectionTable>;
  /** Fetch VirtualConnectionTables with support for pagination */
  virtualConnectionTablesConnection: VirtualConnectionTablesConnection;
  /** Fetches VirtualConnections by filtering on id or name */
  virtualConnections: Array<VirtualConnection>;
  /** Fetch VirtualConnections with support for pagination */
  virtualConnectionsConnection: VirtualConnectionsConnection;
  /** Fetches WebDataConnectors by filtering on id or name */
  webDataConnectors: Array<WebDataConnector>;
  /** Fetch WebDataConnectors with support for pagination */
  webDataConnectorsConnection: WebDataConnectorsConnection;
  /** Fetches Workbooks by filtering on id or name */
  workbooks: Array<Workbook>;
  /** Fetch Workbooks with support for pagination */
  workbooksConnection: WorkbooksConnection;
};


/** Query root for Metadata GraphQL interface */
export type Query_AskDataExtensionsArgs = {
  filter: InputMaybe<AskDataExtension_Filter>;
  orderBy: InputMaybe<AskDataExtensionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_AskDataExtensionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<AskDataExtension_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<AskDataExtensionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_BinFieldsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_BinFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CalculatedFieldsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CalculatedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CloudFilesArgs = {
  filter: InputMaybe<CloudFile_Filter>;
  orderBy: InputMaybe<CloudFileSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CloudFilesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CloudFile_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CloudFileSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ColumnFieldsArgs = {
  filter: InputMaybe<ColumnField_Filter>;
  orderBy: InputMaybe<ColumnFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ColumnFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<ColumnField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CombinedSetFieldsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CombinedSetFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CustomSqlTablesArgs = {
  filter: InputMaybe<CustomSqlTable_Filter>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_CustomSqlTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CustomSqlTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatabaseServersArgs = {
  filter: InputMaybe<DatabaseServer_Filter>;
  orderBy: InputMaybe<DatabaseServerSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatabaseServersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseServer_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseServerSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatabaseTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatabaseTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatasourceFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatasourceFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatasourceFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatasourceFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatasourcesArgs = {
  filter: InputMaybe<Datasource_Filter>;
  orderBy: InputMaybe<DatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_DatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Datasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_EmbeddedDatasourcesArgs = {
  filter: InputMaybe<EmbeddedDatasource_Filter>;
  orderBy: InputMaybe<EmbeddedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_EmbeddedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<EmbeddedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<EmbeddedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FilesArgs = {
  filter: InputMaybe<File_Filter>;
  orderBy: InputMaybe<FileSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FilesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<File_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FileSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowColumnInputFieldsArgs = {
  filter: InputMaybe<FlowColumnInputField_Filter>;
  orderBy: InputMaybe<FlowColumnInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowColumnInputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowColumnInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowColumnInputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowColumnOutputFieldsArgs = {
  filter: InputMaybe<FlowColumnOutputField_Filter>;
  orderBy: InputMaybe<FlowColumnOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowColumnOutputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowColumnOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowColumnOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowFieldInputFieldsArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowFieldInputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowFieldOutputFieldsArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowFieldOutputFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowOutputStepsArgs = {
  filter: InputMaybe<FlowOutputStep_Filter>;
  orderBy: InputMaybe<FlowOutputStepSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowOutputStepsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowOutputStep_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowOutputStepSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_FlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_GenericLabelsArgs = {
  filter: InputMaybe<GenericLabel_Filter>;
  orderBy: InputMaybe<GenericLabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_GenericLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GenericLabel_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GenericLabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_GroupFieldsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_GroupFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_HierarchyFieldsArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_HierarchyFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_LensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_LensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_LensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_LensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_MetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_MetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ParametersArgs = {
  filter: InputMaybe<Parameter_Filter>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ParametersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Parameter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_PublishedDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_PublishedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_SetFieldsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_SetFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TableauSitesArgs = {
  filter: InputMaybe<TableauSite_Filter>;
  orderBy: InputMaybe<TableauSiteSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TableauSitesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauSite_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauSiteSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TableauUsersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TableauUsersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TablesArgs = {
  filter: InputMaybe<Table_Filter>;
  orderBy: InputMaybe<TableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Table_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ViewsArgs = {
  filter: InputMaybe<View_Filter>;
  orderBy: InputMaybe<ViewSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_ViewsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<View_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ViewSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_VirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_VirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_VirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_VirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_WebDataConnectorsArgs = {
  filter: InputMaybe<WebDataConnector_Filter>;
  orderBy: InputMaybe<WebDataConnectorSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_WebDataConnectorsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<WebDataConnector_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WebDataConnectorSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_WorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Query root for Metadata GraphQL interface */
export type Query_WorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/**
 * Possible types of remote types
 *
 * Types correspond to OLEDB types here: https://referencesource.microsoft.com/#system.data/System/Data/OleDb/OLEDB_Enum.cs,364"
 *
 * Types prefixed with 'WDC' correspond to Tableau's Web Data Connector types:
 * https://tableau.github.io/webdataconnector/docs/api_ref.html#webdataconnectorapi.datatypeenum
 */
export enum RemoteType {
  ARRAY = 'ARRAY',
  BOOL = 'BOOL',
  BSTR = 'BSTR',
  BYREF = 'BYREF',
  BYTES = 'BYTES',
  CY = 'CY',
  DATE = 'DATE',
  DBDATE = 'DBDATE',
  DBTIME = 'DBTIME',
  DBTIMESTAMP = 'DBTIMESTAMP',
  DECIMAL = 'DECIMAL',
  EMPTY = 'EMPTY',
  ERROR = 'ERROR',
  FILETIME = 'FILETIME',
  GUID = 'GUID',
  HCHAPTER = 'HCHAPTER',
  I1 = 'I1',
  I2 = 'I2',
  I4 = 'I4',
  I8 = 'I8',
  IDISPATCH = 'IDISPATCH',
  IUNKNOWN = 'IUNKNOWN',
  NULL = 'NULL',
  NUMERIC = 'NUMERIC',
  PROPVARIANT = 'PROPVARIANT',
  R4 = 'R4',
  R8 = 'R8',
  RESERVED = 'RESERVED',
  STR = 'STR',
  UDT = 'UDT',
  UI1 = 'UI1',
  UI2 = 'UI2',
  UI4 = 'UI4',
  UI8 = 'UI8',
  VARIANT = 'VARIANT',
  VARNUMERIC = 'VARNUMERIC',
  VECTOR = 'VECTOR',
  WDC_BOOL = 'WDC_BOOL',
  WDC_DATE = 'WDC_DATE',
  WDC_DATETIME = 'WDC_DATETIME',
  WDC_FLOAT = 'WDC_FLOAT',
  WDC_GEOMETRY = 'WDC_GEOMETRY',
  WDC_INT = 'WDC_INT',
  WDC_STRING = 'WDC_STRING',
  WSTR = 'WSTR'
}

/** Filter by GraphQL field and given value */
export type RemoteType_Filter = {
  /** Unique Identifier of object to retrieve */
  id: InputMaybe<Scalars['ID']>;
  /** Unique Identifier of object to retrieve */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField = Field & FieldReferencingField & Node & {
  __typename: 'SetField';
  /** Data source that contains this field */
  datasource: Maybe<Datasource>;
  /** List of lens fields which are derived from this field */
  derivedLensFields: Maybe<Array<Maybe<LensField>>>;
  /** List of lens fields which are derived from this field */
  derivedLensFieldsConnection: Maybe<LensFieldsConnection>;
  /** Description of field shown in server and desktop clients */
  description: Maybe<Scalars['String']>;
  /** description that is shown in the Tableau UI */
  descriptionInherited: Maybe<Array<Maybe<InheritedStringResult>>>;
  /** Sheets that reference this field */
  directSheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this field */
  directSheetsConnection: Maybe<SheetsConnection>;
  /** Columns downstream of this field */
  downstreamColumns: Array<Column>;
  /** Columns downstream of this field */
  downstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Dashboards connected downstream from the field */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected downstream from the field */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this field */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this field */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected downstream from this field */
  downstreamDatasources: Maybe<Array<PublishedDatasource>>;
  /** Datasources connected downstream from this field */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** downstream fields that reference this field */
  downstreamFields: Array<Field>;
  /** downstream fields that reference this field */
  downstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows downstream of this field */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this field */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from this field */
  downstreamLenses: Maybe<Array<Lens>>;
  /** Lenses connected downstream from this field */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected downstream from the field */
  downstreamMetrics: Maybe<Array<Metric>>;
  /** Metrics connected downstream from the field */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwners: Maybe<Array<TableauUser>>;
  /** Workbook owners (authors) connected downstream from the field */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected downstream from the field */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected downstream from the field */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this field */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this field */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this field */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this field */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooks: Maybe<Array<Workbook>>;
  /** Workbooks connected downstream from the field */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** List of fields, if any, that this field references */
  fields: Array<Field>;
  /** List of fields, if any, that this field references */
  fieldsConnection: Maybe<FieldsConnection>;
  /** Name of folder if the field is in a folder. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/datafields_dwfeatures.html#Organize */
  folderName: Maybe<Scalars['String']>;
  /** Name internally used to uniquely identify fields */
  fullyQualifiedName: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if the field is hidden */
  isHidden: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** List of parameters, if any, used in this field */
  parameters: Array<Parameter>;
  /** List of parameters, if any, used in this field */
  parametersConnection: Maybe<ParametersConnection>;
  /** The bin field that references this field */
  referencedByBins: Maybe<Array<Maybe<BinField>>>;
  /** The bin field that references this field */
  referencedByBinsConnection: Maybe<BinFieldsConnection>;
  /** The calculated field that references this field */
  referencedByCalculations: Maybe<Array<Maybe<CalculatedField>>>;
  /** The calculated field that references this field */
  referencedByCalculationsConnection: Maybe<CalculatedFieldsConnection>;
  /** The combined field that references this field */
  referencedByCombinedFields: Maybe<Array<Maybe<CombinedField>>>;
  /** The combined field that references this field */
  referencedByCombinedFieldsConnection: Maybe<CombinedFieldsConnection>;
  /** Thie combined set field that references this field */
  referencedByCombinedSets: Maybe<Array<Maybe<CombinedSetField>>>;
  /** Thie combined set field that references this field */
  referencedByCombinedSetsConnection: Maybe<CombinedSetFieldsConnection>;
  /** The field that references this field */
  referencedByFields: Maybe<Array<Maybe<FieldReferencingField>>>;
  /** The field that references this field */
  referencedByFieldsConnection: Maybe<FieldReferencingFieldsConnection>;
  /** The data source filters that include this field */
  referencedByFilters: Maybe<Array<Maybe<DatasourceFilter>>>;
  /** The data source filters that include this field */
  referencedByFiltersConnection: Maybe<DatasourceFiltersConnection>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputField: Maybe<Array<Maybe<FlowFieldInputField>>>;
  /** A flow input field that wraps this field */
  referencedByFlowFieldInputFieldConnection: Maybe<FlowFieldInputFieldsConnection>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputField: Maybe<Array<Maybe<FlowFieldOutputField>>>;
  /** A flow output field that wraps this field */
  referencedByFlowFieldOutputFieldConnection: Maybe<FlowFieldOutputFieldsConnection>;
  /** The group field that references this field */
  referencedByGroups: Maybe<Array<Maybe<GroupField>>>;
  /** The group field that references this field */
  referencedByGroupsConnection: Maybe<GroupFieldsConnection>;
  /** The hierarchy field that references this field */
  referencedByHierarchies: Maybe<Array<Maybe<HierarchyField>>>;
  /** The hierarchy field that references this field */
  referencedByHierarchiesConnection: Maybe<HierarchyFieldsConnection>;
  /** The field that references this remote field */
  referencedByRemoteFields: Maybe<Array<Maybe<DatasourceField>>>;
  /** The field that references this remote field */
  referencedByRemoteFieldsConnection: Maybe<DatasourceFieldsConnection>;
  /** The set field that this field references */
  referencedBySets: Maybe<Array<Maybe<SetField>>>;
  /** The set field that this field references */
  referencedBySetsConnection: Maybe<SetFieldsConnection>;
  /** Sheets that reference this data source field */
  sheets: Maybe<Array<Maybe<Sheet>>>;
  /** Sheets that reference this data source field */
  sheetsConnection: Maybe<SheetsConnection>;
  /** All upstream columns this field references */
  upstreamColumns: Array<Maybe<Column>>;
  /** All upstream columns this field references */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Databases connected upstream from the field */
  upstreamDatabases: Array<Database>;
  /** Databases connected upstream from the field */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources connected upstream from the field */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources connected upstream from the field */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** fields that are upstream of this field */
  upstreamFields: Array<Maybe<Field>>;
  /** fields that are upstream of this field */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** Flows connected upstream from the field */
  upstreamFlows: Array<Flow>;
  /** Flows connected upstream from the field */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables connected upstream from the field */
  upstreamTables: Array<DatabaseTable>;
  /** Tables connected upstream from the field */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this field */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this field */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DerivedLensFieldsArgs = {
  filter: InputMaybe<LensField_Filter>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DerivedLensFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<LensField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DescriptionInheritedArgs = {
  inheritanceType: InputMaybe<InheritanceType>;
  permissionMode: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DirectSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DirectSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_FieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_FieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ParametersArgs = {
  filter: InputMaybe<Parameter_Filter>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ParametersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Parameter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByBinsArgs = {
  filter: InputMaybe<BinField_Filter>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByBinsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BinField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BinFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByCalculationsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByCalculationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByCombinedFieldsArgs = {
  filter: InputMaybe<CombinedField_Filter>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByCombinedFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByCombinedSetsArgs = {
  filter: InputMaybe<CombinedSetField_Filter>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByCombinedSetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CombinedSetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CombinedSetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFieldsArgs = {
  filter: InputMaybe<FieldReferencingField_Filter>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FieldReferencingField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldReferencingFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFiltersArgs = {
  filter: InputMaybe<DatasourceFilter_Filter>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFiltersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceFilter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFilterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFlowFieldInputFieldArgs = {
  filter: InputMaybe<FlowFieldInputField_Filter>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFlowFieldInputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldInputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldInputFieldSortOrder>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFlowFieldOutputFieldArgs = {
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByFlowFieldOutputFieldConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<FlowFieldOutputField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowFieldOutputFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByGroupsArgs = {
  filter: InputMaybe<GroupField_Filter>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByGroupsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GroupField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<GroupFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByHierarchiesArgs = {
  filter: InputMaybe<HierarchyField_Filter>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByHierarchiesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<HierarchyField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<HierarchyFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByRemoteFieldsArgs = {
  filter: InputMaybe<DatasourceField_Filter>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedByRemoteFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatasourceField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedBySetsArgs = {
  filter: InputMaybe<SetField_Filter>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_ReferencedBySetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SetField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SetFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** GraphQL type for a set field. See https://onlinehelp.tableau.com/current/pro/desktop/en-us/sortgroup_sets_create.html */
export type SetField_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum SetFieldOrderField {
  /** Sort by downstreamSheets count */
  DOWNSTREAM_SHEETS_COUNT = 'DOWNSTREAM_SHEETS_COUNT',
  /** Sort by fields count */
  FIELDS_COUNT = 'FIELDS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isHidden */
  IS_HIDDEN = 'IS_HIDDEN',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type SetFieldSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: SetFieldOrderField;
};

/** Filter by GraphQL field and given value */
export type SetField_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if the field is hidden */
  isHidden: InputMaybe<Scalars['Boolean']>;
  /** True if the field is hidden */
  isHiddenWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Filter by GraphQL field and given value */
export type SetField_Required_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for SetField */
export type SetFieldsConnection = {
  __typename: 'SetFieldsConnection';
  /** List of nodes */
  nodes: Array<SetField>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  sheet contained in a published workbook. */
export type Sheet = Taggable & View & {
  __typename: 'Sheet';
  /** Dashboards that contain this sheet */
  containedInDashboards: Maybe<Array<Maybe<Dashboard>>>;
  /** Dashboards that contain this sheet */
  containedInDashboardsConnection: Maybe<DashboardsConnection>;
  /** Time the sheet was created */
  createdAt: Scalars['DateTime'];
  /** Fields that are contained in an embedded data source and are also referenced by the worksheet. If a worksheet uses calculated fields (or any other FieldReferencingField), this list will also include all of the referenced fields. */
  datasourceFields: Maybe<Array<Maybe<Field>>>;
  /** Fields that are contained in an embedded data source and are also referenced by the worksheet. If a worksheet uses calculated fields (or any other FieldReferencingField), this list will also include all of the referenced fields. */
  datasourceFieldsConnection: Maybe<FieldsConnection>;
  /** Unique ID for the sheet generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewId: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Index of view; the order it appears in the workbook */
  index: Maybe<Scalars['Int']>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if worksheet is hidden in Workbook) */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Parent embedded data source of this sheet */
  parentEmbeddedDatasources: Array<EmbeddedDatasource>;
  /** Parent embedded data source of this sheet */
  parentEmbeddedDatasourcesConnection: Maybe<EmbeddedDatasourcesConnection>;
  /** Server path to sheet */
  path: Maybe<Scalars['String']>;
  /** The Metrics that reference this View */
  referencedByMetrics: Maybe<Array<Maybe<Metric>>>;
  /** The Metrics that reference this View */
  referencedByMetricsConnection: Maybe<MetricsConnection>;
  /** All fields in the collection worksheetFields as well as the fields in datasourceFields used directly by this sheet. If the worksheet uses calculated fields this list will not include referenced fields that are not directly used by the sheet. */
  sheetFieldInstances: Maybe<Array<Maybe<Field>>>;
  /** All fields in the collection worksheetFields as well as the fields in datasourceFields used directly by this sheet. If the worksheet uses calculated fields this list will not include referenced fields that are not directly used by the sheet. */
  sheetFieldInstancesConnection: Maybe<FieldsConnection>;
  /** Tags associated with the view */
  tags: Array<Tag>;
  /** Tags associated with the view */
  tagsConnection: Maybe<TagsConnection>;
  /** Time the sheet was updated */
  updatedAt: Scalars['DateTime'];
  /** The columns that are upstream of this sheet */
  upstreamColumns: Array<Maybe<Column>>;
  /** The columns that are upstream of this sheet */
  upstreamColumnsConnection: Maybe<ColumnsConnection>;
  /** Data quality warnings upstream from this sheet */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this sheet */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** The databases that are upstream of this sheet */
  upstreamDatabases: Maybe<Array<Maybe<Database>>>;
  /** The databases that are upstream of this sheet */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** The data sources that are upstream of this sheet */
  upstreamDatasources: Maybe<Array<Maybe<Datasource>>>;
  /** The data sources that are upstream of this sheet */
  upstreamDatasourcesConnection: Maybe<DatasourcesConnection>;
  /** The fields that are upstream of this sheet */
  upstreamFields: Array<Maybe<Field>>;
  /** The fields that are upstream of this sheet */
  upstreamFieldsConnection: Maybe<FieldsConnection>;
  /** The flows that are upstream of this sheet */
  upstreamFlows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that are upstream of this sheet */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this sheet. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this sheet. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** The tables that are upstream of this sheet */
  upstreamTables: Maybe<Array<Maybe<Table>>>;
  /** The tables that are upstream of this sheet */
  upstreamTablesConnection: Maybe<TablesConnection>;
  /** The workbook that contains this view */
  workbook: Maybe<Workbook>;
  /** Calculated fields which were created on this sheet, e.g. in the rows or columns shelves and which may not be used on other sheets that use this embedded data source */
  worksheetFields: Maybe<Array<Maybe<CalculatedField>>>;
  /** Calculated fields which were created on this sheet, e.g. in the rows or columns shelves and which may not be used on other sheets that use this embedded data source */
  worksheetFieldsConnection: Maybe<CalculatedFieldsConnection>;
};


/**  sheet contained in a published workbook. */
export type Sheet_ContainedInDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_ContainedInDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_DatasourceFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_DatasourceFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_ParentEmbeddedDatasourcesArgs = {
  filter: InputMaybe<EmbeddedDatasource_Filter>;
  orderBy: InputMaybe<EmbeddedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_ParentEmbeddedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<EmbeddedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<EmbeddedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_ReferencedByMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_ReferencedByMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_SheetFieldInstancesArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_SheetFieldInstancesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamDatasourcesArgs = {
  filter: InputMaybe<Datasource_Filter>;
  orderBy: InputMaybe<DatasourceSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Datasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatasourceSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamFieldsArgs = {
  filter: InputMaybe<Field_Filter>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Field_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamTablesArgs = {
  filter: InputMaybe<Table_Filter>;
  orderBy: InputMaybe<TableSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Table_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableSortOrder>;
};


/**  sheet contained in a published workbook. */
export type Sheet_WorksheetFieldsArgs = {
  filter: InputMaybe<CalculatedField_Filter>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  sheet contained in a published workbook. */
export type Sheet_WorksheetFieldsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CalculatedField_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CalculatedFieldSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum SheetOrderField {
  /** Sort by datasourceFields count */
  DATASOURCE_FIELDS_COUNT = 'DATASOURCE_FIELDS_COUNT',
  /** Sort by documentViewId */
  DOCUMENT_VIEW_ID = 'DOCUMENT_VIEW_ID',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by path */
  PATH = 'PATH',
  /** Sort by sheetFieldInstances count */
  SHEET_FIELD_INSTANCES_COUNT = 'SHEET_FIELD_INSTANCES_COUNT',
  /** Sort by worksheetFields count */
  WORKSHEET_FIELDS_COUNT = 'WORKSHEET_FIELDS_COUNT'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type SheetSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: SheetOrderField;
};

/** Filter by GraphQL field and given value */
export type Sheet_Filter = {
  /** Unique ID for the sheet generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewId: InputMaybe<Scalars['String']>;
  /** Unique ID for the sheet generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if worksheet is hidden in Workbook) */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if worksheet is hidden in Workbook) */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Server path to sheet */
  path: InputMaybe<Scalars['String']>;
  /** Server path to sheet */
  pathWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Sheet */
export type SheetsConnection = {
  __typename: 'SheetsConnection';
  /** List of nodes */
  nodes: Array<Sheet>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  table containing columns */
export type Table = {
  /** Columns contained in this table */
  columns: Array<Column>;
  /** Columns contained in this table */
  columnsConnection: Maybe<ColumnsConnection>;
  /** User modifiable description of this table */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the table */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the table */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this table */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this table */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the table */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the table */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this table */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this table */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected downstream from the table */
  downstreamLenses: Array<Lens>;
  /** Lenses connected downstream from the table */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected to the table */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected to the table */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwners: Array<TableauUser>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the table */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the table */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this table */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this table */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this table */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this table */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection downstream of this table */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection downstream of this table */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the table */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the table */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this table is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Databases upstream of this table */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this table */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this table */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this table */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this table */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this table */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Tables upstream of this table */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this table */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this table */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this table */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
};


/**  table containing columns */
export type Table_ColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_ColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  table containing columns */
export type Table_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  table containing columns */
export type Table_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  table containing columns */
export type Table_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum TableOrderField {
  /** Sort by columns count */
  COLUMNS_COUNT = 'COLUMNS_COUNT',
  /** Sort by downstreamDashboards count */
  DOWNSTREAM_DASHBOARDS_COUNT = 'DOWNSTREAM_DASHBOARDS_COUNT',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type TableSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: TableOrderField;
};

/** Filter by GraphQL field and given value */
export type Table_Filter = {
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Site on Tableau server */
export type TableauSite = {
  __typename: 'TableauSite';
  /** Time the site was created. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The flows that are part of this site */
  flows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that are part of this site */
  flowsConnection: Maybe<FlowsConnection>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** The Lenses that are part of this site */
  lenses: Maybe<Array<Maybe<Lens>>>;
  /** The Lenses that are part of this site */
  lensesConnection: Maybe<LensesConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** The Metrics that are part of this site */
  metrics: Maybe<Array<Maybe<Metric>>>;
  /** The Metrics that are part of this site */
  metricsConnection: Maybe<MetricsConnection>;
  /** Name shown in server */
  name: Scalars['String'];
  /** The published data sources that are part of this site */
  publishedDatasources: Maybe<Array<Maybe<PublishedDatasource>>>;
  /** The published data sources that are part of this site */
  publishedDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** URI of this site, e.g., 'sites/4' */
  uri: Scalars['String'];
  /** The virtual connections that are part of this site */
  virtualConnections: Maybe<Array<Maybe<VirtualConnection>>>;
  /** The virtual connections that are part of this site */
  virtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** The workbooks that are part of this site */
  workbooks: Maybe<Array<Maybe<Workbook>>>;
  /** The workbooks that are part of this site */
  workbooksConnection: Maybe<WorkbooksConnection>;
};


/** Site on Tableau server */
export type TableauSite_FlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_FlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_LensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_LensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_MetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_MetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_PublishedDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_PublishedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_VirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_VirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_WorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Site on Tableau server */
export type TableauSite_WorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum TableauSiteOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type TableauSiteSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: TableauSiteOrderField;
};

/** Filter by GraphQL field and given value */
export type TableauSite_Filter = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for TableauSite */
export type TableauSitesConnection = {
  __typename: 'TableauSitesConnection';
  /** List of nodes */
  nodes: Array<TableauSite>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** User on a site on Tableau server */
export type TableauUser = {
  __typename: 'TableauUser';
  /** The data quality certifications this user has authored */
  authoredDataQualityCertifications: Maybe<Array<Maybe<DataQualityCertification>>>;
  /** The data quality certifications this user has authored */
  authoredDataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /** The data quality warnings this user has authored */
  authoredDataQualityWarnings: Maybe<Array<Maybe<DataQualityWarning>>>;
  /** The data quality warnings this user has authored */
  authoredDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** The labels this user has authored */
  authoredLabels: Maybe<Array<Maybe<Label>>>;
  /** The labels this user has authored */
  authoredLabelsConnection: Maybe<LabelsConnection>;
  /** The databases that this user has certified */
  certifiedDatabases: Maybe<Array<Maybe<Database>>>;
  /** The databases that this user has certified */
  certifiedDatabasesConnection: Maybe<DatabasesConnection>;
  /** The published data sources that this user has certified */
  certifiedDatasources: Maybe<Array<Maybe<PublishedDatasource>>>;
  /** The published data sources that this user has certified */
  certifiedDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** The tables that this user has certified */
  certifiedTables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** The tables that this user has certified */
  certifiedTablesConnection: Maybe<DatabaseTablesConnection>;
  /** The databases that this user is the contact for */
  contactForDatabases: Maybe<Array<Maybe<Database>>>;
  /** The databases that this user is the contact for */
  contactForDatabasesConnection: Maybe<DatabasesConnection>;
  /** The tables that this user is the contact for */
  contactForTables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** The tables that this user is the contact for */
  contactForTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Domain this user belongs to */
  domain: Maybe<Scalars['String']>;
  /** Email address of this user */
  email: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Display name of this user */
  name: Maybe<Scalars['String']>;
  /** The published data sources that belong to this user */
  ownedDatasources: Maybe<Array<Maybe<PublishedDatasource>>>;
  /** The published data sources that belong to this user */
  ownedDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** The flows that belong to this user */
  ownedFlows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that belong to this user */
  ownedFlowsConnection: Maybe<FlowsConnection>;
  /** The Lenses that belong to this user */
  ownedLenses: Maybe<Array<Maybe<Lens>>>;
  /** The Lenses that belong to this user */
  ownedLensesConnection: Maybe<LensesConnection>;
  /** The Metrics that belong to this user */
  ownedMetrics: Maybe<Array<Maybe<Metric>>>;
  /** The Metrics that belong to this user */
  ownedMetricsConnection: Maybe<MetricsConnection>;
  /** The virtual connection tables that belong to this user */
  ownedVirtualConnectionTables: Maybe<Array<Maybe<VirtualConnectionTable>>>;
  /** The virtual connection tables that belong to this user */
  ownedVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** The virtual connections that belong to this user */
  ownedVirtualConnections: Maybe<Array<Maybe<VirtualConnection>>>;
  /** The virtual connections that belong to this user */
  ownedVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** The workbooks that belong to this user */
  ownedWorkbooks: Maybe<Array<Maybe<Workbook>>>;
  /** The workbooks that belong to this user */
  ownedWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** URI of this user, e.g., 'sites/1/users/1396' */
  uri: Scalars['String'];
  /** Username of this user */
  username: Maybe<Scalars['String']>;
  /** Vizportal ID of this user, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};


/** User on a site on Tableau server */
export type TableauUser_AuthoredDataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_AuthoredDataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_AuthoredDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_AuthoredDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_AuthoredLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_AuthoredLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_CertifiedDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_CertifiedDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_CertifiedDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_CertifiedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_CertifiedTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_CertifiedTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_ContactForDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_ContactForDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_ContactForTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_ContactForTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** User on a site on Tableau server */
export type TableauUser_OwnedWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum TableauUserOrderField {
  /** Sort by domain */
  DOMAIN = 'DOMAIN',
  /** Sort by email */
  EMAIL = 'EMAIL',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by username */
  USERNAME = 'USERNAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type TableauUserSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: TableauUserOrderField;
};

/** Filter by GraphQL field and given value */
export type TableauUser_Filter = {
  /** Domain this user belongs to */
  domain: InputMaybe<Scalars['String']>;
  /** Domain this user belongs to */
  domainWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Email address of this user */
  email: InputMaybe<Scalars['String']>;
  /** Email address of this user */
  emailWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Display name of this user */
  name: InputMaybe<Scalars['String']>;
  /** Display name of this user */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Username of this user */
  username: InputMaybe<Scalars['String']>;
  /** Username of this user */
  usernameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for TableauUser */
export type TableauUsersConnection = {
  __typename: 'TableauUsersConnection';
  /** List of nodes */
  nodes: Array<TableauUser>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Connection Type for Table */
export type TablesConnection = {
  __typename: 'TablesConnection';
  /** List of nodes */
  nodes: Array<Table>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  tag associated with content items */
export type Tag = {
  __typename: 'Tag';
  /** The assets that are associated with this tag */
  assets: Maybe<Array<Maybe<Taggable>>>;
  /** The assets that are associated with this tag */
  assetsConnection: Maybe<TaggablesConnection>;
  /** The columns that are associated with this tag */
  columns: Maybe<Array<Maybe<Column>>>;
  /** The columns that are associated with this tag */
  columnsConnection: Maybe<ColumnsConnection>;
  /** The tables that are associated with this tag */
  databaseTables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** The tables that are associated with this tag */
  databaseTablesConnection: Maybe<DatabaseTablesConnection>;
  /** The databases that are associated with this tag */
  databases: Maybe<Array<Maybe<Database>>>;
  /** The databases that are associated with this tag */
  databasesConnection: Maybe<DatabasesConnection>;
  /** The flows that are associated with this tag */
  flows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that are associated with this tag */
  flowsConnection: Maybe<FlowsConnection>;
  /** Unique identifier used by the metadata API. */
  id: Scalars['ID'];
  /** The Metrics that are associated with this tag */
  metrics: Maybe<Array<Maybe<Metric>>>;
  /** The Metrics that are associated with this tag */
  metricsConnection: Maybe<MetricsConnection>;
  /** The name of the tag */
  name: Maybe<Scalars['String']>;
  /** The published datasources that are associated with this tag */
  publishedDatasources: Maybe<Array<Maybe<PublishedDatasource>>>;
  /** The published datasources that are associated with this tag */
  publishedDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** The views that are associated with this tag */
  views: Maybe<Array<Maybe<View>>>;
  /** The views that are associated with this tag */
  viewsConnection: Maybe<ViewsConnection>;
  /** The virtual connection tables that are associated with this tag */
  virtualConnectionTables: Maybe<Array<Maybe<VirtualConnectionTable>>>;
  /** The virtual connection tables that are associated with this tag */
  virtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** The virtual connections that are associated with this tag */
  virtualConnections: Maybe<Array<Maybe<VirtualConnection>>>;
  /** The virtual connections that are associated with this tag */
  virtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** The workbooks that are associated with this tag */
  workbooks: Maybe<Array<Maybe<Workbook>>>;
  /** The workbooks that are associated with this tag */
  workbooksConnection: Maybe<WorkbooksConnection>;
};


/**  tag associated with content items */
export type Tag_AssetsArgs = {
  filter: InputMaybe<Taggable_Filter>;
  orderBy: InputMaybe<TaggableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_AssetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Taggable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TaggableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_ColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_ColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_DatabaseTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_DatabaseTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_DatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_DatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_FlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_FlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_MetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_MetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_PublishedDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_PublishedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_ViewsArgs = {
  filter: InputMaybe<View_Filter>;
  orderBy: InputMaybe<ViewSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_ViewsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<View_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ViewSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_VirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_VirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_VirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_VirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_WorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  tag associated with content items */
export type Tag_WorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum TagOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type TagSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: TagOrderField;
};

/** Filter by GraphQL field and given value */
export type Tag_Filter = {
  /** Unique identifier used by the metadata API. */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The name of the tag */
  name: InputMaybe<Scalars['String']>;
  /** The name of the tag */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/**  content item that has a list of tags */
export type Taggable = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** The name of the asset */
  name: Maybe<Scalars['String']>;
  /** Tags associated with the content item */
  tags: Array<Tag>;
  /** Tags associated with the content item */
  tagsConnection: Maybe<TagsConnection>;
};


/**  content item that has a list of tags */
export type Taggable_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  content item that has a list of tags */
export type Taggable_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};

/** Enum for fields that can be used for sorting */
export enum TaggableOrderField {
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type TaggableSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: TaggableOrderField;
};

/** Filter by GraphQL field and given value */
export type Taggable_Filter = {
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Taggable */
export type TaggablesConnection = {
  __typename: 'TaggablesConnection';
  /** List of nodes */
  nodes: Array<Taggable>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Connection Type for Tag */
export type TagsConnection = {
  __typename: 'TagsConnection';
  /** List of nodes */
  nodes: Array<Tag>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View = {
  /** Time the view was created */
  createdAt: Scalars['DateTime'];
  /** Unique ID for the view generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewId: Maybe<Scalars['String']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Index of view; the order it appears in the workbook */
  index: Maybe<Scalars['Int']>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if sheet is hidden in Workbook) */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** Server path to view */
  path: Maybe<Scalars['String']>;
  /** The Metrics that reference this View */
  referencedByMetrics: Maybe<Array<Maybe<Metric>>>;
  /** The Metrics that reference this View */
  referencedByMetricsConnection: Maybe<MetricsConnection>;
  /** Tags associated with the view */
  tags: Array<Tag>;
  /** Tags associated with the view */
  tagsConnection: Maybe<TagsConnection>;
  /** Time the view was updated */
  updatedAt: Scalars['DateTime'];
  /** Data quality warnings upstream from this view */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this view */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Labels upstream from this view. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this view. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** The workbook that contains this view */
  workbook: Maybe<Workbook>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_ReferencedByMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_ReferencedByMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  view contained in a published workbook. Views can be sheets or dashboards. */
export type View_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum ViewOrderField {
  /** Sort by documentViewId */
  DOCUMENT_VIEW_ID = 'DOCUMENT_VIEW_ID',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by path */
  PATH = 'PATH'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type ViewSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: ViewOrderField;
};

/** Filter by GraphQL field and given value */
export type View_Filter = {
  /** Unique ID for the view generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewId: InputMaybe<Scalars['String']>;
  /** Unique ID for the view generated for and stored within the workbook, survives renames, and is used for internal processes */
  documentViewIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if sheet is hidden in Workbook) */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server (Blank if sheet is hidden in Workbook) */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Server path to view */
  path: InputMaybe<Scalars['String']>;
  /** Server path to view */
  pathWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for View */
export type ViewsConnection = {
  __typename: 'ViewsConnection';
  /** List of nodes */
  nodes: Array<View>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection = CanHaveLabels & Certifiable & Taggable & Warnable & {
  __typename: 'VirtualConnection';
  /**
   * Connection type of this virtual connection
   * @deprecated Returns 'null' in Tableau Cloud December 2022 / Server 2023.1 and later, and may be removed in a future release. Use 'connectionType' of 'upstreamDatabases' instead.
   */
  connectionType: Maybe<Scalars['String']>;
  /** The name of the container in which the virtual connection is visible and usable. Either a personal space or project. */
  containerName: Maybe<Scalars['String']>;
  /** The type of the container in which the virtual connection is visible and usable. Either personal space or project. */
  containerType: Scalars['String'];
  /** Time the Virtual Connection was created. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  createdAt: Maybe<Scalars['DateTime']>;
  /** The data quality certifications on a virtual connection */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a virtual connection */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * Singular data quality warning, deprecated but required to implement @warnable
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a virtual connection */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a virtual connection */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this virtual connection */
  description: Maybe<Scalars['String']>;
  /** Dashboards downstream of this virtual connection */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards downstream of this virtual connection */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Published Data Sources downstream of this virtual connection */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published Data Sources downstream of this virtual connection */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this virtual connection */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this virtual connection */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses downstream of this published connection */
  downstreamLenses: Array<Lens>;
  /** Lenses downstream of this published connection */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics downstream of this virtual connection */
  downstreamMetrics: Array<Metric>;
  /** Metrics downstream of this virtual connection */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners connected to the database */
  downstreamOwners: Array<TableauUser>;
  /** Owners connected to the database */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets downstream of this virtual connection */
  downstreamSheets: Array<Sheet>;
  /** Sheets downstream of this virtual connection */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** VirtualConnectionTables downstream of this virtual connection */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** VirtualConnectionTables downstream of this virtual connection */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Workbooks downstream of this virtual connection */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks downstream of this virtual connection */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** True if the virtual connection has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this virtual connection contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** The labels on a virtual connection. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a virtual connection. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** User who owns this virtual connection */
  owner: TableauUser;
  /** The name of the project that contains this virtual connection. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the virtual connection is visible and usable. Will return null if the published virtual connection is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The site which contains this virtual connection */
  site: TableauSite;
  /** The tables exposed by this virtual connection */
  tables: Array<VirtualConnectionTable>;
  /** The tables exposed by this virtual connection */
  tablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Tags associated with the virtual connection */
  tags: Array<Tag>;
  /** Tags associated with the virtual connection */
  tagsConnection: Maybe<TagsConnection>;
  /** Time the Virtual Connection was last updated. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** Data quality warnings upstream from this virtual connection */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this virtual connection */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this virtual connection */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this virtual connection */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this virtual connection */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this virtual connection */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this virtual connection */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this virtual connection */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this virtual connection. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this virtual connection. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this virtual connection */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this virtual connection */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** The virtual connection tables that are upstream to this virtual connection */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** The virtual connection tables that are upstream to this virtual connection */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Uri of the virtual connection */
  uri: Maybe<Scalars['String']>;
  /** Vizportal ID of this table, for use in client-to-server communications */
  vizportalId: Scalars['String'];
  /** Vizportal URL ID; used for URL generation */
  vizportalUrlId: Scalars['String'];
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_TablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * Virtual connections are sharable central access points to data.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnection_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum VirtualConnectionOrderField {
  /** Sort by connectionType */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Sort by containerName */
  CONTAINER_NAME = 'CONTAINER_NAME',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by owner count */
  OWNER_COUNT = 'OWNER_COUNT',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME',
  /** Sort by vizportalUrlId */
  VIZPORTAL_URL_ID = 'VIZPORTAL_URL_ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type VirtualConnectionSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: VirtualConnectionOrderField;
};

/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable = CanHaveLabels & Certifiable & Table & Taggable & Warnable & {
  __typename: 'VirtualConnectionTable';
  /** Columns contained by this table */
  columns: Array<Column>;
  /** Columns contained by this table */
  columnsConnection: Maybe<ColumnsConnection>;
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: Maybe<Scalars['Boolean']>;
  /** The data quality certifications on a virtual connection table */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a virtual connection table */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * Singular data quality warning, deprecated but required to implement @warnable
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a virtual connection table */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a virtual connection table */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this table */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the table */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the table */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this table */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this table */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the table */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the table */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this table */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this table */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected to the table */
  downstreamLenses: Array<Lens>;
  /** Lenses connected to the table */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics downstream of this table */
  downstreamMetrics: Array<Metric>;
  /** Metrics downstream of this table */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwners: Array<TableauUser>;
  /** Owners of workbooks and published datasources connected to the table */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the table */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the table */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this table */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this table */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this table */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this table */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections downstream of this table */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections downstream of this table */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the table */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the table */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** The type of this table's last extract refresh (incremental or full). */
  extractLastRefreshType: Maybe<ExtractType>;
  /** The time the data for this table's extract was refreshed. */
  extractLastRefreshedAt: Maybe<Scalars['DateTime']>;
  /** True if the table has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this virtual connection table contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** True if this table is embedded in Tableau content, e.g., a packaged workbook */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** Whether or not queries to this table are using an extract. */
  isExtracted: Maybe<Scalars['Boolean']>;
  /** The labels on a virtual connection table. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a virtual connection table. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** User who owns this virtual connection table */
  owner: TableauUser;
  /** Tags associated with this table */
  tags: Array<Tag>;
  /** Tags associated with this table */
  tagsConnection: Maybe<TagsConnection>;
  /** Data quality warnings upstream from this virtual connection */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this virtual connection */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this table */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this table */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this table */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this table */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this table */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this table */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this virtual connection. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this virtual connection. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this table */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this table */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this table */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connections upstream of this table */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connections upstream of this table */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Uri of the virtual connection table */
  uri: Maybe<Scalars['String']>;
  /** The parent virtual connection for this table */
  virtualConnection: Maybe<VirtualConnection>;
  /** Vizportal ID of this column, for use in client-to-server communications */
  vizportalId: Maybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: Scalars['String'];
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_ColumnsArgs = {
  filter: InputMaybe<Column_Filter>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_ColumnsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Column_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ColumnSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**
 * A table in a virtual connection.
 * *Available in Tableau Cloud March 2022 / Server 2022.1 and later.*
 */
export type VirtualConnectionTable_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum VirtualConnectionTableOrderField {
  /** Sort by columns count */
  COLUMNS_COUNT = 'COLUMNS_COUNT',
  /** Sort by containsUnsupportedCustomSql */
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = 'CONTAINS_UNSUPPORTED_CUSTOM_SQL',
  /** Sort by downstreamDashboards count */
  DOWNSTREAM_DASHBOARDS_COUNT = 'DOWNSTREAM_DASHBOARDS_COUNT',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by extractLastRefreshedAt */
  EXTRACT_LAST_REFRESHED_AT = 'EXTRACT_LAST_REFRESHED_AT',
  /** Sort by extractLastRefreshType */
  EXTRACT_LAST_REFRESH_TYPE = 'EXTRACT_LAST_REFRESH_TYPE',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by isExtracted */
  IS_EXTRACTED = 'IS_EXTRACTED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by owner count */
  OWNER_COUNT = 'OWNER_COUNT',
  /** Sort by vizportalUrlId */
  VIZPORTAL_URL_ID = 'VIZPORTAL_URL_ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type VirtualConnectionTableSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: VirtualConnectionTableOrderField;
};

/** Filter by GraphQL field and given value */
export type VirtualConnectionTable_Filter = {
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: InputMaybe<Scalars['Boolean']>;
  /** True if the datasource contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSqlWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** The time the data for this table's extract was refreshed. */
  extractLastRefreshedAt: InputMaybe<Scalars['DateTime']>;
  /** The time the data for this table's extract was refreshed. */
  extractLastRefreshedAtWithin: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** True if the table has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the table has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this virtual connection table contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this virtual connection table contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Whether or not queries to this table are using an extract. */
  isExtracted: InputMaybe<Scalars['Boolean']>;
  /** Whether or not queries to this table are using an extract. */
  isExtractedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: InputMaybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for VirtualConnectionTable */
export type VirtualConnectionTablesConnection = {
  __typename: 'VirtualConnectionTablesConnection';
  /** List of nodes */
  nodes: Array<VirtualConnectionTable>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Filter by GraphQL field and given value */
export type VirtualConnection_Filter = {
  /** Connection type of this virtual connection */
  connectionType: InputMaybe<Scalars['String']>;
  /** Connection type of this virtual connection */
  connectionTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the container in which the virtual connection is visible and usable. Either a personal space or project. */
  containerName: InputMaybe<Scalars['String']>;
  /** The name of the container in which the virtual connection is visible and usable. Either a personal space or project. */
  containerNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the virtual connection has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the virtual connection has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this virtual connection contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this virtual connection contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project that contains this virtual connection. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project that contains this virtual connection. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Vizportal URL ID; used for URL generation */
  vizportalUrlId: InputMaybe<Scalars['String']>;
  /** Vizportal URL ID; used for URL generation */
  vizportalUrlIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for VirtualConnection */
export type VirtualConnectionsConnection = {
  __typename: 'VirtualConnectionsConnection';
  /** List of nodes */
  nodes: Array<VirtualConnection>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  content item that can have data quality warnings */
export type Warnable = {
  /**
   * The optional data quality warning on a content item
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a content item */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a content item */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** True if the content has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** The name of the asset */
  name: Maybe<Scalars['String']>;
};


/**  content item that can have data quality warnings */
export type Warnable_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  content item that can have data quality warnings */
export type Warnable_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum WarnableOrderField {
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type WarnableSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: WarnableOrderField;
};

/** Filter by GraphQL field and given value */
export type Warnable_Filter = {
  /** True if the content has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the content has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Warnable */
export type WarnablesConnection = {
  __typename: 'WarnablesConnection';
  /** List of nodes */
  nodes: Array<Warnable>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/**  web data connector */
export type WebDataConnector = CanHaveLabels & Certifiable & Database & Taggable & Warnable & {
  __typename: 'WebDataConnector';
  /**
   * Notes related to the web data connector table being marked as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certificationNote: Maybe<Scalars['String']>;
  /**
   * User who marked this database as certified
   * @deprecated No longer supported. Use 'dataQualityCertifications'
   */
  certifier: Maybe<TableauUser>;
  /** The type of web data connector */
  connectionType: Maybe<Scalars['String']>;
  /** The url for the sign-in page of the web data connector */
  connectorUrl: Maybe<Scalars['String']>;
  /** Contact for this database */
  contact: Maybe<TableauUser>;
  /** The data quality certifications on a database */
  dataQualityCertifications: Array<DataQualityCertification>;
  /** The data quality certifications on a database */
  dataQualityCertificationsConnection: Maybe<DataQualityCertificationsConnection>;
  /**
   * The optional data quality warning on a database
   * @deprecated Use 'dataQualityWarnings'
   */
  dataQualityWarning: Maybe<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarnings: Array<DataQualityWarning>;
  /** The data quality warnings on a database */
  dataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** User modifiable description of this database */
  description: Maybe<Scalars['String']>;
  /** Dashboards connected to the database */
  downstreamDashboards: Array<Dashboard>;
  /** Dashboards connected to the database */
  downstreamDashboardsConnection: Maybe<DashboardsConnection>;
  /** Databases downstream of this database */
  downstreamDatabases: Array<Database>;
  /** Databases downstream of this database */
  downstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Published datasources connected to the database */
  downstreamDatasources: Array<PublishedDatasource>;
  /** Published datasources connected to the database */
  downstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows downstream of this database */
  downstreamFlows: Array<Flow>;
  /** Flows downstream of this database */
  downstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Lenses connected to the database */
  downstreamLenses: Array<Lens>;
  /** Lenses connected to the database */
  downstreamLensesConnection: Maybe<LensesConnection>;
  /** Metrics connected to the database */
  downstreamMetrics: Array<Metric>;
  /** Metrics connected to the database */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Owners connected to the database */
  downstreamOwners: Array<TableauUser>;
  /** Owners connected to the database */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Sheets connected to the database */
  downstreamSheets: Array<Sheet>;
  /** Sheets connected to the database */
  downstreamSheetsConnection: Maybe<SheetsConnection>;
  /** Tables downstream of this database */
  downstreamTables: Array<DatabaseTable>;
  /** Tables downstream of this database */
  downstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables downstream of this database */
  downstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Workbooks connected to the database */
  downstreamWorkbooks: Array<Workbook>;
  /** Workbooks connected to the database */
  downstreamWorkbooksConnection: Maybe<WorkbooksConnection>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: Scalars['Boolean'];
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** True if this database contains an active data quality certification */
  isCertified: Scalars['Boolean'];
  /** True if this database has its permission locked */
  isControlledPermissionsEnabled: Maybe<Scalars['Boolean']>;
  /** A web data connector is always embedded in Tableau content */
  isEmbedded: Maybe<Scalars['Boolean']>;
  /** True if this database has been grouped with other databases */
  isGrouped: Maybe<Scalars['Boolean']>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labels: Array<Label>;
  /** The labels on a database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  labelsConnection: Maybe<LabelsConnection>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** The custom SQL queries that reference this database */
  referencedByQueries: Maybe<Array<Maybe<CustomSqlTable>>>;
  /** The custom SQL queries that reference this database */
  referencedByQueriesConnection: Maybe<CustomSqlTablesConnection>;
  /** Tables belonging to this database */
  tables: Maybe<Array<Maybe<DatabaseTable>>>;
  /** Tables belonging to this database */
  tablesConnection: Maybe<DatabaseTablesConnection>;
  /** Tags associated with the database */
  tags: Array<Tag>;
  /** Tags associated with the database */
  tagsConnection: Maybe<TagsConnection>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this database */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** Databases upstream of this database */
  upstreamDatabases: Array<Database>;
  /** Databases upstream of this database */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** Datasources upstream of this database */
  upstreamDatasources: Array<PublishedDatasource>;
  /** Datasources upstream of this database */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** Flows upstream of this database */
  upstreamFlows: Array<Flow>;
  /** Flows upstream of this database */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this database. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** Tables upstream of this database */
  upstreamTables: Array<DatabaseTable>;
  /** Tables upstream of this database */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTables: Array<VirtualConnectionTable>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnections: Array<VirtualConnection>;
  /** Virtual connection tables upstream of this database */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Vizportal ID of this database, for use in client-to-server communications */
  vizportalId: Scalars['String'];
};


/**  web data connector */
export type WebDataConnector_DataQualityCertificationsArgs = {
  filter: InputMaybe<DataQualityCertification_Filter>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DataQualityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityCertification_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityCertificationSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamDashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamDashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  web data connector */
export type WebDataConnector_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/**  web data connector */
export type WebDataConnector_DownstreamSheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamSheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamWorkbooksArgs = {
  filter: InputMaybe<Workbook_Filter>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_DownstreamWorkbooksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Workbook_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<WorkbookSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_LabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_LabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_ReferencedByQueriesArgs = {
  filter: InputMaybe<CustomSqlTable_Filter>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_ReferencedByQueriesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CustomSqlTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<CustomSqlTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_TablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_TablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  web data connector */
export type WebDataConnector_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/**  web data connector */
export type WebDataConnector_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/**  web data connector */
export type WebDataConnector_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum WebDataConnectorOrderField {
  /** Sort by connectionType */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Sort by downstreamDatasources count */
  DOWNSTREAM_DATASOURCES_COUNT = 'DOWNSTREAM_DATASOURCES_COUNT',
  /** Sort by downstreamVirtualConnections count */
  DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT = 'DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT',
  /** Sort by downstreamWorkbooks count */
  DOWNSTREAM_WORKBOOKS_COUNT = 'DOWNSTREAM_WORKBOOKS_COUNT',
  /** Sort by hasActiveWarning */
  HAS_ACTIVE_WARNING = 'HAS_ACTIVE_WARNING',
  /** Sort by id */
  ID = 'ID',
  /** Sort by isCertified */
  IS_CERTIFIED = 'IS_CERTIFIED',
  /** Sort by isEmbedded */
  IS_EMBEDDED = 'IS_EMBEDDED',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type WebDataConnectorSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: WebDataConnectorOrderField;
};

/** Filter by GraphQL field and given value */
export type WebDataConnector_Filter = {
  /** The type of web data connector */
  connectionType: InputMaybe<Scalars['String']>;
  /** The type of web data connector */
  connectionTypeWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the database has an active data quality warning */
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  /** True if the database has an active data quality warning */
  hasActiveWarningWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API. Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** True if this database contains an active data quality certification */
  isCertified: InputMaybe<Scalars['Boolean']>;
  /** True if this database contains an active data quality certification */
  isCertifiedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** A web data connector is always embedded in Tableau content */
  isEmbedded: InputMaybe<Scalars['Boolean']>;
  /** A web data connector is always embedded in Tableau content */
  isEmbeddedWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the table is visible. Will be empty if the table is not in a project. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter the output based on text query. */
  text: InputMaybe<Scalars['String']>;
};

/** Connection Type for WebDataConnector */
export type WebDataConnectorsConnection = {
  __typename: 'WebDataConnectorsConnection';
  /** List of nodes */
  nodes: Array<WebDataConnector>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook = Taggable & {
  __typename: 'Workbook';
  /** The name of the container in which the workbook is visible and usable. Either a personal space or project. */
  containerName: Maybe<Scalars['String']>;
  /** The type of the container in which the workbook is visible and usable. Either personal space or project. */
  containerType: Scalars['String'];
  /** True if the workbook contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: Maybe<Scalars['Boolean']>;
  /** Time the workbook was created */
  createdAt: Scalars['DateTime'];
  /** Dashboards that are contained in this workbook */
  dashboards: Array<Dashboard>;
  /** Dashboards that are contained in this workbook */
  dashboardsConnection: Maybe<DashboardsConnection>;
  /** Description of the workbook */
  description: Maybe<Scalars['String']>;
  /** Metrics downstream from this workbook */
  downstreamMetrics: Array<Metric>;
  /** Metrics downstream from this workbook */
  downstreamMetricsConnection: Maybe<MetricsConnection>;
  /** Metric owners downstream from this workbook */
  downstreamOwners: Array<TableauUser>;
  /** Metric owners downstream from this workbook */
  downstreamOwnersConnection: Maybe<TableauUsersConnection>;
  /** Data sources that are embedded in this workbook */
  embeddedDatasources: Array<EmbeddedDatasource>;
  /** Data sources that are embedded in this workbook */
  embeddedDatasourcesConnection: Maybe<EmbeddedDatasourcesConnection>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: Scalars['ID'];
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: Scalars['String'];
  /** Name shown in server and desktop clients */
  name: Maybe<Scalars['String']>;
  /** User who owns this workbook */
  owner: TableauUser;
  /** Parameters that are contained in this workbook */
  parameters: Array<Parameter>;
  /** Parameters that are contained in this workbook */
  parametersConnection: Maybe<ParametersConnection>;
  /** The luid of the project in which the workbook is visible and usable. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  projectLuid: Maybe<Scalars['String']>;
  /** The name of the project in which the workbook is visible and usable. */
  projectName: Maybe<Scalars['String']>;
  /** The ID of the project in which the workbook is visible and usable. Will be null if the workbook is not in a project. */
  projectVizportalUrlId: Maybe<Scalars['String']>;
  /** Worksheets that are contained in this workbook */
  sheets: Array<Sheet>;
  /** Worksheets that are contained in this workbook */
  sheetsConnection: Maybe<SheetsConnection>;
  /** The site in which the workbook is visible and usable */
  site: TableauSite;
  /** Tags associated with the workbook */
  tags: Array<Tag>;
  /** Tags associated with the workbook */
  tagsConnection: Maybe<TagsConnection>;
  /** Time the workbook was updated */
  updatedAt: Scalars['DateTime'];
  /** Data quality warnings upstream from this workbook */
  upstreamDataQualityWarnings: Array<DataQualityWarning>;
  /** Data quality warnings upstream from this workbook */
  upstreamDataQualityWarningsConnection: Maybe<DataQualityWarningsConnection>;
  /** The Databases that are upstream to this Workbook */
  upstreamDatabases: Array<Maybe<Database>>;
  /** The Databases that are upstream to this Workbook */
  upstreamDatabasesConnection: Maybe<DatabasesConnection>;
  /** The Published Datasources that are upstream to this Workbook */
  upstreamDatasources: Array<Maybe<PublishedDatasource>>;
  /** The Published Datasources that are upstream to this Workbook */
  upstreamDatasourcesConnection: Maybe<PublishedDatasourcesConnection>;
  /** The flows that are upstream of this workbook */
  upstreamFlows: Maybe<Array<Maybe<Flow>>>;
  /** The flows that are upstream of this workbook */
  upstreamFlowsConnection: Maybe<FlowsConnection>;
  /** Labels upstream from this workbook. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabels: Array<Label>;
  /** Labels upstream from this workbook. Available in Tableau Cloud March 2023 / Server 2023.1 and later. */
  upstreamLabelsConnection: Maybe<LabelsConnection>;
  /** The Lenses that are upstream of this workbook */
  upstreamLenses: Maybe<Array<Maybe<Lens>>>;
  /** The Lenses that are upstream of this workbook */
  upstreamLensesConnection: Maybe<LensesConnection>;
  /** The tables upstream to this Workbook */
  upstreamTables: Array<Maybe<DatabaseTable>>;
  /** The tables upstream to this Workbook */
  upstreamTablesConnection: Maybe<DatabaseTablesConnection>;
  /** The virtual connection table upstream to this Workbook */
  upstreamVirtualConnectionTables: Array<Maybe<VirtualConnectionTable>>;
  /** The virtual connection table upstream to this Workbook */
  upstreamVirtualConnectionTablesConnection: Maybe<VirtualConnectionTablesConnection>;
  /** The virtual connection upstream to this Workbook */
  upstreamVirtualConnections: Array<Maybe<VirtualConnection>>;
  /** The virtual connection upstream to this Workbook */
  upstreamVirtualConnectionsConnection: Maybe<VirtualConnectionsConnection>;
  /** Uri of the workbook */
  uri: Maybe<Scalars['String']>;
  /** Views that are contained in this workbook */
  views: Array<View>;
  /** Views that are contained in this workbook */
  viewsConnection: Maybe<ViewsConnection>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: Scalars['String'];
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_DashboardsArgs = {
  filter: InputMaybe<Dashboard_Filter>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_DashboardsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Dashboard_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DashboardSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_DownstreamMetricsArgs = {
  filter: InputMaybe<Metric_Filter>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_DownstreamMetricsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Metric_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<MetricSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_DownstreamOwnersArgs = {
  filter: InputMaybe<TableauUser_Filter>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_DownstreamOwnersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TableauUser_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TableauUserSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_EmbeddedDatasourcesArgs = {
  filter: InputMaybe<EmbeddedDatasource_Filter>;
  orderBy: InputMaybe<EmbeddedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_EmbeddedDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<EmbeddedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<EmbeddedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_ParametersArgs = {
  filter: InputMaybe<Parameter_Filter>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_ParametersConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Parameter_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ParameterSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_SheetsArgs = {
  filter: InputMaybe<Sheet_Filter>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_SheetsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Sheet_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<SheetSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_TagsArgs = {
  filter: InputMaybe<Tag_Filter>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_TagsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Tag_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<TagSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamDataQualityWarningsArgs = {
  filter: InputMaybe<DataQualityWarning_Filter>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamDataQualityWarningsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DataQualityWarning_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DataQualityWarningSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamDatabasesArgs = {
  filter: InputMaybe<Database_Filter>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamDatabasesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Database_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamDatasourcesArgs = {
  filter: InputMaybe<PublishedDatasource_Filter>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamDatasourcesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PublishedDatasource_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<PublishedDatasourceSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamFlowsArgs = {
  filter: InputMaybe<Flow_Filter>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamFlowsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Flow_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<FlowSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamLabelsArgs = {
  filter: InputMaybe<Label_Filter>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamLabelsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Label_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LabelSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamLensesArgs = {
  filter: InputMaybe<Lens_Filter>;
  orderBy: InputMaybe<LensSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamLensesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Lens_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<LensSortOrder>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamTablesArgs = {
  filter: InputMaybe<DatabaseTable_Filter>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DatabaseTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<DatabaseTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamVirtualConnectionTablesArgs = {
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamVirtualConnectionTablesConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnectionTable_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionTableSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamVirtualConnectionsArgs = {
  filter: InputMaybe<VirtualConnection_Filter>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_UpstreamVirtualConnectionsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<VirtualConnection_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<VirtualConnectionSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_ViewsArgs = {
  filter: InputMaybe<View_Filter>;
  orderBy: InputMaybe<ViewSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};


/** Workbooks are used to package up Tableau visualizations (which are called "sheets" in the Metadata API) and data models (which are called "embedded data sources" when they are owned by a workbook). */
export type Workbook_ViewsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<View_Filter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ViewSortOrder>;
  permissionMode?: InputMaybe<PermissionMode>;
};

/** Enum for fields that can be used for sorting */
export enum WorkbookOrderField {
  /** Sort by containerName */
  CONTAINER_NAME = 'CONTAINER_NAME',
  /** Sort by containsUnsupportedCustomSql */
  CONTAINS_UNSUPPORTED_CUSTOM_SQL = 'CONTAINS_UNSUPPORTED_CUSTOM_SQL',
  /** Sort by dashboards count */
  DASHBOARDS_COUNT = 'DASHBOARDS_COUNT',
  /** Sort by embeddedDatasources count */
  EMBEDDED_DATASOURCES_COUNT = 'EMBEDDED_DATASOURCES_COUNT',
  /** Sort by id */
  ID = 'ID',
  /** Sort by luid */
  LUID = 'LUID',
  /** Sort by name */
  NAME = 'NAME',
  /** Sort by owner count */
  OWNER_COUNT = 'OWNER_COUNT',
  /** Sort by projectLuid */
  PROJECT_LUID = 'PROJECT_LUID',
  /** Sort by projectName */
  PROJECT_NAME = 'PROJECT_NAME',
  /** Sort by sheets count */
  SHEETS_COUNT = 'SHEETS_COUNT',
  /** Sort by views count */
  VIEWS_COUNT = 'VIEWS_COUNT',
  /** Sort by vizportalUrlId */
  VIZPORTAL_URL_ID = 'VIZPORTAL_URL_ID'
}

/** Sort by given fields. The sort orders defined first in the list will take priority. If there are no given sort orders or a tie on the final sorted field then the resulting set will be sorted by ID in ascending order. */
export type WorkbookSortOrder = {
  /** Order direction to sort output */
  direction: OrderDirection;
  /** GraphQL field to sort on */
  field: WorkbookOrderField;
};

/** Filter by GraphQL field and given value */
export type Workbook_Filter = {
  /** The name of the container in which the workbook is visible and usable. Either a personal space or project. */
  containerName: InputMaybe<Scalars['String']>;
  /** The name of the container in which the workbook is visible and usable. Either a personal space or project. */
  containerNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** True if the workbook contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSql: InputMaybe<Scalars['Boolean']>;
  /** True if the workbook contains unsupported custom SQL, in which case lineage may be incomplete */
  containsUnsupportedCustomSqlWithin: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  id: InputMaybe<Scalars['ID']>;
  /** Unique identifier used by the metadata API.  Not the same as the numeric ID used on server */
  idWithin: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luid: InputMaybe<Scalars['String']>;
  /** Locally unique identifier used for the REST API on the Tableau Server */
  luidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name shown in server and desktop clients */
  name: InputMaybe<Scalars['String']>;
  /** Name shown in server and desktop clients */
  nameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The luid of the project in which the workbook is visible and usable. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  projectLuid: InputMaybe<Scalars['String']>;
  /** The luid of the project in which the workbook is visible and usable. Available in Tableau Cloud June 2022 / Server 2022.3 and later. */
  projectLuidWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of the project in which the workbook is visible and usable. */
  projectName: InputMaybe<Scalars['String']>;
  /** The name of the project in which the workbook is visible and usable. */
  projectNameWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlId: InputMaybe<Scalars['String']>;
  /** VizPortal URL ID; used for URL generation */
  vizportalUrlIdWithin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Connection Type for Workbook */
export type WorkbooksConnection = {
  __typename: 'WorkbooksConnection';
  /** List of nodes */
  nodes: Array<Workbook>;
  /** Information for pagination */
  pageInfo: PageInfo;
  /** Total number of objects in connection */
  totalCount: Scalars['Int'];
};

export type CatalogSelectorDropdownCountsQueryVariables = Exact<{
  textSearch: InputMaybe<Scalars['String']>;
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  isCertified: InputMaybe<Scalars['Boolean']>;
}>;


export type CatalogSelectorDropdownCountsQuery = { databaseTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ), databasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) };

export type ColumnDataQualityWarningsQueryVariables = Exact<{
  columnId: Scalars['ID'];
}>;


export type ColumnDataQualityWarningsQuery = { columns: Array<(
    { dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' | 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )> }
    & { __typename: 'Column' }
  )> };

export type ColumnDetailsQueryVariables = Exact<{
  columnId: Scalars['ID'];
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type ColumnDetailsQuery = { columns: Array<(
    { id: string, vizportalId: string | null, luid: string, name: string | null, description: string | null, remoteType: RemoteType, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, upstreamColumns?: Array<(
      { labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    ) | null>, referencedByFieldsConnection: (
      { totalCount: number }
      & { __typename: 'ColumnFieldsConnection' }
    ) | null, referencedByFlowColumnInputFieldConnection: (
      { totalCount: number }
      & { __typename: 'FlowColumnInputFieldsConnection' }
    ) | null, table: (
      { id: string }
      & { __typename: 'CustomSQLTable' | 'VirtualConnectionTable' }
    ) | (
      { luid: string, id: string }
      & { __typename: 'DatabaseTable' }
    ) | null, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )> }
    & { __typename: 'Column' }
  )> };

export type ColumnDetailsByLuidQueryVariables = Exact<{
  columnId: Scalars['ID'];
}>;


export type ColumnDetailsByLuidQuery = { columns: Array<(
    { remoteType: RemoteType, luid: string, name: string | null }
    & { __typename: 'Column' }
  )> };

export type ColumnFieldsQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ColumnFieldsQuery = { columns: Array<(
    { referencedByFieldsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, datasource: (
          { name: string | null, id: string, workbook: (
            { vizportalUrlId: string }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { name: string | null, vizportalUrlId: string }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'ColumnField' }
      )> }
      & { __typename: 'ColumnFieldsConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type ColumnFieldsNodesFragment = (
  { id: string, name: string | null, datasource: (
    { name: string | null, id: string, workbook: (
      { vizportalUrlId: string }
      & { __typename: 'Workbook' }
    ) | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { name: string | null, vizportalUrlId: string }
    & { __typename: 'PublishedDatasource' }
  ) | null }
  & { __typename: 'ColumnField' }
);

export type ColumnFieldsPublishedDatasourceFragment = (
  { vizportalUrlId: string }
  & { __typename: 'PublishedDatasource' }
);

export type ColumnFieldsEmbeddedDatasourceFragment = (
  { id: string, workbook: (
    { vizportalUrlId: string }
    & { __typename: 'Workbook' }
  ) | null }
  & { __typename: 'EmbeddedDatasource' }
);

export type ColumnFlowsQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ColumnFlowsQuery = { columns: Array<(
    { referencedByFlowColumnInputFieldConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, flow: (
          { vizportalUrlId: string, name: string | null }
          & { __typename: 'Flow' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      )> }
      & { __typename: 'FlowColumnInputFieldsConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type FlowColumnInputFieldRowDataFragment = (
  { id: string, name: string | null, flow: (
    { vizportalUrlId: string, name: string | null }
    & { __typename: 'Flow' }
  ) | null }
  & { __typename: 'FlowColumnInputField' }
);

export type ColumnFragment = (
  { id: string, vizportalId: string | null, luid: string, name: string | null, description: string | null, remoteType: RemoteType, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, upstreamColumns?: Array<(
    { labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Column' }
  ) | null>, referencedByFieldsConnection: (
    { totalCount: number }
    & { __typename: 'ColumnFieldsConnection' }
  ) | null, referencedByFlowColumnInputFieldConnection: (
    { totalCount: number }
    & { __typename: 'FlowColumnInputFieldsConnection' }
  ) | null, table: (
    { id: string }
    & { __typename: 'CustomSQLTable' | 'VirtualConnectionTable' }
  ) | (
    { luid: string, id: string }
    & { __typename: 'DatabaseTable' }
  ) | null }
  & { __typename: 'Column' }
);

export type ColumnsReferencingFieldQueryVariables = Exact<{
  fieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ColumnsReferencingFieldQuery = { fields: Array<{ __typename: 'BinField' | 'CalculatedField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
    { columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  )> };

export type ColumnsReferencingFieldColumnsFragment = (
  { id: string, name: string | null, table: (
    { id: string, name: string | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  ) | null }
  & { __typename: 'Column' }
);

export type ConnectToDatabasesConnectionParams_CloudFile_Fragment = (
  { requestUrl: string | null, fileId: string | null, provider: string | null, mimeType: string | null, connectionType: string | null, name: string | null }
  & { __typename: 'CloudFile' }
);

export type ConnectToDatabasesConnectionParams_DatabaseServer_Fragment = (
  { hostName: string | null, port: number | null, extendedConnectionType: string | null, service: string | null, connectionType: string | null, name: string | null }
  & { __typename: 'DatabaseServer' }
);

export type ConnectToDatabasesConnectionParams_File_Fragment = (
  { filePath: string | null, connectionType: string | null, name: string | null }
  & { __typename: 'File' }
);

export type ConnectToDatabasesConnectionParams_WebDataConnector_Fragment = (
  { connectorUrl: string | null, connectionType: string | null, name: string | null }
  & { __typename: 'WebDataConnector' }
);

export type ConnectToDatabasesConnectionParamsFragment = ConnectToDatabasesConnectionParams_CloudFile_Fragment | ConnectToDatabasesConnectionParams_DatabaseServer_Fragment | ConnectToDatabasesConnectionParams_File_Fragment | ConnectToDatabasesConnectionParams_WebDataConnector_Fragment;

export type ConnectToDatabasesConnectionParamsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
}>;


export type ConnectToDatabasesConnectionParamsQuery = { databasesConnection: (
    { nodes: Array<(
      { requestUrl: string | null, fileId: string | null, provider: string | null, mimeType: string | null, connectionType: string | null, name: string | null }
      & { __typename: 'CloudFile' }
    ) | (
      { hostName: string | null, port: number | null, extendedConnectionType: string | null, service: string | null, connectionType: string | null, name: string | null }
      & { __typename: 'DatabaseServer' }
    ) | (
      { filePath: string | null, connectionType: string | null, name: string | null }
      & { __typename: 'File' }
    ) | (
      { connectorUrl: string | null, connectionType: string | null, name: string | null }
      & { __typename: 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) };

export type ConnectToDatabasesDescriptionQueryVariables = Exact<{
  databaseId: Scalars['ID'];
}>;


export type ConnectToDatabasesDescriptionQuery = { databasesConnection: (
    { nodes: Array<(
      { description: string | null, connectionType: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) };

export type ConnectToDatabasesQueryVariables = Exact<{
  databaseFilterText: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  connectionTypeFilterText: InputMaybe<Scalars['String']>;
  hasActiveWarningFilter: InputMaybe<Scalars['Boolean']>;
  isCertifiedFilter: InputMaybe<Scalars['Boolean']>;
  orderBy: DatabaseSortOrder;
  columnDQWs: Scalars['Boolean'];
}>;


export type ConnectToDatabasesQuery = { databasesConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, name: string | null, contact: (
        { id: string, username: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'CloudFile' }
    ) | (
      { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, name: string | null, contact: (
        { id: string, username: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DatabaseServer' }
    ) | (
      { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, name: string | null, contact: (
        { id: string, username: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'File' }
    ) | (
      { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, name: string | null, contact: (
        { id: string, username: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ), maxDownstreamWorkbooks: (
    { nodes: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) };

export type ConnectToDatabases_CloudFile_Fragment = (
  { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, name: string | null, contact: (
    { id: string, username: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { name: string | null, id: string }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
    ) | (
      { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
        { id: string, luid: string, name: string | null }
        & { __typename: 'DatabaseTable' }
      ) | (
        { luid: string, name: string | null }
        & { __typename: 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { name: string | null, vizportalUrlId: string, id: string }
      & { __typename: 'Flow' | 'PublishedDatasource' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )> }
  & { __typename: 'CloudFile' }
);

export type ConnectToDatabases_DatabaseServer_Fragment = (
  { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, name: string | null, contact: (
    { id: string, username: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { name: string | null, id: string }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
    ) | (
      { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
        { id: string, luid: string, name: string | null }
        & { __typename: 'DatabaseTable' }
      ) | (
        { luid: string, name: string | null }
        & { __typename: 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { name: string | null, vizportalUrlId: string, id: string }
      & { __typename: 'Flow' | 'PublishedDatasource' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )> }
  & { __typename: 'DatabaseServer' }
);

export type ConnectToDatabases_File_Fragment = (
  { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, name: string | null, contact: (
    { id: string, username: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { name: string | null, id: string }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
    ) | (
      { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
        { id: string, luid: string, name: string | null }
        & { __typename: 'DatabaseTable' }
      ) | (
        { luid: string, name: string | null }
        & { __typename: 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { name: string | null, vizportalUrlId: string, id: string }
      & { __typename: 'Flow' | 'PublishedDatasource' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )> }
  & { __typename: 'File' }
);

export type ConnectToDatabases_WebDataConnector_Fragment = (
  { id: string, connectionType: string | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, name: string | null, contact: (
    { id: string, username: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { name: string | null, id: string }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
    ) | (
      { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
        { id: string, luid: string, name: string | null }
        & { __typename: 'DatabaseTable' }
      ) | (
        { luid: string, name: string | null }
        & { __typename: 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { name: string | null, vizportalUrlId: string, id: string }
      & { __typename: 'Flow' | 'PublishedDatasource' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )> }
  & { __typename: 'WebDataConnector' }
);

export type ConnectToDatabasesFragment = ConnectToDatabases_CloudFile_Fragment | ConnectToDatabases_DatabaseServer_Fragment | ConnectToDatabases_File_Fragment | ConnectToDatabases_WebDataConnector_Fragment;

export type ConnectToDatabasesTotalCountQueryVariables = Exact<{
  connectionTypeFilterText: InputMaybe<Scalars['String']>;
  databaseFilterText: InputMaybe<Scalars['String']>;
  hasActiveWarningFilter: InputMaybe<Scalars['Boolean']>;
  isCertifiedFilter: InputMaybe<Scalars['Boolean']>;
}>;


export type ConnectToDatabasesTotalCountQuery = { databasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) };

export type ConnectToTablesConnectionParamsQueryVariables = Exact<{
  tableId: Scalars['ID'];
}>;


export type ConnectToTablesConnectionParamsQuery = { databaseTablesConnection: (
    { nodes: Array<(
      { name: string | null, fullName: string | null, schema: string | null, database: (
        { requestUrl: string | null, fileId: string | null, provider: string | null, mimeType: string | null, connectionType: string | null, name: string | null }
        & { __typename: 'CloudFile' }
      ) | (
        { hostName: string | null, port: number | null, extendedConnectionType: string | null, service: string | null, connectionType: string | null, name: string | null }
        & { __typename: 'DatabaseServer' }
      ) | (
        { filePath: string | null, connectionType: string | null, name: string | null }
        & { __typename: 'File' }
      ) | (
        { connectorUrl: string | null, connectionType: string | null, name: string | null }
        & { __typename: 'WebDataConnector' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ) };

export type ConnectToTablesConnectionFragment = (
  { name: string | null, fullName: string | null, schema: string | null, database: (
    { requestUrl: string | null, fileId: string | null, provider: string | null, mimeType: string | null, connectionType: string | null, name: string | null }
    & { __typename: 'CloudFile' }
  ) | (
    { hostName: string | null, port: number | null, extendedConnectionType: string | null, service: string | null, connectionType: string | null, name: string | null }
    & { __typename: 'DatabaseServer' }
  ) | (
    { filePath: string | null, connectionType: string | null, name: string | null }
    & { __typename: 'File' }
  ) | (
    { connectorUrl: string | null, connectionType: string | null, name: string | null }
    & { __typename: 'WebDataConnector' }
  ) | null }
  & { __typename: 'DatabaseTable' }
);

export type ConnectToTablesDescriptionQueryVariables = Exact<{
  tableId: Scalars['ID'];
}>;


export type ConnectToTablesDescriptionQuery = { databaseTablesConnection: (
    { nodes: Array<(
      { description: string | null, database: (
        { connectionType: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ) };

export type ConnectToTablesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  tableFilterText: Scalars['String'];
  connectionTypeFilterText: InputMaybe<Scalars['String']>;
  hasActiveWarningFilter: InputMaybe<Scalars['Boolean']>;
  isCertifiedFilter: InputMaybe<Scalars['Boolean']>;
  orderBy: DatabaseTableSortOrder;
  columnDQWs: Scalars['Boolean'];
}>;


export type ConnectToTablesQuery = { databaseTablesConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, isCertified: boolean, certificationNote: string | null, name: string | null, connectionType: string | null, schema: string | null, database: (
        { connectionType: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, name: string | null }
        & { __typename: 'CloudFile' }
      ) | (
        { connectionType: string | null, hostName: string | null, port: number | null, name: string | null }
        & { __typename: 'DatabaseServer' }
      ) | (
        { connectionType: string | null, filePath: string | null, name: string | null }
        & { __typename: 'File' }
      ) | (
        { connectionType: string | null, connectorUrl: string | null, name: string | null }
        & { __typename: 'WebDataConnector' }
      ) | null, dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )>, contact: (
        { id: string, username: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ), maxDownstreamDatasources: (
    { nodes: Array<(
      { downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ), maxDownstreamWorkbooks: (
    { nodes: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ) };

export type ConnectToTablesFragment = (
  { id: string, isCertified: boolean, certificationNote: string | null, name: string | null, connectionType: string | null, schema: string | null, database: (
    { connectionType: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, name: string | null }
    & { __typename: 'CloudFile' }
  ) | (
    { connectionType: string | null, hostName: string | null, port: number | null, name: string | null }
    & { __typename: 'DatabaseServer' }
  ) | (
    { connectionType: string | null, filePath: string | null, name: string | null }
    & { __typename: 'File' }
  ) | (
    { connectionType: string | null, connectorUrl: string | null, name: string | null }
    & { __typename: 'WebDataConnector' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { name: string | null, id: string }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
    ) | (
      { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
        { id: string, luid: string, name: string | null }
        & { __typename: 'DatabaseTable' }
      ) | (
        { luid: string, name: string | null }
        & { __typename: 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { name: string | null, vizportalUrlId: string, id: string }
      & { __typename: 'Flow' | 'PublishedDatasource' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, contact: (
    { id: string, username: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null }
  & { __typename: 'DatabaseTable' }
);

export type ConnectToTablesTotalCountQueryVariables = Exact<{
  tableFilterText: InputMaybe<Scalars['String']>;
  connectionTypeFilterText: InputMaybe<Scalars['String']>;
  hasActiveWarningFilter: InputMaybe<Scalars['Boolean']>;
  isCertifiedFilter: InputMaybe<Scalars['Boolean']>;
}>;


export type ConnectToTablesTotalCountQuery = { databaseTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) };

export type CustomSqlDetailsFragment = (
  { id: string, name: string | null, isUnsupportedCustomSql: boolean | null, query: string | null }
  & { __typename: 'CustomSQLTable' }
);

export type CustomSqlFromDatasourceFragment = (
  { name: string | null, fields: Array<{ __typename: 'BinField' | 'CalculatedField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
    { columns: Array<(
      { table: (
        { id: string, name: string | null, isUnsupportedCustomSql: boolean | null, query: string | null }
        & { __typename: 'CustomSQLTable' }
      ) | { __typename: 'DatabaseTable' | 'VirtualConnectionTable' } | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnField' }
  )> }
  & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
);

export type WorkbookCustomSqlQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedEmbeddedDatasourceId: Scalars['ID'];
}>;


export type WorkbookCustomSqlQuery = { workbooks: Array<(
    { embeddedDatasources: Array<(
      { name: string | null, fields: Array<{ __typename: 'BinField' | 'CalculatedField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
        { columns: Array<(
          { table: (
            { id: string, name: string | null, isUnsupportedCustomSql: boolean | null, query: string | null }
            & { __typename: 'CustomSQLTable' }
          ) | { __typename: 'DatabaseTable' | 'VirtualConnectionTable' } | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnField' }
      )> }
      & { __typename: 'EmbeddedDatasource' }
    )> }
    & { __typename: 'Workbook' }
  )> };

export type PublishedDatasourceCustomSqlQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type PublishedDatasourceCustomSqlQuery = { publishedDatasources: Array<(
    { name: string | null, fields: Array<{ __typename: 'BinField' | 'CalculatedField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
      { columns: Array<(
        { table: (
          { id: string, name: string | null, isUnsupportedCustomSql: boolean | null, query: string | null }
          & { __typename: 'CustomSQLTable' }
        ) | { __typename: 'DatabaseTable' | 'VirtualConnectionTable' } | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnField' }
    )> }
    & { __typename: 'PublishedDatasource' }
  )> };

export type VirtualConnectionCustomSqlQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type VirtualConnectionCustomSqlQuery = { virtualConnections: Array<(
    { tables: Array<(
      { columns: Array<(
        { remoteColumn: (
          { table: (
            { id: string, name: string | null, isUnsupportedCustomSql: boolean | null, query: string | null }
            & { __typename: 'CustomSQLTable' }
          ) | { __typename: 'DatabaseTable' | 'VirtualConnectionTable' } | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'VirtualConnectionTable' }
    )> }
    & { __typename: 'VirtualConnection' }
  )> };

export type FlowCustomSqlQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedOutputStepId: Scalars['ID'];
}>;


export type FlowCustomSqlQuery = { flows: Array<(
    { outputSteps: Array<(
      { name: string | null, outputFields: Array<(
        { parentFields: Array<(
          { column: (
            { table: (
              { id: string, name: string | null, isUnsupportedCustomSql: boolean | null, query: string | null }
              & { __typename: 'CustomSQLTable' }
            ) | { __typename: 'DatabaseTable' | 'VirtualConnectionTable' } | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputStep' }
    )> }
    & { __typename: 'Flow' }
  )> };

export type DashboardsDisplayGridRowDataFragment = (
  { id: string, name: string | null, path: string | null, workbook: (
    { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
      { domain: string | null, username: string | null, name: string | null }
      & { __typename: 'TableauUser' }
    ) }
    & { __typename: 'Workbook' }
  ) | null }
  & { __typename: 'Dashboard' }
);

export type ViewWarningsQueryVariables = Exact<{
  viewPath: Scalars['String'];
}>;


export type ViewWarningsQuery = { views: Array<(
    { normalUpstreamDataQualityWarnings: Array<(
      { id: string }
      & { __typename: 'DataQualityWarning' }
    )>, severeUpstreamDataQualityWarnings: Array<(
      { id: string }
      & { __typename: 'DataQualityWarning' }
    )> }
    & { __typename: 'Dashboard' | 'Sheet' }
  )> };

export type DataDetailsViewUpstreamDataQualityWarningsQueryVariables = Exact<{
  datasourceIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type DataDetailsViewUpstreamDataQualityWarningsQuery = { embeddedDatasources: Array<(
    { id: string, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'EmbeddedDatasource' }
  )> };

export type DataDetailsViewUpstreamDataQualityWarningsEmbeddedDatasourcesFragment = (
  { id: string, upstreamDataQualityWarningsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' | 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )> }
    & { __typename: 'DataQualityWarningsConnection' }
  ) | null }
  & { __typename: 'EmbeddedDatasource' }
);

export type DataQualityWarningFragment = (
  { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'DataQualityWarning' }
);

export type DataQualityWarningAssetFragment = (
  { asset: (
    { name: string | null, id: string }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
  ) | (
    { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
      { id: string, luid: string, name: string | null }
      & { __typename: 'DatabaseTable' }
    ) | (
      { luid: string, name: string | null }
      & { __typename: 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'Column' }
  ) | (
    { name: string | null, vizportalUrlId: string, id: string }
    & { __typename: 'Flow' | 'PublishedDatasource' }
  ) | null }
  & { __typename: 'DataQualityWarning' }
);

export type DataQualityCertificationFragment = (
  { id: string, vizportalId: string, isActive: boolean, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'DataQualityCertification' }
);

export type DataQualityCertificationAssetFragment = (
  { asset: (
    { name: string | null, id: string }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
  ) | (
    { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
      { id: string, luid: string, name: string | null }
      & { __typename: 'DatabaseTable' }
    ) | (
      { luid: string, name: string | null }
      & { __typename: 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'Column' }
  ) | (
    { name: string | null, vizportalUrlId: string, id: string }
    & { __typename: 'Flow' }
  ) | (
    { vizportalUrlId: string, name: string | null, id: string }
    & { __typename: 'PublishedDatasource' }
  ) | null }
  & { __typename: 'DataQualityCertification' }
);

export type CertificationsFragment = (
  { dataQualityCertifications: Array<(
    { id: string, vizportalId: string, isActive: boolean, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { name: string | null, id: string }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
    ) | (
      { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
        { id: string, luid: string, name: string | null }
        & { __typename: 'DatabaseTable' }
      ) | (
        { luid: string, name: string | null }
        & { __typename: 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { name: string | null, vizportalUrlId: string, id: string }
      & { __typename: 'Flow' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null }
    & { __typename: 'DataQualityCertification' }
  )> }
  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
);

export type DataQualityWarningsInWebAuthoringQueryVariables = Exact<{
  workbookIds: Array<Scalars['String']> | Scalars['String'];
  flowIds: Array<Scalars['String']> | Scalars['String'];
  publishedDatasourceIds: Array<Scalars['String']> | Scalars['String'];
  databaseServerIds: Array<Scalars['String']> | Scalars['String'];
  databaseTableIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DataQualityWarningsInWebAuthoringQuery = { publishedDatasourcesConnection: (
    { nodes: Array<(
      { dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )>, upstreamDataQualityWarningsConnection: (
        { nodes: Array<(
          { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { name: string | null, id: string }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
          ) | (
            { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
              { id: string, luid: string, name: string | null }
              & { __typename: 'DatabaseTable' }
            ) | (
              { luid: string, name: string | null }
              & { __typename: 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { name: string | null, vizportalUrlId: string, id: string }
            & { __typename: 'Flow' | 'PublishedDatasource' }
          ) | null }
          & { __typename: 'DataQualityWarning' }
        )> }
        & { __typename: 'DataQualityWarningsConnection' }
      ) | null }
      & { __typename: 'PublishedDatasource' }
    )> }
    & { __typename: 'PublishedDatasourcesConnection' }
  ), workbooksConnection: (
    { nodes: Array<(
      { upstreamDataQualityWarningsConnection: (
        { nodes: Array<(
          { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { name: string | null, id: string }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
          ) | (
            { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
              { id: string, luid: string, name: string | null }
              & { __typename: 'DatabaseTable' }
            ) | (
              { luid: string, name: string | null }
              & { __typename: 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { name: string | null, vizportalUrlId: string, id: string }
            & { __typename: 'Flow' | 'PublishedDatasource' }
          ) | null }
          & { __typename: 'DataQualityWarning' }
        )> }
        & { __typename: 'DataQualityWarningsConnection' }
      ) | null }
      & { __typename: 'Workbook' }
    )> }
    & { __typename: 'WorkbooksConnection' }
  ), flowsConnection: (
    { nodes: Array<(
      { dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )>, upstreamDataQualityWarningsConnection: (
        { nodes: Array<(
          { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { name: string | null, id: string }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
          ) | (
            { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
              { id: string, luid: string, name: string | null }
              & { __typename: 'DatabaseTable' }
            ) | (
              { luid: string, name: string | null }
              & { __typename: 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { name: string | null, vizportalUrlId: string, id: string }
            & { __typename: 'Flow' | 'PublishedDatasource' }
          ) | null }
          & { __typename: 'DataQualityWarning' }
        )> }
        & { __typename: 'DataQualityWarningsConnection' }
      ) | null }
      & { __typename: 'Flow' }
    )> }
    & { __typename: 'FlowsConnection' }
  ), databaseServersConnection: (
    { nodes: Array<(
      { dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )>, upstreamDataQualityWarningsConnection: (
        { nodes: Array<(
          { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { name: string | null, id: string }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
          ) | (
            { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
              { id: string, luid: string, name: string | null }
              & { __typename: 'DatabaseTable' }
            ) | (
              { luid: string, name: string | null }
              & { __typename: 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { name: string | null, vizportalUrlId: string, id: string }
            & { __typename: 'Flow' | 'PublishedDatasource' }
          ) | null }
          & { __typename: 'DataQualityWarning' }
        )> }
        & { __typename: 'DataQualityWarningsConnection' }
      ) | null }
      & { __typename: 'DatabaseServer' }
    )> }
    & { __typename: 'DatabaseServersConnection' }
  ), databaseTablesConnection: (
    { nodes: Array<(
      { dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )>, upstreamDataQualityWarningsConnection: (
        { nodes: Array<(
          { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { name: string | null, id: string }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
          ) | (
            { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
              { id: string, luid: string, name: string | null }
              & { __typename: 'DatabaseTable' }
            ) | (
              { luid: string, name: string | null }
              & { __typename: 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { name: string | null, vizportalUrlId: string, id: string }
            & { __typename: 'Flow' | 'PublishedDatasource' }
          ) | null }
          & { __typename: 'DataQualityWarning' }
        )> }
        & { __typename: 'DataQualityWarningsConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ) };

export type DatabaseCertificationFragment = (
  { isCertified: boolean, certificationNote: string | null, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
);

export type DatabaseDownstreamDashboardsFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type DatabaseDownstreamDashboardsFilteredByTableQuery = { tables: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamDashboardsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type DatabaseDownstreamDashboardsQuery = { databases: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamDatabasesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type DatabaseDownstreamDatabasesFilteredByTableQuery = { tables: Array<(
    { downstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamDatabasesQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type DatabaseDownstreamDatabasesQuery = { databases: Array<(
    { downstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamDatasourcesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseDownstreamDatasourcesFilteredByTableQuery = { tables: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceQuery = { tables: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamDatasourcesQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseDownstreamDatasourcesQuery = { databases: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseDownstreamDatasourcesWithoutPersonalSpaceQuery = { databases: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamFlowsFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseDownstreamFlowsFilteredByTableQuery = { tables: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamFlowsFilteredByTableWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseDownstreamFlowsFilteredByTableWithoutPersonalSpaceQuery = { tables: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamFlowsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseDownstreamFlowsQuery = { databases: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseDownstreamFlowsWithoutPersonalSpaceQuery = { databases: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamLensesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type DatabaseDownstreamLensesFilteredByTableQuery = { tables: Array<(
    { downstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamLensesQueryVariables = Exact<{
  id: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type DatabaseDownstreamLensesQuery = { databases: Array<(
    { downstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamMetricsFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DatabaseDownstreamMetricsFilteredByTableQuery = { tables: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamMetricsFilteredByTableWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DatabaseDownstreamMetricsFilteredByTableWithoutPersonalSpaceQuery = { tables: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamMetricsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DatabaseDownstreamMetricsQuery = { databases: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamMetricsWithoutPersonalSpaceQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DatabaseDownstreamMetricsWithoutPersonalSpaceQuery = { databases: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamOwnerIdsFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type DatabaseDownstreamOwnerIdsFilteredByTableQuery = { tables: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamOwnerIdsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type DatabaseDownstreamOwnerIdsQuery = { databases: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamOwnersFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type DatabaseDownstreamOwnersFilteredByTableQuery = { tablesConnection: (
    { nodes: Array<(
      { downstreamOwnersConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, ownedDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, ownedMetricsConnection: (
            { totalCount: number }
            & { __typename: 'MetricsConnection' }
          ) | null, ownedVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null }
          & { __typename: 'TableauUser' }
        )> }
        & { __typename: 'TableauUsersConnection' }
      ) | null }
      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
    )> }
    & { __typename: 'TablesConnection' }
  ) };

export type DatabaseDownstreamOwnersQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type DatabaseDownstreamOwnersQuery = { databases: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamSheetsFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type DatabaseDownstreamSheetsFilteredByTableQuery = { tables: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamSheetsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type DatabaseDownstreamSheetsQuery = { databases: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamTablesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DatabaseDownstreamTablesFilteredByTableQuery = { tables: Array<(
    { downstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamTablesQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DatabaseDownstreamTablesQuery = { databases: Array<(
    { downstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamVirtualConnectionTablesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type DatabaseDownstreamVirtualConnectionTablesFilteredByTableQuery = { tables: Array<(
    { downstreamVirtualConnectionTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamVirtualConnectionTablesQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type DatabaseDownstreamVirtualConnectionTablesQuery = { databases: Array<(
    { downstreamVirtualConnectionTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamVirtualConnectionsFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type DatabaseDownstreamVirtualConnectionsFilteredByTableQuery = { tables: Array<(
    { downstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseDownstreamVirtualConnectionsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type DatabaseDownstreamVirtualConnectionsQuery = { databases: Array<(
    { downstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamWorkbooksFilteredByTableQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatabaseDownstreamWorkbooksFilteredByTableQuery = { databases: Array<(
    { tables: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null }
          & { __typename: 'Workbook' }
        )> }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    ) | null> | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceQuery = { databases: Array<(
    { tables: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, description: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null }
          & { __typename: 'Workbook' }
        )> }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    ) | null> | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamWorkbooksQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatabaseDownstreamWorkbooksQuery = { databases: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseDownstreamWorkbooksWithoutPersonalSpaceQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatabaseDownstreamWorkbooksWithoutPersonalSpaceQuery = { databases: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type Database_CloudFile_Fragment = (
  { fileId: string | null, provider: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'CloudFile' }
);

export type Database_DatabaseServer_Fragment = (
  { hostName: string | null, port: number | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'DatabaseServer' }
);

export type Database_File_Fragment = (
  { filePath: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'File' }
);

export type Database_WebDataConnector_Fragment = (
  { connectorUrl: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'WebDataConnector' }
);

export type DatabaseFragment = Database_CloudFile_Fragment | Database_DatabaseServer_Fragment | Database_File_Fragment | Database_WebDataConnector_Fragment;

export type DatabaseIconFragment = (
  { connectionType: string | null, isCertified: boolean, certificationNote: string | null }
  & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
);

export type DatabaseLineageCountsFilteredByTableQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  tableId: Scalars['ID'];
}>;


export type DatabaseLineageCountsFilteredByTableQuery = { databases: Array<(
    { filteredTablesConnection: (
      { nodes: Array<(
        { name: string | null, upstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, upstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, upstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, upstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, downstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamVirtualConnectionTablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamLensesConnection: (
          { totalCount: number }
          & { __typename: 'LensesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDashboardsConnection: (
          { totalCount: number }
          & { __typename: 'DashboardsConnection' }
        ) | null, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, downstreamMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, downstreamOwnersConnection: (
          { totalCount: number }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, unfilteredTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, downstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseLineageCountsFragment = (
  { unfilteredTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, upstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, upstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, downstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamVirtualConnectionTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, downstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamLensesConnection: (
    { totalCount: number }
    & { __typename: 'LensesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
);

export type DatabaseLineageCountsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
}>;


export type DatabaseLineageCountsQuery = { databases: Array<(
    { unfilteredTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, downstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type DatabaseLineageUpstreamDataQualityWarningsQuery = { databases: Array<(
    { id: string, name: string | null, dataQualityWarnings: Array<(
      { isActive: boolean, id: string, vizportalId: string, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' | 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { isActive: boolean, id: string, vizportalId: string, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseQueryVariables = Exact<{
  databaseId: Scalars['ID'];
}>;


export type DatabaseQuery = { databases: Array<(
    { fileId: string | null, provider: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'CloudFile' }
  ) | (
    { hostName: string | null, port: number | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DatabaseServer' }
  ) | (
    { filePath: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'File' }
  ) | (
    { connectorUrl: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'WebDataConnector' }
  )> };

export type DatabaseQuery_CloudFile_Fragment = (
  { fileId: string | null, provider: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )>, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'CloudFile' }
);

export type DatabaseQuery_DatabaseServer_Fragment = (
  { hostName: string | null, port: number | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )>, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'DatabaseServer' }
);

export type DatabaseQuery_File_Fragment = (
  { filePath: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )>, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'File' }
);

export type DatabaseQuery_WebDataConnector_Fragment = (
  { connectorUrl: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )>, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'WebDataConnector' }
);

export type DatabaseQueryFragment = DatabaseQuery_CloudFile_Fragment | DatabaseQuery_DatabaseServer_Fragment | DatabaseQuery_File_Fragment | DatabaseQuery_WebDataConnector_Fragment;

export type DatabaseQueryWithCertificationsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
}>;


export type DatabaseQueryWithCertificationsQuery = { databases: Array<(
    { fileId: string | null, provider: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, dataQualityCertifications: Array<(
      { id: string, vizportalId: string, isActive: boolean, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityCertification' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'CloudFile' }
  ) | (
    { hostName: string | null, port: number | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, dataQualityCertifications: Array<(
      { id: string, vizportalId: string, isActive: boolean, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityCertification' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DatabaseServer' }
  ) | (
    { filePath: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, dataQualityCertifications: Array<(
      { id: string, vizportalId: string, isActive: boolean, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityCertification' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'File' }
  ) | (
    { connectorUrl: string | null, id: string, luid: string, vizportalId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, description: string | null, isGrouped: boolean | null, isEmbedded: boolean | null, connectionType: string | null, isCertified: boolean, certificationNote: string | null, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, dataQualityCertifications: Array<(
      { id: string, vizportalId: string, isActive: boolean, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityCertification' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'WebDataConnector' }
  )> };

export type DatabaseServerOrPath_CloudFile_Fragment = (
  { requestUrl: string | null, fileId: string | null, provider: string | null, name: string | null }
  & { __typename: 'CloudFile' }
);

export type DatabaseServerOrPath_DatabaseServer_Fragment = (
  { hostName: string | null, port: number | null, name: string | null }
  & { __typename: 'DatabaseServer' }
);

export type DatabaseServerOrPath_File_Fragment = (
  { filePath: string | null, name: string | null }
  & { __typename: 'File' }
);

export type DatabaseServerOrPath_WebDataConnector_Fragment = (
  { connectorUrl: string | null, name: string | null }
  & { __typename: 'WebDataConnector' }
);

export type DatabaseServerOrPathFragment = DatabaseServerOrPath_CloudFile_Fragment | DatabaseServerOrPath_DatabaseServer_Fragment | DatabaseServerOrPath_File_Fragment | DatabaseServerOrPath_WebDataConnector_Fragment;

export type DatabaseTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
}>;


export type DatabaseTableQuery = { databaseTables: Array<(
    { fullName: string | null, luid: string, vizportalId: string, description: string | null, id: string, name: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, database: (
      { fileId: string | null, provider: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' }
    ) | (
      { hostName: string | null, port: number | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'DatabaseServer' }
    ) | (
      { filePath: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'File' }
    ) | (
      { connectorUrl: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'WebDataConnector' }
    ) | null, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, dataQualityCertifications: Array<(
      { id: string, vizportalId: string, isActive: boolean, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityCertification' }
    )>, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DatabaseTable' }
  )> };

export type DatabaseTablesByIdQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DatabaseTablesByIdQuery = { databases: Array<(
    { tablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseUpstreamDatabasesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type DatabaseUpstreamDatabasesFilteredByTableQuery = { tables: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseUpstreamDatabasesQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type DatabaseUpstreamDatabasesQuery = { databases: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseUpstreamDatasourcesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseUpstreamDatasourcesFilteredByTableQuery = { tables: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceQuery = { tables: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseUpstreamDatasourcesQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseUpstreamDatasourcesQuery = { databases: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseUpstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatabaseUpstreamDatasourcesWithoutPersonalSpaceQuery = { databases: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseUpstreamFlowsFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseUpstreamFlowsFilteredByTableQuery = { tables: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseUpstreamFlowsFilteredByTableWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseUpstreamFlowsFilteredByTableWithoutPersonalSpaceQuery = { tables: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseUpstreamFlowsQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseUpstreamFlowsQuery = { databases: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseUpstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatabaseUpstreamFlowsWithoutPersonalSpaceQuery = { databases: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseUpstreamTablesFilteredByTableQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DatabaseUpstreamTablesFilteredByTableQuery = { tables: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type DatabaseUpstreamTablesQueryVariables = Exact<{
  databaseId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DatabaseUpstreamTablesQuery = { databases: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabasesByTagQueryVariables = Exact<{
  tagName: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  textSearch: InputMaybe<Scalars['String']>;
  orderBy: DatabaseSortOrder;
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  isCertified: InputMaybe<Scalars['Boolean']>;
}>;


export type DatabasesByTagQuery = { tags: Array<(
    { databasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'Tag' }
  )> };

export type DatabasesDisplayGridRowData_CloudFile_Fragment = (
  { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )> }
  & { __typename: 'CloudFile' }
);

export type DatabasesDisplayGridRowData_DatabaseServer_Fragment = (
  { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )> }
  & { __typename: 'DatabaseServer' }
);

export type DatabasesDisplayGridRowData_File_Fragment = (
  { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )> }
  & { __typename: 'File' }
);

export type DatabasesDisplayGridRowData_WebDataConnector_Fragment = (
  { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )> }
  & { __typename: 'WebDataConnector' }
);

export type DatabasesDisplayGridRowDataFragment = DatabasesDisplayGridRowData_CloudFile_Fragment | DatabasesDisplayGridRowData_DatabaseServer_Fragment | DatabasesDisplayGridRowData_File_Fragment | DatabasesDisplayGridRowData_WebDataConnector_Fragment;

export type DatabasesByIdsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  databaseIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DatabasesByIdsQuery = { databasesConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, controlledPermissionsEnabled: boolean | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) };

export type DatabasesByIdsNodesFragment = (
  { id: string, name: string | null, controlledPermissionsEnabled: boolean | null }
  & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
);

export type DatabasesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  textSearch: InputMaybe<Scalars['String']>;
  orderBy: DatabaseSortOrder;
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  isCertified: InputMaybe<Scalars['Boolean']>;
}>;


export type DatabasesQuery = { databasesConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamVirtualConnectionsConnection: (
        { totalCount: number }
        & { __typename: 'VirtualConnectionsConnection' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )>, tags: Array<(
        { name: string | null }
        & { __typename: 'Tag' }
      )> }
      & { __typename: 'CloudFile' }
    ) | (
      { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamVirtualConnectionsConnection: (
        { totalCount: number }
        & { __typename: 'VirtualConnectionsConnection' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )>, tags: Array<(
        { name: string | null }
        & { __typename: 'Tag' }
      )> }
      & { __typename: 'DatabaseServer' }
    ) | (
      { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamVirtualConnectionsConnection: (
        { totalCount: number }
        & { __typename: 'VirtualConnectionsConnection' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )>, tags: Array<(
        { name: string | null }
        & { __typename: 'Tag' }
      )> }
      & { __typename: 'File' }
    ) | (
      { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, downstreamVirtualConnectionsConnection: (
        { totalCount: number }
        & { __typename: 'VirtualConnectionsConnection' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )>, tags: Array<(
        { name: string | null }
        & { __typename: 'Tag' }
      )> }
      & { __typename: 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ), maxDownstreamDatasources: (
    { nodes: Array<(
      { downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ), maxDownstreamWorkbooks: (
    { nodes: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) };

export type DatasourceDownstreamDashboardsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type DatasourceDownstreamDashboardsQuery = { publishedDatasources: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamDatabasesQueryVariables = Exact<{
  vizportalUrlId: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type DatasourceDownstreamDatabasesQuery = { publishedDatasources: Array<(
    { downstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamDatasourcesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatasourceDownstreamDatasourcesQuery = { publishedDatasources: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatasourceDownstreamDatasourcesWithoutPersonalSpaceQuery = { publishedDatasources: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamFlowsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatasourceDownstreamFlowsQuery = { publishedDatasources: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatasourceDownstreamFlowsWithoutPersonalSpaceQuery = { publishedDatasources: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamLensesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type DatasourceDownstreamLensesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamLensesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ), downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'Lens' }
        )> }
        & { __typename: 'LensesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DatasourceDownstreamLensesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type DatasourceDownstreamLensesQuery = { publishedDatasources: Array<(
    { downstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamMetricsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DatasourceDownstreamMetricsQuery = { publishedDatasources: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamMetricsWithoutPersonalSpaceQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DatasourceDownstreamMetricsWithoutPersonalSpaceQuery = { publishedDatasources: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamOwnerIdsQueryVariables = Exact<{
  datasourceVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type DatasourceDownstreamOwnerIdsQuery = { publishedDatasources: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamOwnersQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type DatasourceDownstreamOwnersQuery = { publishedDatasources: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamSheetsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type DatasourceDownstreamSheetsQuery = { publishedDatasources: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DatasourceDownstreamTablesQuery = { publishedDatasources: Array<(
    { downstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamWorkbooksFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatasourceDownstreamWorkbooksFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, description: string | null, projectName: string | null, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null }
          & { __typename: 'Workbook' }
        )> }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, description: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null }
          & { __typename: 'Workbook' }
        )> }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DatasourceDownstreamWorkbooksQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatasourceDownstreamWorkbooksQuery = { publishedDatasources: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceDownstreamWorkbooksWithoutPersonalSpaceQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DatasourceDownstreamWorkbooksWithoutPersonalSpaceQuery = { publishedDatasources: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceFieldsByIdQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FieldSortOrder;
  searchText: InputMaybe<Scalars['String']>;
}>;


export type DatasourceFieldsByIdQuery = { publishedDatasources: Array<(
    { id: string, name: string | null, vizportalUrlId: string, fieldsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'BinField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'CalculatedField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'ColumnField' }
      ) | (
        { id: string, name: string | null, description: string | null, combinedField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'CombinedField' }
      ) | (
        { id: string, name: string | null, description: string | null, combinedSetField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'CombinedSetField' }
      ) | (
        { id: string, name: string | null, description: string | null, datasourceField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, remoteField: (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
          & { __typename: 'BinField' }
        ) | (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
          & { __typename: 'CalculatedField' }
        ) | (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
          & { __typename: 'ColumnField' }
        ) | (
          { combinedField: string }
          & { __typename: 'CombinedField' }
        ) | (
          { combinedSetField: string }
          & { __typename: 'CombinedSetField' }
        ) | { __typename: 'DatasourceField' } | (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
            { semanticRole: string | null }
            & { __typename: 'CalculatedField' | 'ColumnField' }
          )> }
          & { __typename: 'GroupField' }
        ) | (
          { hierarchyField: string }
          & { __typename: 'HierarchyField' }
        ) | (
          { setField: string }
          & { __typename: 'SetField' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'DatasourceField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
          { semanticRole: string | null }
          & { __typename: 'CalculatedField' | 'ColumnField' }
        )> }
        & { __typename: 'GroupField' }
      ) | (
        { id: string, name: string | null, description: string | null, hierarchyField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'HierarchyField' }
      ) | (
        { id: string, name: string | null, description: string | null, setField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'SetField' }
      )> }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceFieldsByIdNodes_BinField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'BinField' }
);

export type DatasourceFieldsByIdNodes_CalculatedField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'CalculatedField' }
);

export type DatasourceFieldsByIdNodes_ColumnField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'ColumnField' }
);

export type DatasourceFieldsByIdNodes_CombinedField_Fragment = (
  { id: string, name: string | null, description: string | null, combinedField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'CombinedField' }
);

export type DatasourceFieldsByIdNodes_CombinedSetField_Fragment = (
  { id: string, name: string | null, description: string | null, combinedSetField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'CombinedSetField' }
);

export type DatasourceFieldsByIdNodes_DatasourceField_Fragment = (
  { id: string, name: string | null, description: string | null, datasourceField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, remoteField: (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
    & { __typename: 'BinField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
    & { __typename: 'CalculatedField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
    & { __typename: 'ColumnField' }
  ) | (
    { combinedField: string }
    & { __typename: 'CombinedField' }
  ) | (
    { combinedSetField: string }
    & { __typename: 'CombinedSetField' }
  ) | { __typename: 'DatasourceField' } | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
      { semanticRole: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { hierarchyField: string }
    & { __typename: 'HierarchyField' }
  ) | (
    { setField: string }
    & { __typename: 'SetField' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type DatasourceFieldsByIdNodes_GroupField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
    { semanticRole: string | null }
    & { __typename: 'CalculatedField' | 'ColumnField' }
  )> }
  & { __typename: 'GroupField' }
);

export type DatasourceFieldsByIdNodes_HierarchyField_Fragment = (
  { id: string, name: string | null, description: string | null, hierarchyField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'HierarchyField' }
);

export type DatasourceFieldsByIdNodes_SetField_Fragment = (
  { id: string, name: string | null, description: string | null, setField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'SetField' }
);

export type DatasourceFieldsByIdNodesFragment = DatasourceFieldsByIdNodes_BinField_Fragment | DatasourceFieldsByIdNodes_CalculatedField_Fragment | DatasourceFieldsByIdNodes_ColumnField_Fragment | DatasourceFieldsByIdNodes_CombinedField_Fragment | DatasourceFieldsByIdNodes_CombinedSetField_Fragment | DatasourceFieldsByIdNodes_DatasourceField_Fragment | DatasourceFieldsByIdNodes_GroupField_Fragment | DatasourceFieldsByIdNodes_HierarchyField_Fragment | DatasourceFieldsByIdNodes_SetField_Fragment;

export type DatasourceFieldsWithInheritanceByIdQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FieldSortOrder;
}>;


export type DatasourceFieldsWithInheritanceByIdQuery = { publishedDatasources: Array<(
    { id: string, name: string | null, vizportalUrlId: string, fieldsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null }
        & { __typename: 'BinField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null }
        & { __typename: 'CalculatedField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null }
        & { __typename: 'ColumnField' }
      ) | (
        { id: string, name: string | null, description: string | null, combinedField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null }
        & { __typename: 'CombinedField' }
      ) | (
        { id: string, name: string | null, description: string | null, combinedSetField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null }
        & { __typename: 'CombinedSetField' }
      ) | (
        { id: string, name: string | null, description: string | null, datasourceField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, remoteField: (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
          & { __typename: 'BinField' }
        ) | (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
          & { __typename: 'CalculatedField' }
        ) | (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
          & { __typename: 'ColumnField' }
        ) | (
          { combinedField: string }
          & { __typename: 'CombinedField' }
        ) | (
          { combinedSetField: string }
          & { __typename: 'CombinedSetField' }
        ) | { __typename: 'DatasourceField' } | (
          { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
            { semanticRole: string | null }
            & { __typename: 'CalculatedField' | 'ColumnField' }
          )> }
          & { __typename: 'GroupField' }
        ) | (
          { hierarchyField: string }
          & { __typename: 'HierarchyField' }
        ) | (
          { setField: string }
          & { __typename: 'SetField' }
        ) | null }
        & { __typename: 'DatasourceField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
          { semanticRole: string | null }
          & { __typename: 'CalculatedField' | 'ColumnField' }
        )> }
        & { __typename: 'GroupField' }
      ) | (
        { id: string, name: string | null, description: string | null, hierarchyField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null }
        & { __typename: 'HierarchyField' }
      ) | (
        { id: string, name: string | null, description: string | null, setField: string, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, descriptionInherited: Array<(
          { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
            { name: string | null, id: string, datasource: (
              { id: string, name: string | null }
              & { __typename: 'EmbeddedDatasource' }
            ) | (
              { vizportalUrlId: string, id: string, name: string | null }
              & { __typename: 'PublishedDatasource' }
            ) | null }
            & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
          ) | (
            { name: string | null, id: string, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'InheritedStringResult' }
        ) | null> | null }
        & { __typename: 'SetField' }
      )> }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceLineageCountsFilteredByFieldQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedFieldId: Scalars['ID'];
}>;


export type DatasourceLineageCountsFilteredByFieldQuery = { publishedDatasources: Array<(
    { filteredFieldsConnection: (
      { nodes: Array<(
        { name: string | null, upstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, upstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, upstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, upstreamVirtualConnectionTablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, upstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, upstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, downstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, downstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamLensesConnection: (
          { totalCount: number }
          & { __typename: 'LensesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDashboardsConnection: (
          { totalCount: number }
          & { __typename: 'DashboardsConnection' }
        ) | null, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, downstreamMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, downstreamOwnersConnection: (
          { totalCount: number }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )> }
      & { __typename: 'FieldsConnection' }
    ) | null, unfilteredFieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, upstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceLineageCountsFragment = (
  { unfilteredFieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, upstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, upstreamVirtualConnectionTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, upstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, upstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, downstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, downstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamLensesConnection: (
    { totalCount: number }
    & { __typename: 'LensesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'PublishedDatasource' }
);

export type DatasourceLineageCountsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type DatasourceLineageCountsQuery = { publishedDatasources: Array<(
    { unfilteredFieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, upstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type DatasourceQuery = { publishedDatasources: Array<(
    { name: string | null, luid: string }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamDatabasesQueryVariables = Exact<{
  vizportalUrlId: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: DatabaseSortOrder;
}>;


export type DatasourceUpstreamDatabasesQuery = { publishedDatasources: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamDatasourcesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatasourceUpstreamDatasourcesQuery = { publishedDatasources: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DatasourceUpstreamDatasourcesWithoutPersonalSpaceQuery = { publishedDatasources: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamFlowsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatasourceUpstreamFlowsQuery = { publishedDatasources: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DatasourceUpstreamFlowsWithoutPersonalSpaceQuery = { publishedDatasources: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DatasourceUpstreamTablesQuery = { publishedDatasources: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamVirtualConnectionTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type DatasourceUpstreamVirtualConnectionTablesQuery = { publishedDatasources: Array<(
    { upstreamVirtualConnectionTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourceUpstreamVirtualConnectionsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type DatasourceUpstreamVirtualConnectionsQuery = { publishedDatasources: Array<(
    { upstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragment = (
  { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ), certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null }
  & { __typename: 'PublishedDatasource' }
);

export type DatasourcesDisplayGridRowDataFragment = (
  { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ), certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null }
  & { __typename: 'PublishedDatasource' }
);

export type DownstreamDashboardsFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type DownstreamDashboardsFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamDashboardsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' }
        )> }
        & { __typename: 'DashboardsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamDatabasesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type DownstreamDatabasesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamDatabasesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'CloudFile' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'DatabaseServer' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'File' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamDatasourcesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DownstreamDatasourcesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamDatasourcesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'PublishedDatasource' }
        )> }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamDatasourcesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'PublishedDatasource' }
        )> }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamFlowsFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DownstreamFlowsFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type DownstreamFlowsFilteredByFieldWithoutPersonalSpaceQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamMetricsFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DownstreamMetricsFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamMetricsConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
            { name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Dashboard' | 'Sheet' }
          ) | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Metric' }
        )> }
        & { __typename: 'MetricsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamMetricsFilteredByFieldWithoutPersonalSpaceQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type DownstreamMetricsFilteredByFieldWithoutPersonalSpaceQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamMetricsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
            { name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Dashboard' | 'Sheet' }
          ) | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Metric' }
        )> }
        & { __typename: 'MetricsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamOwnerIdsFilteredByFieldQueryVariables = Exact<{
  fieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type DownstreamOwnerIdsFilteredByFieldQuery = { fields: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )> };

export type DownstreamOwnersFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type DownstreamOwnersFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamOwnersConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, ownedDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, ownedMetricsConnection: (
            { totalCount: number }
            & { __typename: 'MetricsConnection' }
          ) | null, ownedVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null }
          & { __typename: 'TableauUser' }
        )> }
        & { __typename: 'TableauUsersConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamSheetsFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type DownstreamSheetsFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamSheetsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Sheet' }
        )> }
        & { __typename: 'SheetsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamTablesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type DownstreamTablesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamTablesConnection: (
        { totalCount: number, nodes: Array<(
          { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, columnsConnectionWithWarnings: (
            { totalCount: number, nodes: Array<(
              { labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { name: string | null }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, database: (
            { name: string | null, isGrouped: boolean | null }
            & { __typename: 'CloudFile' | 'WebDataConnector' }
          ) | (
            { hostName: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'DatabaseServer' }
          ) | (
            { filePath: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'File' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type DownstreamWorkbooksFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type DownstreamWorkbooksFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null }
          & { __typename: 'Workbook' }
        )> }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  embeddedDatasourceId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type EmbeddedDatasourceLineageUpstreamDataQualityWarningsQuery = { embeddedDatasources: Array<(
    { upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'EmbeddedDatasource' }
  )> };

export type FieldDescriptionInheritedFragment = (
  { description: string | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null }
  & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
);

export type FieldDetails_BinField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fields: Array<(
    { id: string, name: string | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )>, parameters: Array<(
    { name: string | null }
    & { __typename: 'Parameter' }
  )> }
  & { __typename: 'BinField' }
);

export type FieldDetails_CalculatedField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fields: Array<(
    { id: string, name: string | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )>, parameters: Array<(
    { name: string | null }
    & { __typename: 'Parameter' }
  )> }
  & { __typename: 'CalculatedField' }
);

export type FieldDetails_ColumnField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, description: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null, referencedByFlowColumnOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowColumnOutputField' }
      ) | null> | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'ColumnField' }
);

export type FieldDetails_CombinedField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'CombinedField' }
);

export type FieldDetails_CombinedSetField_Fragment = (
  { combinationType: string | null, delimiter: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'CombinedSetField' }
);

export type FieldDetails_DatasourceField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, remoteField: (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, remoteField: (
      { id: string, name: string | null, description: string | null, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
      { name: string | null, id: string }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null, id: string }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type FieldDetails_GroupField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fieldsReferencedByGroup: Array<(
    { name: string | null }
    & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | (
    { semanticRole: string | null, name: string | null }
    & { __typename: 'CalculatedField' | 'ColumnField' }
  )> }
  & { __typename: 'GroupField' }
);

export type FieldDetails_HierarchyField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'HierarchyField' }
);

export type FieldDetails_SetField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'SetField' }
);

export type FieldDetailsFragment = FieldDetails_BinField_Fragment | FieldDetails_CalculatedField_Fragment | FieldDetails_ColumnField_Fragment | FieldDetails_CombinedField_Fragment | FieldDetails_CombinedSetField_Fragment | FieldDetails_DatasourceField_Fragment | FieldDetails_GroupField_Fragment | FieldDetails_HierarchyField_Fragment | FieldDetails_SetField_Fragment;

export type FieldDetailsDatasourceFieldFragment = (
  { datasourceField: string, remoteField: (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { combinationType: string | null, delimiter: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, remoteField: (
      { id: string, name: string | null, description: string | null, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type FieldDetailsQueryVariables = Exact<{
  fieldId: Scalars['ID'];
}>;


export type FieldDetailsQuery = { fields: Array<(
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { combinationType: string | null, delimiter: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, remoteField: (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, remoteField: (
        { id: string, name: string | null, description: string | null, datasource: (
          { id: string, name: string | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
        { name: string | null, id: string }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, name: string | null, id: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  )> };

export type FieldDirectColumnDataQualityWarningsQueryVariables = Exact<{
  fieldId: Scalars['ID'];
}>;


export type FieldDirectColumnDataQualityWarningsQuery = { fields: Array<{ __typename: 'BinField' | 'CalculatedField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
    { columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, dataQualityWarnings: Array<(
          { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { name: string | null, id: string }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
          ) | (
            { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
              { id: string, luid: string, name: string | null }
              & { __typename: 'DatabaseTable' }
            ) | (
              { luid: string, name: string | null }
              & { __typename: 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { name: string | null, vizportalUrlId: string, id: string }
            & { __typename: 'Flow' | 'PublishedDatasource' }
          ) | null }
          & { __typename: 'DataQualityWarning' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  )> };

export type FieldIcon_BinField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
  & { __typename: 'BinField' }
);

export type FieldIcon_CalculatedField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
  & { __typename: 'CalculatedField' }
);

export type FieldIcon_ColumnField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
  & { __typename: 'ColumnField' }
);

export type FieldIcon_CombinedField_Fragment = (
  { combinedField: string }
  & { __typename: 'CombinedField' }
);

export type FieldIcon_CombinedSetField_Fragment = (
  { combinedSetField: string }
  & { __typename: 'CombinedSetField' }
);

export type FieldIcon_DatasourceField_Fragment = (
  { datasourceField: string, remoteField: (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
    & { __typename: 'BinField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
    & { __typename: 'CalculatedField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
    & { __typename: 'ColumnField' }
  ) | (
    { combinedField: string }
    & { __typename: 'CombinedField' }
  ) | (
    { combinedSetField: string }
    & { __typename: 'CombinedSetField' }
  ) | { __typename: 'DatasourceField' } | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
      { semanticRole: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { hierarchyField: string }
    & { __typename: 'HierarchyField' }
  ) | (
    { setField: string }
    & { __typename: 'SetField' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type FieldIcon_GroupField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
    { semanticRole: string | null }
    & { __typename: 'CalculatedField' | 'ColumnField' }
  )> }
  & { __typename: 'GroupField' }
);

export type FieldIcon_HierarchyField_Fragment = (
  { hierarchyField: string }
  & { __typename: 'HierarchyField' }
);

export type FieldIcon_SetField_Fragment = (
  { setField: string }
  & { __typename: 'SetField' }
);

export type FieldIconFragment = FieldIcon_BinField_Fragment | FieldIcon_CalculatedField_Fragment | FieldIcon_ColumnField_Fragment | FieldIcon_CombinedField_Fragment | FieldIcon_CombinedSetField_Fragment | FieldIcon_DatasourceField_Fragment | FieldIcon_GroupField_Fragment | FieldIcon_HierarchyField_Fragment | FieldIcon_SetField_Fragment;

export type FieldLineageUpstreamDataQualityWarnings_D7Mmfm3Ht_2Ukd2yxgjD6PjA6iX3zn4nMDbmwM2V7ug_Fragment = { __typename: 'BinField' | 'CalculatedField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' };

export type FieldLineageUpstreamDataQualityWarnings_ColumnField_Fragment = (
  { columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, dataQualityWarnings: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'ColumnField' }
);

export type FieldLineageUpstreamDataQualityWarningsFragment = FieldLineageUpstreamDataQualityWarnings_D7Mmfm3Ht_2Ukd2yxgjD6PjA6iX3zn4nMDbmwM2V7ug_Fragment | FieldLineageUpstreamDataQualityWarnings_ColumnField_Fragment;

export type FieldLineageUpstreamLabelsFragment = (
  { columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
);

export type FieldsReferencedByFieldQueryVariables = Exact<{
  fieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FieldsReferencedByFieldQuery = { fields: Array<(
    { fieldsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, datasource: (
          { id: string, name: string | null, workbook: (
            { vizportalUrlId: string }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { name: string | null, vizportalUrlId: string }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )> }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'CombinedField' | 'CombinedSetField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | { __typename: 'ColumnField' | 'DatasourceField' }> };

export type FieldsReferencedByFieldNodesDatasource_EmbeddedDatasource_Fragment = (
  { id: string, name: string | null, workbook: (
    { vizportalUrlId: string }
    & { __typename: 'Workbook' }
  ) | null }
  & { __typename: 'EmbeddedDatasource' }
);

export type FieldsReferencedByFieldNodesDatasource_PublishedDatasource_Fragment = (
  { name: string | null, vizportalUrlId: string }
  & { __typename: 'PublishedDatasource' }
);

export type FieldsReferencedByFieldNodesDatasourceFragment = FieldsReferencedByFieldNodesDatasource_EmbeddedDatasource_Fragment | FieldsReferencedByFieldNodesDatasource_PublishedDatasource_Fragment;

export type FieldsReferencedByFieldNodesFragment = (
  { id: string, name: string | null, datasource: (
    { id: string, name: string | null, workbook: (
      { vizportalUrlId: string }
      & { __typename: 'Workbook' }
    ) | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { name: string | null, vizportalUrlId: string }
    & { __typename: 'PublishedDatasource' }
  ) | null }
  & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
);

export type FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamDashboardsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
                { domain: string | null, username: string | null, name: string | null }
                & { __typename: 'TableauUser' }
              ) }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Dashboard' }
          )> }
          & { __typename: 'DashboardsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamDashboardsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type FlowDownstreamDashboardsQuery = { flows: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamDatabasesFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type FlowDownstreamDatabasesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamDatabasesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'CloudFile' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'DatabaseServer' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'File' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamDatabasesQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type FlowDownstreamDatabasesQuery = { flows: Array<(
    { downstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamDatasourcesFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowDownstreamDatasourcesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'PublishedDatasource' }
          )> }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowDownstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'PublishedDatasource' }
          )> }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamDatasourcesQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowDownstreamDatasourcesQuery = { flows: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowDownstreamDatasourcesWithoutPersonalSpaceQuery = { flows: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamFlowsFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowDownstreamFlowsFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamFlowsConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) | null }
            & { __typename: 'Flow' }
          )> }
          & { __typename: 'FlowsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowDownstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamFlowsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) | null }
            & { __typename: 'Flow' }
          )> }
          & { __typename: 'FlowsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamFlowsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowDownstreamFlowsQuery = { flows: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowDownstreamFlowsWithoutPersonalSpaceQuery = { flows: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamLensesFilteredByFlowOutputFieldQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type FlowDownstreamLensesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamLensesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ), downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'Lens' }
          )> }
          & { __typename: 'LensesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamLensesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type FlowDownstreamLensesQuery = { flows: Array<(
    { downstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamMetricsFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type FlowDownstreamMetricsFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamMetricsConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
              { name: string | null, path: string | null, workbook: (
                { vizportalUrlId: string, name: string | null }
                & { __typename: 'Workbook' }
              ) | null }
              & { __typename: 'Dashboard' | 'Sheet' }
            ) | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) }
            & { __typename: 'Metric' }
          )> }
          & { __typename: 'MetricsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamMetricsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type FlowDownstreamMetricsFilteredByFlowOutputFieldWithoutPersonalSpaceQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamMetricsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
              { name: string | null, path: string | null, workbook: (
                { vizportalUrlId: string, name: string | null }
                & { __typename: 'Workbook' }
              ) | null }
              & { __typename: 'Dashboard' | 'Sheet' }
            ) | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) }
            & { __typename: 'Metric' }
          )> }
          & { __typename: 'MetricsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamMetricsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type FlowDownstreamMetricsQuery = { flows: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamMetricsWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type FlowDownstreamMetricsWithoutPersonalSpaceQuery = { flows: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFields: Array<(
      { downstreamOwnersConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, vizportalId: string }
          & { __typename: 'TableauUser' }
        )> }
        & { __typename: 'TableauUsersConnection' }
      ) | null }
      & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
    )> }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamOwnerIdsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FlowDownstreamOwnerIdsQuery = { flows: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamOwnersFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type FlowDownstreamOwnersFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamOwnersConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, ownedDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, ownedMetricsConnection: (
              { totalCount: number }
              & { __typename: 'MetricsConnection' }
            ) | null, ownedVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null }
            & { __typename: 'TableauUser' }
          )> }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamOwnersQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type FlowDownstreamOwnersQuery = { flows: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamSheetsFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type FlowDownstreamSheetsFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamSheetsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
                { domain: string | null, username: string | null, name: string | null }
                & { __typename: 'TableauUser' }
              ) }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Sheet' }
          )> }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamSheetsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type FlowDownstreamSheetsQuery = { flows: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamTablesFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type FlowDownstreamTablesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamTablesConnection: (
          { totalCount: number, nodes: Array<(
            { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, columnsConnectionWithWarnings: (
              { totalCount: number, nodes: Array<(
                { labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { name: string | null }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, database: (
              { name: string | null, isGrouped: boolean | null }
              & { __typename: 'CloudFile' | 'WebDataConnector' }
            ) | (
              { hostName: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'DatabaseServer' }
            ) | (
              { filePath: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'File' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamTablesQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type FlowDownstreamTablesQuery = { flows: Array<(
    { downstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamWorkbooksFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type FlowDownstreamWorkbooksFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
              { name: string | null, username: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), sheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null }
            & { __typename: 'Workbook' }
          )> }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
              { name: string | null, username: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), sheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null }
            & { __typename: 'Workbook' }
          )> }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamWorkbooksQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type FlowDownstreamWorkbooksQuery = { flows: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowDownstreamWorkbooksWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type FlowDownstreamWorkbooksWithoutPersonalSpaceQuery = { flows: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowFieldDetailsQueryVariables = Exact<{
  flowOutputStepId: Scalars['ID'];
  flowFieldId: Scalars['ID'];
}>;


export type FlowFieldDetailsQuery = { flowOutputSteps: Array<(
    { outputFields: Array<(
      { id: string, name: string | null, column: (
        { id: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | null }
      & { __typename: 'FlowColumnOutputField' }
    ) | (
      { name: string | null, id: string, field: (
        { id: string, name: string | null, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, datasource: (
          { name: string | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | null }
      & { __typename: 'FlowFieldOutputField' }
    )> }
    & { __typename: 'FlowOutputStep' }
  )> };

export type FlowFieldDetailsFlowFieldOutputFieldFragment = (
  { id: string, name: string | null, field: (
    { id: string, name: string | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, datasource: (
      { name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | null }
  & { __typename: 'FlowFieldOutputField' }
);

export type FlowFieldsByIdQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedOutputStepId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowOutputFieldSortOrder;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type FlowFieldsByIdQuery = { flows: Array<(
    { vizportalUrlId: string, outputSteps: Array<(
      { outputFieldsConnection: (
        { totalCount: number, nodes: Array<(
          { name: string | null, id: string, column: (
            { id: string, name: string | null, remoteType: RemoteType, labels?: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, upstreamColumns?: Array<(
              { luid: string, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            ) | null> }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnOutputField' }
        ) | (
          { name: string | null, id: string, field: (
            { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'BinField' }
          ) | (
            { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'CalculatedField' }
          ) | (
            { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'ColumnField' }
          ) | (
            { id: string, name: string | null, combinedField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'CombinedField' }
          ) | (
            { id: string, name: string | null, combinedSetField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'CombinedSetField' }
          ) | (
            { id: string, name: string | null, datasourceField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, remoteField: (
              { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
              & { __typename: 'BinField' }
            ) | (
              { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
              & { __typename: 'CalculatedField' }
            ) | (
              { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
              & { __typename: 'ColumnField' }
            ) | (
              { combinedField: string }
              & { __typename: 'CombinedField' }
            ) | (
              { combinedSetField: string }
              & { __typename: 'CombinedSetField' }
            ) | { __typename: 'DatasourceField' } | (
              { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
                { semanticRole: string | null }
                & { __typename: 'CalculatedField' | 'ColumnField' }
              )> }
              & { __typename: 'GroupField' }
            ) | (
              { hierarchyField: string }
              & { __typename: 'HierarchyField' }
            ) | (
              { setField: string }
              & { __typename: 'SetField' }
            ) | null }
            & { __typename: 'DatasourceField' }
          ) | (
            { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
              { semanticRole: string | null }
              & { __typename: 'CalculatedField' | 'ColumnField' }
            )> }
            & { __typename: 'GroupField' }
          ) | (
            { id: string, name: string | null, hierarchyField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'HierarchyField' }
          ) | (
            { id: string, name: string | null, setField: string, downstreamSheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { id: string, name: string | null, labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'SetField' }
          ) | null }
          & { __typename: 'FlowFieldOutputField' }
        )> }
        & { __typename: 'FlowOutputFieldsConnection' }
      ) | null }
      & { __typename: 'FlowOutputStep' }
    )> }
    & { __typename: 'Flow' }
  )> };

export type FlowFieldsByIdNodes_FlowColumnOutputField_Fragment = (
  { name: string | null, id: string, column: (
    { id: string, name: string | null, remoteType: RemoteType, labels?: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, upstreamColumns?: Array<(
      { luid: string, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    ) | null> }
    & { __typename: 'Column' }
  ) | null }
  & { __typename: 'FlowColumnOutputField' }
);

export type FlowFieldsByIdNodes_FlowFieldOutputField_Fragment = (
  { name: string | null, id: string, field: (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, combinedField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, combinedSetField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, datasourceField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, remoteField: (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
      & { __typename: 'BinField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
      & { __typename: 'CalculatedField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
      & { __typename: 'ColumnField' }
    ) | (
      { combinedField: string }
      & { __typename: 'CombinedField' }
    ) | (
      { combinedSetField: string }
      & { __typename: 'CombinedSetField' }
    ) | { __typename: 'DatasourceField' } | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
        { semanticRole: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { hierarchyField: string }
      & { __typename: 'HierarchyField' }
    ) | (
      { setField: string }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
      { semanticRole: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, hierarchyField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, setField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null }
  & { __typename: 'FlowFieldOutputField' }
);

export type FlowFieldsByIdNodesFragment = FlowFieldsByIdNodes_FlowColumnOutputField_Fragment | FlowFieldsByIdNodes_FlowFieldOutputField_Fragment;

export type FlowFieldsByIdFlowFieldOutputFieldFragment = (
  { name: string | null, id: string, field: (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, combinedField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, combinedSetField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, datasourceField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, remoteField: (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
      & { __typename: 'BinField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
      & { __typename: 'CalculatedField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
      & { __typename: 'ColumnField' }
    ) | (
      { combinedField: string }
      & { __typename: 'CombinedField' }
    ) | (
      { combinedSetField: string }
      & { __typename: 'CombinedSetField' }
    ) | { __typename: 'DatasourceField' } | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
        { semanticRole: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { hierarchyField: string }
      & { __typename: 'HierarchyField' }
    ) | (
      { setField: string }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
      { semanticRole: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, hierarchyField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, setField: string, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null }
  & { __typename: 'FlowFieldOutputField' }
);

export type FlowLineageCountsFilteredByFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  outputStepId: Scalars['ID'];
  selectedFieldId: Scalars['ID'];
}>;


export type FlowLineageCountsFilteredByFieldQuery = { flows: Array<(
    { outputSteps: Array<(
      { filteredFieldsConnection: (
        { nodes: Array<(
          { name: string | null, upstreamDatabasesConnection: (
            { totalCount: number }
            & { __typename: 'DatabasesConnection' }
          ) | null, upstreamTablesConnection: (
            { totalCount: number }
            & { __typename: 'DatabaseTablesConnection' }
          ) | null, upstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, upstreamVirtualConnectionTablesConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionTablesConnection' }
          ) | null, upstreamFlowsConnection: (
            { totalCount: number }
            & { __typename: 'FlowsConnection' }
          ) | null, upstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, downstreamDatabasesConnection: (
            { totalCount: number }
            & { __typename: 'DatabasesConnection' }
          ) | null, downstreamTablesConnection: (
            { totalCount: number }
            & { __typename: 'DatabaseTablesConnection' }
          ) | null, downstreamFlowsConnection: (
            { totalCount: number }
            & { __typename: 'FlowsConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, downstreamLensesConnection: (
            { totalCount: number }
            & { __typename: 'LensesConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDashboardsConnection: (
            { totalCount: number }
            & { __typename: 'DashboardsConnection' }
          ) | null, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, downstreamMetricsConnection: (
            { totalCount: number }
            & { __typename: 'MetricsConnection' }
          ) | null, downstreamOwnersConnection: (
            { totalCount: number }
            & { __typename: 'TableauUsersConnection' }
          ) | null }
          & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
        )> }
        & { __typename: 'FlowOutputFieldsConnection' }
      ) | null }
      & { __typename: 'FlowOutputStep' }
    )>, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, upstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowLineageCountsFragment = (
  { upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, upstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, upstreamVirtualConnectionTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, upstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, upstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, downstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, downstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamLensesConnection: (
    { totalCount: number }
    & { __typename: 'LensesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'Flow' }
);

export type FlowLineageCountsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
}>;


export type FlowLineageCountsQuery = { flows: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, upstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FlowLineageUpstreamDataQualityWarningsQuery = { flows: Array<(
    { id: string, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
}>;


export type FlowQuery = { flows: Array<(
    { name: string | null, luid: string, outputSteps: Array<(
      { name: string | null, id: string, outputFieldsConnection: (
        { totalCount: number }
        & { __typename: 'FlowOutputFieldsConnection' }
      ) | null }
      & { __typename: 'FlowOutputStep' }
    )>, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowOutputStepsFragment = (
  { name: string | null, id: string, outputFieldsConnection: (
    { totalCount: number }
    & { __typename: 'FlowOutputFieldsConnection' }
  ) | null }
  & { __typename: 'FlowOutputStep' }
);

export type FlowDownstreamDatasourcesFragment = (
  { totalCount: number }
  & { __typename: 'PublishedDatasourcesConnection' }
);

export type FlowDownstreamDatabasesFragment = (
  { totalCount: number }
  & { __typename: 'DatabasesConnection' }
);

export type FlowUpstreamDatabasesFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type FlowUpstreamDatabasesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamDatabasesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'CloudFile' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'DatabaseServer' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'File' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamDatabasesQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type FlowUpstreamDatabasesQuery = { flows: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamDatasourcesFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowUpstreamDatasourcesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamDatasourcesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'PublishedDatasource' }
          )> }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowUpstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamDatasourcesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'PublishedDatasource' }
          )> }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamDatasourcesQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowUpstreamDatasourcesQuery = { flows: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type FlowUpstreamDatasourcesWithoutPersonalSpaceQuery = { flows: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamFlowsFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowUpstreamFlowsFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamFlowsConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) | null }
            & { __typename: 'Flow' }
          )> }
          & { __typename: 'FlowsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamFlowsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) | null }
            & { __typename: 'Flow' }
          )> }
          & { __typename: 'FlowsConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamFlowsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowUpstreamFlowsQuery = { flows: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type FlowUpstreamFlowsWithoutPersonalSpaceQuery = { flows: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamTablesFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type FlowUpstreamTablesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamTablesConnection: (
          { totalCount: number, nodes: Array<(
            { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, columnsConnectionWithWarnings: (
              { totalCount: number, nodes: Array<(
                { labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { name: string | null }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, database: (
              { name: string | null, isGrouped: boolean | null }
              & { __typename: 'CloudFile' | 'WebDataConnector' }
            ) | (
              { hostName: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'DatabaseServer' }
            ) | (
              { filePath: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'File' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamTablesQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type FlowUpstreamTablesQuery = { flows: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamVirtualConnectionTablesConnection: (
          { totalCount: number, nodes: Array<(
            { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, columnsConnectionWithWarnings: (
              { totalCount: number, nodes: Array<(
                { labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { name: string | null }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null }
            & { __typename: 'VirtualConnectionTable' }
          )> }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamVirtualConnectionTablesQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type FlowUpstreamVirtualConnectionTablesQuery = { flows: Array<(
    { upstreamVirtualConnectionTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  selectedFlowOutputFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldQuery = { flows: Array<(
    { outputFieldsConnection: (
      { nodes: Array<(
        { upstreamVirtualConnectionsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
              { name: string | null, username: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), tablesConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionTablesConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'VirtualConnection' }
          )> }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null }
        & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
      )> }
      & { __typename: 'FlowOutputFieldsConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowUpstreamVirtualConnectionsQueryVariables = Exact<{
  flowVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type FlowUpstreamVirtualConnectionsQuery = { flows: Array<(
    { upstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Flow' }
  )> };

export type FlowsDisplayGridRowDataFragment = (
  { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
    { domain: string | null, username: string | null, name: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'Flow' }
);

export type FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragment = (
  { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
    { domain: string | null, username: string | null, name: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'Flow' }
);

export type FieldLabelsFragment = (
  { upstreamColumns: Array<(
    { labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Column' }
  ) | null> }
  & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
);

export type DatabaseLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
}>;


export type DatabaseLineageLabelsQuery = { items: Array<(
    { upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> };

export type DatabaseTableLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type DatabaseTableLineageLabelsQuery = { items: Array<(
    { upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, columns: Array<(
      { id: string, name: string | null, luid: string, table: (
        { id: string }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' }
      ) | (
        { vizportalUrlId: string, id: string }
        & { __typename: 'VirtualConnectionTable' }
      ) | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )>, upstreamColumns?: Array<(
        { luid: string, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      ) | null> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'DatabaseTable' }
  )> };

export type VirtualConnectionLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type VirtualConnectionLineageLabelsQuery = { items: Array<(
    { upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, tables?: Array<(
      { columns: Array<(
        { id: string, name: string | null, luid: string, table: (
          { id: string }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' }
        ) | (
          { vizportalUrlId: string, id: string }
          & { __typename: 'VirtualConnectionTable' }
        ) | null, upstreamColumns?: Array<(
          { luid: string, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )> }
          & { __typename: 'Column' }
        ) | null> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'VirtualConnectionTable' }
    )> }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionTablesLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type VirtualConnectionTablesLineageLabelsQuery = { items: Array<(
    { upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, columns?: Array<(
      { id: string, name: string | null, luid: string, table: (
        { id: string }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' }
      ) | (
        { vizportalUrlId: string, id: string }
        & { __typename: 'VirtualConnectionTable' }
      ) | null, upstreamColumns?: Array<(
        { luid: string, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      ) | null> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type ColumnLineageLabelsQueryVariables = Exact<{
  id: InputMaybe<Scalars['ID']>;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type ColumnLineageLabelsQuery = { items: Array<(
    { id: string, upstreamColumns?: Array<(
      { luid: string, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    ) | null> }
    & { __typename: 'Column' }
  )> };

export type FlowLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type FlowLineageLabelsQuery = { items: Array<(
    { upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, outputFields?: Array<(
      { id: string, name: string | null, parentFields: Array<(
        { id: string, name: string | null, column: (
          { luid: string }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
    )> }
    & { __typename: 'Flow' }
  )> };

export type PublishedDatasourceLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type PublishedDatasourceLineageLabelsQuery = { items: Array<(
    { upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, fields?: Array<(
      { id: string, name: string | null, upstreamColumns: Array<(
        { luid: string }
        & { __typename: 'Column' }
      ) | null> }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'PublishedDatasource' }
  )> };

export type EmbeddedDatasourceLineageLabelsQueryVariables = Exact<{
  id: InputMaybe<Scalars['ID']>;
}>;


export type EmbeddedDatasourceLineageLabelsQuery = { items: Array<(
    { id: string, upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'EmbeddedDatasource' }
  )> };

export type ViewLineageLabelsQueryVariables = Exact<{
  id: InputMaybe<Scalars['ID']>;
}>;


export type ViewLineageLabelsQuery = { items: Array<(
    { id: string, upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Dashboard' | 'Sheet' }
  )> };

export type WorkbookLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type WorkbookLineageLabelsQuery = { items: Array<(
    { id: string, upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, embeddedDatasources?: Array<(
      { fields: Array<(
        { id: string, name: string | null, upstreamColumns: Array<(
          { luid: string }
          & { __typename: 'Column' }
        ) | null> }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )> }
      & { __typename: 'EmbeddedDatasource' }
    )> }
    & { __typename: 'Workbook' }
  )> };

export type FieldLineageLabelsQueryVariables = Exact<{
  id: InputMaybe<Scalars['ID']>;
}>;


export type FieldLineageLabelsQuery = { items: Array<(
    { id: string, upstreamColumns: Array<(
      { labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    ) | null> }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )> };

export type FlowColumnFieldLineageLabelsQueryVariables = Exact<{
  id: Scalars['ID'];
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type FlowColumnFieldLineageLabelsQuery = { items: Array<(
    { id: string, column: (
      { labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )>, upstreamColumns?: Array<(
        { luid: string, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      ) | null> }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'FlowColumnOutputField' }
  )> };

export type FlowFieldLineageLabelsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FlowFieldLineageLabelsQuery = { items: Array<(
    { id: string, field: (
      { upstreamColumns: Array<(
        { labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      ) | null> }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null }
    & { __typename: 'FlowFieldOutputField' }
  )> };

export type MetricLineageLabelsQueryVariables = Exact<{
  luid: InputMaybe<Scalars['String']>;
}>;


export type MetricLineageLabelsQuery = { items: Array<(
    { id: string, upstreamLabels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Metric' }
  )> };

export type GetUserQueryVariables = Exact<{
  luids: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetUserQuery = { items: Array<(
    { luid: string, username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  )> };

export type InheritedLabelsColumnFragment = (
  { id: string, name: string | null, luid: string, table: (
    { id: string }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' }
  ) | (
    { vizportalUrlId: string, id: string }
    & { __typename: 'VirtualConnectionTable' }
  ) | null, upstreamColumns?: Array<(
    { luid: string, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Column' }
  ) | null> }
  & { __typename: 'Column' }
);

export type ColumnLabelsFragment = (
  { luid: string, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )> }
  & { __typename: 'Column' }
);

export type UpstreamColumnLabelsFragment = (
  { upstreamColumns?: Array<(
    { luid: string, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Column' }
  ) | null> }
  & { __typename: 'Column' }
);

export type InheritedLabelsFieldFragment = (
  { id: string, name: string | null, upstreamColumns: Array<(
    { luid: string }
    & { __typename: 'Column' }
  ) | null> }
  & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
);

export type InheritedLabelsFlowOutputFieldFragment = (
  { id: string, name: string | null, parentFields: Array<(
    { id: string, name: string | null, column: (
      { luid: string }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'FlowColumnInputField' }
  ) | { __typename: 'FlowFieldInputField' }> }
  & { __typename: 'FlowColumnOutputField' | 'FlowFieldOutputField' }
);

export type Asset_SDVJAmUprkldIk4heh50sFqsd2Z3gxRr4Kewy6StHw_Fragment = (
  { id: string, luid: string, name: string | null }
  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
);

export type Asset_Column_Fragment = (
  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
    { id: string, name: string | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  ) | null }
  & { __typename: 'Column' }
);

export type Asset_V10Kt7Gb3kiNYsR0mY5iAmpQoRapBsFkPd9do3t54Jk_Fragment = (
  { vizportalUrlId: string, id: string, luid: string, name: string | null }
  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
);

export type AssetFragment = Asset_SDVJAmUprkldIk4heh50sFqsd2Z3gxRr4Kewy6StHw_Fragment | Asset_Column_Fragment | Asset_V10Kt7Gb3kiNYsR0mY5iAmpQoRapBsFkPd9do3t54Jk_Fragment;

export type LabelAssetFragment = (
  { asset: (
    { id: string, luid: string, name: string | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
  ) | (
    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
      { id: string, name: string | null }
      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'Column' }
  ) | (
    { vizportalUrlId: string, id: string, luid: string, name: string | null }
    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
  ) | null }
  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
);

export type LabelFragment = (
  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, asset: (
    { id: string, luid: string, name: string | null }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
  ) | (
    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
      { id: string, name: string | null }
      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'Column' }
  ) | (
    { vizportalUrlId: string, id: string, luid: string, name: string | null }
    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
  ) | null }
  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
);

export type LensDownstreamDashboardsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type LensDownstreamDashboardsQuery = { lenses: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensDownstreamMetricsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type LensDownstreamMetricsQuery = { lenses: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensDownstreamOwnerIdsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type LensDownstreamOwnerIdsQuery = { lenses: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensDownstreamOwnersQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type LensDownstreamOwnersQuery = { lenses: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensDownstreamWorkbooksQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type LensDownstreamWorkbooksQuery = { lenses: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensFieldDetailsQueryVariables = Exact<{
  lensFieldId: Scalars['ID'];
}>;


export type LensFieldDetailsQuery = { lensFields: Array<(
    { name: string | null, description: string | null, datasourceField: (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { combinationType: string | null, delimiter: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, remoteField: (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fields: Array<(
          { id: string, name: string | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        )>, parameters: Array<(
          { name: string | null }
          & { __typename: 'Parameter' }
        )> }
        & { __typename: 'BinField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fields: Array<(
          { id: string, name: string | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        )>, parameters: Array<(
          { name: string | null }
          & { __typename: 'Parameter' }
        )> }
        & { __typename: 'CalculatedField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null, referencedByFlowColumnOutputField: Array<(
              { parentFields: Array<(
                { column: (
                  { id: string, name: string | null, description: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | null }
                & { __typename: 'FlowColumnInputField' }
              ) | { __typename: 'FlowFieldInputField' }> }
              & { __typename: 'FlowColumnOutputField' }
            ) | null> | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'ColumnField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'CombinedField' }
      ) | (
        { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'CombinedSetField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, remoteField: (
          { id: string, name: string | null, description: string | null, datasource: (
            { id: string, name: string | null }
            & { __typename: 'EmbeddedDatasource' }
          ) | (
            { vizportalUrlId: string, id: string, name: string | null }
            & { __typename: 'PublishedDatasource' }
          ) | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        ) | null }
        & { __typename: 'DatasourceField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fieldsReferencedByGroup: Array<(
          { name: string | null }
          & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        ) | (
          { semanticRole: string | null, name: string | null }
          & { __typename: 'CalculatedField' | 'ColumnField' }
        )> }
        & { __typename: 'GroupField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'HierarchyField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
          { name: string | null, id: string }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, name: string | null, id: string }
          & { __typename: 'PublishedDatasource' }
        ) | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: { __typename: 'EmbeddedDatasource' } | (
        { vizportalUrlId: string }
        & { __typename: 'PublishedDatasource' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) }
    & { __typename: 'LensField' }
  )> };

export type LensFieldsByIdQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensFieldSortOrder;
}>;


export type LensFieldsByIdQuery = { lenses: Array<(
    { id: string, name: string | null, vizportalUrlId: string, fieldsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, datasourceField: (
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
          & { __typename: 'BinField' }
        ) | (
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
          & { __typename: 'CalculatedField' }
        ) | (
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
          & { __typename: 'ColumnField' }
        ) | (
          { id: string, name: string | null, description: string | null, combinedField: string }
          & { __typename: 'CombinedField' }
        ) | (
          { id: string, name: string | null, description: string | null, combinedSetField: string }
          & { __typename: 'CombinedSetField' }
        ) | (
          { id: string, name: string | null, description: string | null, datasourceField: string, remoteField: (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
            & { __typename: 'BinField' }
          ) | (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
            & { __typename: 'CalculatedField' }
          ) | (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
            & { __typename: 'ColumnField' }
          ) | (
            { combinedField: string }
            & { __typename: 'CombinedField' }
          ) | (
            { combinedSetField: string }
            & { __typename: 'CombinedSetField' }
          ) | { __typename: 'DatasourceField' } | (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
              { semanticRole: string | null }
              & { __typename: 'CalculatedField' | 'ColumnField' }
            )> }
            & { __typename: 'GroupField' }
          ) | (
            { hierarchyField: string }
            & { __typename: 'HierarchyField' }
          ) | (
            { setField: string }
            & { __typename: 'SetField' }
          ) | null }
          & { __typename: 'DatasourceField' }
        ) | (
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
            { semanticRole: string | null }
            & { __typename: 'CalculatedField' | 'ColumnField' }
          )> }
          & { __typename: 'GroupField' }
        ) | (
          { id: string, name: string | null, description: string | null, hierarchyField: string }
          & { __typename: 'HierarchyField' }
        ) | (
          { id: string, name: string | null, description: string | null, setField: string }
          & { __typename: 'SetField' }
        ) }
        & { __typename: 'LensField' }
      )> }
      & { __typename: 'LensFieldsConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensFieldsByIdFieldsConnectionNodesFragment = (
  { id: string, name: string | null, description: string | null, datasourceField: (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinedField: string }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinedSetField: string }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, datasourceField: string, remoteField: (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
      & { __typename: 'BinField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
      & { __typename: 'CalculatedField' }
    ) | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
      & { __typename: 'ColumnField' }
    ) | (
      { combinedField: string }
      & { __typename: 'CombinedField' }
    ) | (
      { combinedSetField: string }
      & { __typename: 'CombinedSetField' }
    ) | { __typename: 'DatasourceField' } | (
      { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
        { semanticRole: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { hierarchyField: string }
      & { __typename: 'HierarchyField' }
    ) | (
      { setField: string }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
      { semanticRole: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, hierarchyField: string }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, setField: string }
    & { __typename: 'SetField' }
  ) }
  & { __typename: 'LensField' }
);

export type LensLineageCountsFragment = (
  { upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'TablesConnection' }
  ) | null, upstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, upstreamVirtualConnectionTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, upstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, upstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'LensFieldsConnection' }
  ) | null, downstreamDashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'Lens' }
);

export type LensLineageCountsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type LensLineageCountsQuery = { lenses: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'TablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, upstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'LensFieldsConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type LensQuery = { lenses: Array<(
    { name: string | null, luid: string }
    & { __typename: 'Lens' }
  )> };

export type LensUpstreamDatabasesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type LensUpstreamDatabasesQuery = { lenses: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensUpstreamDatasourcesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type LensUpstreamDatasourcesQuery = { lenses: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensUpstreamFlowsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type LensUpstreamFlowsQuery = { lenses: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensUpstreamTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableSortOrder;
}>;


export type LensUpstreamTablesQuery = { lenses: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, isEmbedded: boolean | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'CustomSQLTable' }
      ) | (
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      ) | (
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'TablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      )> }
      & { __typename: 'TablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      )> }
      & { __typename: 'TablesConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensUpstreamVirtualConnectionTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type LensUpstreamVirtualConnectionTablesQuery = { lenses: Array<(
    { upstreamVirtualConnectionTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensUpstreamVirtualConnectionsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type LensUpstreamVirtualConnectionsQuery = { lenses: Array<(
    { upstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null }
    & { __typename: 'Lens' }
  )> };

export type LensUpstreamVirtualConnectionsNodesFragment = (
  { totalCount: number, nodes: Array<(
    { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
      { name: string | null, username: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ), tablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'VirtualConnection' }
  )> }
  & { __typename: 'VirtualConnectionsConnection' }
);

export type LensesDisplayGridRowDataFragment = (
  { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
    { domain: string | null, username: string | null, name: string | null }
    & { __typename: 'TableauUser' }
  ), downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null }
  & { __typename: 'Lens' }
);

export type MetricUpstreamDataQualityWarningsQueryVariables = Exact<{
  metricLuid: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type MetricUpstreamDataQualityWarningsQuery = { metrics: Array<(
    { upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'Metric' }
  )> };

export type MetricsDisplayGridRowDataFragment = (
  { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
    { name: string | null, path: string | null, workbook: (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'Workbook' }
    ) | null }
    & { __typename: 'Dashboard' | 'Sheet' }
  ) | null, owner: (
    { domain: string | null, username: string | null, name: string | null }
    & { __typename: 'TableauUser' }
  ) }
  & { __typename: 'Metric' }
);

export type MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragment = (
  { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
    { name: string | null, path: string | null, workbook: (
      { vizportalUrlId: string, name: string | null }
      & { __typename: 'Workbook' }
    ) | null }
    & { __typename: 'Dashboard' | 'Sheet' }
  ) | null, owner: (
    { domain: string | null, username: string | null, name: string | null }
    & { __typename: 'TableauUser' }
  ) }
  & { __typename: 'Metric' }
);

export type NonDatasourceFieldDetails_BinField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fields: Array<(
    { id: string, name: string | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )>, parameters: Array<(
    { name: string | null }
    & { __typename: 'Parameter' }
  )> }
  & { __typename: 'BinField' }
);

export type NonDatasourceFieldDetails_CalculatedField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fields: Array<(
    { id: string, name: string | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )>, parameters: Array<(
    { name: string | null }
    & { __typename: 'Parameter' }
  )> }
  & { __typename: 'CalculatedField' }
);

export type NonDatasourceFieldDetails_ColumnField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, description: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null, referencedByFlowColumnOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowColumnOutputField' }
      ) | null> | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'ColumnField' }
);

export type NonDatasourceFieldDetails_CombinedField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'CombinedField' }
);

export type NonDatasourceFieldDetails_CombinedSetField_Fragment = (
  { combinationType: string | null, delimiter: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'CombinedSetField' }
);

export type NonDatasourceFieldDetails_DatasourceField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, remoteField: (
    { id: string, name: string | null, description: string | null, datasource: (
      { id: string, name: string | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null }
      & { __typename: 'PublishedDatasource' }
    ) | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type NonDatasourceFieldDetails_GroupField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fieldsReferencedByGroup: Array<(
    { name: string | null }
    & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | (
    { semanticRole: string | null, name: string | null }
    & { __typename: 'CalculatedField' | 'ColumnField' }
  )> }
  & { __typename: 'GroupField' }
);

export type NonDatasourceFieldDetails_HierarchyField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'HierarchyField' }
);

export type NonDatasourceFieldDetails_SetField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'SetField' }
);

export type NonDatasourceFieldDetailsFragment = NonDatasourceFieldDetails_BinField_Fragment | NonDatasourceFieldDetails_CalculatedField_Fragment | NonDatasourceFieldDetails_ColumnField_Fragment | NonDatasourceFieldDetails_CombinedField_Fragment | NonDatasourceFieldDetails_CombinedSetField_Fragment | NonDatasourceFieldDetails_DatasourceField_Fragment | NonDatasourceFieldDetails_GroupField_Fragment | NonDatasourceFieldDetails_HierarchyField_Fragment | NonDatasourceFieldDetails_SetField_Fragment;

export type NonDatasourceFieldDetails_ColumnFragment = (
  { id: string, name: string | null, description: string | null, table: (
    { id: string, name: string | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  ) | null, referencedByFlowColumnOutputField: Array<(
    { parentFields: Array<(
      { column: (
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | null }
      & { __typename: 'FlowColumnInputField' }
    ) | { __typename: 'FlowFieldInputField' }> }
    & { __typename: 'FlowColumnOutputField' }
  ) | null> | null }
  & { __typename: 'Column' }
);

export type NonDatasourceFieldDetails_UpstreamColumnFragment = (
  { id: string, name: string | null, description: string | null, table: (
    { id: string, name: string | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  ) | null }
  & { __typename: 'Column' }
);

export type NonDatasourceFieldIcon_BinField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
  & { __typename: 'BinField' }
);

export type NonDatasourceFieldIcon_CalculatedField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
  & { __typename: 'CalculatedField' }
);

export type NonDatasourceFieldIcon_ColumnField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
  & { __typename: 'ColumnField' }
);

export type NonDatasourceFieldIcon_CombinedField_Fragment = (
  { combinedField: string }
  & { __typename: 'CombinedField' }
);

export type NonDatasourceFieldIcon_CombinedSetField_Fragment = (
  { combinedSetField: string }
  & { __typename: 'CombinedSetField' }
);

export type NonDatasourceFieldIcon_DatasourceField_Fragment = { __typename: 'DatasourceField' };

export type NonDatasourceFieldIcon_GroupField_Fragment = (
  { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
    { semanticRole: string | null }
    & { __typename: 'CalculatedField' | 'ColumnField' }
  )> }
  & { __typename: 'GroupField' }
);

export type NonDatasourceFieldIcon_HierarchyField_Fragment = (
  { hierarchyField: string }
  & { __typename: 'HierarchyField' }
);

export type NonDatasourceFieldIcon_SetField_Fragment = (
  { setField: string }
  & { __typename: 'SetField' }
);

export type NonDatasourceFieldIconFragment = NonDatasourceFieldIcon_BinField_Fragment | NonDatasourceFieldIcon_CalculatedField_Fragment | NonDatasourceFieldIcon_ColumnField_Fragment | NonDatasourceFieldIcon_CombinedField_Fragment | NonDatasourceFieldIcon_CombinedSetField_Fragment | NonDatasourceFieldIcon_DatasourceField_Fragment | NonDatasourceFieldIcon_GroupField_Fragment | NonDatasourceFieldIcon_HierarchyField_Fragment | NonDatasourceFieldIcon_SetField_Fragment;

export type OwnerIdFragment = (
  { id: string, vizportalId: string }
  & { __typename: 'TableauUser' }
);

export type OwnersDisplayGridRowDataFragment = (
  { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, ownedDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, ownedMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, ownedVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null }
  & { __typename: 'TableauUser' }
);

export type PublishedDatasourceLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type PublishedDatasourceLineageUpstreamDataQualityWarningsQuery = { publishedDatasources: Array<(
    { id: string, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'PublishedDatasource' }
  )> };

export type SheetFieldInstanceDatasourceFragment = (
  { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
  & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
);

export type SheetFieldInstance_BinField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fields: Array<(
    { id: string, name: string | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )>, parameters: Array<(
    { name: string | null }
    & { __typename: 'Parameter' }
  )> }
  & { __typename: 'BinField' }
);

export type SheetFieldInstance_CalculatedField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fields: Array<(
    { id: string, name: string | null }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  )>, parameters: Array<(
    { name: string | null }
    & { __typename: 'Parameter' }
  )> }
  & { __typename: 'CalculatedField' }
);

export type SheetFieldInstance_ColumnField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, description: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null, referencedByFlowColumnOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowColumnOutputField' }
      ) | null> | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'ColumnField' }
);

export type SheetFieldInstance_CombinedField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'CombinedField' }
);

export type SheetFieldInstance_CombinedSetField_Fragment = (
  { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'CombinedSetField' }
);

export type SheetFieldInstance_DatasourceField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, remoteField: (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, remoteField: (
      { id: string, name: string | null, description: string | null, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type SheetFieldInstance_GroupField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null, fieldsReferencedByGroup: Array<(
    { name: string | null }
    & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | (
    { semanticRole: string | null, name: string | null }
    & { __typename: 'CalculatedField' | 'ColumnField' }
  )> }
  & { __typename: 'GroupField' }
);

export type SheetFieldInstance_HierarchyField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'HierarchyField' }
);

export type SheetFieldInstance_SetField_Fragment = (
  { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
    & { __typename: 'EmbeddedDatasource' }
  ) | (
    { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
    & { __typename: 'PublishedDatasource' }
  ) | null, upstreamDatabasesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
    )> }
    & { __typename: 'DatabasesConnection' }
  ) | null, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'SetField' }
);

export type SheetFieldInstanceFragment = SheetFieldInstance_BinField_Fragment | SheetFieldInstance_CalculatedField_Fragment | SheetFieldInstance_ColumnField_Fragment | SheetFieldInstance_CombinedField_Fragment | SheetFieldInstance_CombinedSetField_Fragment | SheetFieldInstance_DatasourceField_Fragment | SheetFieldInstance_GroupField_Fragment | SheetFieldInstance_HierarchyField_Fragment | SheetFieldInstance_SetField_Fragment;

export type SheetFieldInstanceDatasourceFieldFragment = (
  { datasourceField: string, remoteField: (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { combinationType: string | null, delimiter: string | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, remoteField: (
      { id: string, name: string | null, description: string | null, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' | 'PublishedDatasource' }
    ) | null, referencedByFlowFieldOutputField: Array<(
      { parentFields: Array<(
        { column: (
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | null }
        & { __typename: 'FlowColumnInputField' }
      ) | { __typename: 'FlowFieldInputField' }> }
      & { __typename: 'FlowFieldOutputField' }
    ) | null> | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type SheetFieldInstancePublishedDatasourceFragment = (
  { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
  & { __typename: 'PublishedDatasource' }
);

export type SheetFieldInstanceUpstreamDatabasesConnectionFragment = (
  { nodes: Array<(
    { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
  )> }
  & { __typename: 'DatabasesConnection' }
);

export type SheetsDisplayGridRowDataFragment = (
  { id: string, name: string | null, path: string | null, workbook: (
    { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
      { domain: string | null, username: string | null, name: string | null }
      & { __typename: 'TableauUser' }
    ) }
    & { __typename: 'Workbook' }
  ) | null }
  & { __typename: 'Sheet' }
);

export type TableCertificationFragment = (
  { isCertified: boolean, certificationNote: string | null, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'DatabaseTable' }
);

export type ColumnsByTableIdFragment = (
  { id: string, luid: string, name: string | null, remoteType: RemoteType, description: string | null, upstreamColumns?: Array<(
    { luid: string, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Column' }
  ) | null>, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )> }
  & { __typename: 'Column' }
);

export type TableColumnsByIdQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: ColumnSortOrder;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type TableColumnsByIdQuery = { tablesConnection: (
    { nodes: Array<(
      { id: string, name: string | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, luid: string, name: string | null, remoteType: RemoteType, description: string | null, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )>, upstreamColumns?: Array<(
            { luid: string, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          ) | null>, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )> }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'CustomSQLTable' | 'VirtualConnectionTable' }
    ) | (
      { schema: string | null, vizportalId: string, id: string, name: string | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, luid: string, name: string | null, remoteType: RemoteType, description: string | null, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )>, upstreamColumns?: Array<(
            { luid: string, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          ) | null>, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )> }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'TablesConnection' }
  ) };

export type TableColumnsByIdColumnsFragment = (
  { id: string, luid: string, name: string | null, remoteType: RemoteType, description: string | null, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )>, upstreamColumns?: Array<(
    { luid: string, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )> }
    & { __typename: 'Column' }
  ) | null>, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )> }
  & { __typename: 'Column' }
);

export type TableDatabaseName_CustomSqlTable_VirtualConnectionTable_Fragment = { __typename: 'CustomSQLTable' | 'VirtualConnectionTable' };

export type TableDatabaseName_DatabaseTable_Fragment = (
  { vizportalId: string, database: (
    { name: string | null, isGrouped: boolean | null }
    & { __typename: 'CloudFile' | 'WebDataConnector' }
  ) | (
    { hostName: string | null, name: string | null, isGrouped: boolean | null }
    & { __typename: 'DatabaseServer' }
  ) | (
    { filePath: string | null, name: string | null, isGrouped: boolean | null }
    & { __typename: 'File' }
  ) | null }
  & { __typename: 'DatabaseTable' }
);

export type TableDatabaseNameFragment = TableDatabaseName_CustomSqlTable_VirtualConnectionTable_Fragment | TableDatabaseName_DatabaseTable_Fragment;

export type TableDownstreamDashboardsFilteredByColumnQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type TableDownstreamDashboardsFilteredByColumnQuery = { columns: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamDashboardsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type TableDownstreamDashboardsQuery = { tables: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamDatabasesFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type TableDownstreamDatabasesFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { downstreamDatabasesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'CloudFile' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'DatabaseServer' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'File' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamDatabasesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type TableDownstreamDatabasesQuery = { tables: Array<(
    { downstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamFlowsFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableDownstreamFlowsFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { downstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamFlowsFilteredByColumnWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableDownstreamFlowsFilteredByColumnWithoutPersonalSpaceQuery = { tables: Array<(
    { columns: Array<(
      { downstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamFlowsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableDownstreamFlowsQuery = { tables: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableDownstreamFlowsWithoutPersonalSpaceQuery = { tables: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamLensesFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type TableDownstreamLensesFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { downstreamLensesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ), downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'Lens' }
        )> }
        & { __typename: 'LensesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamLensesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type TableDownstreamLensesQuery = { tables: Array<(
    { downstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamMetricsFilteredByColumnQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type TableDownstreamMetricsFilteredByColumnQuery = { columns: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceQuery = { columns: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamMetricsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type TableDownstreamMetricsQuery = { tables: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamMetricsWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type TableDownstreamMetricsWithoutPersonalSpaceQuery = { tables: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamOwnerIdsFilteredByColumnQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type TableDownstreamOwnerIdsFilteredByColumnQuery = { columns: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamOwnerIdsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type TableDownstreamOwnerIdsQuery = { tables: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamOwnersFilteredByColumnQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type TableDownstreamOwnersFilteredByColumnQuery = { columns: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamOwnersQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type TableDownstreamOwnersQuery = { tables: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamPublishedDatasourcesFilteredByColumnQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableDownstreamPublishedDatasourcesFilteredByColumnQuery = { columns: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceQuery = { columns: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamPublishedDatasourcesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableDownstreamPublishedDatasourcesQuery = { tables: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamPublishedDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableDownstreamPublishedDatasourcesWithoutPersonalSpaceQuery = { tables: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamSheetsFilteredByColumnQueryVariables = Exact<{
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type TableDownstreamSheetsFilteredByColumnQuery = { columns: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'Column' }
  )> };

export type TableDownstreamSheetsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type TableDownstreamSheetsQuery = { tables: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamTablesFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type TableDownstreamTablesFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { downstreamTablesConnection: (
        { totalCount: number, nodes: Array<(
          { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, columnsConnectionWithWarnings: (
            { totalCount: number, nodes: Array<(
              { labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { name: string | null }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, database: (
            { name: string | null, isGrouped: boolean | null }
            & { __typename: 'CloudFile' | 'WebDataConnector' }
          ) | (
            { hostName: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'DatabaseServer' }
          ) | (
            { filePath: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'File' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamTablesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type TableDownstreamTablesQuery = { tables: Array<(
    { downstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamVirtualConnectionTablesFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type TableDownstreamVirtualConnectionTablesFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { downstreamVirtualConnectionTablesConnection: (
        { totalCount: number, nodes: Array<(
          { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, columnsConnectionWithWarnings: (
            { totalCount: number, nodes: Array<(
              { labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { name: string | null }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'VirtualConnectionTable' }
        )> }
        & { __typename: 'VirtualConnectionTablesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamVirtualConnectionTablesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type TableDownstreamVirtualConnectionTablesQuery = { tables: Array<(
    { downstreamVirtualConnectionTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamVirtualConnectionsFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type TableDownstreamVirtualConnectionsFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { downstreamVirtualConnectionsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), tablesConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionTablesConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )> }
          & { __typename: 'VirtualConnection' }
        )> }
        & { __typename: 'VirtualConnectionsConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamVirtualConnectionsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type TableDownstreamVirtualConnectionsQuery = { tables: Array<(
    { downstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamWorkbooksFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type TableDownstreamWorkbooksFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null }
          & { __typename: 'Workbook' }
        )> }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceQuery = { tables: Array<(
    { columns: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, description: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null }
          & { __typename: 'Workbook' }
        )> }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamWorkbooksQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type TableDownstreamWorkbooksQuery = { tables: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableDownstreamWorkbooksWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type TableDownstreamWorkbooksWithoutPersonalSpaceQuery = { tables: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type Table_CustomSqlTable_VirtualConnectionTable_Fragment = (
  { id: string, name: string | null, description: string | null, isEmbedded: boolean | null }
  & { __typename: 'CustomSQLTable' | 'VirtualConnectionTable' }
);

export type Table_DatabaseTable_Fragment = (
  { fullName: string | null, luid: string, vizportalId: string, description: string | null, id: string, name: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, database: (
    { fileId: string | null, provider: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'CloudFile' }
  ) | (
    { hostName: string | null, port: number | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'DatabaseServer' }
  ) | (
    { filePath: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'File' }
  ) | (
    { connectorUrl: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'WebDataConnector' }
  ) | null, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'DatabaseTable' }
);

export type TableFragment = Table_CustomSqlTable_VirtualConnectionTable_Fragment | Table_DatabaseTable_Fragment;

export type TableLineageCountsFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
}>;


export type TableLineageCountsFilteredByColumnQuery = { tables: Array<(
    { filteredColumnsConnection: (
      { nodes: Array<(
        { name: string | null, id: string, upstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, upstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, upstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, upstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, downstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamVirtualConnectionTablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamLensesConnection: (
          { totalCount: number }
          & { __typename: 'LensesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDashboardsConnection: (
          { totalCount: number }
          & { __typename: 'DashboardsConnection' }
        ) | null, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, downstreamMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, downstreamOwnersConnection: (
          { totalCount: number }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, unfilteredColumnsConnection: (
      { totalCount: number }
      & { __typename: 'ColumnsConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, downstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableLineageCountsFragment = (
  { unfilteredColumnsConnection: (
    { totalCount: number }
    & { __typename: 'ColumnsConnection' }
  ) | null, upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, upstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, upstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, downstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamVirtualConnectionTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, downstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamLensesConnection: (
    { totalCount: number }
    & { __typename: 'LensesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
);

export type TableLineageCountsQueryVariables = Exact<{
  tableId: Scalars['ID'];
}>;


export type TableLineageCountsQuery = { tables: Array<(
    { unfilteredColumnsConnection: (
      { totalCount: number }
      & { __typename: 'ColumnsConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, downstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, downstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type TableLineageUpstreamDataQualityWarningsQuery = { databaseTables: Array<(
    { id: string, name: string | null, dataQualityWarnings: Array<(
      { isActive: boolean, id: string, vizportalId: string, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { name: string | null, id: string }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
      ) | (
        { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
          { id: string, luid: string, name: string | null }
          & { __typename: 'DatabaseTable' }
        ) | (
          { luid: string, name: string | null }
          & { __typename: 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { name: string | null, vizportalUrlId: string, id: string }
        & { __typename: 'Flow' | 'PublishedDatasource' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { name: string | null, remoteType: RemoteType, dataQualityWarnings: Array<(
          { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { name: string | null, id: string }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
          ) | (
            { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
              { id: string, luid: string, name: string | null }
              & { __typename: 'DatabaseTable' }
            ) | (
              { luid: string, name: string | null }
              & { __typename: 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { name: string | null, vizportalUrlId: string, id: string }
            & { __typename: 'Flow' | 'PublishedDatasource' }
          ) | null }
          & { __typename: 'DataQualityWarning' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'DatabaseTable' }
  )> };

export type TableQueryVariables = Exact<{
  tableId: Scalars['ID'];
}>;


export type TableQuery = { tables: Array<(
    { id: string, name: string | null, description: string | null, isEmbedded: boolean | null }
    & { __typename: 'CustomSQLTable' | 'VirtualConnectionTable' }
  ) | (
    { fullName: string | null, luid: string, vizportalId: string, description: string | null, id: string, name: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
      { name: string | null }
      & { __typename: 'Tag' }
    )>, contact: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, dataQualityWarnings: Array<(
      { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null }
      & { __typename: 'DataQualityWarning' }
    )>, labels: Array<(
      { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, asset: (
        { id: string, luid: string, name: string | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
      ) | (
        { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'Column' }
      ) | (
        { vizportalUrlId: string, id: string, luid: string, name: string | null }
        & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
    )>, database: (
      { fileId: string | null, provider: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'CloudFile' }
    ) | (
      { hostName: string | null, port: number | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'DatabaseServer' }
    ) | (
      { filePath: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'File' }
    ) | (
      { connectorUrl: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
      & { __typename: 'WebDataConnector' }
    ) | null, certifier: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DatabaseTable' }
  )> };

export type TableQuery_CustomSqlTable_VirtualConnectionTable_Fragment = (
  { id: string, name: string | null, description: string | null, isEmbedded: boolean | null }
  & { __typename: 'CustomSQLTable' | 'VirtualConnectionTable' }
);

export type TableQuery_DatabaseTable_Fragment = (
  { fullName: string | null, luid: string, vizportalId: string, description: string | null, id: string, name: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )>, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, dataQualityWarnings: Array<(
    { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null }
    & { __typename: 'DataQualityWarning' }
  )>, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, database: (
    { fileId: string | null, provider: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'CloudFile' }
  ) | (
    { hostName: string | null, port: number | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'DatabaseServer' }
  ) | (
    { filePath: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'File' }
  ) | (
    { connectorUrl: string | null, id: string, name: string | null, connectionType: string | null, isCertified: boolean }
    & { __typename: 'WebDataConnector' }
  ) | null, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null }
  & { __typename: 'DatabaseTable' }
);

export type TableQueryFragment = TableQuery_CustomSqlTable_VirtualConnectionTable_Fragment | TableQuery_DatabaseTable_Fragment;

export type TableUpstreamDatabasesFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type TableUpstreamDatabasesFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { upstreamDatabasesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'CloudFile' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'DatabaseServer' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'File' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamDatabasesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type TableUpstreamDatabasesQuery = { tables: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamDatasourcesFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableUpstreamDatasourcesFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { upstreamDatasourcesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'PublishedDatasource' }
        )> }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamDatasourcesFilteredByColumnWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableUpstreamDatasourcesFilteredByColumnWithoutPersonalSpaceQuery = { tables: Array<(
    { columns: Array<(
      { upstreamDatasourcesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'PublishedDatasource' }
        )> }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamDatasourcesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableUpstreamDatasourcesQuery = { tables: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type TableUpstreamDatasourcesWithoutPersonalSpaceQuery = { tables: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamFlowsFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableUpstreamFlowsFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { upstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceQuery = { tables: Array<(
    { columns: Array<(
      { upstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamFlowsQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableUpstreamFlowsQuery = { tables: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type TableUpstreamFlowsWithoutPersonalSpaceQuery = { tables: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamTablesFilteredByColumnQueryVariables = Exact<{
  tableId: Scalars['ID'];
  columnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type TableUpstreamTablesFilteredByColumnQuery = { tables: Array<(
    { columns: Array<(
      { upstreamTablesConnection: (
        { totalCount: number, nodes: Array<(
          { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, columnsConnectionWithWarnings: (
            { totalCount: number, nodes: Array<(
              { labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { name: string | null }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, database: (
            { name: string | null, isGrouped: boolean | null }
            & { __typename: 'CloudFile' | 'WebDataConnector' }
          ) | (
            { hostName: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'DatabaseServer' }
          ) | (
            { filePath: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'File' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableUpstreamTablesQueryVariables = Exact<{
  tableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type TableUpstreamTablesQuery = { tables: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
  )> };

export type TableauUserFragment = (
  { username: string | null, name: string | null, domain: string | null }
  & { __typename: 'TableauUser' }
);

export type TablesByTagQueryVariables = Exact<{
  tagName: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  textSearch: InputMaybe<Scalars['String']>;
  orderBy: DatabaseTableSortOrder;
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  isCertified: InputMaybe<Scalars['Boolean']>;
}>;


export type TablesByTagQuery = { tags: Array<(
    { databaseTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )>, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Tag' }
  )> };

export type TablesDisplayGridRowData_CustomSqlTable_Fragment = (
  { id: string, name: string | null, description: string | null, isEmbedded: boolean | null, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, columnsConnectionWithWarnings: (
    { totalCount: number, nodes: Array<(
      { labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { name: string | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'CustomSQLTable' }
);

export type TablesDisplayGridRowData_DatabaseTable_Fragment = (
  { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, columnsConnectionWithWarnings: (
    { totalCount: number, nodes: Array<(
      { labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { name: string | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null, certifier: (
    { username: string | null, name: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ) | null, database: (
    { name: string | null, isGrouped: boolean | null }
    & { __typename: 'CloudFile' | 'WebDataConnector' }
  ) | (
    { hostName: string | null, name: string | null, isGrouped: boolean | null }
    & { __typename: 'DatabaseServer' }
  ) | (
    { filePath: string | null, name: string | null, isGrouped: boolean | null }
    & { __typename: 'File' }
  ) | null }
  & { __typename: 'DatabaseTable' }
);

export type TablesDisplayGridRowData_VirtualConnectionTable_Fragment = (
  { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, columnsConnectionWithWarnings: (
    { totalCount: number, nodes: Array<(
      { labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { name: string | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'VirtualConnectionTable' }
);

export type TablesDisplayGridRowDataFragment = TablesDisplayGridRowData_CustomSqlTable_Fragment | TablesDisplayGridRowData_DatabaseTable_Fragment | TablesDisplayGridRowData_VirtualConnectionTable_Fragment;

export type TablesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  textSearch: InputMaybe<Scalars['String']>;
  orderBy: DatabaseTableSortOrder;
  hasActiveWarning: InputMaybe<Scalars['Boolean']>;
  isCertified: InputMaybe<Scalars['Boolean']>;
}>;


export type TablesQuery = { databaseTablesConnection: (
    { totalCount: number, nodes: Array<(
      { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )>, downstreamVirtualConnectionsConnection: (
        { totalCount: number }
        & { __typename: 'VirtualConnectionsConnection' }
      ) | null, downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null, downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null, columnsConnectionWithWarnings: (
        { totalCount: number, nodes: Array<(
          { labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )> }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { name: string | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null, tags: Array<(
        { name: string | null }
        & { __typename: 'Tag' }
      )>, certifier: (
        { username: string | null, name: string | null, domain: string | null }
        & { __typename: 'TableauUser' }
      ) | null, database: (
        { name: string | null, isGrouped: boolean | null }
        & { __typename: 'CloudFile' | 'WebDataConnector' }
      ) | (
        { hostName: string | null, name: string | null, isGrouped: boolean | null }
        & { __typename: 'DatabaseServer' }
      ) | (
        { filePath: string | null, name: string | null, isGrouped: boolean | null }
        & { __typename: 'File' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ), maxDownstreamDatasources: (
    { nodes: Array<(
      { downstreamDatasourcesConnection: (
        { totalCount: number }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ), maxDownstreamWorkbooks: (
    { nodes: Array<(
      { downstreamWorkbooksConnection: (
        { totalCount: number }
        & { __typename: 'WorkbooksConnection' }
      ) | null }
      & { __typename: 'DatabaseTable' }
    )> }
    & { __typename: 'DatabaseTablesConnection' }
  ) };

export type TagsFragment = (
  { tags: Array<(
    { name: string | null }
    & { __typename: 'Tag' }
  )> }
  & { __typename: 'CloudFile' | 'Column' | 'Dashboard' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'Flow' | 'Metric' | 'PublishedDatasource' | 'Sheet' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' | 'Workbook' }
);

export type TagsQueryWithFiltersQueryVariables = Exact<{
  first: Scalars['Int'];
  connectionTypeFilter: InputMaybe<Scalars['String']>;
  hasActiveWarningFilter: InputMaybe<Scalars['Boolean']>;
  isCertifiedFilter: InputMaybe<Scalars['Boolean']>;
  isEmbeddedFilter: InputMaybe<Scalars['Boolean']>;
  name: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  textSearch: InputMaybe<Scalars['String']>;
}>;


export type TagsQueryWithFiltersQuery = { tagsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, databasesConnection: (
        { totalCount: number }
        & { __typename: 'DatabasesConnection' }
      ) | null, databaseTablesConnection: (
        { totalCount: number }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'Tag' }
    )> }
    & { __typename: 'TagsConnection' }
  ) };

export type TagsQueryWithFiltersTagsConnectionFragment = (
  { totalCount: number, nodes: Array<(
    { id: string, name: string | null, databasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, databaseTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Tag' }
  )> }
  & { __typename: 'TagsConnection' }
);

export type TagsQueryWithFiltersTagsConnectionNodesFragment = (
  { id: string, name: string | null, databasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, databaseTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null }
  & { __typename: 'Tag' }
);

export type UpstreamDatabasesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type UpstreamDatabasesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamDatabasesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'CloudFile' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'DatabaseServer' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'File' }
        ) | (
          { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, tags: Array<(
            { name: string | null }
            & { __typename: 'Tag' }
          )> }
          & { __typename: 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type UpstreamDatasourcesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type UpstreamDatasourcesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamDatasourcesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'PublishedDatasource' }
        )> }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamDatasourcesConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'PublishedDatasource' }
        )> }
        & { __typename: 'PublishedDatasourcesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type UpstreamFlowsFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type UpstreamFlowsFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type UpstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type UpstreamFlowsFilteredByFieldWithoutPersonalSpaceQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamFlowsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) | null }
          & { __typename: 'Flow' }
        )> }
        & { __typename: 'FlowsConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type UpstreamTablesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type UpstreamTablesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamTablesConnection: (
        { totalCount: number, nodes: Array<(
          { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, columnsConnectionWithWarnings: (
            { totalCount: number, nodes: Array<(
              { labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { name: string | null }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, certifier: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, database: (
            { name: string | null, isGrouped: boolean | null }
            & { __typename: 'CloudFile' | 'WebDataConnector' }
          ) | (
            { hostName: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'DatabaseServer' }
          ) | (
            { filePath: string | null, name: string | null, isGrouped: boolean | null }
            & { __typename: 'File' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type UpstreamVirtualConnectionTablesFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type UpstreamVirtualConnectionTablesFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamVirtualConnectionTablesConnection: (
        { totalCount: number, nodes: Array<(
          { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )>, downstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, columnsConnectionWithWarnings: (
            { totalCount: number, nodes: Array<(
              { labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { name: string | null }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'VirtualConnectionTable' }
        )> }
        & { __typename: 'VirtualConnectionTablesConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type UpstreamVirtualConnectionsFilteredByFieldQueryVariables = Exact<{
  selectedFieldId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type UpstreamVirtualConnectionsFilteredByFieldQuery = { fieldsConnection: (
    { nodes: Array<(
      { upstreamVirtualConnectionsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
            { name: string | null, username: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ), tablesConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionTablesConnection' }
          ) | null, downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null, downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )> }
          & { __typename: 'VirtualConnection' }
        )> }
        & { __typename: 'VirtualConnectionsConnection' }
      ) | null, maxDownstreamDatasources: (
        { nodes: Array<(
          { downstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null, maxDownstreamWorkbooks: (
        { nodes: Array<(
          { downstreamWorkbooksConnection: (
            { totalCount: number }
            & { __typename: 'WorkbooksConnection' }
          ) | null }
          & { __typename: 'DatabaseTable' }
        )> }
        & { __typename: 'DatabaseTablesConnection' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )> }
    & { __typename: 'FieldsConnection' }
  ) };

export type ViewDetailsByPathQueryVariables = Exact<{
  viewPath: Scalars['String'];
}>;


export type ViewDetailsByPathQuery = { views: Array<(
    { id: string, name: string | null, updatedAt: any, path: string | null, workbook: (
      { name: string | null, projectName: string | null, projectVizportalUrlId: string | null, vizportalUrlId: string, owner: (
        { id: string, name: string | null, username: string | null, uri: string, domain: string | null }
        & { __typename: 'TableauUser' }
      ) }
      & { __typename: 'Workbook' }
    ) | null, sheets: Array<(
      { worksheetFields: Array<(
        { id: string }
        & { __typename: 'CalculatedField' }
      ) | null> | null, datasourceFields: Array<(
        { id: string }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | null> | null }
      & { __typename: 'Sheet' }
    )>, upstreamSheetFieldInstances: Array<(
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, remoteField: (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fields: Array<(
          { id: string, name: string | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        )>, parameters: Array<(
          { name: string | null }
          & { __typename: 'Parameter' }
        )> }
        & { __typename: 'BinField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fields: Array<(
          { id: string, name: string | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        )>, parameters: Array<(
          { name: string | null }
          & { __typename: 'Parameter' }
        )> }
        & { __typename: 'CalculatedField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null, referencedByFlowColumnOutputField: Array<(
              { parentFields: Array<(
                { column: (
                  { id: string, name: string | null, description: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | null }
                & { __typename: 'FlowColumnInputField' }
              ) | { __typename: 'FlowFieldInputField' }> }
              & { __typename: 'FlowColumnOutputField' }
            ) | null> | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'ColumnField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'CombinedField' }
      ) | (
        { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'CombinedSetField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, remoteField: (
          { id: string, name: string | null, description: string | null, datasource: (
            { id: string, name: string | null }
            & { __typename: 'EmbeddedDatasource' }
          ) | (
            { vizportalUrlId: string, id: string, name: string | null }
            & { __typename: 'PublishedDatasource' }
          ) | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        ) | null }
        & { __typename: 'DatasourceField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fieldsReferencedByGroup: Array<(
          { name: string | null }
          & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        ) | (
          { semanticRole: string | null, name: string | null }
          & { __typename: 'CalculatedField' | 'ColumnField' }
        )> }
        & { __typename: 'GroupField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'HierarchyField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) | null> | null }
    & { __typename: 'Dashboard' }
  ) | (
    { id: string, name: string | null, updatedAt: any, path: string | null, workbook: (
      { name: string | null, projectName: string | null, projectVizportalUrlId: string | null, vizportalUrlId: string, owner: (
        { id: string, name: string | null, username: string | null, uri: string, domain: string | null }
        & { __typename: 'TableauUser' }
      ) }
      & { __typename: 'Workbook' }
    ) | null, worksheetFields: Array<(
      { id: string }
      & { __typename: 'CalculatedField' }
    ) | null> | null, datasourceFields: Array<(
      { id: string }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null> | null, sheetFieldInstances: Array<(
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, remoteField: (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fields: Array<(
          { id: string, name: string | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        )>, parameters: Array<(
          { name: string | null }
          & { __typename: 'Parameter' }
        )> }
        & { __typename: 'BinField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fields: Array<(
          { id: string, name: string | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        )>, parameters: Array<(
          { name: string | null }
          & { __typename: 'Parameter' }
        )> }
        & { __typename: 'CalculatedField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null, referencedByFlowColumnOutputField: Array<(
              { parentFields: Array<(
                { column: (
                  { id: string, name: string | null, description: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | null }
                & { __typename: 'FlowColumnInputField' }
              ) | { __typename: 'FlowFieldInputField' }> }
              & { __typename: 'FlowColumnOutputField' }
            ) | null> | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'ColumnField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'CombinedField' }
      ) | (
        { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'CombinedSetField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, remoteField: (
          { id: string, name: string | null, description: string | null, datasource: (
            { id: string, name: string | null }
            & { __typename: 'EmbeddedDatasource' }
          ) | (
            { vizportalUrlId: string, id: string, name: string | null }
            & { __typename: 'PublishedDatasource' }
          ) | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        ) | null }
        & { __typename: 'DatasourceField' }
      ) | (
        { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null, fieldsReferencedByGroup: Array<(
          { name: string | null }
          & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        ) | (
          { semanticRole: string | null, name: string | null }
          & { __typename: 'CalculatedField' | 'ColumnField' }
        )> }
        & { __typename: 'GroupField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'HierarchyField' }
      ) | (
        { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
          & { __typename: 'PublishedDatasource' }
        ) | null, datasource: (
          { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
          & { __typename: 'PublishedDatasource' }
        ) | null, referencedByFlowFieldOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowFieldOutputField' }
        ) | null> | null, fieldsConnection: (
          { totalCount: number }
          & { __typename: 'FieldsConnection' }
        ) | null }
        & { __typename: 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, upstreamDatabasesConnection: (
        { nodes: Array<(
          { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
        )> }
        & { __typename: 'DatabasesConnection' }
      ) | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) | null> | null }
    & { __typename: 'Sheet' }
  )> };

export type ViewDetailsByPath_Dashboard_Fragment = (
  { id: string, name: string | null, updatedAt: any, path: string | null, workbook: (
    { name: string | null, projectName: string | null, projectVizportalUrlId: string | null, vizportalUrlId: string, owner: (
      { id: string, name: string | null, username: string | null, uri: string, domain: string | null }
      & { __typename: 'TableauUser' }
    ) }
    & { __typename: 'Workbook' }
  ) | null, sheets: Array<(
    { worksheetFields: Array<(
      { id: string }
      & { __typename: 'CalculatedField' }
    ) | null> | null, datasourceFields: Array<(
      { id: string }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null> | null }
    & { __typename: 'Sheet' }
  )>, upstreamSheetFieldInstances: Array<(
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, remoteField: (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, remoteField: (
        { id: string, name: string | null, description: string | null, datasource: (
          { id: string, name: string | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null> | null }
  & { __typename: 'Dashboard' }
);

export type ViewDetailsByPath_Sheet_Fragment = (
  { id: string, name: string | null, updatedAt: any, path: string | null, workbook: (
    { name: string | null, projectName: string | null, projectVizportalUrlId: string | null, vizportalUrlId: string, owner: (
      { id: string, name: string | null, username: string | null, uri: string, domain: string | null }
      & { __typename: 'TableauUser' }
    ) }
    & { __typename: 'Workbook' }
  ) | null, worksheetFields: Array<(
    { id: string }
    & { __typename: 'CalculatedField' }
  ) | null> | null, datasourceFields: Array<(
    { id: string }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | null> | null, sheetFieldInstances: Array<(
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, remoteField: (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, remoteField: (
        { id: string, name: string | null, description: string | null, datasource: (
          { id: string, name: string | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null> | null }
  & { __typename: 'Sheet' }
);

export type ViewDetailsByPathFragment = ViewDetailsByPath_Dashboard_Fragment | ViewDetailsByPath_Sheet_Fragment;

export type ViewDetailsByPathDashboardFragment = (
  { sheets: Array<(
    { worksheetFields: Array<(
      { id: string }
      & { __typename: 'CalculatedField' }
    ) | null> | null, datasourceFields: Array<(
      { id: string }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | null> | null }
    & { __typename: 'Sheet' }
  )>, upstreamSheetFieldInstances: Array<(
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, remoteField: (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, remoteField: (
        { id: string, name: string | null, description: string | null, datasource: (
          { id: string, name: string | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null> | null }
  & { __typename: 'Dashboard' }
);

export type ViewDetailsByPathSheetFragment = (
  { worksheetFields: Array<(
    { id: string }
    & { __typename: 'CalculatedField' }
  ) | null> | null, datasourceFields: Array<(
    { id: string }
    & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
  ) | null> | null, sheetFieldInstances: Array<(
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'BinField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fields: Array<(
      { id: string, name: string | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    )>, parameters: Array<(
      { name: string | null }
      & { __typename: 'Parameter' }
    )> }
    & { __typename: 'CalculatedField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, table: (
          { id: string, name: string | null }
          & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
        ) | null, referencedByFlowColumnOutputField: Array<(
          { parentFields: Array<(
            { column: (
              { id: string, name: string | null, description: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'FlowColumnInputField' }
          ) | { __typename: 'FlowFieldInputField' }> }
          & { __typename: 'FlowColumnOutputField' }
        ) | null> | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'ColumnField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedField' }
  ) | (
    { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'CombinedSetField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, remoteField: (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, binSize: string | null, formula: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, binField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'BinField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, formula: string | null, hasUserReference: boolean | null, isAutoGenerated: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, calculatedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fields: Array<(
        { id: string, name: string | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      )>, parameters: Array<(
        { name: string | null }
        & { __typename: 'Parameter' }
      )> }
      & { __typename: 'CalculatedField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, aggregation: string | null, aggregationParam: string | null, defaultFormat: string | null, semanticRole: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, columnField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, columnsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null, referencedByFlowColumnOutputField: Array<(
            { parentFields: Array<(
              { column: (
                { id: string, name: string | null, description: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | null }
              & { __typename: 'FlowColumnInputField' }
            ) | { __typename: 'FlowFieldInputField' }> }
            & { __typename: 'FlowColumnOutputField' }
          ) | null> | null }
          & { __typename: 'Column' }
        )> }
        & { __typename: 'ColumnsConnection' }
      ) | null }
      & { __typename: 'ColumnField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedField' }
    ) | (
      { id: string, name: string | null, description: string | null, combinationType: string | null, delimiter: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, combinedSetField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'CombinedSetField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, datasourceField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, remoteField: (
        { id: string, name: string | null, description: string | null, datasource: (
          { id: string, name: string | null }
          & { __typename: 'EmbeddedDatasource' }
        ) | (
          { vizportalUrlId: string, id: string, name: string | null }
          & { __typename: 'PublishedDatasource' }
        ) | null }
        & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | null }
      & { __typename: 'DatasourceField' }
    ) | (
      { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null, fieldsReferencedByGroup: Array<(
        { name: string | null }
        & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
      ) | (
        { semanticRole: string | null, name: string | null }
        & { __typename: 'CalculatedField' | 'ColumnField' }
      )> }
      & { __typename: 'GroupField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'HierarchyField' }
    ) | (
      { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, publishedDataSourceDetails: { __typename: 'EmbeddedDatasource' } | (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
        & { __typename: 'PublishedDatasource' }
      ) | null, datasource: (
        { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
        & { __typename: 'PublishedDatasource' }
      ) | null, referencedByFlowFieldOutputField: Array<(
        { parentFields: Array<(
          { column: (
            { id: string, name: string | null, description: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | null }
          & { __typename: 'FlowColumnInputField' }
        ) | { __typename: 'FlowFieldInputField' }> }
        & { __typename: 'FlowFieldOutputField' }
      ) | null> | null, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'SetField' }
    ) | null }
    & { __typename: 'DatasourceField' }
  ) | (
    { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, role: FieldRole | null, hasOther: boolean | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, groupField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null, fieldsReferencedByGroup: Array<(
      { name: string | null }
      & { __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { semanticRole: string | null, name: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, hierarchyField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'HierarchyField' }
  ) | (
    { id: string, name: string | null, description: string | null, folderName: string | null, isHidden: boolean | null, fullyQualifiedName: string | null, setField: string, datasource: (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null }
      & { __typename: 'EmbeddedDatasource' }
    ) | (
      { id: string, name: string | null, hasExtracts: boolean | null, extractLastUpdateTime: any | null, vizportalUrlId: string, isCertified: boolean }
      & { __typename: 'PublishedDatasource' }
    ) | null, upstreamDatabasesConnection: (
      { nodes: Array<(
        { id: string, name: string | null, connectionType: string | null, isCertified: boolean }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, fieldsConnection: (
      { totalCount: number }
      & { __typename: 'FieldsConnection' }
    ) | null }
    & { __typename: 'SetField' }
  ) | null> | null }
  & { __typename: 'Sheet' }
);

export type VirtualConnectionDownstreamDashboardsFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type VirtualConnectionDownstreamDashboardsFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamDashboardsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
                { domain: string | null, username: string | null, name: string | null }
                & { __typename: 'TableauUser' }
              ) }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Dashboard' }
          )> }
          & { __typename: 'DashboardsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamDashboardsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type VirtualConnectionDownstreamDashboardsQuery = { virtualConnections: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamDatasourcesFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type VirtualConnectionDownstreamDatasourcesFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'PublishedDatasource' }
          )> }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamDatasourcesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type VirtualConnectionDownstreamDatasourcesQuery = { virtualConnections: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamFlowsFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type VirtualConnectionDownstreamFlowsFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamFlowsConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) | null }
            & { __typename: 'Flow' }
          )> }
          & { __typename: 'FlowsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamFlowsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type VirtualConnectionDownstreamFlowsQuery = { virtualConnections: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamLensesFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type VirtualConnectionDownstreamLensesFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamLensesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ), downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'Lens' }
          )> }
          & { __typename: 'LensesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamLensesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type VirtualConnectionDownstreamLensesQuery = { virtualConnections: Array<(
    { downstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamMetricsFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type VirtualConnectionDownstreamMetricsFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamMetricsConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
              { name: string | null, path: string | null, workbook: (
                { vizportalUrlId: string, name: string | null }
                & { __typename: 'Workbook' }
              ) | null }
              & { __typename: 'Dashboard' | 'Sheet' }
            ) | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) }
            & { __typename: 'Metric' }
          )> }
          & { __typename: 'MetricsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamMetricsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type VirtualConnectionDownstreamMetricsQuery = { virtualConnections: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamOwnerIdsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VirtualConnectionDownstreamOwnerIdsFilteredByColumnQuery = { virtualConnections: Array<(
    { tables: Array<(
      { downstreamOwnersConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, vizportalId: string }
          & { __typename: 'TableauUser' }
        )> }
        & { __typename: 'TableauUsersConnection' }
      ) | null }
      & { __typename: 'VirtualConnectionTable' }
    )> }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamOwnerIdsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VirtualConnectionDownstreamOwnerIdsQuery = { virtualConnections: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamOwnersFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type VirtualConnectionDownstreamOwnersFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamOwnersConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, ownedDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, ownedMetricsConnection: (
              { totalCount: number }
              & { __typename: 'MetricsConnection' }
            ) | null, ownedVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null }
            & { __typename: 'TableauUser' }
          )> }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamOwnersQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type VirtualConnectionDownstreamOwnersQuery = { virtualConnections: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamSheetsFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type VirtualConnectionDownstreamSheetsFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamSheetsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
                { domain: string | null, username: string | null, name: string | null }
                & { __typename: 'TableauUser' }
              ) }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Sheet' }
          )> }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamSheetsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type VirtualConnectionDownstreamSheetsQuery = { virtualConnections: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamWorkbooksFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type VirtualConnectionDownstreamWorkbooksFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
              { name: string | null, username: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), sheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null }
            & { __typename: 'Workbook' }
          )> }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionDownstreamWorkbooksQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type VirtualConnectionDownstreamWorkbooksQuery = { virtualConnections: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionLineageCountsFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
}>;


export type VirtualConnectionLineageCountsFilteredByTableQuery = { virtualConnections: Array<(
    { filteredTablesConnection: (
      { nodes: Array<(
        { name: string | null, upstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, upstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, upstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, upstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, downstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, downstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamLensesConnection: (
          { totalCount: number }
          & { __typename: 'LensesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDashboardsConnection: (
          { totalCount: number }
          & { __typename: 'DashboardsConnection' }
        ) | null, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, downstreamMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, downstreamOwnersConnection: (
          { totalCount: number }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, unfilteredTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionLineageCountsFragment = (
  { unfilteredTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, downstreamVirtualConnectionTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, downstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamLensesConnection: (
    { totalCount: number }
    & { __typename: 'LensesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'VirtualConnection' }
);

export type VirtualConnectionLineageCountsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type VirtualConnectionLineageCountsQuery = { virtualConnections: Array<(
    { unfilteredTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, downstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VirtualConnectionLineageUpstreamDataQualityWarningsQuery = { virtualConnections: Array<(
    { id: string, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type VirtualConnectionQuery = { virtualConnections: Array<(
    { name: string | null, luid: string, tables: Array<(
      { name: string | null, id: string }
      & { __typename: 'VirtualConnectionTable' }
    )> }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionTablesFragment = (
  { name: string | null, id: string }
  & { __typename: 'VirtualConnectionTable' }
);

export type VirtualConnectionTableColumnLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VirtualConnectionTableColumnLineageUpstreamDataQualityWarningsQuery = { virtualConnectionTables: Array<(
    { id: string, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableColumnsByIdQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: ColumnSortOrder;
  customSensitivityLabelsEnabled: Scalars['Boolean'];
}>;


export type VirtualConnectionTableColumnsByIdQuery = { virtualConnectionTables: Array<(
    { id: string, name: string | null, vizportalUrlId: string, columnsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, name: string | null, remoteType: RemoteType, description: string | null, upstreamColumns?: Array<(
          { luid: string, labels: Array<(
            { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, asset: (
              { id: string, luid: string, name: string | null }
              & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
            ) | (
              { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | (
              { vizportalUrlId: string, id: string, luid: string, name: string | null }
              & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
          )> }
          & { __typename: 'Column' }
        ) | null>, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamDashboardsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
                { domain: string | null, username: string | null, name: string | null }
                & { __typename: 'TableauUser' }
              ) }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Dashboard' }
          )> }
          & { __typename: 'DashboardsConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamDashboardsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type VirtualConnectionTableDownstreamDashboardsQuery = { virtualConnectionTables: Array<(
    { downstreamDashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'PublishedDatasource' }
          )> }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamDatasourcesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type VirtualConnectionTableDownstreamDatasourcesQuery = { virtualConnectionTables: Array<(
    { downstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamFlowsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type VirtualConnectionTableDownstreamFlowsFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamFlowsConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) | null }
            & { __typename: 'Flow' }
          )> }
          & { __typename: 'FlowsConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamFlowsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type VirtualConnectionTableDownstreamFlowsQuery = { virtualConnectionTables: Array<(
    { downstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamLensesFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type VirtualConnectionTableDownstreamLensesFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamLensesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ), downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'Lens' }
          )> }
          & { __typename: 'LensesConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamLensesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type VirtualConnectionTableDownstreamLensesQuery = { virtualConnectionTables: Array<(
    { downstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamMetricsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type VirtualConnectionTableDownstreamMetricsFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamMetricsConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
              { name: string | null, path: string | null, workbook: (
                { vizportalUrlId: string, name: string | null }
                & { __typename: 'Workbook' }
              ) | null }
              & { __typename: 'Dashboard' | 'Sheet' }
            ) | null, owner: (
              { domain: string | null, username: string | null, name: string | null }
              & { __typename: 'TableauUser' }
            ) }
            & { __typename: 'Metric' }
          )> }
          & { __typename: 'MetricsConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamMetricsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type VirtualConnectionTableDownstreamMetricsQuery = { virtualConnectionTables: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columns: Array<(
      { downstreamOwnersConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, vizportalId: string }
          & { __typename: 'TableauUser' }
        )> }
        & { __typename: 'TableauUsersConnection' }
      ) | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamOwnerIdsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VirtualConnectionTableDownstreamOwnerIdsQuery = { virtualConnectionTables: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamOwnersFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type VirtualConnectionTableDownstreamOwnersFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamOwnersConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, ownedDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, ownedMetricsConnection: (
              { totalCount: number }
              & { __typename: 'MetricsConnection' }
            ) | null, ownedVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null }
            & { __typename: 'TableauUser' }
          )> }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamOwnersQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type VirtualConnectionTableDownstreamOwnersQuery = { virtualConnectionTables: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamSheetsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, path: string | null, workbook: (
              { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
                { domain: string | null, username: string | null, name: string | null }
                & { __typename: 'TableauUser' }
              ) }
              & { __typename: 'Workbook' }
            ) | null }
            & { __typename: 'Sheet' }
          )> }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamSheetsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type VirtualConnectionTableDownstreamSheetsQuery = { virtualConnectionTables: Array<(
    { downstreamSheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number, nodes: Array<(
            { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
              { name: string | null, username: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), sheetsConnection: (
              { totalCount: number }
              & { __typename: 'SheetsConnection' }
            ) | null }
            & { __typename: 'Workbook' }
          )> }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableDownstreamWorkbooksQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: WorkbookSortOrder;
}>;


export type VirtualConnectionTableDownstreamWorkbooksQuery = { virtualConnectionTables: Array<(
    { downstreamWorkbooksConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), sheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null }
        & { __typename: 'Workbook' }
      )> }
      & { __typename: 'WorkbooksConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableLineageCountsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
}>;


export type VirtualConnectionTableLineageCountsFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { filteredColumnsConnection: (
      { nodes: Array<(
        { name: string | null, upstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, upstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, upstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamDatabasesConnection: (
          { totalCount: number }
          & { __typename: 'DatabasesConnection' }
        ) | null, downstreamTablesConnection: (
          { totalCount: number }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, downstreamFlowsConnection: (
          { totalCount: number }
          & { __typename: 'FlowsConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, downstreamLensesConnection: (
          { totalCount: number }
          & { __typename: 'LensesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDashboardsConnection: (
          { totalCount: number }
          & { __typename: 'DashboardsConnection' }
        ) | null, downstreamSheetsConnection: (
          { totalCount: number }
          & { __typename: 'SheetsConnection' }
        ) | null, downstreamMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, downstreamOwnersConnection: (
          { totalCount: number }
          & { __typename: 'TableauUsersConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null, unfilteredColumnsConnection: (
      { totalCount: number }
      & { __typename: 'ColumnsConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableLineageCountsFragment = (
  { unfilteredColumnsConnection: (
    { totalCount: number }
    & { __typename: 'ColumnsConnection' }
  ) | null, upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, upstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, downstreamLensesConnection: (
    { totalCount: number }
    & { __typename: 'LensesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'VirtualConnectionTable' }
);

export type VirtualConnectionTableLineageCountsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type VirtualConnectionTableLineageCountsQuery = { virtualConnectionTables: Array<(
    { unfilteredColumnsConnection: (
      { totalCount: number }
      & { __typename: 'ColumnsConnection' }
    ) | null, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, downstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, downstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, downstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, downstreamWorkbooksConnection: (
      { totalCount: number }
      & { __typename: 'WorkbooksConnection' }
    ) | null, downstreamDashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, downstreamSheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type VirtualConnectionTableLineageUpstreamDataQualityWarningsQuery = { virtualConnectionTables: Array<(
    { id: string, upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
}>;


export type VirtualConnectionTableQuery = { virtualConnectionTables: Array<(
    { name: string | null, luid: string, columns: Array<(
      { name: string | null, id: string }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableUpstreamDatabasesFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type VirtualConnectionTableUpstreamDatabasesFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { upstreamDatabasesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'CloudFile' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'DatabaseServer' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'File' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableUpstreamDatabasesQueryVariables = Exact<{
  vizportalUrlId: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: DatabaseSortOrder;
}>;


export type VirtualConnectionTableUpstreamDatabasesQuery = { virtualConnectionTables: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableUpstreamTablesFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type VirtualConnectionTableUpstreamTablesFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { upstreamTablesConnection: (
          { totalCount: number, nodes: Array<(
            { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, columnsConnectionWithWarnings: (
              { totalCount: number, nodes: Array<(
                { labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { name: string | null }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, database: (
              { name: string | null, isGrouped: boolean | null }
              & { __typename: 'CloudFile' | 'WebDataConnector' }
            ) | (
              { hostName: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'DatabaseServer' }
            ) | (
              { filePath: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'File' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableUpstreamTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type VirtualConnectionTableUpstreamTablesQuery = { virtualConnectionTables: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedColumnId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnQuery = { virtualConnectionTables: Array<(
    { columnsConnection: (
      { nodes: Array<(
        { upstreamVirtualConnectionsConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
              { name: string | null, username: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ), tablesConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionTablesConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'VirtualConnection' }
          )> }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'VirtualConnection' }
          )> }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'VirtualConnection' }
          )> }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'Column' }
      )> }
      & { __typename: 'ColumnsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTableUpstreamVirtualConnectionsQueryVariables = Exact<{
  vizportalUrlId: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: VirtualConnectionSortOrder;
}>;


export type VirtualConnectionTableUpstreamVirtualConnectionsQuery = { virtualConnectionTables: Array<(
    { upstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null }
    & { __typename: 'VirtualConnectionTable' }
  )> };

export type VirtualConnectionTablesByIdQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type VirtualConnectionTablesByIdQuery = { virtualConnections: Array<(
    { id: string, name: string | null, vizportalUrlId: string, tablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionTablesDisplayGridRowDataFragment = (
  { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )>, downstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, columnsConnectionWithWarnings: (
    { totalCount: number, nodes: Array<(
      { labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { name: string | null }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'VirtualConnectionTable' }
);

export type VirtualConnectionUpstreamDatabasesFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type VirtualConnectionUpstreamDatabasesFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { upstreamDatabasesConnection: (
          { totalCount: number, nodes: Array<(
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'CloudFile' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'DatabaseServer' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'File' }
          ) | (
            { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, tags: Array<(
              { name: string | null }
              & { __typename: 'Tag' }
            )> }
            & { __typename: 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
          )> }
          & { __typename: 'DatabasesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionUpstreamDatabasesQueryVariables = Exact<{
  vizportalUrlId: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: DatabaseSortOrder;
}>;


export type VirtualConnectionUpstreamDatabasesQuery = { virtualConnections: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionUpstreamTablesFilteredByTableQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  selectedTableId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type VirtualConnectionUpstreamTablesFilteredByTableQuery = { virtualConnections: Array<(
    { tablesConnection: (
      { nodes: Array<(
        { upstreamTablesConnection: (
          { totalCount: number, nodes: Array<(
            { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )>, downstreamVirtualConnectionsConnection: (
              { totalCount: number }
              & { __typename: 'VirtualConnectionsConnection' }
            ) | null, downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null, downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null, columnsConnectionWithWarnings: (
              { totalCount: number, nodes: Array<(
                { labels: Array<(
                  { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                    { username: string | null, name: string | null, domain: string | null }
                    & { __typename: 'TableauUser' }
                  ) | null, asset: (
                    { id: string, luid: string, name: string | null }
                    & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                  ) | (
                    { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                      { id: string, name: string | null }
                      & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                    ) | null }
                    & { __typename: 'Column' }
                  ) | (
                    { vizportalUrlId: string, id: string, luid: string, name: string | null }
                    & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
                )> }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, columnsConnection: (
              { totalCount: number, nodes: Array<(
                { name: string | null }
                & { __typename: 'Column' }
              )> }
              & { __typename: 'ColumnsConnection' }
            ) | null, certifier: (
              { username: string | null, name: string | null, domain: string | null }
              & { __typename: 'TableauUser' }
            ) | null, database: (
              { name: string | null, isGrouped: boolean | null }
              & { __typename: 'CloudFile' | 'WebDataConnector' }
            ) | (
              { hostName: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'DatabaseServer' }
            ) | (
              { filePath: string | null, name: string | null, isGrouped: boolean | null }
              & { __typename: 'File' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamDatasources: (
          { nodes: Array<(
            { downstreamDatasourcesConnection: (
              { totalCount: number }
              & { __typename: 'PublishedDatasourcesConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null, maxDownstreamWorkbooks: (
          { nodes: Array<(
            { downstreamWorkbooksConnection: (
              { totalCount: number }
              & { __typename: 'WorkbooksConnection' }
            ) | null }
            & { __typename: 'DatabaseTable' }
          )> }
          & { __typename: 'DatabaseTablesConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionUpstreamTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type VirtualConnectionUpstreamTablesQuery = { virtualConnections: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'VirtualConnection' }
  )> };

export type VirtualConnectionsDisplayGridRowDataFragment = (
  { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
    { name: string | null, username: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ), tablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, downstreamWorkbooksConnection: (
    { totalCount: number }
    & { __typename: 'WorkbooksConnection' }
  ) | null, downstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, labels: Array<(
    { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
      { username: string | null, name: string | null, domain: string | null }
      & { __typename: 'TableauUser' }
    ) | null, asset: (
      { id: string, luid: string, name: string | null }
      & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
    ) | (
      { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | (
      { vizportalUrlId: string, id: string, luid: string, name: string | null }
      & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
    ) | null }
    & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
  )> }
  & { __typename: 'VirtualConnection' }
);

export type WorkbookDownstreamDashboardsQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DashboardSortOrder;
}>;


export type WorkbookDownstreamDashboardsQuery = { workbooks: Array<(
    { dashboardsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Dashboard' }
      )> }
      & { __typename: 'DashboardsConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookDownstreamMetricsQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type WorkbookDownstreamMetricsQuery = { workbooks: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookDownstreamMetricsWithoutPersonalSpaceQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: MetricSortOrder;
}>;


export type WorkbookDownstreamMetricsWithoutPersonalSpaceQuery = { workbooks: Array<(
    { downstreamMetricsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string, underlyingView: (
          { name: string | null, path: string | null, workbook: (
            { vizportalUrlId: string, name: string | null }
            & { __typename: 'Workbook' }
          ) | null }
          & { __typename: 'Dashboard' | 'Sheet' }
        ) | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) }
        & { __typename: 'Metric' }
      )> }
      & { __typename: 'MetricsConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookDownstreamOwnerIdsQueryVariables = Exact<{
  WorkbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type WorkbookDownstreamOwnerIdsQuery = { workbooks: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookDownstreamOwnersQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: TableauUserSortOrder;
}>;


export type WorkbookDownstreamOwnersQuery = { workbooks: Array<(
    { downstreamOwnersConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, username: string | null, domain: string | null, vizportalId: string, ownedWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, ownedDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, ownedMetricsConnection: (
          { totalCount: number }
          & { __typename: 'MetricsConnection' }
        ) | null, ownedVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null }
        & { __typename: 'TableauUser' }
      )> }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookDownstreamSheetsQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: SheetSortOrder;
}>;


export type WorkbookDownstreamSheetsQuery = { workbooks: Array<(
    { sheetsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, path: string | null, workbook: (
          { vizportalUrlId: string, name: string | null, projectName: string | null, projectVizportalUrlId: string | null, owner: (
            { domain: string | null, username: string | null, name: string | null }
            & { __typename: 'TableauUser' }
          ) }
          & { __typename: 'Workbook' }
        ) | null }
        & { __typename: 'Sheet' }
      )> }
      & { __typename: 'SheetsConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookFieldsByIdQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  selectedEmbeddedDatasourceId: Scalars['ID'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FieldSortOrder;
}>;


export type WorkbookFieldsByIdQuery = { workbooks: Array<(
    { vizportalUrlId: string, embeddedDatasources: Array<(
      { fieldsConnection: (
        { totalCount: number, nodes: Array<(
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'BinField' }
        ) | (
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'CalculatedField' }
        ) | (
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'ColumnField' }
        ) | (
          { id: string, name: string | null, description: string | null, combinedField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'CombinedField' }
        ) | (
          { id: string, name: string | null, description: string | null, combinedSetField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'CombinedSetField' }
        ) | (
          { id: string, name: string | null, description: string | null, datasourceField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, remoteField: (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
            & { __typename: 'BinField' }
          ) | (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
            & { __typename: 'CalculatedField' }
          ) | (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
            & { __typename: 'ColumnField' }
          ) | (
            { combinedField: string }
            & { __typename: 'CombinedField' }
          ) | (
            { combinedSetField: string }
            & { __typename: 'CombinedSetField' }
          ) | { __typename: 'DatasourceField' } | (
            { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
              { semanticRole: string | null }
              & { __typename: 'CalculatedField' | 'ColumnField' }
            )> }
            & { __typename: 'GroupField' }
          ) | (
            { hierarchyField: string }
            & { __typename: 'HierarchyField' }
          ) | (
            { setField: string }
            & { __typename: 'SetField' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'DatasourceField' }
        ) | (
          { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
            { semanticRole: string | null }
            & { __typename: 'CalculatedField' | 'ColumnField' }
          )> }
          & { __typename: 'GroupField' }
        ) | (
          { id: string, name: string | null, description: string | null, hierarchyField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'HierarchyField' }
        ) | (
          { id: string, name: string | null, description: string | null, setField: string, downstreamSheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, descriptionInherited: Array<(
            { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
              { name: string | null, id: string, datasource: (
                { id: string, name: string | null }
                & { __typename: 'EmbeddedDatasource' }
              ) | (
                { vizportalUrlId: string, id: string, name: string | null }
                & { __typename: 'PublishedDatasource' }
              ) | null }
              & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
            ) | (
              { name: string | null, id: string, table: (
                { id: string, name: string | null }
                & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'Column' }
            ) | null }
            & { __typename: 'InheritedStringResult' }
          ) | null> | null, columnsConnection: (
            { totalCount: number, nodes: Array<(
              { id: string, name: string | null, labels: Array<(
                { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                  { username: string | null, name: string | null, domain: string | null }
                  & { __typename: 'TableauUser' }
                ) | null, asset: (
                  { id: string, luid: string, name: string | null }
                  & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
                ) | (
                  { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                    { id: string, name: string | null }
                    & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                  ) | null }
                  & { __typename: 'Column' }
                ) | (
                  { vizportalUrlId: string, id: string, luid: string, name: string | null }
                  & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
              )> }
              & { __typename: 'Column' }
            )> }
            & { __typename: 'ColumnsConnection' }
          ) | null }
          & { __typename: 'SetField' }
        )> }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'EmbeddedDatasource' }
    )> }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookFieldsByIdFieldsConnection_BinField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'BinField' }
);

export type WorkbookFieldsByIdFieldsConnection_CalculatedField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'CalculatedField' }
);

export type WorkbookFieldsByIdFieldsConnection_ColumnField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'ColumnField' }
);

export type WorkbookFieldsByIdFieldsConnection_CombinedField_Fragment = (
  { id: string, name: string | null, description: string | null, combinedField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'CombinedField' }
);

export type WorkbookFieldsByIdFieldsConnection_CombinedSetField_Fragment = (
  { id: string, name: string | null, description: string | null, combinedSetField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'CombinedSetField' }
);

export type WorkbookFieldsByIdFieldsConnection_DatasourceField_Fragment = (
  { id: string, name: string | null, description: string | null, datasourceField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, remoteField: (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, binField: string }
    & { __typename: 'BinField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, calculatedField: string }
    & { __typename: 'CalculatedField' }
  ) | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, semanticRole: string | null, columnField: string }
    & { __typename: 'ColumnField' }
  ) | (
    { combinedField: string }
    & { __typename: 'CombinedField' }
  ) | (
    { combinedSetField: string }
    & { __typename: 'CombinedSetField' }
  ) | { __typename: 'DatasourceField' } | (
    { dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
      { semanticRole: string | null }
      & { __typename: 'CalculatedField' | 'ColumnField' }
    )> }
    & { __typename: 'GroupField' }
  ) | (
    { hierarchyField: string }
    & { __typename: 'HierarchyField' }
  ) | (
    { setField: string }
    & { __typename: 'SetField' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'DatasourceField' }
);

export type WorkbookFieldsByIdFieldsConnection_GroupField_Fragment = (
  { id: string, name: string | null, description: string | null, dataCategory: FieldRoleCategory | null, dataType: FieldDataType | null, groupField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null, fieldsReferencedByGroup: Array<{ __typename: 'BinField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' } | (
    { semanticRole: string | null }
    & { __typename: 'CalculatedField' | 'ColumnField' }
  )> }
  & { __typename: 'GroupField' }
);

export type WorkbookFieldsByIdFieldsConnection_HierarchyField_Fragment = (
  { id: string, name: string | null, description: string | null, hierarchyField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'HierarchyField' }
);

export type WorkbookFieldsByIdFieldsConnection_SetField_Fragment = (
  { id: string, name: string | null, description: string | null, setField: string, downstreamSheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, descriptionInherited: Array<(
    { assetId: string, attribute: string, value: string | null, distance: number | null, edges: Array<string> | null, asset: (
      { name: string | null, id: string, datasource: (
        { id: string, name: string | null }
        & { __typename: 'EmbeddedDatasource' }
      ) | (
        { vizportalUrlId: string, id: string, name: string | null }
        & { __typename: 'PublishedDatasource' }
      ) | null }
      & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
    ) | (
      { name: string | null, id: string, table: (
        { id: string, name: string | null }
        & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
      ) | null }
      & { __typename: 'Column' }
    ) | null }
    & { __typename: 'InheritedStringResult' }
  ) | null> | null, columnsConnection: (
    { totalCount: number, nodes: Array<(
      { id: string, name: string | null, labels: Array<(
        { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { id: string, luid: string, name: string | null }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
        ) | (
          { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
            { id: string, name: string | null }
            & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { vizportalUrlId: string, id: string, luid: string, name: string | null }
          & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
        ) | null }
        & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
      )> }
      & { __typename: 'Column' }
    )> }
    & { __typename: 'ColumnsConnection' }
  ) | null }
  & { __typename: 'SetField' }
);

export type WorkbookFieldsByIdFieldsConnectionFragment = WorkbookFieldsByIdFieldsConnection_BinField_Fragment | WorkbookFieldsByIdFieldsConnection_CalculatedField_Fragment | WorkbookFieldsByIdFieldsConnection_ColumnField_Fragment | WorkbookFieldsByIdFieldsConnection_CombinedField_Fragment | WorkbookFieldsByIdFieldsConnection_CombinedSetField_Fragment | WorkbookFieldsByIdFieldsConnection_DatasourceField_Fragment | WorkbookFieldsByIdFieldsConnection_GroupField_Fragment | WorkbookFieldsByIdFieldsConnection_HierarchyField_Fragment | WorkbookFieldsByIdFieldsConnection_SetField_Fragment;

export type WorkbookLineageCountsFilteredByFieldQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  selectedEmbeddedDatasourceId: Scalars['ID'];
  selectedFieldId: Scalars['ID'];
}>;


export type WorkbookLineageCountsFilteredByFieldQuery = { workbooks: Array<(
    { embeddedDatasources: Array<(
      { filteredFieldsConnection: (
        { nodes: Array<(
          { name: string | null, upstreamDatabasesConnection: (
            { totalCount: number }
            & { __typename: 'DatabasesConnection' }
          ) | null, upstreamTablesConnection: (
            { totalCount: number }
            & { __typename: 'DatabaseTablesConnection' }
          ) | null, upstreamVirtualConnectionsConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionsConnection' }
          ) | null, upstreamVirtualConnectionTablesConnection: (
            { totalCount: number }
            & { __typename: 'VirtualConnectionTablesConnection' }
          ) | null, upstreamFlowsConnection: (
            { totalCount: number }
            & { __typename: 'FlowsConnection' }
          ) | null, upstreamDatasourcesConnection: (
            { totalCount: number }
            & { __typename: 'PublishedDatasourcesConnection' }
          ) | null, sheetsConnection: (
            { totalCount: number }
            & { __typename: 'SheetsConnection' }
          ) | null, dashboardsConnection: (
            { totalCount: number }
            & { __typename: 'DashboardsConnection' }
          ) | null, downstreamMetricsConnection: (
            { totalCount: number }
            & { __typename: 'MetricsConnection' }
          ) | null, downstreamOwnersConnection: (
            { totalCount: number }
            & { __typename: 'TableauUsersConnection' }
          ) | null }
          & { __typename: 'BinField' | 'CalculatedField' | 'ColumnField' | 'CombinedField' | 'CombinedSetField' | 'DatasourceField' | 'GroupField' | 'HierarchyField' | 'SetField' }
        )> }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'EmbeddedDatasource' }
    )>, upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, upstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, upstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, dashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, sheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookLineageCountsFragment = (
  { upstreamDatabasesConnection: (
    { totalCount: number }
    & { __typename: 'DatabasesConnection' }
  ) | null, upstreamTablesConnection: (
    { totalCount: number }
    & { __typename: 'DatabaseTablesConnection' }
  ) | null, upstreamVirtualConnectionsConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionsConnection' }
  ) | null, upstreamVirtualConnectionTablesConnection: (
    { totalCount: number }
    & { __typename: 'VirtualConnectionTablesConnection' }
  ) | null, upstreamFlowsConnection: (
    { totalCount: number }
    & { __typename: 'FlowsConnection' }
  ) | null, upstreamDatasourcesConnection: (
    { totalCount: number }
    & { __typename: 'PublishedDatasourcesConnection' }
  ) | null, upstreamLensesConnection: (
    { totalCount: number }
    & { __typename: 'LensesConnection' }
  ) | null, dashboardsConnection: (
    { totalCount: number }
    & { __typename: 'DashboardsConnection' }
  ) | null, sheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null, downstreamMetricsConnection: (
    { totalCount: number }
    & { __typename: 'MetricsConnection' }
  ) | null, downstreamOwnersConnection: (
    { totalCount: number }
    & { __typename: 'TableauUsersConnection' }
  ) | null }
  & { __typename: 'Workbook' }
);

export type WorkbookLineageCountsQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
}>;


export type WorkbookLineageCountsQuery = { workbooks: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number }
      & { __typename: 'DatabasesConnection' }
    ) | null, upstreamTablesConnection: (
      { totalCount: number }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, upstreamVirtualConnectionsConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, upstreamVirtualConnectionTablesConnection: (
      { totalCount: number }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, upstreamFlowsConnection: (
      { totalCount: number }
      & { __typename: 'FlowsConnection' }
    ) | null, upstreamDatasourcesConnection: (
      { totalCount: number }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null, upstreamLensesConnection: (
      { totalCount: number }
      & { __typename: 'LensesConnection' }
    ) | null, dashboardsConnection: (
      { totalCount: number }
      & { __typename: 'DashboardsConnection' }
    ) | null, sheetsConnection: (
      { totalCount: number }
      & { __typename: 'SheetsConnection' }
    ) | null, downstreamMetricsConnection: (
      { totalCount: number }
      & { __typename: 'MetricsConnection' }
    ) | null, downstreamOwnersConnection: (
      { totalCount: number }
      & { __typename: 'TableauUsersConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookLineageUpstreamDataQualityWarningsQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type WorkbookLineageUpstreamDataQualityWarningsQuery = { workbooks: Array<(
    { upstreamDataQualityWarningsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, vizportalId: string, isActive: boolean, isSevere: boolean, warningType: string, message: string | null, updatedAt: any, authorDisplayName: string | null, author: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, asset: (
          { name: string | null, id: string }
          & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'VirtualConnection' | 'VirtualConnectionTable' | 'WebDataConnector' }
        ) | (
          { name: string | null, remoteType: RemoteType, id: string, table: { __typename: 'CustomSQLTable' } | (
            { id: string, luid: string, name: string | null }
            & { __typename: 'DatabaseTable' }
          ) | (
            { luid: string, name: string | null }
            & { __typename: 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'Column' }
        ) | (
          { name: string | null, vizportalUrlId: string, id: string }
          & { __typename: 'Flow' | 'PublishedDatasource' }
        ) | null }
        & { __typename: 'DataQualityWarning' }
      )> }
      & { __typename: 'DataQualityWarningsConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
}>;


export type WorkbookQuery = { workbooks: Array<(
    { name: string | null, luid: string, embeddedDatasources: Array<(
      { name: string | null, id: string, fieldsConnection: (
        { totalCount: number }
        & { __typename: 'FieldsConnection' }
      ) | null }
      & { __typename: 'EmbeddedDatasource' }
    )> }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookEmbeddedDatasourceFragment = (
  { name: string | null, id: string, fieldsConnection: (
    { totalCount: number }
    & { __typename: 'FieldsConnection' }
  ) | null }
  & { __typename: 'EmbeddedDatasource' }
);

export type WorkbookUpstreamDatabasesQueryVariables = Exact<{
  workbookVizportalUrlId: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseSortOrder;
}>;


export type WorkbookUpstreamDatabasesQuery = { workbooks: Array<(
    { upstreamDatabasesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, requestUrl: string | null, fileId: string | null, provider: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'CloudFile' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, hostName: string | null, port: number | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'DatabaseServer' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, filePath: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'File' }
      ) | (
        { id: string, name: string | null, description: string | null, connectionType: string | null, luid: string, vizportalId: string, isGrouped: boolean | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, connectorUrl: string | null, controlledPermissionsEnabled: boolean | null, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, tags: Array<(
          { name: string | null }
          & { __typename: 'Tag' }
        )> }
        & { __typename: 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'CloudFile' | 'DatabaseServer' | 'File' | 'WebDataConnector' }
      )> }
      & { __typename: 'DatabasesConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamDatasourcesQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type WorkbookUpstreamDatasourcesQuery = { workbooks: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectName: string | null, projectVizportalUrlId: string | null, containerName: string | null, containerType: string, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamDatasourcesWithoutPersonalSpaceQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: PublishedDatasourceSortOrder;
}>;


export type WorkbookUpstreamDatasourcesWithoutPersonalSpaceQuery = { workbooks: Array<(
    { upstreamDatasourcesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, hasExtracts: boolean | null, extractLastUpdateTime: any | null, isCertified: boolean, certificationNote: string | null, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'PublishedDatasource' }
      )> }
      & { __typename: 'PublishedDatasourcesConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamFlowsQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type WorkbookUpstreamFlowsQuery = { workbooks: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamFlowsWithoutPersonalSpaceQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: FlowSortOrder;
}>;


export type WorkbookUpstreamFlowsWithoutPersonalSpaceQuery = { workbooks: Array<(
    { upstreamFlowsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, vizportalUrlId: string, projectVizportalUrlId: string | null, projectName: string | null, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ) | null }
        & { __typename: 'Flow' }
      )> }
      & { __typename: 'FlowsConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamLensesQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: LensSortOrder;
}>;


export type WorkbookUpstreamLensesQuery = { workbooks: Array<(
    { upstreamLensesConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, name: string | null, description: string | null, vizportalUrlId: string, projectVizportalUrlId: string, updatedAt: any, owner: (
          { domain: string | null, username: string | null, name: string | null }
          & { __typename: 'TableauUser' }
        ), downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'Lens' }
      )> }
      & { __typename: 'LensesConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamTablesQueryVariables = Exact<{
  workbookVizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: DatabaseTableSortOrder;
}>;


export type WorkbookUpstreamTablesQuery = { workbooks: Array<(
    { upstreamTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, projectName: string | null, projectVizportalUrlId: string | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, isCertified: boolean, certificationNote: string | null, vizportalId: string, contact: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, certifier: (
          { username: string | null, name: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ) | null, database: (
          { name: string | null, isGrouped: boolean | null }
          & { __typename: 'CloudFile' | 'WebDataConnector' }
        ) | (
          { hostName: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'DatabaseServer' }
        ) | (
          { filePath: string | null, name: string | null, isGrouped: boolean | null }
          & { __typename: 'File' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamVirtualConnectionTablesQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionTableSortOrder;
}>;


export type WorkbookUpstreamVirtualConnectionTablesQuery = { workbooks: Array<(
    { upstreamVirtualConnectionTablesConnection: (
      { totalCount: number, nodes: Array<(
        { luid: string, vizportalUrlId: string, isCertified: boolean, isExtracted: boolean | null, extractLastRefreshedAt: any | null, id: string, name: string | null, description: string | null, isEmbedded: boolean | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )>, downstreamVirtualConnectionsConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionsConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, columnsConnectionWithWarnings: (
          { totalCount: number, nodes: Array<(
            { labels: Array<(
              { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
                { username: string | null, name: string | null, domain: string | null }
                & { __typename: 'TableauUser' }
              ) | null, asset: (
                { id: string, luid: string, name: string | null }
                & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
              ) | (
                { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
                  { id: string, name: string | null }
                  & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
                ) | null }
                & { __typename: 'Column' }
              ) | (
                { vizportalUrlId: string, id: string, luid: string, name: string | null }
                & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
              ) | null }
              & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
            )> }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null, columnsConnection: (
          { totalCount: number, nodes: Array<(
            { name: string | null }
            & { __typename: 'Column' }
          )> }
          & { __typename: 'ColumnsConnection' }
        ) | null }
        & { __typename: 'VirtualConnectionTable' }
      )> }
      & { __typename: 'VirtualConnectionTablesConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbookUpstreamVirtualConnectionsQueryVariables = Exact<{
  vizportalUrlId: Scalars['String'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: VirtualConnectionSortOrder;
}>;


export type WorkbookUpstreamVirtualConnectionsQuery = { workbooks: Array<(
    { upstreamVirtualConnectionsConnection: (
      { totalCount: number, nodes: Array<(
        { id: string, luid: string, vizportalUrlId: string, name: string | null, isCertified: boolean, containerName: string | null, containerType: string, projectVizportalUrlId: string | null, owner: (
          { name: string | null, username: string | null, domain: string | null }
          & { __typename: 'TableauUser' }
        ), tablesConnection: (
          { totalCount: number }
          & { __typename: 'VirtualConnectionTablesConnection' }
        ) | null, downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null, downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null, labels: Array<(
          { id: string, authorDisplayName: string | null, isActive: boolean, value: string, isElevated: boolean, message: string | null, category: string, updatedAt: any, author: (
            { username: string | null, name: string | null, domain: string | null }
            & { __typename: 'TableauUser' }
          ) | null, asset: (
            { id: string, luid: string, name: string | null }
            & { __typename: 'CloudFile' | 'DatabaseServer' | 'DatabaseTable' | 'File' | 'WebDataConnector' }
          ) | (
            { id: string, remoteType: RemoteType, luid: string, name: string | null, table: (
              { id: string, name: string | null }
              & { __typename: 'CustomSQLTable' | 'DatabaseTable' | 'VirtualConnectionTable' }
            ) | null }
            & { __typename: 'Column' }
          ) | (
            { vizportalUrlId: string, id: string, luid: string, name: string | null }
            & { __typename: 'Flow' | 'PublishedDatasource' | 'VirtualConnection' | 'VirtualConnectionTable' }
          ) | null }
          & { __typename: 'DataQualityCertification' | 'DataQualityWarning' | 'GenericLabel' }
        )> }
        & { __typename: 'VirtualConnection' }
      )> }
      & { __typename: 'VirtualConnectionsConnection' }
    ) | null, maxDownstreamDatasources: (
      { nodes: Array<(
        { downstreamDatasourcesConnection: (
          { totalCount: number }
          & { __typename: 'PublishedDatasourcesConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null, maxDownstreamWorkbooks: (
      { nodes: Array<(
        { downstreamWorkbooksConnection: (
          { totalCount: number }
          & { __typename: 'WorkbooksConnection' }
        ) | null }
        & { __typename: 'DatabaseTable' }
      )> }
      & { __typename: 'DatabaseTablesConnection' }
    ) | null }
    & { __typename: 'Workbook' }
  )> };

export type WorkbooksDisplayGridRowDataFragment = (
  { containerName: string | null, containerType: string, id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
    { name: string | null, username: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ), sheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null }
  & { __typename: 'Workbook' }
);

export type WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragment = (
  { id: string, name: string | null, vizportalUrlId: string, projectName: string | null, projectVizportalUrlId: string | null, owner: (
    { name: string | null, username: string | null, domain: string | null }
    & { __typename: 'TableauUser' }
  ), sheetsConnection: (
    { totalCount: number }
    & { __typename: 'SheetsConnection' }
  ) | null }
  & { __typename: 'Workbook' }
);

export const ColumnFieldsPublishedDatasourceFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnFieldsPublishedDatasource on PublishedDatasource {
  vizportalUrlId
}
    `;
export const ColumnFieldsEmbeddedDatasourceFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnFieldsEmbeddedDatasource on EmbeddedDatasource {
  id
  workbook {
    vizportalUrlId
  }
}
    `;
export const ColumnFieldsNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnFieldsNodes on ColumnField {
  id
  name
  datasource {
    name
    ...ColumnFieldsPublishedDatasource
    ...ColumnFieldsEmbeddedDatasource
  }
}
    `;
export const FlowColumnInputFieldRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowColumnInputFieldRowData on FlowColumnInputField {
  id
  name
  flow {
    vizportalUrlId
    name
  }
}
    `;
export const TableauUserFragmentDoc = /*#__PURE__*/ gql`
    fragment TableauUser on TableauUser {
  username
  name
  domain
}
    `;
export const AssetFragmentDoc = /*#__PURE__*/ gql`
    fragment Asset on CanHaveLabels {
  id
  luid
  name
  __typename
  ... on Column {
    id
    remoteType
    table {
      id
      name
      __typename
    }
  }
  ... on Flow {
    vizportalUrlId
  }
  ... on PublishedDatasource {
    vizportalUrlId
  }
  ... on VirtualConnectionTable {
    vizportalUrlId
  }
  ... on VirtualConnection {
    vizportalUrlId
  }
}
    `;
export const LabelFragmentDoc = /*#__PURE__*/ gql`
    fragment Label on Label {
  id
  authorDisplayName
  author {
    ...TableauUser
  }
  isActive
  value
  isElevated
  message
  category
  updatedAt
  asset {
    ...Asset
  }
  __typename
}
    `;
export const ColumnFragmentDoc = /*#__PURE__*/ gql`
    fragment Column on Column {
  id
  vizportalId
  luid
  name
  description
  remoteType
  labels {
    ...Label
  }
  upstreamColumns @include(if: $customSensitivityLabelsEnabled) {
    labels(filter: {isActive: true}) {
      ...Label
    }
  }
  referencedByFieldsConnection {
    totalCount
  }
  referencedByFlowColumnInputFieldConnection {
    totalCount
  }
  table {
    id
    ... on DatabaseTable {
      luid
    }
  }
}
    `;
export const ColumnsReferencingFieldColumnsFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnsReferencingFieldColumns on Column {
  id
  name
  table {
    __typename
    id
    name
  }
}
    `;
export const DatabaseServerOrPathFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseServerOrPath on Database {
  __typename
  name
  ... on DatabaseServer {
    hostName
    port
  }
  ... on CloudFile {
    requestUrl
    fileId
    provider
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
    `;
export const DataQualityWarningFragmentDoc = /*#__PURE__*/ gql`
    fragment DataQualityWarning on DataQualityWarning {
  id
  __typename
  vizportalId
  isActive
  isSevere
  warningType
  message
  updatedAt
  authorDisplayName
  author {
    ...TableauUser
  }
}
    `;
export const DataQualityWarningAssetFragmentDoc = /*#__PURE__*/ gql`
    fragment DataQualityWarningAsset on DataQualityWarning {
  asset {
    id
    name
    __typename
    ... on Flow {
      name
      vizportalUrlId
    }
    ... on PublishedDatasource {
      name
      vizportalUrlId
    }
    ... on Database {
      name
    }
    ... on DatabaseTable {
      name
    }
    ... on VirtualConnectionTable {
      name
    }
    ... on VirtualConnection {
      name
    }
    ... on Column {
      name
      remoteType
      table {
        ... on DatabaseTable {
          id
          luid
          name
        }
        ... on VirtualConnectionTable {
          luid
          name
        }
      }
    }
  }
}
    `;
export const ConnectToDatabasesFragmentDoc = /*#__PURE__*/ gql`
    fragment ConnectToDatabases on Database {
  id
  connectionType
  isCertified
  certificationNote
  contact {
    id
    username
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  ...DatabaseServerOrPath
  dataQualityWarnings {
    ...DataQualityWarning
    ...DataQualityWarningAsset
  }
}
    `;
export const ConnectToDatabasesConnectionParamsFragmentDoc = /*#__PURE__*/ gql`
    fragment ConnectToDatabasesConnectionParams on Database {
  __typename
  connectionType
  name
  ... on DatabaseServer {
    hostName
    port
    extendedConnectionType
    service
  }
  ... on CloudFile {
    requestUrl
    fileId
    provider
    mimeType
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
    `;
export const ConnectToTablesConnectionFragmentDoc = /*#__PURE__*/ gql`
    fragment ConnectToTablesConnection on DatabaseTable {
  name
  fullName
  schema
  ... on DatabaseTable {
    database {
      ...ConnectToDatabasesConnectionParams
    }
  }
}
    `;
export const ConnectToTablesFragmentDoc = /*#__PURE__*/ gql`
    fragment ConnectToTables on DatabaseTable {
  __typename
  contact {
    id
    username
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  id
  isCertified
  certificationNote
  name
  connectionType
  schema
  ... on DatabaseTable {
    database {
      ...DatabaseServerOrPath
      connectionType
    }
    dataQualityWarnings {
      ...DataQualityWarning
      ...DataQualityWarningAsset
    }
  }
}
    `;
export const CustomSqlDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment CustomSqlDetails on CustomSQLTable {
  id
  name
  isUnsupportedCustomSql
  query
}
    `;
export const CustomSqlFromDatasourceFragmentDoc = /*#__PURE__*/ gql`
    fragment CustomSqlFromDatasource on Datasource {
  name
  fields {
    ... on ColumnField {
      columns {
        table {
          ... on CustomSQLTable {
            ...CustomSqlDetails
          }
        }
      }
    }
  }
}
    `;
export const DashboardsDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DashboardsDisplayGridRowData on Dashboard {
  id
  name
  path
  workbook {
    vizportalUrlId
    name
    projectName
    projectVizportalUrlId
    owner {
      domain
      username
      name
    }
  }
}
    `;
export const DataDetailsViewUpstreamDataQualityWarningsEmbeddedDatasourcesFragmentDoc = /*#__PURE__*/ gql`
    fragment DataDetailsViewUpstreamDataQualityWarningsEmbeddedDatasources on EmbeddedDatasource {
  id
  upstreamDataQualityWarningsConnection(
    filter: {isActive: true}
    first: $first
    offset: $offset
    orderBy: {field: IS_SEVERE, direction: DESC}
  ) {
    totalCount
    nodes {
      id
      ...DataQualityWarning
      ...DataQualityWarningAsset
    }
  }
}
    `;
export const DataQualityCertificationFragmentDoc = /*#__PURE__*/ gql`
    fragment DataQualityCertification on DataQualityCertification {
  id
  __typename
  vizportalId
  isActive
  message
  updatedAt
  authorDisplayName
  author {
    ...TableauUser
  }
}
    `;
export const DataQualityCertificationAssetFragmentDoc = /*#__PURE__*/ gql`
    fragment DataQualityCertificationAsset on DataQualityCertification {
  asset {
    id
    name
    __typename
    ... on Flow {
      name
      vizportalUrlId
    }
    ... on PublishedDatasource {
      vizportalUrlId
      name
    }
    ... on Database {
      name
    }
    ... on DatabaseTable {
      name
    }
    ... on VirtualConnectionTable {
      name
    }
    ... on VirtualConnection {
      name
    }
    ... on Column {
      name
      remoteType
      table {
        ... on DatabaseTable {
          id
          luid
          name
        }
        ... on VirtualConnectionTable {
          luid
          name
        }
      }
    }
  }
}
    `;
export const CertificationsFragmentDoc = /*#__PURE__*/ gql`
    fragment Certifications on Certifiable {
  dataQualityCertifications {
    ...DataQualityCertification
    ...DataQualityCertificationAsset
  }
}
    `;
export const DatabaseLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseLineageCounts on Database {
  unfilteredTablesConnection: tablesConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const DatabaseCertificationFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseCertification on Database {
  isCertified
  certificationNote
  certifier {
    ...TableauUser
  }
}
    `;
export const DatabaseFragmentDoc = /*#__PURE__*/ gql`
    fragment Database on Database {
  id
  luid
  vizportalId
  name
  projectName
  projectVizportalUrlId
  description
  isGrouped
  isEmbedded
  ...DatabaseCertification
  contact {
    ...TableauUser
  }
  connectionType
  dataQualityWarnings {
    ...DataQualityWarning
  }
  labels {
    ...Label
  }
  ... on DatabaseServer {
    hostName
    port
  }
  ... on CloudFile {
    fileId
    provider
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
    `;
export const DatabaseQueryFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseQuery on Database {
  ...Database
  tags {
    name
  }
}
    `;
export const TagsFragmentDoc = /*#__PURE__*/ gql`
    fragment Tags on Taggable {
  tags {
    name
  }
}
    `;
export const DatabaseIconFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseIcon on Database {
  __typename
  connectionType
  isCertified
  certificationNote
}
    `;
export const DatabasesDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabasesDisplayGridRowData on Database {
  id
  name
  description
  connectionType
  luid
  vizportalId
  isGrouped
  isEmbedded
  ...Tags
  contact {
    ...TableauUser
  }
  controlledPermissionsEnabled: isControlledPermissionsEnabled
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ...DatabaseIcon
  ...DatabaseServerOrPath
  labels(filter: {isActive: true}) {
    ...Label
  }
}
    `;
export const DatabasesByIdsNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabasesByIdsNodes on Database {
  id
  name
  controlledPermissionsEnabled: isControlledPermissionsEnabled
}
    `;
export const NonDatasourceFieldIconFragmentDoc = /*#__PURE__*/ gql`
    fragment NonDatasourceFieldIcon on Field {
  __typename
  ... on DataField {
    dataCategory
    dataType
  }
  ... on AnalyticsField {
    semanticRole
  }
  ... on BinField {
    binField: id
  }
  ... on CalculatedField {
    calculatedField: id
  }
  ... on ColumnField {
    columnField: id
  }
  ... on CombinedField {
    combinedField: id
  }
  ... on CombinedSetField {
    combinedSetField: id
  }
  ... on GroupField {
    groupField: id
    fieldsReferencedByGroup: fields {
      ... on AnalyticsField {
        semanticRole
      }
    }
  }
  ... on HierarchyField {
    hierarchyField: id
  }
  ... on SetField {
    setField: id
  }
}
    `;
export const FieldIconFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldIcon on Field {
  ...NonDatasourceFieldIcon
  ... on DatasourceField {
    datasourceField: id
    remoteField {
      ...NonDatasourceFieldIcon
    }
  }
}
    `;
export const FieldDescriptionInheritedFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldDescriptionInherited on Field {
  description
  descriptionInherited {
    assetId
    attribute
    value
    distance
    edges
    asset {
      id
      __typename
      ... on Column {
        name
        table {
          id
          name
        }
      }
      ... on Field {
        name
        datasource {
          id
          name
          __typename
          ... on PublishedDatasource {
            vizportalUrlId
          }
        }
      }
    }
  }
}
    `;
export const FieldLineageUpstreamLabelsFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldLineageUpstreamLabels on Field {
  __typename
  columnsConnection: upstreamColumnsConnection {
    totalCount
    nodes {
      __typename
      id
      name
      labels(filter: {isActive: true}) {
        ...Label
      }
    }
  }
}
    `;
export const DatasourceFieldsByIdNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment DatasourceFieldsByIdNodes on Field {
  id
  name
  ...FieldIcon
  ...FieldDescriptionInherited
  ...FieldLineageUpstreamLabels
  downstreamSheetsConnection {
    totalCount
  }
}
    `;
export const DatasourceLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment DatasourceLineageCounts on PublishedDatasource {
  unfilteredFieldsConnection: fieldsConnection(filter: {isHidden: false}) {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace on PublishedDatasource {
  id
  name
  description
  vizportalUrlId
  hasExtracts
  extractLastUpdateTime
  isCertified
  certificationNote
  projectVizportalUrlId
  projectName
  owner {
    username
    name
    domain
  }
  certifier {
    username
    name
    domain
  }
  downstreamWorkbooksConnection {
    totalCount
  }
}
    `;
export const DatasourcesDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DatasourcesDisplayGridRowData on PublishedDatasource {
  id
  name
  description
  vizportalUrlId
  hasExtracts
  extractLastUpdateTime
  isCertified
  certificationNote
  projectName
  projectVizportalUrlId
  owner {
    username
    name
    domain
  }
  certifier {
    username
    name
    domain
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  containerName
  containerType
}
    `;
export const NonDatasourceFieldDetails_UpstreamColumnFragmentDoc = /*#__PURE__*/ gql`
    fragment NonDatasourceFieldDetails_UpstreamColumn on Column {
  id
  name
  description
  table {
    id
    name
  }
}
    `;
export const NonDatasourceFieldDetails_ColumnFragmentDoc = /*#__PURE__*/ gql`
    fragment NonDatasourceFieldDetails_Column on Column {
  id
  name
  description
  table {
    id
    name
  }
  referencedByFlowColumnOutputField {
    parentFields {
      ... on FlowColumnInputField {
        column {
          ...NonDatasourceFieldDetails_UpstreamColumn
        }
      }
    }
  }
}
    `;
export const NonDatasourceFieldDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment NonDatasourceFieldDetails on Field {
  id
  name
  description
  folderName
  isHidden
  fullyQualifiedName
  ... on DatasourceField {
    datasourceField: id
    remoteField {
      id
      name
      datasource {
        id
        name
        ... on PublishedDatasource {
          vizportalUrlId
        }
      }
      description
    }
  }
  ... on FieldReferencingField {
    fieldsConnection {
      totalCount
    }
  }
  ... on DataField {
    dataCategory
    dataType
    role
  }
  ... on AnalyticsField {
    aggregation
    aggregationParam
    defaultFormat
    semanticRole
  }
  ... on BinField {
    binField: id
    binSize
    formula
    fields {
      id
      name
    }
    parameters {
      name
    }
  }
  ... on CalculatedField {
    calculatedField: id
    formula
    hasUserReference
    isAutoGenerated
    fields {
      id
      name
    }
    parameters {
      name
    }
  }
  ... on ColumnField {
    columnField: id
    columnsConnection {
      totalCount
      nodes {
        ...NonDatasourceFieldDetails_Column
      }
    }
  }
  ... on CombinedField {
    combinedField: id
  }
  ... on CombinedSetField {
    combinedSetField: id
    combinationType
    delimiter
  }
  ... on GroupField {
    groupField: id
    hasOther
    fieldsReferencedByGroup: fields {
      name
      ... on AnalyticsField {
        semanticRole
      }
    }
  }
  ... on HierarchyField {
    hierarchyField: id
  }
  ... on SetField {
    setField: id
  }
}
    `;
export const FieldDetailsDatasourceFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldDetailsDatasourceField on DatasourceField {
  datasourceField: id
  remoteField {
    datasource {
      name
      ... on PublishedDatasource {
        vizportalUrlId
      }
    }
    ...NonDatasourceFieldDetails
  }
}
    `;
export const FieldDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldDetails on Field {
  ... on DatasourceField {
    ...FieldDetailsDatasourceField
  }
  ...NonDatasourceFieldDetails
}
    `;
export const FieldLineageUpstreamDataQualityWarningsFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldLineageUpstreamDataQualityWarnings on Field {
  __typename
  ... on ColumnField {
    columnsConnection(filter: {hasActiveWarning: true}) {
      totalCount
      nodes {
        __typename
        id
        name
        dataQualityWarnings(filter: {isActive: true}) {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
}
    `;
export const FieldsReferencedByFieldNodesDatasourceFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldsReferencedByFieldNodesDatasource on Datasource {
  ... on PublishedDatasource {
    name
    vizportalUrlId
  }
  ... on EmbeddedDatasource {
    id
    name
    workbook {
      vizportalUrlId
    }
  }
}
    `;
export const FieldsReferencedByFieldNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldsReferencedByFieldNodes on Field {
  id
  name
  datasource {
    ...FieldsReferencedByFieldNodesDatasource
  }
}
    `;
export const FlowFieldDetailsFlowFieldOutputFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowFieldDetailsFlowFieldOutputField on FlowFieldOutputField {
  id
  name
  field {
    id
    name
    downstreamSheetsConnection {
      totalCount
    }
    datasource {
      ... on PublishedDatasource {
        vizportalUrlId
      }
      name
    }
  }
}
    `;
export const ColumnLabelsFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnLabels on Column {
  luid
  labels(filter: {isActive: true}) {
    ...Label
  }
}
    `;
export const UpstreamColumnLabelsFragmentDoc = /*#__PURE__*/ gql`
    fragment UpstreamColumnLabels on Column {
  upstreamColumns @include(if: $customSensitivityLabelsEnabled) {
    ...ColumnLabels
  }
}
    `;
export const FlowFieldsByIdFlowFieldOutputFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowFieldsByIdFlowFieldOutputField on FlowFieldOutputField {
  name
  id
  field {
    id
    name
    downstreamSheetsConnection {
      totalCount
    }
    ...FieldLineageUpstreamLabels @include(if: $customSensitivityLabelsEnabled)
    ...FieldIcon
  }
}
    `;
export const FlowFieldsByIdNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowFieldsByIdNodes on FlowOutputField {
  name
  id
  ... on FlowColumnOutputField {
    column {
      id
      name
      labels(filter: {isActive: true}) @include(if: $customSensitivityLabelsEnabled) {
        ...Label
      }
      ...UpstreamColumnLabels
      downstreamSheetsConnection {
        totalCount
      }
      remoteType
    }
  }
  ... on FlowFieldOutputField {
    ...FlowFieldsByIdFlowFieldOutputField
  }
}
    `;
export const FlowLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowLineageCounts on Flow {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const FlowOutputStepsFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowOutputSteps on FlowOutputStep {
  name
  id
  outputFieldsConnection {
    totalCount
  }
}
    `;
export const FlowDownstreamDatasourcesFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowDownstreamDatasources on PublishedDatasourcesConnection {
  totalCount
}
    `;
export const FlowDownstreamDatabasesFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowDownstreamDatabases on DatabasesConnection {
  totalCount
}
    `;
export const FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowsDisplayGridRowDataFragmentWithoutPersonalSpace on Flow {
  id
  name
  vizportalUrlId
  projectVizportalUrlId
  projectName
  owner {
    domain
    username
    name
  }
}
    `;
export const FlowsDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment FlowsDisplayGridRowData on Flow {
  ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
  containerName
  containerType
}
    `;
export const FieldLabelsFragmentDoc = /*#__PURE__*/ gql`
    fragment FieldLabels on Field {
  upstreamColumns {
    labels(filter: {isActive: true}) {
      ...Label
    }
  }
}
    `;
export const InheritedLabelsColumnFragmentDoc = /*#__PURE__*/ gql`
    fragment InheritedLabelsColumn on Column {
  id
  name
  luid
  ...UpstreamColumnLabels
  table {
    id
    ... on VirtualConnectionTable {
      vizportalUrlId
    }
  }
}
    `;
export const InheritedLabelsFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment InheritedLabelsField on Field {
  id
  name
  upstreamColumns {
    luid
  }
}
    `;
export const InheritedLabelsFlowOutputFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment InheritedLabelsFlowOutputField on FlowOutputField {
  id
  name
  parentFields {
    ... on FlowColumnInputField {
      id
      name
      column {
        luid
      }
    }
  }
}
    `;
export const LabelAssetFragmentDoc = /*#__PURE__*/ gql`
    fragment LabelAsset on Label {
  asset {
    id
    luid
    name
    __typename
    ... on Column {
      id
      remoteType
      table {
        id
        name
        __typename
      }
    }
    ... on Flow {
      vizportalUrlId
    }
    ... on PublishedDatasource {
      vizportalUrlId
    }
    ... on VirtualConnectionTable {
      vizportalUrlId
    }
    ... on VirtualConnection {
      vizportalUrlId
    }
  }
}
    `;
export const LensFieldsByIdFieldsConnectionNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment LensFieldsByIdFieldsConnectionNodes on LensField {
  id
  name
  description
  datasourceField {
    id
    name
    description
    ...FieldIcon
  }
}
    `;
export const LensLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment LensLineageCounts on Lens {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  fieldsConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const VirtualConnectionsDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment VirtualConnectionsDisplayGridRowData on VirtualConnection {
  __typename
  id
  luid
  vizportalUrlId
  name
  owner {
    name
    username
    domain
  }
  tablesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  isCertified
  labels {
    ...Label
  }
  containerName
  containerType
  projectVizportalUrlId
}
    `;
export const LensUpstreamVirtualConnectionsNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment LensUpstreamVirtualConnectionsNodes on VirtualConnectionsConnection {
  totalCount
  nodes {
    ...VirtualConnectionsDisplayGridRowData
  }
}
    `;
export const LensesDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment LensesDisplayGridRowData on Lens {
  id
  name
  description
  vizportalUrlId
  projectVizportalUrlId
  updatedAt
  owner {
    domain
    username
    name
  }
  downstreamWorkbooksConnection {
    totalCount
  }
}
    `;
export const MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricsDisplayGridRowDataFragmentWithoutPersonalSpace on Metric {
  id
  name
  vizportalUrlId
  projectName
  projectVizportalUrlId
  underlyingView {
    name
    path
    workbook {
      vizportalUrlId
      name
    }
  }
  owner {
    domain
    username
    name
  }
}
    `;
export const MetricsDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricsDisplayGridRowData on Metric {
  ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
  containerName
  containerType
}
    `;
export const OwnerIdFragmentDoc = /*#__PURE__*/ gql`
    fragment OwnerId on TableauUser {
  id
  vizportalId
}
    `;
export const OwnersDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment OwnersDisplayGridRowData on TableauUser {
  id
  name
  username
  domain
  vizportalId
  ownedWorkbooksConnection {
    totalCount
  }
  ownedDatasourcesConnection {
    totalCount
  }
  ownedMetricsConnection {
    totalCount
  }
  ownedVirtualConnectionsConnection {
    totalCount
  }
}
    `;
export const SheetsDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SheetsDisplayGridRowData on Sheet {
  id
  name
  path
  workbook {
    vizportalUrlId
    name
    projectName
    projectVizportalUrlId
    owner {
      domain
      username
      name
    }
  }
}
    `;
export const ColumnsByTableIdFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnsByTableId on Column {
  id
  luid
  name
  remoteType
  description
  ...ColumnLabels
  upstreamColumns @include(if: $customSensitivityLabelsEnabled) {
    ...ColumnLabels
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
}
    `;
export const TableColumnsByIdColumnsFragmentDoc = /*#__PURE__*/ gql`
    fragment TableColumnsByIdColumns on Column {
  ...Tags
  ...ColumnsByTableId
}
    `;
export const TableLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment TableLineageCounts on Table {
  unfilteredColumnsConnection: columnsConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const TableCertificationFragmentDoc = /*#__PURE__*/ gql`
    fragment TableCertification on DatabaseTable {
  isCertified
  certificationNote
  certifier {
    ...TableauUser
  }
}
    `;
export const TableFragmentDoc = /*#__PURE__*/ gql`
    fragment Table on Table {
  id
  name
  description
  isEmbedded
  ... on DatabaseTable {
    fullName
    luid
    vizportalId
    description
    ...TableCertification
    contact {
      ...TableauUser
    }
    dataQualityWarnings {
      ...DataQualityWarning
    }
    labels {
      ...Label
    }
    database {
      id
      name
      connectionType
      isCertified
      ... on DatabaseServer {
        hostName
        port
      }
      ... on CloudFile {
        fileId
        provider
      }
      ... on File {
        filePath
      }
      ... on WebDataConnector {
        connectorUrl
      }
    }
  }
}
    `;
export const TableQueryFragmentDoc = /*#__PURE__*/ gql`
    fragment TableQuery on Table {
  ...Table
  ... on DatabaseTable {
    tags {
      name
    }
  }
}
    `;
export const TagsQueryWithFiltersTagsConnectionNodesFragmentDoc = /*#__PURE__*/ gql`
    fragment TagsQueryWithFiltersTagsConnectionNodes on Tag {
  id
  name
  databasesConnection(
    filter: {connectionType: $connectionTypeFilter, isCertified: $isCertifiedFilter, isEmbedded: $isEmbeddedFilter, hasActiveWarning: $hasActiveWarningFilter, text: $textSearch}
  ) {
    totalCount
  }
  databaseTablesConnection(
    filter: {connectionType: $connectionTypeFilter, isCertified: $isCertifiedFilter, isEmbedded: $isEmbeddedFilter, hasActiveWarning: $hasActiveWarningFilter, text: $textSearch}
  ) {
    totalCount
  }
}
    `;
export const TagsQueryWithFiltersTagsConnectionFragmentDoc = /*#__PURE__*/ gql`
    fragment TagsQueryWithFiltersTagsConnection on TagsConnection {
  totalCount
  nodes {
    ...TagsQueryWithFiltersTagsConnectionNodes
  }
}
    `;
export const SheetFieldInstanceDatasourceFragmentDoc = /*#__PURE__*/ gql`
    fragment SheetFieldInstanceDatasource on Datasource {
  __typename
  id
  name
  hasExtracts
  extractLastUpdateTime
}
    `;
export const SheetFieldInstancePublishedDatasourceFragmentDoc = /*#__PURE__*/ gql`
    fragment SheetFieldInstancePublishedDatasource on PublishedDatasource {
  __typename
  id
  name
  hasExtracts
  extractLastUpdateTime
  vizportalUrlId
  isCertified
}
    `;
export const SheetFieldInstanceDatasourceFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment SheetFieldInstanceDatasourceField on DatasourceField {
  datasourceField: id
  remoteField {
    publishedDataSourceDetails: datasource {
      ...SheetFieldInstancePublishedDatasource
    }
    datasource {
      ...SheetFieldInstanceDatasource
    }
    ...NonDatasourceFieldDetails
    referencedByFlowFieldOutputField {
      parentFields {
        ... on FlowColumnInputField {
          column {
            id
            name
            description
            table {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const SheetFieldInstanceUpstreamDatabasesConnectionFragmentDoc = /*#__PURE__*/ gql`
    fragment SheetFieldInstanceUpstreamDatabasesConnection on DatabasesConnection {
  nodes {
    id
    name
    connectionType
    isCertified
  }
}
    `;
export const SheetFieldInstanceFragmentDoc = /*#__PURE__*/ gql`
    fragment SheetFieldInstance on Field {
  __typename
  id
  name
  description
  ...NonDatasourceFieldDetails
  datasource {
    ...SheetFieldInstanceDatasource
    ...SheetFieldInstancePublishedDatasource
  }
  ... on DatasourceField {
    ...SheetFieldInstanceDatasourceField
  }
  upstreamDatabasesConnection {
    ...SheetFieldInstanceUpstreamDatabasesConnection
  }
}
    `;
export const ViewDetailsByPathDashboardFragmentDoc = /*#__PURE__*/ gql`
    fragment ViewDetailsByPathDashboard on Dashboard {
  sheets {
    worksheetFields {
      id
    }
    datasourceFields {
      id
    }
  }
  upstreamSheetFieldInstances(orderBy: {field: NAME, direction: ASC}) {
    ...SheetFieldInstance
  }
}
    `;
export const ViewDetailsByPathSheetFragmentDoc = /*#__PURE__*/ gql`
    fragment ViewDetailsByPathSheet on Sheet {
  worksheetFields {
    id
  }
  datasourceFields {
    id
  }
  sheetFieldInstances(orderBy: {field: NAME, direction: ASC}) {
    ...SheetFieldInstance
  }
}
    `;
export const ViewDetailsByPathFragmentDoc = /*#__PURE__*/ gql`
    fragment ViewDetailsByPath on View {
  __typename
  id
  name
  updatedAt
  path
  workbook {
    owner {
      id
      name
      username
      uri
      domain
    }
    name
    projectName
    projectVizportalUrlId
    vizportalUrlId
  }
  ... on Dashboard {
    ...ViewDetailsByPathDashboard
  }
  ... on Sheet {
    ...ViewDetailsByPathSheet
  }
}
    `;
export const VirtualConnectionLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment VirtualConnectionLineageCounts on VirtualConnection {
  unfilteredTablesConnection: tablesConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const VirtualConnectionTablesFragmentDoc = /*#__PURE__*/ gql`
    fragment VirtualConnectionTables on VirtualConnectionTable {
  name
  id
}
    `;
export const VirtualConnectionTableLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment VirtualConnectionTableLineageCounts on VirtualConnectionTable {
  unfilteredColumnsConnection: columnsConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const TableDatabaseNameFragmentDoc = /*#__PURE__*/ gql`
    fragment TableDatabaseName on Table {
  __typename
  ... on DatabaseTable {
    vizportalId
    database {
      name
      isGrouped
      ... on DatabaseServer {
        hostName
      }
      ... on File {
        filePath
      }
    }
  }
}
    `;
export const TablesDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TablesDisplayGridRowData on Table {
  __typename
  id
  name
  description
  isEmbedded
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ... on DatabaseTable {
    luid
    contact {
      ...TableauUser
    }
    projectName
    projectVizportalUrlId
    ...TableCertification
    labels(filter: {isActive: true}) {
      ...Label
    }
  }
  ... on VirtualConnectionTable {
    luid
    vizportalUrlId
    isCertified
    labels(filter: {isActive: true}) {
      ...Label
    }
    isExtracted
    extractLastRefreshedAt
  }
  ...TableDatabaseName
  columnsConnectionWithWarnings: columnsConnection(
    filter: {hasActiveWarning: true}
  ) {
    totalCount
    nodes {
      labels(filter: {isActive: true}) {
        ...Label
        __typename
      }
    }
  }
  columnsConnection(first: 3, orderBy: {field: NAME, direction: ASC}) {
    totalCount
    nodes {
      name
    }
  }
}
    `;
export const VirtualConnectionTablesDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment VirtualConnectionTablesDisplayGridRowData on VirtualConnectionTable {
  ...TablesDisplayGridRowData
}
    `;
export const WorkbookFieldsByIdFieldsConnectionFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkbookFieldsByIdFieldsConnection on Field {
  id
  name
  ...FieldIcon
  ...FieldDescriptionInherited
  ...FieldLineageUpstreamLabels
  downstreamSheetsConnection {
    totalCount
  }
}
    `;
export const WorkbookLineageCountsFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkbookLineageCounts on Workbook {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  upstreamLensesConnection {
    totalCount
  }
  dashboardsConnection {
    totalCount
  }
  sheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
export const WorkbookEmbeddedDatasourceFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkbookEmbeddedDatasource on EmbeddedDatasource {
  name
  id
  fieldsConnection(filter: {isHidden: false}) {
    totalCount
  }
}
    `;
export const WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace on Workbook {
  id
  name
  vizportalUrlId
  projectName
  projectVizportalUrlId
  owner {
    name
    username
    domain
  }
  sheetsConnection {
    totalCount
  }
}
    `;
export const WorkbooksDisplayGridRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkbooksDisplayGridRowData on Workbook {
  ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
  containerName
  containerType
}
    `;
export const CatalogSelectorDropdownCountsDocument = /*#__PURE__*/ gql`
    query CatalogSelectorDropdownCounts($textSearch: String, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  databaseTablesConnection(
    filter: {text: $textSearch, hasActiveWarning: $hasActiveWarning, isCertified: $isCertified}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
  databasesConnection(
    filter: {text: $textSearch, hasActiveWarning: $hasActiveWarning, isCertified: $isCertified}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
}
    `;
export type CatalogSelectorDropdownCountsQueryResult = Apollo.QueryResult<CatalogSelectorDropdownCountsQuery, CatalogSelectorDropdownCountsQueryVariables>;
export const ColumnDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query ColumnDataQualityWarnings($columnId: ID!) {
  columns(filter: {id: $columnId}) {
    dataQualityWarnings(filter: {isActive: true}) {
      ...DataQualityWarning
      ...DataQualityWarningAsset
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type ColumnDataQualityWarningsQueryResult = Apollo.QueryResult<ColumnDataQualityWarningsQuery, ColumnDataQualityWarningsQueryVariables>;
export const ColumnDetailsDocument = /*#__PURE__*/ gql`
    query ColumnDetails($columnId: ID!, $customSensitivityLabelsEnabled: Boolean!) {
  columns(filter: {id: $columnId}) {
    ...Column
    ...Tags
  }
}
    ${ColumnFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${TagsFragmentDoc}`;
export type ColumnDetailsQueryResult = Apollo.QueryResult<ColumnDetailsQuery, ColumnDetailsQueryVariables>;
export const ColumnDetailsByLuidDocument = /*#__PURE__*/ gql`
    query ColumnDetailsByLuid($columnId: ID!) {
  columns(filter: {id: $columnId}) {
    remoteType
    luid
    name
  }
}
    `;
export type ColumnDetailsByLuidQueryResult = Apollo.QueryResult<ColumnDetailsByLuidQuery, ColumnDetailsByLuidQueryVariables>;
export const ColumnFieldsDocument = /*#__PURE__*/ gql`
    query ColumnFields($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: {id: $columnId}) {
    referencedByFieldsConnection(
      first: $first
      offset: $offset
      orderBy: {field: NAME, direction: ASC}
    ) {
      totalCount
      nodes {
        ...ColumnFieldsNodes
      }
    }
  }
}
    ${ColumnFieldsNodesFragmentDoc}
${ColumnFieldsPublishedDatasourceFragmentDoc}
${ColumnFieldsEmbeddedDatasourceFragmentDoc}`;
export type ColumnFieldsQueryResult = Apollo.QueryResult<ColumnFieldsQuery, ColumnFieldsQueryVariables>;
export const ColumnFlowsDocument = /*#__PURE__*/ gql`
    query ColumnFlows($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: {id: $columnId}) {
    referencedByFlowColumnInputFieldConnection(
      first: $first
      offset: $offset
      orderBy: {field: NAME, direction: ASC}
    ) {
      totalCount
      nodes {
        ...FlowColumnInputFieldRowData
      }
    }
  }
}
    ${FlowColumnInputFieldRowDataFragmentDoc}`;
export type ColumnFlowsQueryResult = Apollo.QueryResult<ColumnFlowsQuery, ColumnFlowsQueryVariables>;
export const ColumnsReferencingFieldDocument = /*#__PURE__*/ gql`
    query ColumnsReferencingField($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: {id: $fieldId}) {
    __typename
    ... on ColumnField {
      columnsConnection(
        first: $first
        offset: $offset
        orderBy: {field: ID, direction: ASC}
      ) {
        totalCount
        nodes {
          ...ColumnsReferencingFieldColumns
        }
      }
    }
  }
}
    ${ColumnsReferencingFieldColumnsFragmentDoc}`;
export type ColumnsReferencingFieldQueryResult = Apollo.QueryResult<ColumnsReferencingFieldQuery, ColumnsReferencingFieldQueryVariables>;
export const ConnectToDatabasesConnectionParamsDocument = /*#__PURE__*/ gql`
    query ConnectToDatabasesConnectionParams($databaseId: ID!) {
  databasesConnection(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    nodes {
      ...ConnectToDatabasesConnectionParams
    }
  }
}
    ${ConnectToDatabasesConnectionParamsFragmentDoc}`;
export type ConnectToDatabasesConnectionParamsQueryResult = Apollo.QueryResult<ConnectToDatabasesConnectionParamsQuery, ConnectToDatabasesConnectionParamsQueryVariables>;
export const ConnectToDatabasesDescriptionDocument = /*#__PURE__*/ gql`
    query ConnectToDatabasesDescription($databaseId: ID!) {
  databasesConnection(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    nodes {
      description
      connectionType
    }
  }
}
    `;
export type ConnectToDatabasesDescriptionQueryResult = Apollo.QueryResult<ConnectToDatabasesDescriptionQuery, ConnectToDatabasesDescriptionQueryVariables>;
export const ConnectToDatabasesDocument = /*#__PURE__*/ gql`
    query ConnectToDatabases($databaseFilterText: String, $first: Int, $offset: Int, $connectionTypeFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean, $orderBy: DatabaseSortOrder!, $columnDQWs: Boolean!) {
  databasesConnection(
    filter: {text: $databaseFilterText, connectionType: $connectionTypeFilterText, isCertified: $isCertifiedFilter, isEmbedded: false, hasActiveWarning: $hasActiveWarningFilter}
    first: $first
    offset: $offset
    orderBy: $orderBy
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...ConnectToDatabases
    }
  }
  maxDownstreamWorkbooks: databasesConnection(
    filter: {text: $databaseFilterText, connectionType: $connectionTypeFilterText, isCertified: $isCertifiedFilter, isEmbedded: false, hasActiveWarning: $hasActiveWarningFilter}
    first: 1
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${ConnectToDatabasesFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type ConnectToDatabasesQueryResult = Apollo.QueryResult<ConnectToDatabasesQuery, ConnectToDatabasesQueryVariables>;
export const ConnectToDatabasesTotalCountDocument = /*#__PURE__*/ gql`
    query ConnectToDatabasesTotalCount($connectionTypeFilterText: String, $databaseFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean) {
  databasesConnection(
    filter: {text: $databaseFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
}
    `;
export type ConnectToDatabasesTotalCountQueryResult = Apollo.QueryResult<ConnectToDatabasesTotalCountQuery, ConnectToDatabasesTotalCountQueryVariables>;
export const ConnectToTablesConnectionParamsDocument = /*#__PURE__*/ gql`
    query ConnectToTablesConnectionParams($tableId: ID!) {
  databaseTablesConnection(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    nodes {
      ...ConnectToTablesConnection
    }
  }
}
    ${ConnectToTablesConnectionFragmentDoc}
${ConnectToDatabasesConnectionParamsFragmentDoc}`;
export type ConnectToTablesConnectionParamsQueryResult = Apollo.QueryResult<ConnectToTablesConnectionParamsQuery, ConnectToTablesConnectionParamsQueryVariables>;
export const ConnectToTablesDescriptionDocument = /*#__PURE__*/ gql`
    query ConnectToTablesDescription($tableId: ID!) {
  databaseTablesConnection(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    nodes {
      description
      ... on DatabaseTable {
        database {
          connectionType
        }
      }
    }
  }
}
    `;
export type ConnectToTablesDescriptionQueryResult = Apollo.QueryResult<ConnectToTablesDescriptionQuery, ConnectToTablesDescriptionQueryVariables>;
export const ConnectToTablesDocument = /*#__PURE__*/ gql`
    query ConnectToTables($first: Int!, $offset: Int!, $tableFilterText: String!, $connectionTypeFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean, $orderBy: DatabaseTableSortOrder!, $columnDQWs: Boolean!) {
  databaseTablesConnection(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...ConnectToTables
    }
  }
  maxDownstreamDatasources: databaseTablesConnection(
    first: 1
    orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamDatasourcesConnection {
        totalCount
      }
    }
  }
  maxDownstreamWorkbooks: databaseTablesConnection(
    first: 1
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${ConnectToTablesFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type ConnectToTablesQueryResult = Apollo.QueryResult<ConnectToTablesQuery, ConnectToTablesQueryVariables>;
export const ConnectToTablesTotalCountDocument = /*#__PURE__*/ gql`
    query ConnectToTablesTotalCount($tableFilterText: String, $connectionTypeFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean) {
  databaseTablesConnection(
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
}
    `;
export type ConnectToTablesTotalCountQueryResult = Apollo.QueryResult<ConnectToTablesTotalCountQuery, ConnectToTablesTotalCountQueryVariables>;
export const WorkbookCustomSqlDocument = /*#__PURE__*/ gql`
    query WorkbookCustomSql($vizportalUrlId: String!, $selectedEmbeddedDatasourceId: ID!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    embeddedDatasources(filter: {id: $selectedEmbeddedDatasourceId}) {
      name
      ...CustomSqlFromDatasource
    }
  }
}
    ${CustomSqlFromDatasourceFragmentDoc}
${CustomSqlDetailsFragmentDoc}`;
export type WorkbookCustomSqlQueryResult = Apollo.QueryResult<WorkbookCustomSqlQuery, WorkbookCustomSqlQueryVariables>;
export const PublishedDatasourceCustomSqlDocument = /*#__PURE__*/ gql`
    query PublishedDatasourceCustomSql($vizportalUrlId: String!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...CustomSqlFromDatasource
  }
}
    ${CustomSqlFromDatasourceFragmentDoc}
${CustomSqlDetailsFragmentDoc}`;
export type PublishedDatasourceCustomSqlQueryResult = Apollo.QueryResult<PublishedDatasourceCustomSqlQuery, PublishedDatasourceCustomSqlQueryVariables>;
export const VirtualConnectionCustomSqlDocument = /*#__PURE__*/ gql`
    query VirtualConnectionCustomSql($vizportalUrlId: String!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tables {
      columns {
        remoteColumn {
          table {
            ... on CustomSQLTable {
              ...CustomSqlDetails
            }
          }
        }
      }
    }
  }
}
    ${CustomSqlDetailsFragmentDoc}`;
export type VirtualConnectionCustomSqlQueryResult = Apollo.QueryResult<VirtualConnectionCustomSqlQuery, VirtualConnectionCustomSqlQueryVariables>;
export const FlowCustomSqlDocument = /*#__PURE__*/ gql`
    query FlowCustomSql($vizportalUrlId: String!, $selectedOutputStepId: ID!) {
  flows(filter: {vizportalUrlId: $vizportalUrlId}) {
    outputSteps(filter: {id: $selectedOutputStepId}) {
      name
      outputFields {
        parentFields {
          ... on FlowColumnInputField {
            column {
              table {
                ... on CustomSQLTable {
                  ...CustomSqlDetails
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CustomSqlDetailsFragmentDoc}`;
export type FlowCustomSqlQueryResult = Apollo.QueryResult<FlowCustomSqlQuery, FlowCustomSqlQueryVariables>;
export const ViewWarningsDocument = /*#__PURE__*/ gql`
    query ViewWarnings($viewPath: String!) {
  views(filter: {path: $viewPath}, permissionMode: FILTER_RESULTS) {
    normalUpstreamDataQualityWarnings: upstreamDataQualityWarnings(
      filter: {isActive: true, isSevere: false}
    ) {
      id
    }
    severeUpstreamDataQualityWarnings: upstreamDataQualityWarnings(
      filter: {isActive: true, isSevere: true}
    ) {
      id
    }
  }
}
    `;
export type ViewWarningsQueryResult = Apollo.QueryResult<ViewWarningsQuery, ViewWarningsQueryVariables>;
export const DataDetailsViewUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query DataDetailsViewUpstreamDataQualityWarnings($datasourceIds: [ID]!, $first: Int!, $offset: Int!) {
  embeddedDatasources(filter: {idWithin: $datasourceIds}) {
    ...DataDetailsViewUpstreamDataQualityWarningsEmbeddedDatasources
  }
}
    ${DataDetailsViewUpstreamDataQualityWarningsEmbeddedDatasourcesFragmentDoc}
${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type DataDetailsViewUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<DataDetailsViewUpstreamDataQualityWarningsQuery, DataDetailsViewUpstreamDataQualityWarningsQueryVariables>;
export const DataQualityWarningsInWebAuthoringDocument = /*#__PURE__*/ gql`
    query DataQualityWarningsInWebAuthoring($workbookIds: [String!]!, $flowIds: [String!]!, $publishedDatasourceIds: [String!]!, $databaseServerIds: [String!]!, $databaseTableIds: [String!]!) {
  publishedDatasourcesConnection(filter: {luidWithin: $publishedDatasourceIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  workbooksConnection(filter: {luidWithin: $workbookIds}) {
    nodes {
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  flowsConnection(filter: {luidWithin: $flowIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  databaseServersConnection(filter: {luidWithin: $databaseServerIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  databaseTablesConnection(filter: {luidWithin: $databaseTableIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type DataQualityWarningsInWebAuthoringQueryResult = Apollo.QueryResult<DataQualityWarningsInWebAuthoringQuery, DataQualityWarningsInWebAuthoringQueryVariables>;
export const DatabaseDownstreamDashboardsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDashboardsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamDashboardsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamDashboardsFilteredByTableQuery, DatabaseDownstreamDashboardsFilteredByTableQueryVariables>;
export const DatabaseDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDashboards($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamDashboardsQueryResult = Apollo.QueryResult<DatabaseDownstreamDashboardsQuery, DatabaseDownstreamDashboardsQueryVariables>;
export const DatabaseDownstreamDatabasesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDatabasesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseDownstreamDatabasesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamDatabasesFilteredByTableQuery, DatabaseDownstreamDatabasesFilteredByTableQueryVariables>;
export const DatabaseDownstreamDatabasesDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDatabases($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseDownstreamDatabasesQueryResult = Apollo.QueryResult<DatabaseDownstreamDatabasesQuery, DatabaseDownstreamDatabasesQueryVariables>;
export const DatabaseDownstreamDatasourcesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDatasourcesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamDatasourcesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamDatasourcesFilteredByTableQuery, DatabaseDownstreamDatasourcesFilteredByTableQueryVariables>;
export const DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceQuery, DatabaseDownstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryVariables>;
export const DatabaseDownstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDatasources($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamDatasourcesQueryResult = Apollo.QueryResult<DatabaseDownstreamDatasourcesQuery, DatabaseDownstreamDatasourcesQueryVariables>;
export const DatabaseDownstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamDatasourcesWithoutPersonalSpace($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamDatasourcesWithoutPersonalSpaceQuery, DatabaseDownstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const DatabaseDownstreamFlowsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamFlowsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamFlowsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamFlowsFilteredByTableQuery, DatabaseDownstreamFlowsFilteredByTableQueryVariables>;
export const DatabaseDownstreamFlowsFilteredByTableWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamFlowsFilteredByTableWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamFlowsFilteredByTableWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamFlowsFilteredByTableWithoutPersonalSpaceQuery, DatabaseDownstreamFlowsFilteredByTableWithoutPersonalSpaceQueryVariables>;
export const DatabaseDownstreamFlowsDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamFlows($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamFlowsQueryResult = Apollo.QueryResult<DatabaseDownstreamFlowsQuery, DatabaseDownstreamFlowsQueryVariables>;
export const DatabaseDownstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamFlowsWithoutPersonalSpace($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamFlowsWithoutPersonalSpaceQuery, DatabaseDownstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const DatabaseDownstreamLensesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamLensesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamLensesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamLensesFilteredByTableQuery, DatabaseDownstreamLensesFilteredByTableQueryVariables>;
export const DatabaseDownstreamLensesDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamLenses($id: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  databases(filter: {id: $id}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamLensesQueryResult = Apollo.QueryResult<DatabaseDownstreamLensesQuery, DatabaseDownstreamLensesQueryVariables>;
export const DatabaseDownstreamMetricsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamMetricsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamMetricsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamMetricsFilteredByTableQuery, DatabaseDownstreamMetricsFilteredByTableQueryVariables>;
export const DatabaseDownstreamMetricsFilteredByTableWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamMetricsFilteredByTableWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamMetricsFilteredByTableWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamMetricsFilteredByTableWithoutPersonalSpaceQuery, DatabaseDownstreamMetricsFilteredByTableWithoutPersonalSpaceQueryVariables>;
export const DatabaseDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamMetrics($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamMetricsQueryResult = Apollo.QueryResult<DatabaseDownstreamMetricsQuery, DatabaseDownstreamMetricsQueryVariables>;
export const DatabaseDownstreamMetricsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamMetricsWithoutPersonalSpace($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamMetricsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamMetricsWithoutPersonalSpaceQuery, DatabaseDownstreamMetricsWithoutPersonalSpaceQueryVariables>;
export const DatabaseDownstreamOwnerIdsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamOwnerIdsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!) {
  tables(filter: {id: $tableId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type DatabaseDownstreamOwnerIdsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamOwnerIdsFilteredByTableQuery, DatabaseDownstreamOwnerIdsFilteredByTableQueryVariables>;
export const DatabaseDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamOwnerIds($databaseId: ID!, $first: Int!, $offset: Int!) {
  databases(filter: {id: $databaseId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type DatabaseDownstreamOwnerIdsQueryResult = Apollo.QueryResult<DatabaseDownstreamOwnerIdsQuery, DatabaseDownstreamOwnerIdsQueryVariables>;
export const DatabaseDownstreamOwnersFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamOwnersFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  tablesConnection(filter: {id: $tableId}) {
    nodes {
      downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...OwnersDisplayGridRowData
        }
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamOwnersFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamOwnersFilteredByTableQuery, DatabaseDownstreamOwnersFilteredByTableQueryVariables>;
export const DatabaseDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamOwners($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamOwnersQueryResult = Apollo.QueryResult<DatabaseDownstreamOwnersQuery, DatabaseDownstreamOwnersQueryVariables>;
export const DatabaseDownstreamSheetsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamSheetsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamSheetsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamSheetsFilteredByTableQuery, DatabaseDownstreamSheetsFilteredByTableQueryVariables>;
export const DatabaseDownstreamSheetsDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamSheets($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type DatabaseDownstreamSheetsQueryResult = Apollo.QueryResult<DatabaseDownstreamSheetsQuery, DatabaseDownstreamSheetsQueryVariables>;
export const DatabaseDownstreamTablesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamTablesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatabaseDownstreamTablesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamTablesFilteredByTableQuery, DatabaseDownstreamTablesFilteredByTableQueryVariables>;
export const DatabaseDownstreamTablesDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamTables($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatabaseDownstreamTablesQueryResult = Apollo.QueryResult<DatabaseDownstreamTablesQuery, DatabaseDownstreamTablesQueryVariables>;
export const DatabaseDownstreamVirtualConnectionTablesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamVirtualConnectionTablesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatabaseDownstreamVirtualConnectionTablesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamVirtualConnectionTablesFilteredByTableQuery, DatabaseDownstreamVirtualConnectionTablesFilteredByTableQueryVariables>;
export const DatabaseDownstreamVirtualConnectionTablesDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamVirtualConnectionTables($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatabaseDownstreamVirtualConnectionTablesQueryResult = Apollo.QueryResult<DatabaseDownstreamVirtualConnectionTablesQuery, DatabaseDownstreamVirtualConnectionTablesQueryVariables>;
export const DatabaseDownstreamVirtualConnectionsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamVirtualConnectionsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseDownstreamVirtualConnectionsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamVirtualConnectionsFilteredByTableQuery, DatabaseDownstreamVirtualConnectionsFilteredByTableQueryVariables>;
export const DatabaseDownstreamVirtualConnectionsDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamVirtualConnections($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseDownstreamVirtualConnectionsQueryResult = Apollo.QueryResult<DatabaseDownstreamVirtualConnectionsQuery, DatabaseDownstreamVirtualConnectionsQueryVariables>;
export const DatabaseDownstreamWorkbooksFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamWorkbooksFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...WorkbooksDisplayGridRowData
        }
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamWorkbooksFilteredByTableQueryResult = Apollo.QueryResult<DatabaseDownstreamWorkbooksFilteredByTableQuery, DatabaseDownstreamWorkbooksFilteredByTableQueryVariables>;
export const DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpace($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
    `;
export type DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceQuery, DatabaseDownstreamWorkbooksFilteredByTableWithoutPersonalSpaceQueryVariables>;
export const DatabaseDownstreamWorkbooksDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamWorkbooks($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamWorkbooksQueryResult = Apollo.QueryResult<DatabaseDownstreamWorkbooksQuery, DatabaseDownstreamWorkbooksQueryVariables>;
export const DatabaseDownstreamWorkbooksWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseDownstreamWorkbooksWithoutPersonalSpace($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseDownstreamWorkbooksWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseDownstreamWorkbooksWithoutPersonalSpaceQuery, DatabaseDownstreamWorkbooksWithoutPersonalSpaceQueryVariables>;
export const DatabaseLineageCountsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseLineageCountsFilteredByTable($databaseId: ID!, $tableId: ID!) {
  databases(filter: {id: $databaseId}) {
    ...DatabaseLineageCounts
    filteredTablesConnection: tablesConnection(filter: {id: $tableId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamVirtualConnectionsConnection {
          totalCount
        }
        downstreamVirtualConnectionTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabaseLineageCountsFragmentDoc}`;
export type DatabaseLineageCountsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseLineageCountsFilteredByTableQuery, DatabaseLineageCountsFilteredByTableQueryVariables>;
export const DatabaseLineageCountsDocument = /*#__PURE__*/ gql`
    query DatabaseLineageCounts($databaseId: ID!) {
  databases(filter: {id: $databaseId}) {
    ...DatabaseLineageCounts
  }
}
    ${DatabaseLineageCountsFragmentDoc}`;
export type DatabaseLineageCountsQueryResult = Apollo.QueryResult<DatabaseLineageCountsQuery, DatabaseLineageCountsQueryVariables>;
export const DatabaseLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query DatabaseLineageUpstreamDataQualityWarnings($databaseId: ID!, $first: Int!, $offset: Int!) {
  databases(filter: {id: $databaseId}) {
    id
    name
    __typename
    dataQualityWarnings {
      isActive
      ...DataQualityWarning
      ...DataQualityWarningAsset
    }
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        isActive
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type DatabaseLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<DatabaseLineageUpstreamDataQualityWarningsQuery, DatabaseLineageUpstreamDataQualityWarningsQueryVariables>;
export const DatabaseDocument = /*#__PURE__*/ gql`
    query Database($databaseId: ID!) {
  databases(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    ...DatabaseQuery
  }
}
    ${DatabaseQueryFragmentDoc}
${DatabaseFragmentDoc}
${DatabaseCertificationFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseQueryResult = Apollo.QueryResult<DatabaseQuery, DatabaseQueryVariables>;
export const DatabaseQueryWithCertificationsDocument = /*#__PURE__*/ gql`
    query DatabaseQueryWithCertifications($databaseId: ID!) {
  databases(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    ...Database
    ...Tags
    ...Certifications
  }
}
    ${DatabaseFragmentDoc}
${DatabaseCertificationFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TagsFragmentDoc}
${CertificationsFragmentDoc}
${DataQualityCertificationFragmentDoc}
${DataQualityCertificationAssetFragmentDoc}`;
export type DatabaseQueryWithCertificationsQueryResult = Apollo.QueryResult<DatabaseQueryWithCertificationsQuery, DatabaseQueryWithCertificationsQueryVariables>;
export const DatabaseTableDocument = /*#__PURE__*/ gql`
    query DatabaseTable($tableId: ID!) {
  databaseTables(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    ...Table
    ...Tags
    ...Certifications
  }
}
    ${TableFragmentDoc}
${TableCertificationFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TagsFragmentDoc}
${CertificationsFragmentDoc}
${DataQualityCertificationFragmentDoc}
${DataQualityCertificationAssetFragmentDoc}`;
export type DatabaseTableQueryResult = Apollo.QueryResult<DatabaseTableQuery, DatabaseTableQueryVariables>;
export const DatabaseTablesByIdDocument = /*#__PURE__*/ gql`
    query DatabaseTablesById($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: tablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: tablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatabaseTablesByIdQueryResult = Apollo.QueryResult<DatabaseTablesByIdQuery, DatabaseTablesByIdQueryVariables>;
export const DatabaseUpstreamDatabasesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamDatabasesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseUpstreamDatabasesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseUpstreamDatabasesFilteredByTableQuery, DatabaseUpstreamDatabasesFilteredByTableQueryVariables>;
export const DatabaseUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamDatabases($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseUpstreamDatabasesQueryResult = Apollo.QueryResult<DatabaseUpstreamDatabasesQuery, DatabaseUpstreamDatabasesQueryVariables>;
export const DatabaseUpstreamDatasourcesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamDatasourcesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type DatabaseUpstreamDatasourcesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseUpstreamDatasourcesFilteredByTableQuery, DatabaseUpstreamDatasourcesFilteredByTableQueryVariables>;
export const DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceQuery, DatabaseUpstreamDatasourcesFilteredByTableWithoutPersonalSpaceQueryVariables>;
export const DatabaseUpstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamDatasources($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type DatabaseUpstreamDatasourcesQueryResult = Apollo.QueryResult<DatabaseUpstreamDatasourcesQuery, DatabaseUpstreamDatasourcesQueryVariables>;
export const DatabaseUpstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamDatasourcesWithoutPersonalSpace($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseUpstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseUpstreamDatasourcesWithoutPersonalSpaceQuery, DatabaseUpstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const DatabaseUpstreamFlowsFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamFlowsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseUpstreamFlowsFilteredByTableQueryResult = Apollo.QueryResult<DatabaseUpstreamFlowsFilteredByTableQuery, DatabaseUpstreamFlowsFilteredByTableQueryVariables>;
export const DatabaseUpstreamFlowsFilteredByTableWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamFlowsFilteredByTableWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseUpstreamFlowsFilteredByTableWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseUpstreamFlowsFilteredByTableWithoutPersonalSpaceQuery, DatabaseUpstreamFlowsFilteredByTableWithoutPersonalSpaceQueryVariables>;
export const DatabaseUpstreamFlowsDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamFlows($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseUpstreamFlowsQueryResult = Apollo.QueryResult<DatabaseUpstreamFlowsQuery, DatabaseUpstreamFlowsQueryVariables>;
export const DatabaseUpstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamFlowsWithoutPersonalSpace($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatabaseUpstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatabaseUpstreamFlowsWithoutPersonalSpaceQuery, DatabaseUpstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const DatabaseUpstreamTablesFilteredByTableDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamTablesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatabaseUpstreamTablesFilteredByTableQueryResult = Apollo.QueryResult<DatabaseUpstreamTablesFilteredByTableQuery, DatabaseUpstreamTablesFilteredByTableQueryVariables>;
export const DatabaseUpstreamTablesDocument = /*#__PURE__*/ gql`
    query DatabaseUpstreamTables($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatabaseUpstreamTablesQueryResult = Apollo.QueryResult<DatabaseUpstreamTablesQuery, DatabaseUpstreamTablesQueryVariables>;
export const DatabasesByTagDocument = /*#__PURE__*/ gql`
    query DatabasesByTag($tagName: String!, $first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  tags(filter: {name: $tagName}) {
    databasesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      permissionMode: FILTER_RESULTS
    ) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: databasesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: databasesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatabasesByTagQueryResult = Apollo.QueryResult<DatabasesByTagQuery, DatabasesByTagQueryVariables>;
export const DatabasesByIdsDocument = /*#__PURE__*/ gql`
    query DatabasesByIds($first: Int!, $offset: Int!, $databaseIds: [ID]!) {
  databasesConnection(
    first: $first
    offset: $offset
    filter: {idWithin: $databaseIds}
  ) {
    totalCount
    nodes {
      ...DatabasesByIdsNodes
    }
  }
}
    ${DatabasesByIdsNodesFragmentDoc}`;
export type DatabasesByIdsQueryResult = Apollo.QueryResult<DatabasesByIdsQuery, DatabasesByIdsQueryVariables>;
export const DatabasesDocument = /*#__PURE__*/ gql`
    query Databases($first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  databasesConnection(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...DatabasesDisplayGridRowData
    }
  }
  maxDownstreamDatasources: databasesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamDatasourcesConnection {
        totalCount
      }
    }
  }
  maxDownstreamWorkbooks: databasesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatabasesQueryResult = Apollo.QueryResult<DatabasesQuery, DatabasesQueryVariables>;
export const DatasourceDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type DatasourceDownstreamDashboardsQueryResult = Apollo.QueryResult<DatasourceDownstreamDashboardsQuery, DatasourceDownstreamDashboardsQueryVariables>;
export const DatasourceDownstreamDatabasesDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamDatabases($vizportalUrlId: String, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatasourceDownstreamDatabasesQueryResult = Apollo.QueryResult<DatasourceDownstreamDatabasesQuery, DatasourceDownstreamDatabasesQueryVariables>;
export const DatasourceDownstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type DatasourceDownstreamDatasourcesQueryResult = Apollo.QueryResult<DatasourceDownstreamDatasourcesQuery, DatasourceDownstreamDatasourcesQueryVariables>;
export const DatasourceDownstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamDatasourcesWithoutPersonalSpace($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceDownstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatasourceDownstreamDatasourcesWithoutPersonalSpaceQuery, DatasourceDownstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const DatasourceDownstreamFlowsDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceDownstreamFlowsQueryResult = Apollo.QueryResult<DatasourceDownstreamFlowsQuery, DatasourceDownstreamFlowsQueryVariables>;
export const DatasourceDownstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamFlowsWithoutPersonalSpace($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceDownstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatasourceDownstreamFlowsWithoutPersonalSpaceQuery, DatasourceDownstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const DatasourceDownstreamLensesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamLensesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...LensesDisplayGridRowData
        }
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type DatasourceDownstreamLensesFilteredByFieldQueryResult = Apollo.QueryResult<DatasourceDownstreamLensesFilteredByFieldQuery, DatasourceDownstreamLensesFilteredByFieldQueryVariables>;
export const DatasourceDownstreamLensesDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type DatasourceDownstreamLensesQueryResult = Apollo.QueryResult<DatasourceDownstreamLensesQuery, DatasourceDownstreamLensesQueryVariables>;
export const DatasourceDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceDownstreamMetricsQueryResult = Apollo.QueryResult<DatasourceDownstreamMetricsQuery, DatasourceDownstreamMetricsQueryVariables>;
export const DatasourceDownstreamMetricsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamMetricsWithoutPersonalSpace($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceDownstreamMetricsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatasourceDownstreamMetricsWithoutPersonalSpaceQuery, DatasourceDownstreamMetricsWithoutPersonalSpaceQueryVariables>;
export const DatasourceDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamOwnerIds($datasourceVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  publishedDatasources(filter: {vizportalUrlId: $datasourceVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type DatasourceDownstreamOwnerIdsQueryResult = Apollo.QueryResult<DatasourceDownstreamOwnerIdsQuery, DatasourceDownstreamOwnerIdsQueryVariables>;
export const DatasourceDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type DatasourceDownstreamOwnersQueryResult = Apollo.QueryResult<DatasourceDownstreamOwnersQuery, DatasourceDownstreamOwnersQueryVariables>;
export const DatasourceDownstreamSheetsDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamSheets($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type DatasourceDownstreamSheetsQueryResult = Apollo.QueryResult<DatasourceDownstreamSheetsQuery, DatasourceDownstreamSheetsQueryVariables>;
export const DatasourceDownstreamTablesDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatasourceDownstreamTablesQueryResult = Apollo.QueryResult<DatasourceDownstreamTablesQuery, DatasourceDownstreamTablesQueryVariables>;
export const DatasourceDownstreamWorkbooksFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamWorkbooksFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          containerName
          containerType
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
    `;
export type DatasourceDownstreamWorkbooksFilteredByFieldQueryResult = Apollo.QueryResult<DatasourceDownstreamWorkbooksFilteredByFieldQuery, DatasourceDownstreamWorkbooksFilteredByFieldQueryVariables>;
export const DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpace($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
    `;
export type DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceQuery, DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceQueryVariables>;
export const DatasourceDownstreamWorkbooksDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceDownstreamWorkbooksQueryResult = Apollo.QueryResult<DatasourceDownstreamWorkbooksQuery, DatasourceDownstreamWorkbooksQueryVariables>;
export const DatasourceDownstreamWorkbooksWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatasourceDownstreamWorkbooksWithoutPersonalSpace($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceDownstreamWorkbooksWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatasourceDownstreamWorkbooksWithoutPersonalSpaceQuery, DatasourceDownstreamWorkbooksWithoutPersonalSpaceQueryVariables>;
export const DatasourceFieldsByIdDocument = /*#__PURE__*/ gql`
    query DatasourceFieldsById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!, $searchText: String) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    fieldsConnection(
      filter: {isHidden: false, text: $searchText}
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourceFieldsByIdNodes
      }
    }
  }
}
    ${DatasourceFieldsByIdNodesFragmentDoc}
${FieldIconFragmentDoc}
${NonDatasourceFieldIconFragmentDoc}
${FieldDescriptionInheritedFragmentDoc}
${FieldLineageUpstreamLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type DatasourceFieldsByIdQueryResult = Apollo.QueryResult<DatasourceFieldsByIdQuery, DatasourceFieldsByIdQueryVariables>;
export const DatasourceFieldsWithInheritanceByIdDocument = /*#__PURE__*/ gql`
    query DatasourceFieldsWithInheritanceById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    fieldsConnection(
      filter: {isHidden: false}
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        name
        ...FieldDescriptionInherited
        downstreamSheetsConnection {
          totalCount
        }
        ...FieldIcon
      }
    }
  }
}
    ${FieldDescriptionInheritedFragmentDoc}
${FieldIconFragmentDoc}
${NonDatasourceFieldIconFragmentDoc}`;
export type DatasourceFieldsWithInheritanceByIdQueryResult = Apollo.QueryResult<DatasourceFieldsWithInheritanceByIdQuery, DatasourceFieldsWithInheritanceByIdQueryVariables>;
export const DatasourceLineageCountsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DatasourceLineageCountsFilteredByField($vizportalUrlId: String!, $selectedFieldId: ID!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...DatasourceLineageCounts
    filteredFieldsConnection: fieldsConnection(filter: {id: $selectedFieldId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamVirtualConnectionsConnection {
          totalCount
        }
        upstreamVirtualConnectionTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatasourceLineageCountsFragmentDoc}`;
export type DatasourceLineageCountsFilteredByFieldQueryResult = Apollo.QueryResult<DatasourceLineageCountsFilteredByFieldQuery, DatasourceLineageCountsFilteredByFieldQueryVariables>;
export const DatasourceLineageCountsDocument = /*#__PURE__*/ gql`
    query DatasourceLineageCounts($vizportalUrlId: String!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...DatasourceLineageCounts
  }
}
    ${DatasourceLineageCountsFragmentDoc}`;
export type DatasourceLineageCountsQueryResult = Apollo.QueryResult<DatasourceLineageCountsQuery, DatasourceLineageCountsQueryVariables>;
export const DatasourceDocument = /*#__PURE__*/ gql`
    query Datasource($vizportalUrlId: String!) {
  publishedDatasources(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
  }
}
    `;
export type DatasourceQueryResult = Apollo.QueryResult<DatasourceQuery, DatasourceQueryVariables>;
export const DatasourceUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamDatabases($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: DatabaseSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DatasourceUpstreamDatabasesQueryResult = Apollo.QueryResult<DatasourceUpstreamDatabasesQuery, DatasourceUpstreamDatabasesQueryVariables>;
export const DatasourceUpstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type DatasourceUpstreamDatasourcesQueryResult = Apollo.QueryResult<DatasourceUpstreamDatasourcesQuery, DatasourceUpstreamDatasourcesQueryVariables>;
export const DatasourceUpstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamDatasourcesWithoutPersonalSpace($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceUpstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatasourceUpstreamDatasourcesWithoutPersonalSpaceQuery, DatasourceUpstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const DatasourceUpstreamFlowsDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceUpstreamFlowsQueryResult = Apollo.QueryResult<DatasourceUpstreamFlowsQuery, DatasourceUpstreamFlowsQueryVariables>;
export const DatasourceUpstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamFlowsWithoutPersonalSpace($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DatasourceUpstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DatasourceUpstreamFlowsWithoutPersonalSpaceQuery, DatasourceUpstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const DatasourceUpstreamTablesDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatasourceUpstreamTablesQueryResult = Apollo.QueryResult<DatasourceUpstreamTablesQuery, DatasourceUpstreamTablesQueryVariables>;
export const DatasourceUpstreamVirtualConnectionTablesDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamVirtualConnectionTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DatasourceUpstreamVirtualConnectionTablesQueryResult = Apollo.QueryResult<DatasourceUpstreamVirtualConnectionTablesQuery, DatasourceUpstreamVirtualConnectionTablesQueryVariables>;
export const DatasourceUpstreamVirtualConnectionsDocument = /*#__PURE__*/ gql`
    query DatasourceUpstreamVirtualConnections($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type DatasourceUpstreamVirtualConnectionsQueryResult = Apollo.QueryResult<DatasourceUpstreamVirtualConnectionsQuery, DatasourceUpstreamVirtualConnectionsQueryVariables>;
export const DownstreamDashboardsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamDashboardsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDashboardsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...DashboardsDisplayGridRowData
        }
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type DownstreamDashboardsFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamDashboardsFilteredByFieldQuery, DownstreamDashboardsFilteredByFieldQueryVariables>;
export const DownstreamDatabasesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamDatabasesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type DownstreamDatabasesFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamDatabasesFilteredByFieldQuery, DownstreamDatabasesFilteredByFieldQueryVariables>;
export const DownstreamDatasourcesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamDatasourcesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDatasourcesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowData
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type DownstreamDatasourcesFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamDatasourcesFilteredByFieldQuery, DownstreamDatasourcesFilteredByFieldQueryVariables>;
export const DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DownstreamDatasourcesFilteredByFieldWithoutPersonalSpace($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDatasourcesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQuery, DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryVariables>;
export const DownstreamFlowsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamFlowsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DownstreamFlowsFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamFlowsFilteredByFieldQuery, DownstreamFlowsFilteredByFieldQueryVariables>;
export const DownstreamFlowsFilteredByFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DownstreamFlowsFilteredByFieldWithoutPersonalSpace($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DownstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DownstreamFlowsFilteredByFieldWithoutPersonalSpaceQuery, DownstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryVariables>;
export const DownstreamMetricsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamMetricsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...MetricsDisplayGridRowData
        }
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DownstreamMetricsFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamMetricsFilteredByFieldQuery, DownstreamMetricsFilteredByFieldQueryVariables>;
export const DownstreamMetricsFilteredByFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query DownstreamMetricsFilteredByFieldWithoutPersonalSpace($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DownstreamMetricsFilteredByFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<DownstreamMetricsFilteredByFieldWithoutPersonalSpaceQuery, DownstreamMetricsFilteredByFieldWithoutPersonalSpaceQueryVariables>;
export const DownstreamOwnerIdsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamOwnerIdsFilteredByField($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: {id: $fieldId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type DownstreamOwnerIdsFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamOwnerIdsFilteredByFieldQuery, DownstreamOwnerIdsFilteredByFieldQueryVariables>;
export const DownstreamOwnersFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamOwnersFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...OwnersDisplayGridRowData
        }
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type DownstreamOwnersFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamOwnersFilteredByFieldQuery, DownstreamOwnersFilteredByFieldQueryVariables>;
export const DownstreamSheetsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamSheetsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...SheetsDisplayGridRowData
        }
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type DownstreamSheetsFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamSheetsFilteredByFieldQuery, DownstreamSheetsFilteredByFieldQueryVariables>;
export const DownstreamTablesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamTablesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type DownstreamTablesFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamTablesFilteredByFieldQuery, DownstreamTablesFilteredByFieldQueryVariables>;
export const DownstreamWorkbooksFilteredByFieldDocument = /*#__PURE__*/ gql`
    query DownstreamWorkbooksFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...WorkbooksDisplayGridRowData
        }
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type DownstreamWorkbooksFilteredByFieldQueryResult = Apollo.QueryResult<DownstreamWorkbooksFilteredByFieldQuery, DownstreamWorkbooksFilteredByFieldQueryVariables>;
export const EmbeddedDatasourceLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query EmbeddedDatasourceLineageUpstreamDataQualityWarnings($embeddedDatasourceId: ID!, $first: Int!, $offset: Int!) {
  embeddedDatasources(filter: {id: $embeddedDatasourceId}) {
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<EmbeddedDatasourceLineageUpstreamDataQualityWarningsQuery, EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryVariables>;
export const FieldDetailsDocument = /*#__PURE__*/ gql`
    query FieldDetails($fieldId: ID!) {
  fields(filter: {id: $fieldId}) {
    ...FieldDetails
  }
}
    ${FieldDetailsFragmentDoc}
${FieldDetailsDatasourceFieldFragmentDoc}
${NonDatasourceFieldDetailsFragmentDoc}
${NonDatasourceFieldDetails_ColumnFragmentDoc}
${NonDatasourceFieldDetails_UpstreamColumnFragmentDoc}`;
export type FieldDetailsQueryResult = Apollo.QueryResult<FieldDetailsQuery, FieldDetailsQueryVariables>;
export const FieldDirectColumnDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query FieldDirectColumnDataQualityWarnings($fieldId: ID!) {
  fields(filter: {id: $fieldId}) {
    ...FieldLineageUpstreamDataQualityWarnings
  }
}
    ${FieldLineageUpstreamDataQualityWarningsFragmentDoc}
${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type FieldDirectColumnDataQualityWarningsQueryResult = Apollo.QueryResult<FieldDirectColumnDataQualityWarningsQuery, FieldDirectColumnDataQualityWarningsQueryVariables>;
export const FieldsReferencedByFieldDocument = /*#__PURE__*/ gql`
    query FieldsReferencedByField($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: {id: $fieldId}) {
    ... on FieldReferencingField {
      fieldsConnection(
        first: $first
        offset: $offset
        orderBy: {field: ID, direction: ASC}
      ) {
        totalCount
        nodes {
          ...FieldsReferencedByFieldNodes
        }
      }
    }
  }
}
    ${FieldsReferencedByFieldNodesFragmentDoc}
${FieldsReferencedByFieldNodesDatasourceFragmentDoc}`;
export type FieldsReferencedByFieldQueryResult = Apollo.QueryResult<FieldsReferencedByFieldQuery, FieldsReferencedByFieldQueryVariables>;
export const FlowDownstreamDashboardsFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDashboardsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamDashboardsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamDashboardsFilteredByFlowOutputFieldQuery, FlowDownstreamDashboardsFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDashboards($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamDashboardsQueryResult = Apollo.QueryResult<FlowDownstreamDashboardsQuery, FlowDownstreamDashboardsQueryVariables>;
export const FlowDownstreamDatabasesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDatabasesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: downstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: downstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type FlowDownstreamDatabasesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamDatabasesFilteredByFlowOutputFieldQuery, FlowDownstreamDatabasesFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamDatabasesDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDatabases($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type FlowDownstreamDatabasesQueryResult = Apollo.QueryResult<FlowDownstreamDatabasesQuery, FlowDownstreamDatabasesQueryVariables>;
export const FlowDownstreamDatasourcesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDatasourcesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamDatasourcesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamDatasourcesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamDatasourcesFilteredByFlowOutputFieldQuery, FlowDownstreamDatasourcesFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpace($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamDatasourcesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQuery, FlowDownstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables>;
export const FlowDownstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDatasources($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamDatasourcesQueryResult = Apollo.QueryResult<FlowDownstreamDatasourcesQuery, FlowDownstreamDatasourcesQueryVariables>;
export const FlowDownstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamDatasourcesWithoutPersonalSpace($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamDatasourcesWithoutPersonalSpaceQuery, FlowDownstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const FlowDownstreamFlowsFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamFlowsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamFlowsFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamFlowsFilteredByFlowOutputFieldQuery, FlowDownstreamFlowsFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpace($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQuery, FlowDownstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables>;
export const FlowDownstreamFlowsDocument = /*#__PURE__*/ gql`
    query FlowDownstreamFlows($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamFlowsQueryResult = Apollo.QueryResult<FlowDownstreamFlowsQuery, FlowDownstreamFlowsQueryVariables>;
export const FlowDownstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamFlowsWithoutPersonalSpace($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamFlowsWithoutPersonalSpaceQuery, FlowDownstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const FlowDownstreamLensesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamLensesFilteredByFlowOutputField($vizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  flows(filter: {vizportalUrlId: $vizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...LensesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamLensesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamLensesFilteredByFlowOutputFieldQuery, FlowDownstreamLensesFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamLensesDocument = /*#__PURE__*/ gql`
    query FlowDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  flows(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamLensesQueryResult = Apollo.QueryResult<FlowDownstreamLensesQuery, FlowDownstreamLensesQueryVariables>;
export const FlowDownstreamMetricsFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamMetricsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamMetricsFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamMetricsFilteredByFlowOutputFieldQuery, FlowDownstreamMetricsFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamMetricsFilteredByFlowOutputFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamMetricsFilteredByFlowOutputFieldWithoutPersonalSpace($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamMetricsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamMetricsFilteredByFlowOutputFieldWithoutPersonalSpaceQuery, FlowDownstreamMetricsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables>;
export const FlowDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query FlowDownstreamMetrics($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamMetricsQueryResult = Apollo.QueryResult<FlowDownstreamMetricsQuery, FlowDownstreamMetricsQueryVariables>;
export const FlowDownstreamMetricsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamMetricsWithoutPersonalSpace($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamMetricsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamMetricsWithoutPersonalSpaceQuery, FlowDownstreamMetricsWithoutPersonalSpaceQueryVariables>;
export const FlowDownstreamOwnerIdsFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamOwnerIdsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFields(filter: {id: $selectedFlowOutputFieldId}) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerId
        }
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQuery, FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query FlowDownstreamOwnerIds($flowVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type FlowDownstreamOwnerIdsQueryResult = Apollo.QueryResult<FlowDownstreamOwnerIdsQuery, FlowDownstreamOwnerIdsQueryVariables>;
export const FlowDownstreamOwnersFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamOwnersFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamOwnersFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamOwnersFilteredByFlowOutputFieldQuery, FlowDownstreamOwnersFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query FlowDownstreamOwners($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamOwnersQueryResult = Apollo.QueryResult<FlowDownstreamOwnersQuery, FlowDownstreamOwnersQueryVariables>;
export const FlowDownstreamSheetsFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamSheetsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamSheetsFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamSheetsFilteredByFlowOutputFieldQuery, FlowDownstreamSheetsFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamSheetsDocument = /*#__PURE__*/ gql`
    query FlowDownstreamSheets($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type FlowDownstreamSheetsQueryResult = Apollo.QueryResult<FlowDownstreamSheetsQuery, FlowDownstreamSheetsQueryVariables>;
export const FlowDownstreamTablesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamTablesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: downstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: downstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type FlowDownstreamTablesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamTablesFilteredByFlowOutputFieldQuery, FlowDownstreamTablesFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamTablesDocument = /*#__PURE__*/ gql`
    query FlowDownstreamTables($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type FlowDownstreamTablesQueryResult = Apollo.QueryResult<FlowDownstreamTablesQuery, FlowDownstreamTablesQueryVariables>;
export const FlowDownstreamWorkbooksFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowDownstreamWorkbooksFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamWorkbooksFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowDownstreamWorkbooksFilteredByFlowOutputFieldQuery, FlowDownstreamWorkbooksFilteredByFlowOutputFieldQueryVariables>;
export const FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpace($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceQuery, FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables>;
export const FlowDownstreamWorkbooksDocument = /*#__PURE__*/ gql`
    query FlowDownstreamWorkbooks($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamWorkbooksQueryResult = Apollo.QueryResult<FlowDownstreamWorkbooksQuery, FlowDownstreamWorkbooksQueryVariables>;
export const FlowDownstreamWorkbooksWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowDownstreamWorkbooksWithoutPersonalSpace($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowDownstreamWorkbooksWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowDownstreamWorkbooksWithoutPersonalSpaceQuery, FlowDownstreamWorkbooksWithoutPersonalSpaceQueryVariables>;
export const FlowFieldDetailsDocument = /*#__PURE__*/ gql`
    query FlowFieldDetails($flowOutputStepId: ID!, $flowFieldId: ID!) {
  flowOutputSteps(filter: {id: $flowOutputStepId}) {
    outputFields(filter: {id: $flowFieldId}) {
      name
      __typename
      ... on FlowColumnOutputField {
        id
        column {
          id
          name
          table {
            id
            name
          }
        }
      }
      ... on FlowFieldOutputField {
        ...FlowFieldDetailsFlowFieldOutputField
      }
    }
  }
}
    ${FlowFieldDetailsFlowFieldOutputFieldFragmentDoc}`;
export type FlowFieldDetailsQueryResult = Apollo.QueryResult<FlowFieldDetailsQuery, FlowFieldDetailsQueryVariables>;
export const FlowFieldsByIdDocument = /*#__PURE__*/ gql`
    query FlowFieldsById($flowVizportalUrlId: String!, $selectedOutputStepId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowOutputFieldSortOrder!, $customSensitivityLabelsEnabled: Boolean!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    vizportalUrlId
    outputSteps(filter: {id: $selectedOutputStepId}) {
      outputFieldsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowFieldsByIdNodes
        }
      }
    }
  }
}
    ${FlowFieldsByIdNodesFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${UpstreamColumnLabelsFragmentDoc}
${ColumnLabelsFragmentDoc}
${FlowFieldsByIdFlowFieldOutputFieldFragmentDoc}
${FieldLineageUpstreamLabelsFragmentDoc}
${FieldIconFragmentDoc}
${NonDatasourceFieldIconFragmentDoc}`;
export type FlowFieldsByIdQueryResult = Apollo.QueryResult<FlowFieldsByIdQuery, FlowFieldsByIdQueryVariables>;
export const FlowLineageCountsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query FlowLineageCountsFilteredByField($flowVizportalUrlId: String!, $outputStepId: ID!, $selectedFieldId: ID!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    ...FlowLineageCounts
    outputSteps(filter: {id: $outputStepId}) {
      filteredFieldsConnection: outputFieldsConnection(filter: {id: $selectedFieldId}) {
        nodes {
          name
          upstreamDatabasesConnection {
            totalCount
          }
          upstreamTablesConnection {
            totalCount
          }
          upstreamVirtualConnectionsConnection {
            totalCount
          }
          upstreamVirtualConnectionTablesConnection {
            totalCount
          }
          upstreamFlowsConnection {
            totalCount
          }
          upstreamDatasourcesConnection {
            totalCount
          }
          downstreamDatabasesConnection {
            totalCount
          }
          downstreamTablesConnection {
            totalCount
          }
          downstreamFlowsConnection {
            totalCount
          }
          downstreamDatasourcesConnection {
            totalCount
          }
          downstreamLensesConnection {
            totalCount
          }
          downstreamWorkbooksConnection {
            totalCount
          }
          downstreamDashboardsConnection {
            totalCount
          }
          downstreamSheetsConnection {
            totalCount
          }
          downstreamMetricsConnection {
            totalCount
          }
          downstreamOwnersConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${FlowLineageCountsFragmentDoc}`;
export type FlowLineageCountsFilteredByFieldQueryResult = Apollo.QueryResult<FlowLineageCountsFilteredByFieldQuery, FlowLineageCountsFilteredByFieldQueryVariables>;
export const FlowLineageCountsDocument = /*#__PURE__*/ gql`
    query FlowLineageCounts($flowVizportalUrlId: String!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    ...FlowLineageCounts
  }
}
    ${FlowLineageCountsFragmentDoc}`;
export type FlowLineageCountsQueryResult = Apollo.QueryResult<FlowLineageCountsQuery, FlowLineageCountsQueryVariables>;
export const FlowLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query FlowLineageUpstreamDataQualityWarnings($flowVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    id
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type FlowLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<FlowLineageUpstreamDataQualityWarningsQuery, FlowLineageUpstreamDataQualityWarningsQueryVariables>;
export const FlowDocument = /*#__PURE__*/ gql`
    query Flow($flowVizportalUrlId: String!) {
  flows(
    filter: {vizportalUrlId: $flowVizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    outputSteps(orderBy: {field: NAME, direction: ASC}) {
      ...FlowOutputSteps
    }
    downstreamDatasourcesConnection {
      ...FlowDownstreamDatasources
    }
    downstreamDatabasesConnection {
      ...FlowDownstreamDatabases
    }
  }
}
    ${FlowOutputStepsFragmentDoc}
${FlowDownstreamDatasourcesFragmentDoc}
${FlowDownstreamDatabasesFragmentDoc}`;
export type FlowQueryResult = Apollo.QueryResult<FlowQuery, FlowQueryVariables>;
export const FlowUpstreamDatabasesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowUpstreamDatabasesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type FlowUpstreamDatabasesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowUpstreamDatabasesFilteredByFlowOutputFieldQuery, FlowUpstreamDatabasesFilteredByFlowOutputFieldQueryVariables>;
export const FlowUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query FlowUpstreamDatabases($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type FlowUpstreamDatabasesQueryResult = Apollo.QueryResult<FlowUpstreamDatabasesQuery, FlowUpstreamDatabasesQueryVariables>;
export const FlowUpstreamDatasourcesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowUpstreamDatasourcesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type FlowUpstreamDatasourcesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowUpstreamDatasourcesFilteredByFlowOutputFieldQuery, FlowUpstreamDatasourcesFilteredByFlowOutputFieldQueryVariables>;
export const FlowUpstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowUpstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpace($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowUpstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowUpstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQuery, FlowUpstreamDatasourcesFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables>;
export const FlowUpstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query FlowUpstreamDatasources($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type FlowUpstreamDatasourcesQueryResult = Apollo.QueryResult<FlowUpstreamDatasourcesQuery, FlowUpstreamDatasourcesQueryVariables>;
export const FlowUpstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowUpstreamDatasourcesWithoutPersonalSpace($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowUpstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowUpstreamDatasourcesWithoutPersonalSpaceQuery, FlowUpstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const FlowUpstreamFlowsFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowUpstreamFlowsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowUpstreamFlowsFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowUpstreamFlowsFilteredByFlowOutputFieldQuery, FlowUpstreamFlowsFilteredByFlowOutputFieldQueryVariables>;
export const FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpace($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQuery, FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryVariables>;
export const FlowUpstreamFlowsDocument = /*#__PURE__*/ gql`
    query FlowUpstreamFlows($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowUpstreamFlowsQueryResult = Apollo.QueryResult<FlowUpstreamFlowsQuery, FlowUpstreamFlowsQueryVariables>;
export const FlowUpstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query FlowUpstreamFlowsWithoutPersonalSpace($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type FlowUpstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<FlowUpstreamFlowsWithoutPersonalSpaceQuery, FlowUpstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const FlowUpstreamTablesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowUpstreamTablesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type FlowUpstreamTablesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowUpstreamTablesFilteredByFlowOutputFieldQuery, FlowUpstreamTablesFilteredByFlowOutputFieldQueryVariables>;
export const FlowUpstreamTablesDocument = /*#__PURE__*/ gql`
    query FlowUpstreamTables($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type FlowUpstreamTablesQueryResult = Apollo.QueryResult<FlowUpstreamTablesQuery, FlowUpstreamTablesQueryVariables>;
export const FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamVirtualConnectionTablesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...VirtualConnectionTablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldQuery, FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldQueryVariables>;
export const FlowUpstreamVirtualConnectionTablesDocument = /*#__PURE__*/ gql`
    query FlowUpstreamVirtualConnectionTables($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type FlowUpstreamVirtualConnectionTablesQueryResult = Apollo.QueryResult<FlowUpstreamVirtualConnectionTablesQuery, FlowUpstreamVirtualConnectionTablesQueryVariables>;
export const FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldDocument = /*#__PURE__*/ gql`
    query FlowUpstreamVirtualConnectionsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamVirtualConnectionsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...VirtualConnectionsDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldQueryResult = Apollo.QueryResult<FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldQuery, FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldQueryVariables>;
export const FlowUpstreamVirtualConnectionsDocument = /*#__PURE__*/ gql`
    query FlowUpstreamVirtualConnections($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type FlowUpstreamVirtualConnectionsQueryResult = Apollo.QueryResult<FlowUpstreamVirtualConnectionsQuery, FlowUpstreamVirtualConnectionsQueryVariables>;
export const DatabaseLineageLabelsDocument = /*#__PURE__*/ gql`
    query DatabaseLineageLabels($luid: String) {
  items: databases(filter: {luid: $luid}) {
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type DatabaseLineageLabelsQueryResult = Apollo.QueryResult<DatabaseLineageLabelsQuery, DatabaseLineageLabelsQueryVariables>;
export const DatabaseTableLineageLabelsDocument = /*#__PURE__*/ gql`
    query DatabaseTableLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: databaseTables(filter: {luid: $luid}) {
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
    columns {
      id
      name
      luid
      table {
        id
        ... on VirtualConnectionTable {
          vizportalUrlId
        }
      }
      ...UpstreamColumnLabels
      labels(filter: {isActive: true}) {
        ...Label
      }
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${UpstreamColumnLabelsFragmentDoc}
${ColumnLabelsFragmentDoc}`;
export type DatabaseTableLineageLabelsQueryResult = Apollo.QueryResult<DatabaseTableLineageLabelsQuery, DatabaseTableLineageLabelsQueryVariables>;
export const VirtualConnectionLineageLabelsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: virtualConnections(filter: {luid: $luid}) {
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
    tables @include(if: $customSensitivityLabelsEnabled) {
      columns {
        ...InheritedLabelsColumn
      }
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${InheritedLabelsColumnFragmentDoc}
${UpstreamColumnLabelsFragmentDoc}
${ColumnLabelsFragmentDoc}`;
export type VirtualConnectionLineageLabelsQueryResult = Apollo.QueryResult<VirtualConnectionLineageLabelsQuery, VirtualConnectionLineageLabelsQueryVariables>;
export const VirtualConnectionTablesLineageLabelsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTablesLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: virtualConnectionTables(filter: {luid: $luid}) {
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
    columns @include(if: $customSensitivityLabelsEnabled) {
      ...InheritedLabelsColumn
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${InheritedLabelsColumnFragmentDoc}
${UpstreamColumnLabelsFragmentDoc}
${ColumnLabelsFragmentDoc}`;
export type VirtualConnectionTablesLineageLabelsQueryResult = Apollo.QueryResult<VirtualConnectionTablesLineageLabelsQuery, VirtualConnectionTablesLineageLabelsQueryVariables>;
export const ColumnLineageLabelsDocument = /*#__PURE__*/ gql`
    query ColumnLineageLabels($id: ID, $customSensitivityLabelsEnabled: Boolean!) {
  items: columns(filter: {id: $id}) {
    id
    ...UpstreamColumnLabels
  }
}
    ${UpstreamColumnLabelsFragmentDoc}
${ColumnLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type ColumnLineageLabelsQueryResult = Apollo.QueryResult<ColumnLineageLabelsQuery, ColumnLineageLabelsQueryVariables>;
export const FlowLineageLabelsDocument = /*#__PURE__*/ gql`
    query FlowLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: flows(filter: {luid: $luid}) {
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
    outputFields @include(if: $customSensitivityLabelsEnabled) {
      ...InheritedLabelsFlowOutputField
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${InheritedLabelsFlowOutputFieldFragmentDoc}`;
export type FlowLineageLabelsQueryResult = Apollo.QueryResult<FlowLineageLabelsQuery, FlowLineageLabelsQueryVariables>;
export const PublishedDatasourceLineageLabelsDocument = /*#__PURE__*/ gql`
    query PublishedDatasourceLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: publishedDatasources(filter: {luid: $luid}) {
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
    fields @include(if: $customSensitivityLabelsEnabled) {
      ...InheritedLabelsField
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${InheritedLabelsFieldFragmentDoc}`;
export type PublishedDatasourceLineageLabelsQueryResult = Apollo.QueryResult<PublishedDatasourceLineageLabelsQuery, PublishedDatasourceLineageLabelsQueryVariables>;
export const EmbeddedDatasourceLineageLabelsDocument = /*#__PURE__*/ gql`
    query EmbeddedDatasourceLineageLabels($id: ID) {
  items: embeddedDatasources(filter: {id: $id}) {
    id
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type EmbeddedDatasourceLineageLabelsQueryResult = Apollo.QueryResult<EmbeddedDatasourceLineageLabelsQuery, EmbeddedDatasourceLineageLabelsQueryVariables>;
export const ViewLineageLabelsDocument = /*#__PURE__*/ gql`
    query ViewLineageLabels($id: ID) {
  items: views(filter: {id: $id}) {
    id
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type ViewLineageLabelsQueryResult = Apollo.QueryResult<ViewLineageLabelsQuery, ViewLineageLabelsQueryVariables>;
export const WorkbookLineageLabelsDocument = /*#__PURE__*/ gql`
    query WorkbookLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: workbooks(filter: {luid: $luid}) {
    id
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
    embeddedDatasources @include(if: $customSensitivityLabelsEnabled) {
      fields {
        ...InheritedLabelsField
      }
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}
${InheritedLabelsFieldFragmentDoc}`;
export type WorkbookLineageLabelsQueryResult = Apollo.QueryResult<WorkbookLineageLabelsQuery, WorkbookLineageLabelsQueryVariables>;
export const FieldLineageLabelsDocument = /*#__PURE__*/ gql`
    query FieldLineageLabels($id: ID) {
  items: fields(filter: {id: $id}) {
    id
    ...FieldLabels
  }
}
    ${FieldLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type FieldLineageLabelsQueryResult = Apollo.QueryResult<FieldLineageLabelsQuery, FieldLineageLabelsQueryVariables>;
export const FlowColumnFieldLineageLabelsDocument = /*#__PURE__*/ gql`
    query FlowColumnFieldLineageLabels($id: ID!, $customSensitivityLabelsEnabled: Boolean!) {
  items: flowColumnOutputFields(filter: {id: $id}) {
    id
    column {
      ...UpstreamColumnLabels
      labels(filter: {isActive: true}) {
        ...Label
      }
    }
  }
}
    ${UpstreamColumnLabelsFragmentDoc}
${ColumnLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type FlowColumnFieldLineageLabelsQueryResult = Apollo.QueryResult<FlowColumnFieldLineageLabelsQuery, FlowColumnFieldLineageLabelsQueryVariables>;
export const FlowFieldLineageLabelsDocument = /*#__PURE__*/ gql`
    query FlowFieldLineageLabels($id: ID!) {
  items: flowFieldOutputFields(filter: {id: $id}) {
    id
    field {
      ...FieldLabels
    }
  }
}
    ${FieldLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type FlowFieldLineageLabelsQueryResult = Apollo.QueryResult<FlowFieldLineageLabelsQuery, FlowFieldLineageLabelsQueryVariables>;
export const MetricLineageLabelsDocument = /*#__PURE__*/ gql`
    query MetricLineageLabels($luid: String) {
  items: metrics(filter: {luid: $luid}) {
    id
    upstreamLabels(filter: {isActive: true}) {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type MetricLineageLabelsQueryResult = Apollo.QueryResult<MetricLineageLabelsQuery, MetricLineageLabelsQueryVariables>;
export const GetUserDocument = /*#__PURE__*/ gql`
    query GetUser($luids: [String]) {
  items: tableauUsers(filter: {luidWithin: $luids}) {
    ...TableauUser
    luid
  }
}
    ${TableauUserFragmentDoc}`;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const LensDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query LensDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type LensDownstreamDashboardsQueryResult = Apollo.QueryResult<LensDownstreamDashboardsQuery, LensDownstreamDashboardsQueryVariables>;
export const LensDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query LensDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type LensDownstreamMetricsQueryResult = Apollo.QueryResult<LensDownstreamMetricsQuery, LensDownstreamMetricsQueryVariables>;
export const LensDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query LensDownstreamOwnerIds($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type LensDownstreamOwnerIdsQueryResult = Apollo.QueryResult<LensDownstreamOwnerIdsQuery, LensDownstreamOwnerIdsQueryVariables>;
export const LensDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query LensDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type LensDownstreamOwnersQueryResult = Apollo.QueryResult<LensDownstreamOwnersQuery, LensDownstreamOwnersQueryVariables>;
export const LensDownstreamWorkbooksDocument = /*#__PURE__*/ gql`
    query LensDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type LensDownstreamWorkbooksQueryResult = Apollo.QueryResult<LensDownstreamWorkbooksQuery, LensDownstreamWorkbooksQueryVariables>;
export const LensFieldDetailsDocument = /*#__PURE__*/ gql`
    query LensFieldDetails($lensFieldId: ID!) {
  lensFields(filter: {id: $lensFieldId}) {
    name
    description
    datasourceField {
      datasource {
        ... on PublishedDatasource {
          vizportalUrlId
        }
      }
      ...FieldDetails
    }
  }
}
    ${FieldDetailsFragmentDoc}
${FieldDetailsDatasourceFieldFragmentDoc}
${NonDatasourceFieldDetailsFragmentDoc}
${NonDatasourceFieldDetails_ColumnFragmentDoc}
${NonDatasourceFieldDetails_UpstreamColumnFragmentDoc}`;
export type LensFieldDetailsQueryResult = Apollo.QueryResult<LensFieldDetailsQuery, LensFieldDetailsQueryVariables>;
export const LensFieldsByIdDocument = /*#__PURE__*/ gql`
    query LensFieldsById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensFieldSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    fieldsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensFieldsByIdFieldsConnectionNodes
      }
    }
  }
}
    ${LensFieldsByIdFieldsConnectionNodesFragmentDoc}
${FieldIconFragmentDoc}
${NonDatasourceFieldIconFragmentDoc}`;
export type LensFieldsByIdQueryResult = Apollo.QueryResult<LensFieldsByIdQuery, LensFieldsByIdQueryVariables>;
export const LensLineageCountsDocument = /*#__PURE__*/ gql`
    query LensLineageCounts($vizportalUrlId: String!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...LensLineageCounts
  }
}
    ${LensLineageCountsFragmentDoc}`;
export type LensLineageCountsQueryResult = Apollo.QueryResult<LensLineageCountsQuery, LensLineageCountsQueryVariables>;
export const LensDocument = /*#__PURE__*/ gql`
    query Lens($vizportalUrlId: String!) {
  lenses(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
  }
}
    `;
export type LensQueryResult = Apollo.QueryResult<LensQuery, LensQueryVariables>;
export const LensUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query LensUpstreamDatabases($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type LensUpstreamDatabasesQueryResult = Apollo.QueryResult<LensUpstreamDatabasesQuery, LensUpstreamDatabasesQueryVariables>;
export const LensUpstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query LensUpstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type LensUpstreamDatasourcesQueryResult = Apollo.QueryResult<LensUpstreamDatasourcesQuery, LensUpstreamDatasourcesQueryVariables>;
export const LensUpstreamFlowsDocument = /*#__PURE__*/ gql`
    query LensUpstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type LensUpstreamFlowsQueryResult = Apollo.QueryResult<LensUpstreamFlowsQuery, LensUpstreamFlowsQueryVariables>;
export const LensUpstreamTablesDocument = /*#__PURE__*/ gql`
    query LensUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type LensUpstreamTablesQueryResult = Apollo.QueryResult<LensUpstreamTablesQuery, LensUpstreamTablesQueryVariables>;
export const LensUpstreamVirtualConnectionTablesDocument = /*#__PURE__*/ gql`
    query LensUpstreamVirtualConnectionTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type LensUpstreamVirtualConnectionTablesQueryResult = Apollo.QueryResult<LensUpstreamVirtualConnectionTablesQuery, LensUpstreamVirtualConnectionTablesQueryVariables>;
export const LensUpstreamVirtualConnectionsDocument = /*#__PURE__*/ gql`
    query LensUpstreamVirtualConnections($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      ...LensUpstreamVirtualConnectionsNodes
    }
    maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${LensUpstreamVirtualConnectionsNodesFragmentDoc}
${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type LensUpstreamVirtualConnectionsQueryResult = Apollo.QueryResult<LensUpstreamVirtualConnectionsQuery, LensUpstreamVirtualConnectionsQueryVariables>;
export const MetricUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query MetricUpstreamDataQualityWarnings($metricLuid: String!, $first: Int!, $offset: Int!) {
  metrics(filter: {luid: $metricLuid}) {
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        id
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type MetricUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<MetricUpstreamDataQualityWarningsQuery, MetricUpstreamDataQualityWarningsQueryVariables>;
export const PublishedDatasourceLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query PublishedDatasourceLineageUpstreamDataQualityWarnings($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type PublishedDatasourceLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<PublishedDatasourceLineageUpstreamDataQualityWarningsQuery, PublishedDatasourceLineageUpstreamDataQualityWarningsQueryVariables>;
export const TableColumnsByIdDocument = /*#__PURE__*/ gql`
    query TableColumnsById($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: ColumnSortOrder!, $customSensitivityLabelsEnabled: Boolean!) {
  tablesConnection(filter: {id: $tableId}) {
    nodes {
      id
      name
      ... on DatabaseTable {
        schema
        vizportalId
      }
      columnsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TableColumnsByIdColumns
        }
      }
    }
  }
}
    ${TableColumnsByIdColumnsFragmentDoc}
${TagsFragmentDoc}
${ColumnsByTableIdFragmentDoc}
${ColumnLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type TableColumnsByIdQueryResult = Apollo.QueryResult<TableColumnsByIdQuery, TableColumnsByIdQueryVariables>;
export const TableDownstreamDashboardsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamDashboardsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamDashboardsFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamDashboardsFilteredByColumnQuery, TableDownstreamDashboardsFilteredByColumnQueryVariables>;
export const TableDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query TableDownstreamDashboards($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamDashboardsQueryResult = Apollo.QueryResult<TableDownstreamDashboardsQuery, TableDownstreamDashboardsQueryVariables>;
export const TableDownstreamDatabasesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamDatabasesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type TableDownstreamDatabasesFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamDatabasesFilteredByColumnQuery, TableDownstreamDatabasesFilteredByColumnQueryVariables>;
export const TableDownstreamDatabasesDocument = /*#__PURE__*/ gql`
    query TableDownstreamDatabases($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type TableDownstreamDatabasesQueryResult = Apollo.QueryResult<TableDownstreamDatabasesQuery, TableDownstreamDatabasesQueryVariables>;
export const TableDownstreamFlowsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamFlowsFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamFlowsFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamFlowsFilteredByColumnQuery, TableDownstreamFlowsFilteredByColumnQueryVariables>;
export const TableDownstreamFlowsFilteredByColumnWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamFlowsFilteredByColumnWithoutPersonalSpace($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamFlowsFilteredByColumnWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamFlowsFilteredByColumnWithoutPersonalSpaceQuery, TableDownstreamFlowsFilteredByColumnWithoutPersonalSpaceQueryVariables>;
export const TableDownstreamFlowsDocument = /*#__PURE__*/ gql`
    query TableDownstreamFlows($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamFlowsQueryResult = Apollo.QueryResult<TableDownstreamFlowsQuery, TableDownstreamFlowsQueryVariables>;
export const TableDownstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamFlowsWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamFlowsWithoutPersonalSpaceQuery, TableDownstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const TableDownstreamLensesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamLensesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...LensesDisplayGridRowData
        }
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamLensesFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamLensesFilteredByColumnQuery, TableDownstreamLensesFilteredByColumnQueryVariables>;
export const TableDownstreamLensesDocument = /*#__PURE__*/ gql`
    query TableDownstreamLenses($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamLensesQueryResult = Apollo.QueryResult<TableDownstreamLensesQuery, TableDownstreamLensesQueryVariables>;
export const TableDownstreamMetricsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamMetricsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamMetricsFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamMetricsFilteredByColumnQuery, TableDownstreamMetricsFilteredByColumnQueryVariables>;
export const TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamMetricsFilteredByColumnWithoutPersonalSpace($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceQuery, TableDownstreamMetricsFilteredByColumnWithoutPersonalSpaceQueryVariables>;
export const TableDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query TableDownstreamMetrics($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamMetricsQueryResult = Apollo.QueryResult<TableDownstreamMetricsQuery, TableDownstreamMetricsQueryVariables>;
export const TableDownstreamMetricsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamMetricsWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamMetricsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamMetricsWithoutPersonalSpaceQuery, TableDownstreamMetricsWithoutPersonalSpaceQueryVariables>;
export const TableDownstreamOwnerIdsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamOwnerIdsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: {id: $columnId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type TableDownstreamOwnerIdsFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamOwnerIdsFilteredByColumnQuery, TableDownstreamOwnerIdsFilteredByColumnQueryVariables>;
export const TableDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query TableDownstreamOwnerIds($tableId: ID!, $first: Int!, $offset: Int!) {
  tables(filter: {id: $tableId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type TableDownstreamOwnerIdsQueryResult = Apollo.QueryResult<TableDownstreamOwnerIdsQuery, TableDownstreamOwnerIdsQueryVariables>;
export const TableDownstreamOwnersFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamOwnersFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamOwnersFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamOwnersFilteredByColumnQuery, TableDownstreamOwnersFilteredByColumnQueryVariables>;
export const TableDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query TableDownstreamOwners($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamOwnersQueryResult = Apollo.QueryResult<TableDownstreamOwnersQuery, TableDownstreamOwnersQueryVariables>;
export const TableDownstreamPublishedDatasourcesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamPublishedDatasourcesFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamPublishedDatasourcesFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamPublishedDatasourcesFilteredByColumnQuery, TableDownstreamPublishedDatasourcesFilteredByColumnQueryVariables>;
export const TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpace($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceQuery, TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceQueryVariables>;
export const TableDownstreamPublishedDatasourcesDocument = /*#__PURE__*/ gql`
    query TableDownstreamPublishedDatasources($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamPublishedDatasourcesQueryResult = Apollo.QueryResult<TableDownstreamPublishedDatasourcesQuery, TableDownstreamPublishedDatasourcesQueryVariables>;
export const TableDownstreamPublishedDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamPublishedDatasourcesWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamPublishedDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamPublishedDatasourcesWithoutPersonalSpaceQuery, TableDownstreamPublishedDatasourcesWithoutPersonalSpaceQueryVariables>;
export const TableDownstreamSheetsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamSheetsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamSheetsFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamSheetsFilteredByColumnQuery, TableDownstreamSheetsFilteredByColumnQueryVariables>;
export const TableDownstreamSheetsDocument = /*#__PURE__*/ gql`
    query TableDownstreamSheets($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type TableDownstreamSheetsQueryResult = Apollo.QueryResult<TableDownstreamSheetsQuery, TableDownstreamSheetsQueryVariables>;
export const TableDownstreamTablesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamTablesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type TableDownstreamTablesFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamTablesFilteredByColumnQuery, TableDownstreamTablesFilteredByColumnQueryVariables>;
export const TableDownstreamTablesDocument = /*#__PURE__*/ gql`
    query TableDownstreamTables($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type TableDownstreamTablesQueryResult = Apollo.QueryResult<TableDownstreamTablesQuery, TableDownstreamTablesQueryVariables>;
export const TableDownstreamVirtualConnectionTablesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamVirtualConnectionTablesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamVirtualConnectionTablesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionTablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type TableDownstreamVirtualConnectionTablesFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamVirtualConnectionTablesFilteredByColumnQuery, TableDownstreamVirtualConnectionTablesFilteredByColumnQueryVariables>;
export const TableDownstreamVirtualConnectionTablesDocument = /*#__PURE__*/ gql`
    query TableDownstreamVirtualConnectionTables($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type TableDownstreamVirtualConnectionTablesQueryResult = Apollo.QueryResult<TableDownstreamVirtualConnectionTablesQuery, TableDownstreamVirtualConnectionTablesQueryVariables>;
export const TableDownstreamVirtualConnectionsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamVirtualConnectionsFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamVirtualConnectionsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionsDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type TableDownstreamVirtualConnectionsFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamVirtualConnectionsFilteredByColumnQuery, TableDownstreamVirtualConnectionsFilteredByColumnQueryVariables>;
export const TableDownstreamVirtualConnectionsDocument = /*#__PURE__*/ gql`
    query TableDownstreamVirtualConnections($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type TableDownstreamVirtualConnectionsQueryResult = Apollo.QueryResult<TableDownstreamVirtualConnectionsQuery, TableDownstreamVirtualConnectionsQueryVariables>;
export const TableDownstreamWorkbooksFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableDownstreamWorkbooksFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...WorkbooksDisplayGridRowData
        }
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamWorkbooksFilteredByColumnQueryResult = Apollo.QueryResult<TableDownstreamWorkbooksFilteredByColumnQuery, TableDownstreamWorkbooksFilteredByColumnQueryVariables>;
export const TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpace($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
    `;
export type TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceQuery, TableDownstreamWorkbooksFilteredByColumnWithoutPersonalSpaceQueryVariables>;
export const TableDownstreamWorkbooksDocument = /*#__PURE__*/ gql`
    query TableDownstreamWorkbooks($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamWorkbooksQueryResult = Apollo.QueryResult<TableDownstreamWorkbooksQuery, TableDownstreamWorkbooksQueryVariables>;
export const TableDownstreamWorkbooksWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableDownstreamWorkbooksWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableDownstreamWorkbooksWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableDownstreamWorkbooksWithoutPersonalSpaceQuery, TableDownstreamWorkbooksWithoutPersonalSpaceQueryVariables>;
export const TableLineageCountsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableLineageCountsFilteredByColumn($tableId: ID!, $columnId: ID!) {
  tables(filter: {id: $tableId}) {
    ...TableLineageCounts
    filteredColumnsConnection: columnsConnection(filter: {id: $columnId}) {
      nodes {
        name
        id
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamVirtualConnectionsConnection {
          totalCount
        }
        downstreamVirtualConnectionTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${TableLineageCountsFragmentDoc}`;
export type TableLineageCountsFilteredByColumnQueryResult = Apollo.QueryResult<TableLineageCountsFilteredByColumnQuery, TableLineageCountsFilteredByColumnQueryVariables>;
export const TableLineageCountsDocument = /*#__PURE__*/ gql`
    query TableLineageCounts($tableId: ID!) {
  tables(filter: {id: $tableId}) {
    ...TableLineageCounts
  }
}
    ${TableLineageCountsFragmentDoc}`;
export type TableLineageCountsQueryResult = Apollo.QueryResult<TableLineageCountsQuery, TableLineageCountsQueryVariables>;
export const TableLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query TableLineageUpstreamDataQualityWarnings($tableId: ID!, $first: Int!, $offset: Int!) {
  databaseTables(filter: {id: $tableId}) {
    id
    name
    __typename
    dataQualityWarnings {
      isActive
      ...DataQualityWarning
      ...DataQualityWarningAsset
    }
    columnsConnection(filter: {hasActiveWarning: true}) {
      totalCount
      nodes {
        name
        remoteType
        dataQualityWarnings {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type TableLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<TableLineageUpstreamDataQualityWarningsQuery, TableLineageUpstreamDataQualityWarningsQueryVariables>;
export const TableDocument = /*#__PURE__*/ gql`
    query Table($tableId: ID!) {
  tables(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    ...TableQuery
  }
}
    ${TableQueryFragmentDoc}
${TableFragmentDoc}
${TableCertificationFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type TableQueryResult = Apollo.QueryResult<TableQuery, TableQueryVariables>;
export const TableUpstreamDatabasesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableUpstreamDatabasesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type TableUpstreamDatabasesFilteredByColumnQueryResult = Apollo.QueryResult<TableUpstreamDatabasesFilteredByColumnQuery, TableUpstreamDatabasesFilteredByColumnQueryVariables>;
export const TableUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query TableUpstreamDatabases($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type TableUpstreamDatabasesQueryResult = Apollo.QueryResult<TableUpstreamDatabasesQuery, TableUpstreamDatabasesQueryVariables>;
export const TableUpstreamDatasourcesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableUpstreamDatasourcesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowData
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type TableUpstreamDatasourcesFilteredByColumnQueryResult = Apollo.QueryResult<TableUpstreamDatasourcesFilteredByColumnQuery, TableUpstreamDatasourcesFilteredByColumnQueryVariables>;
export const TableUpstreamDatasourcesFilteredByColumnWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableUpstreamDatasourcesFilteredByColumnWithoutPersonalSpace($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableUpstreamDatasourcesFilteredByColumnWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableUpstreamDatasourcesFilteredByColumnWithoutPersonalSpaceQuery, TableUpstreamDatasourcesFilteredByColumnWithoutPersonalSpaceQueryVariables>;
export const TableUpstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query TableUpstreamDatasources($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type TableUpstreamDatasourcesQueryResult = Apollo.QueryResult<TableUpstreamDatasourcesQuery, TableUpstreamDatasourcesQueryVariables>;
export const TableUpstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableUpstreamDatasourcesWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableUpstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableUpstreamDatasourcesWithoutPersonalSpaceQuery, TableUpstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const TableUpstreamFlowsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableUpstreamFlowsFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableUpstreamFlowsFilteredByColumnQueryResult = Apollo.QueryResult<TableUpstreamFlowsFilteredByColumnQuery, TableUpstreamFlowsFilteredByColumnQueryVariables>;
export const TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableUpstreamFlowsFilteredByColumnWithoutPersonalSpace($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceQuery, TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceQueryVariables>;
export const TableUpstreamFlowsDocument = /*#__PURE__*/ gql`
    query TableUpstreamFlows($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableUpstreamFlowsQueryResult = Apollo.QueryResult<TableUpstreamFlowsQuery, TableUpstreamFlowsQueryVariables>;
export const TableUpstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query TableUpstreamFlowsWithoutPersonalSpace($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type TableUpstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<TableUpstreamFlowsWithoutPersonalSpaceQuery, TableUpstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const TableUpstreamTablesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query TableUpstreamTablesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type TableUpstreamTablesFilteredByColumnQueryResult = Apollo.QueryResult<TableUpstreamTablesFilteredByColumnQuery, TableUpstreamTablesFilteredByColumnQueryVariables>;
export const TableUpstreamTablesDocument = /*#__PURE__*/ gql`
    query TableUpstreamTables($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type TableUpstreamTablesQueryResult = Apollo.QueryResult<TableUpstreamTablesQuery, TableUpstreamTablesQueryVariables>;
export const TablesByTagDocument = /*#__PURE__*/ gql`
    query TablesByTag($tagName: String!, $first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseTableSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  tags(filter: {name: $tagName}) {
    databaseTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      permissionMode: FILTER_RESULTS
    ) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
        ...Tags
      }
    }
    maxDownstreamDatasources: databaseTablesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: databaseTablesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}
${TagsFragmentDoc}`;
export type TablesByTagQueryResult = Apollo.QueryResult<TablesByTagQuery, TablesByTagQueryVariables>;
export const TablesDocument = /*#__PURE__*/ gql`
    query Tables($first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseTableSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  databaseTablesConnection(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...TablesDisplayGridRowData
      ...Tags
    }
  }
  maxDownstreamDatasources: databaseTablesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamDatasourcesConnection {
        totalCount
      }
    }
  }
  maxDownstreamWorkbooks: databaseTablesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}
${TagsFragmentDoc}`;
export type TablesQueryResult = Apollo.QueryResult<TablesQuery, TablesQueryVariables>;
export const TagsQueryWithFiltersDocument = /*#__PURE__*/ gql`
    query TagsQueryWithFilters($first: Int!, $connectionTypeFilter: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean, $isEmbeddedFilter: Boolean, $name: String, $offset: Int!, $textSearch: String) {
  tagsConnection(
    filter: {text: $name}
    first: $first
    offset: $offset
    orderBy: {field: NAME, direction: ASC}
  ) {
    ...TagsQueryWithFiltersTagsConnection
  }
}
    ${TagsQueryWithFiltersTagsConnectionFragmentDoc}
${TagsQueryWithFiltersTagsConnectionNodesFragmentDoc}`;
export type TagsQueryWithFiltersQueryResult = Apollo.QueryResult<TagsQueryWithFiltersQuery, TagsQueryWithFiltersQueryVariables>;
export const UpstreamDatabasesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query UpstreamDatabasesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type UpstreamDatabasesFilteredByFieldQueryResult = Apollo.QueryResult<UpstreamDatabasesFilteredByFieldQuery, UpstreamDatabasesFilteredByFieldQueryVariables>;
export const UpstreamDatasourcesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query UpstreamDatasourcesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowData
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type UpstreamDatasourcesFilteredByFieldQueryResult = Apollo.QueryResult<UpstreamDatasourcesFilteredByFieldQuery, UpstreamDatasourcesFilteredByFieldQueryVariables>;
export const UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query UpstreamDatasourcesFilteredByFieldWithoutPersonalSpace($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQuery, UpstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryVariables>;
export const UpstreamFlowsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query UpstreamFlowsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type UpstreamFlowsFilteredByFieldQueryResult = Apollo.QueryResult<UpstreamFlowsFilteredByFieldQuery, UpstreamFlowsFilteredByFieldQueryVariables>;
export const UpstreamFlowsFilteredByFieldWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query UpstreamFlowsFilteredByFieldWithoutPersonalSpace($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type UpstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryResult = Apollo.QueryResult<UpstreamFlowsFilteredByFieldWithoutPersonalSpaceQuery, UpstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryVariables>;
export const UpstreamTablesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query UpstreamTablesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type UpstreamTablesFilteredByFieldQueryResult = Apollo.QueryResult<UpstreamTablesFilteredByFieldQuery, UpstreamTablesFilteredByFieldQueryVariables>;
export const UpstreamVirtualConnectionTablesFilteredByFieldDocument = /*#__PURE__*/ gql`
    query UpstreamVirtualConnectionTablesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamVirtualConnectionTablesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type UpstreamVirtualConnectionTablesFilteredByFieldQueryResult = Apollo.QueryResult<UpstreamVirtualConnectionTablesFilteredByFieldQuery, UpstreamVirtualConnectionTablesFilteredByFieldQueryVariables>;
export const UpstreamVirtualConnectionsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query UpstreamVirtualConnectionsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamVirtualConnectionsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionsDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type UpstreamVirtualConnectionsFilteredByFieldQueryResult = Apollo.QueryResult<UpstreamVirtualConnectionsFilteredByFieldQuery, UpstreamVirtualConnectionsFilteredByFieldQueryVariables>;
export const ViewDetailsByPathDocument = /*#__PURE__*/ gql`
    query ViewDetailsByPath($viewPath: String!) {
  views(filter: {path: $viewPath}, permissionMode: FILTER_RESULTS) {
    ...ViewDetailsByPath
  }
}
    ${ViewDetailsByPathFragmentDoc}
${ViewDetailsByPathDashboardFragmentDoc}
${SheetFieldInstanceFragmentDoc}
${NonDatasourceFieldDetailsFragmentDoc}
${NonDatasourceFieldDetails_ColumnFragmentDoc}
${NonDatasourceFieldDetails_UpstreamColumnFragmentDoc}
${SheetFieldInstanceDatasourceFragmentDoc}
${SheetFieldInstancePublishedDatasourceFragmentDoc}
${SheetFieldInstanceDatasourceFieldFragmentDoc}
${SheetFieldInstanceUpstreamDatabasesConnectionFragmentDoc}
${ViewDetailsByPathSheetFragmentDoc}`;
export type ViewDetailsByPathQueryResult = Apollo.QueryResult<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables>;
export const VirtualConnectionDownstreamDashboardsFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamDashboardsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamDashboardsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamDashboardsFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamDashboardsFilteredByTableQuery, VirtualConnectionDownstreamDashboardsFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamDashboardsQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamDashboardsQuery, VirtualConnectionDownstreamDashboardsQueryVariables>;
export const VirtualConnectionDownstreamDatasourcesFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamDatasourcesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamDatasourcesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamDatasourcesFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamDatasourcesFilteredByTableQuery, VirtualConnectionDownstreamDatasourcesFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamDatasourcesQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamDatasourcesQuery, VirtualConnectionDownstreamDatasourcesQueryVariables>;
export const VirtualConnectionDownstreamFlowsFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamFlowsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionDownstreamFlowsFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamFlowsFilteredByTableQuery, VirtualConnectionDownstreamFlowsFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamFlowsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionDownstreamFlowsQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamFlowsQuery, VirtualConnectionDownstreamFlowsQueryVariables>;
export const VirtualConnectionDownstreamLensesFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamLensesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...LensesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamLensesFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamLensesFilteredByTableQuery, VirtualConnectionDownstreamLensesFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamLensesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamLensesQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamLensesQuery, VirtualConnectionDownstreamLensesQueryVariables>;
export const VirtualConnectionDownstreamMetricsFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamMetricsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionDownstreamMetricsFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamMetricsFilteredByTableQuery, VirtualConnectionDownstreamMetricsFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionDownstreamMetricsQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamMetricsQuery, VirtualConnectionDownstreamMetricsQueryVariables>;
export const VirtualConnectionDownstreamOwnerIdsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamOwnerIdsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tables(filter: {id: $selectedColumnId}) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerId
        }
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type VirtualConnectionDownstreamOwnerIdsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamOwnerIdsFilteredByColumnQuery, VirtualConnectionDownstreamOwnerIdsFilteredByColumnQueryVariables>;
export const VirtualConnectionDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamOwnerIds($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type VirtualConnectionDownstreamOwnerIdsQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamOwnerIdsQuery, VirtualConnectionDownstreamOwnerIdsQueryVariables>;
export const VirtualConnectionDownstreamOwnersFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamOwnersFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamOwnersFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamOwnersFilteredByTableQuery, VirtualConnectionDownstreamOwnersFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamOwnersQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamOwnersQuery, VirtualConnectionDownstreamOwnersQueryVariables>;
export const VirtualConnectionDownstreamSheetsFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamSheetsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamSheetsFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamSheetsFilteredByTableQuery, VirtualConnectionDownstreamSheetsFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamSheetsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamSheets($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionDownstreamSheetsQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamSheetsQuery, VirtualConnectionDownstreamSheetsQueryVariables>;
export const VirtualConnectionDownstreamWorkbooksFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamWorkbooksFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionDownstreamWorkbooksFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamWorkbooksFilteredByTableQuery, VirtualConnectionDownstreamWorkbooksFilteredByTableQueryVariables>;
export const VirtualConnectionDownstreamWorkbooksDocument = /*#__PURE__*/ gql`
    query VirtualConnectionDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionDownstreamWorkbooksQueryResult = Apollo.QueryResult<VirtualConnectionDownstreamWorkbooksQuery, VirtualConnectionDownstreamWorkbooksQueryVariables>;
export const VirtualConnectionLineageCountsFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionLineageCountsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionLineageCounts
    filteredTablesConnection: tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionLineageCountsFragmentDoc}`;
export type VirtualConnectionLineageCountsFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionLineageCountsFilteredByTableQuery, VirtualConnectionLineageCountsFilteredByTableQueryVariables>;
export const VirtualConnectionLineageCountsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionLineageCounts($vizportalUrlId: String!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionLineageCounts
  }
}
    ${VirtualConnectionLineageCountsFragmentDoc}`;
export type VirtualConnectionLineageCountsQueryResult = Apollo.QueryResult<VirtualConnectionLineageCountsQuery, VirtualConnectionLineageCountsQueryVariables>;
export const VirtualConnectionLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionLineageUpstreamDataQualityWarnings($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type VirtualConnectionLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<VirtualConnectionLineageUpstreamDataQualityWarningsQuery, VirtualConnectionLineageUpstreamDataQualityWarningsQueryVariables>;
export const VirtualConnectionDocument = /*#__PURE__*/ gql`
    query VirtualConnection($vizportalUrlId: String!) {
  virtualConnections(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    tables(orderBy: {field: NAME, direction: ASC}) {
      ...VirtualConnectionTables
    }
  }
}
    ${VirtualConnectionTablesFragmentDoc}`;
export type VirtualConnectionQueryResult = Apollo.QueryResult<VirtualConnectionQuery, VirtualConnectionQueryVariables>;
export const VirtualConnectionTableColumnLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableColumnLineageUpstreamDataQualityWarnings($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type VirtualConnectionTableColumnLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<VirtualConnectionTableColumnLineageUpstreamDataQualityWarningsQuery, VirtualConnectionTableColumnLineageUpstreamDataQualityWarningsQueryVariables>;
export const VirtualConnectionTableColumnsByIdDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableColumnsById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: ColumnSortOrder!, $customSensitivityLabelsEnabled: Boolean!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    columnsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...ColumnsByTableId
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${ColumnsByTableIdFragmentDoc}
${ColumnLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type VirtualConnectionTableColumnsByIdQueryResult = Apollo.QueryResult<VirtualConnectionTableColumnsByIdQuery, VirtualConnectionTableColumnsByIdQueryVariables>;
export const VirtualConnectionTableDownstreamDashboardsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamDashboardsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamDashboardsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery, VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamDashboardsQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamDashboardsQuery, VirtualConnectionTableDownstreamDashboardsQueryVariables>;
export const VirtualConnectionTableDownstreamDatasourcesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamDatasourcesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamDatasourcesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQuery, VirtualConnectionTableDownstreamDatasourcesFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamDatasourcesQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamDatasourcesQuery, VirtualConnectionTableDownstreamDatasourcesQueryVariables>;
export const VirtualConnectionTableDownstreamFlowsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamFlowsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionTableDownstreamFlowsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamFlowsFilteredByColumnQuery, VirtualConnectionTableDownstreamFlowsFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamFlowsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionTableDownstreamFlowsQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamFlowsQuery, VirtualConnectionTableDownstreamFlowsQueryVariables>;
export const VirtualConnectionTableDownstreamLensesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamLensesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...LensesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamLensesFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamLensesFilteredByColumnQuery, VirtualConnectionTableDownstreamLensesFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamLensesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamLensesQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamLensesQuery, VirtualConnectionTableDownstreamLensesQueryVariables>;
export const VirtualConnectionTableDownstreamMetricsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamMetricsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionTableDownstreamMetricsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamMetricsFilteredByColumnQuery, VirtualConnectionTableDownstreamMetricsFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionTableDownstreamMetricsQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamMetricsQuery, VirtualConnectionTableDownstreamMetricsQueryVariables>;
export const VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamOwnerIdsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columns(filter: {id: $selectedColumnId}) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerId
        }
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnQuery, VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamOwnerIds($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type VirtualConnectionTableDownstreamOwnerIdsQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamOwnerIdsQuery, VirtualConnectionTableDownstreamOwnerIdsQueryVariables>;
export const VirtualConnectionTableDownstreamOwnersFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamOwnersFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamOwnersFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamOwnersFilteredByColumnQuery, VirtualConnectionTableDownstreamOwnersFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamOwnersQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamOwnersQuery, VirtualConnectionTableDownstreamOwnersQueryVariables>;
export const VirtualConnectionTableDownstreamSheetsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamSheetsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery, VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamSheetsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamSheets($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type VirtualConnectionTableDownstreamSheetsQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamSheetsQuery, VirtualConnectionTableDownstreamSheetsQueryVariables>;
export const VirtualConnectionTableDownstreamWorkbooksFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamWorkbooksFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQuery, VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQueryVariables>;
export const VirtualConnectionTableDownstreamWorkbooksDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${WorkbooksDisplayGridRowDataFragmentDoc}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type VirtualConnectionTableDownstreamWorkbooksQueryResult = Apollo.QueryResult<VirtualConnectionTableDownstreamWorkbooksQuery, VirtualConnectionTableDownstreamWorkbooksQueryVariables>;
export const VirtualConnectionTableLineageCountsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableLineageCountsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionTableLineageCounts
    filteredColumnsConnection: columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamVirtualConnectionsConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTableLineageCountsFragmentDoc}`;
export type VirtualConnectionTableLineageCountsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableLineageCountsFilteredByColumnQuery, VirtualConnectionTableLineageCountsFilteredByColumnQueryVariables>;
export const VirtualConnectionTableLineageCountsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableLineageCounts($vizportalUrlId: String!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionTableLineageCounts
  }
}
    ${VirtualConnectionTableLineageCountsFragmentDoc}`;
export type VirtualConnectionTableLineageCountsQueryResult = Apollo.QueryResult<VirtualConnectionTableLineageCountsQuery, VirtualConnectionTableLineageCountsQueryVariables>;
export const VirtualConnectionTableLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableLineageUpstreamDataQualityWarnings($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type VirtualConnectionTableLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<VirtualConnectionTableLineageUpstreamDataQualityWarningsQuery, VirtualConnectionTableLineageUpstreamDataQualityWarningsQueryVariables>;
export const VirtualConnectionTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTable($vizportalUrlId: String!) {
  virtualConnectionTables(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    columns(orderBy: {field: NAME, direction: ASC}) {
      name
      id
    }
  }
}
    `;
export type VirtualConnectionTableQueryResult = Apollo.QueryResult<VirtualConnectionTableQuery, VirtualConnectionTableQueryVariables>;
export const VirtualConnectionTableUpstreamDatabasesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableUpstreamDatabasesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type VirtualConnectionTableUpstreamDatabasesFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableUpstreamDatabasesFilteredByColumnQuery, VirtualConnectionTableUpstreamDatabasesFilteredByColumnQueryVariables>;
export const VirtualConnectionTableUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableUpstreamDatabases($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: DatabaseSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type VirtualConnectionTableUpstreamDatabasesQueryResult = Apollo.QueryResult<VirtualConnectionTableUpstreamDatabasesQuery, VirtualConnectionTableUpstreamDatabasesQueryVariables>;
export const VirtualConnectionTableUpstreamTablesFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableUpstreamTablesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type VirtualConnectionTableUpstreamTablesFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableUpstreamTablesFilteredByColumnQuery, VirtualConnectionTableUpstreamTablesFilteredByColumnQueryVariables>;
export const VirtualConnectionTableUpstreamTablesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type VirtualConnectionTableUpstreamTablesQueryResult = Apollo.QueryResult<VirtualConnectionTableUpstreamTablesQuery, VirtualConnectionTableUpstreamTablesQueryVariables>;
export const VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        upstreamVirtualConnectionsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...VirtualConnectionsDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnQueryResult = Apollo.QueryResult<VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnQuery, VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnQueryVariables>;
export const VirtualConnectionTableUpstreamVirtualConnectionsDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTableUpstreamVirtualConnections($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: VirtualConnectionSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type VirtualConnectionTableUpstreamVirtualConnectionsQueryResult = Apollo.QueryResult<VirtualConnectionTableUpstreamVirtualConnectionsQuery, VirtualConnectionTableUpstreamVirtualConnectionsQueryVariables>;
export const VirtualConnectionTablesByIdDocument = /*#__PURE__*/ gql`
    query VirtualConnectionTablesById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    tablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type VirtualConnectionTablesByIdQueryResult = Apollo.QueryResult<VirtualConnectionTablesByIdQuery, VirtualConnectionTablesByIdQueryVariables>;
export const VirtualConnectionUpstreamDatabasesFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionUpstreamDatabasesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type VirtualConnectionUpstreamDatabasesFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionUpstreamDatabasesFilteredByTableQuery, VirtualConnectionUpstreamDatabasesFilteredByTableQueryVariables>;
export const VirtualConnectionUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionUpstreamDatabases($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: DatabaseSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type VirtualConnectionUpstreamDatabasesQueryResult = Apollo.QueryResult<VirtualConnectionUpstreamDatabasesQuery, VirtualConnectionUpstreamDatabasesQueryVariables>;
export const VirtualConnectionUpstreamTablesFilteredByTableDocument = /*#__PURE__*/ gql`
    query VirtualConnectionUpstreamTablesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type VirtualConnectionUpstreamTablesFilteredByTableQueryResult = Apollo.QueryResult<VirtualConnectionUpstreamTablesFilteredByTableQuery, VirtualConnectionUpstreamTablesFilteredByTableQueryVariables>;
export const VirtualConnectionUpstreamTablesDocument = /*#__PURE__*/ gql`
    query VirtualConnectionUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type VirtualConnectionUpstreamTablesQueryResult = Apollo.QueryResult<VirtualConnectionUpstreamTablesQuery, VirtualConnectionUpstreamTablesQueryVariables>;
export const WorkbookDownstreamDashboardsDocument = /*#__PURE__*/ gql`
    query WorkbookDownstreamDashboards($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    dashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${DashboardsDisplayGridRowDataFragmentDoc}`;
export type WorkbookDownstreamDashboardsQueryResult = Apollo.QueryResult<WorkbookDownstreamDashboardsQuery, WorkbookDownstreamDashboardsQueryVariables>;
export const WorkbookDownstreamMetricsDocument = /*#__PURE__*/ gql`
    query WorkbookDownstreamMetrics($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentDoc}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type WorkbookDownstreamMetricsQueryResult = Apollo.QueryResult<WorkbookDownstreamMetricsQuery, WorkbookDownstreamMetricsQueryVariables>;
export const WorkbookDownstreamMetricsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query WorkbookDownstreamMetricsWithoutPersonalSpace($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type WorkbookDownstreamMetricsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<WorkbookDownstreamMetricsWithoutPersonalSpaceQuery, WorkbookDownstreamMetricsWithoutPersonalSpaceQueryVariables>;
export const WorkbookDownstreamOwnerIdsDocument = /*#__PURE__*/ gql`
    query WorkbookDownstreamOwnerIds($WorkbookVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  workbooks(filter: {vizportalUrlId: $WorkbookVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${OwnerIdFragmentDoc}`;
export type WorkbookDownstreamOwnerIdsQueryResult = Apollo.QueryResult<WorkbookDownstreamOwnerIdsQuery, WorkbookDownstreamOwnerIdsQueryVariables>;
export const WorkbookDownstreamOwnersDocument = /*#__PURE__*/ gql`
    query WorkbookDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${OwnersDisplayGridRowDataFragmentDoc}`;
export type WorkbookDownstreamOwnersQueryResult = Apollo.QueryResult<WorkbookDownstreamOwnersQuery, WorkbookDownstreamOwnersQueryVariables>;
export const WorkbookDownstreamSheetsDocument = /*#__PURE__*/ gql`
    query WorkbookDownstreamSheets($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    sheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${SheetsDisplayGridRowDataFragmentDoc}`;
export type WorkbookDownstreamSheetsQueryResult = Apollo.QueryResult<WorkbookDownstreamSheetsQuery, WorkbookDownstreamSheetsQueryVariables>;
export const WorkbookFieldsByIdDocument = /*#__PURE__*/ gql`
    query WorkbookFieldsById($workbookVizportalUrlId: String!, $selectedEmbeddedDatasourceId: ID!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    vizportalUrlId
    embeddedDatasources(filter: {id: $selectedEmbeddedDatasourceId}) {
      fieldsConnection(
        filter: {isHidden: false}
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...WorkbookFieldsByIdFieldsConnection
        }
      }
    }
  }
}
    ${WorkbookFieldsByIdFieldsConnectionFragmentDoc}
${FieldIconFragmentDoc}
${NonDatasourceFieldIconFragmentDoc}
${FieldDescriptionInheritedFragmentDoc}
${FieldLineageUpstreamLabelsFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type WorkbookFieldsByIdQueryResult = Apollo.QueryResult<WorkbookFieldsByIdQuery, WorkbookFieldsByIdQueryVariables>;
export const WorkbookLineageCountsFilteredByFieldDocument = /*#__PURE__*/ gql`
    query WorkbookLineageCountsFilteredByField($workbookVizportalUrlId: String!, $selectedEmbeddedDatasourceId: ID!, $selectedFieldId: ID!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    embeddedDatasources(filter: {id: $selectedEmbeddedDatasourceId}) {
      filteredFieldsConnection: fieldsConnection(filter: {id: $selectedFieldId}) {
        nodes {
          name
          upstreamDatabasesConnection {
            totalCount
          }
          upstreamTablesConnection {
            totalCount
          }
          upstreamVirtualConnectionsConnection {
            totalCount
          }
          upstreamVirtualConnectionTablesConnection {
            totalCount
          }
          upstreamFlowsConnection {
            totalCount
          }
          upstreamDatasourcesConnection {
            totalCount
          }
          sheetsConnection {
            totalCount
          }
          dashboardsConnection: downstreamDashboardsConnection {
            totalCount
          }
          downstreamMetricsConnection {
            totalCount
          }
          downstreamOwnersConnection {
            totalCount
          }
        }
      }
    }
    ...WorkbookLineageCounts
  }
}
    ${WorkbookLineageCountsFragmentDoc}`;
export type WorkbookLineageCountsFilteredByFieldQueryResult = Apollo.QueryResult<WorkbookLineageCountsFilteredByFieldQuery, WorkbookLineageCountsFilteredByFieldQueryVariables>;
export const WorkbookLineageCountsDocument = /*#__PURE__*/ gql`
    query WorkbookLineageCounts($workbookVizportalUrlId: String!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    ...WorkbookLineageCounts
  }
}
    ${WorkbookLineageCountsFragmentDoc}`;
export type WorkbookLineageCountsQueryResult = Apollo.QueryResult<WorkbookLineageCountsQuery, WorkbookLineageCountsQueryVariables>;
export const WorkbookLineageUpstreamDataQualityWarningsDocument = /*#__PURE__*/ gql`
    query WorkbookLineageUpstreamDataQualityWarnings($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamDataQualityWarningsConnection(
      filter: {isActive: true}
      first: $first
      offset: $offset
      orderBy: {field: IS_SEVERE, direction: DESC}
    ) {
      totalCount
      nodes {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
    }
  }
}
    ${DataQualityWarningFragmentDoc}
${TableauUserFragmentDoc}
${DataQualityWarningAssetFragmentDoc}`;
export type WorkbookLineageUpstreamDataQualityWarningsQueryResult = Apollo.QueryResult<WorkbookLineageUpstreamDataQualityWarningsQuery, WorkbookLineageUpstreamDataQualityWarningsQueryVariables>;
export const WorkbookDocument = /*#__PURE__*/ gql`
    query Workbook($workbookVizportalUrlId: String!) {
  workbooks(
    filter: {vizportalUrlId: $workbookVizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    embeddedDatasources(orderBy: {field: NAME, direction: ASC}) {
      ...WorkbookEmbeddedDatasource
    }
  }
}
    ${WorkbookEmbeddedDatasourceFragmentDoc}`;
export type WorkbookQueryResult = Apollo.QueryResult<WorkbookQuery, WorkbookQueryVariables>;
export const WorkbookUpstreamDatabasesDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamDatabases($workbookVizportalUrlId: String, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${DatabasesDisplayGridRowDataFragmentDoc}
${TagsFragmentDoc}
${TableauUserFragmentDoc}
${DatabaseIconFragmentDoc}
${DatabaseServerOrPathFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}`;
export type WorkbookUpstreamDatabasesQueryResult = Apollo.QueryResult<WorkbookUpstreamDatabasesQuery, WorkbookUpstreamDatabasesQueryVariables>;
export const WorkbookUpstreamDatasourcesDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamDatasources($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentDoc}`;
export type WorkbookUpstreamDatasourcesQueryResult = Apollo.QueryResult<WorkbookUpstreamDatasourcesQuery, WorkbookUpstreamDatasourcesQueryVariables>;
export const WorkbookUpstreamDatasourcesWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamDatasourcesWithoutPersonalSpace($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type WorkbookUpstreamDatasourcesWithoutPersonalSpaceQueryResult = Apollo.QueryResult<WorkbookUpstreamDatasourcesWithoutPersonalSpaceQuery, WorkbookUpstreamDatasourcesWithoutPersonalSpaceQueryVariables>;
export const WorkbookUpstreamFlowsDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamFlows($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentDoc}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type WorkbookUpstreamFlowsQueryResult = Apollo.QueryResult<WorkbookUpstreamFlowsQuery, WorkbookUpstreamFlowsQueryVariables>;
export const WorkbookUpstreamFlowsWithoutPersonalSpaceDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamFlowsWithoutPersonalSpace($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
    ${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceFragmentDoc}`;
export type WorkbookUpstreamFlowsWithoutPersonalSpaceQueryResult = Apollo.QueryResult<WorkbookUpstreamFlowsWithoutPersonalSpaceQuery, WorkbookUpstreamFlowsWithoutPersonalSpaceQueryVariables>;
export const WorkbookUpstreamLensesDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamLenses($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${LensesDisplayGridRowDataFragmentDoc}`;
export type WorkbookUpstreamLensesQueryResult = Apollo.QueryResult<WorkbookUpstreamLensesQuery, WorkbookUpstreamLensesQueryVariables>;
export const WorkbookUpstreamTablesDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamTables($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type WorkbookUpstreamTablesQueryResult = Apollo.QueryResult<WorkbookUpstreamTablesQuery, WorkbookUpstreamTablesQueryVariables>;
export const WorkbookUpstreamVirtualConnectionTablesDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamVirtualConnectionTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${TablesDisplayGridRowDataFragmentDoc}
${TableauUserFragmentDoc}
${TableCertificationFragmentDoc}
${LabelFragmentDoc}
${AssetFragmentDoc}
${TableDatabaseNameFragmentDoc}`;
export type WorkbookUpstreamVirtualConnectionTablesQueryResult = Apollo.QueryResult<WorkbookUpstreamVirtualConnectionTablesQuery, WorkbookUpstreamVirtualConnectionTablesQueryVariables>;
export const WorkbookUpstreamVirtualConnectionsDocument = /*#__PURE__*/ gql`
    query WorkbookUpstreamVirtualConnections($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${VirtualConnectionsDisplayGridRowDataFragmentDoc}
${LabelFragmentDoc}
${TableauUserFragmentDoc}
${AssetFragmentDoc}`;
export type WorkbookUpstreamVirtualConnectionsQueryResult = Apollo.QueryResult<WorkbookUpstreamVirtualConnectionsQuery, WorkbookUpstreamVirtualConnectionsQueryVariables>;